// Code generated by the Encore v1.58.8 client generator. DO NOT EDIT.

// Disable eslint, jshint, and jslint for this file.
/* eslint-disable */
/* jshint ignore:start */
/*jslint-disable*/

/**
 * BaseURL is the base URL for calling the Encore application's API.
 */
export type BaseURL = string

export const Local: BaseURL = "http://localhost:4000"

/**
 * Environment returns a BaseURL for calling the cloud environment with the given name.
 */
export function Environment(name: string): BaseURL {
    return `https://${name}-core-6p22.encr.app`
}

/**
 * PreviewEnv returns a BaseURL for calling the preview environment with the given PR number.
 */
export function PreviewEnv(pr: number | string): BaseURL {
    return Environment(`pr${pr}`)
}

const BROWSER = typeof globalThis === "object" && ("window" in globalThis);

/**
 * Client is an API client for the core-6p22 Encore application.
 */
export default class Client {
    public readonly accountexternal: accountexternal.ServiceClient
    public readonly accountinternal: accountinternal.ServiceClient
    public readonly bookingexternal: bookingexternal.ServiceClient
    public readonly bookinginternal: bookinginternal.ServiceClient
    public readonly config: config.ServiceClient
    public readonly consultationexternal: consultationexternal.ServiceClient
    public readonly consultationinternal: consultationinternal.ServiceClient
    public readonly crmexternal: crmexternal.ServiceClient
    public readonly prodexternal: prodexternal.ServiceClient
    public readonly prodinternal: prodinternal.ServiceClient
    public readonly reportingexternal: reportingexternal.ServiceClient
    public readonly reportinginternal: reportinginternal.ServiceClient
    public readonly scexternal: scexternal.ServiceClient
    public readonly scinternal: scinternal.ServiceClient
    public readonly seeding: seeding.ServiceClient
    public readonly sessions: sessions.ServiceClient
    public readonly trialmanagementexternal: trialmanagementexternal.ServiceClient
    public readonly trialmanagementinternal: trialmanagementinternal.ServiceClient
    public readonly usersubmission: usersubmission.ServiceClient
    public readonly venomcodeinternal: venomcodeinternal.ServiceClient
    public readonly vetaichatexternal: vetaichatexternal.ServiceClient
    public readonly vetaichatinternal: vetaichatinternal.ServiceClient
    private readonly options: ClientOptions
    private readonly target: string


    /**
     * Creates a Client for calling the public and authenticated APIs of your Encore application.
     *
     * @param target  The target which the client should be configured to use. See Local and Environment for options.
     * @param options Options for the client
     */
    constructor(target: BaseURL, options?: ClientOptions) {
        this.target = target
        this.options = options ?? {}
        const base = new BaseClient(this.target, this.options)
        this.accountexternal = new accountexternal.ServiceClient(base)
        this.accountinternal = new accountinternal.ServiceClient(base)
        this.bookingexternal = new bookingexternal.ServiceClient(base)
        this.bookinginternal = new bookinginternal.ServiceClient(base)
        this.config = new config.ServiceClient(base)
        this.consultationexternal = new consultationexternal.ServiceClient(base)
        this.consultationinternal = new consultationinternal.ServiceClient(base)
        this.crmexternal = new crmexternal.ServiceClient(base)
        this.prodexternal = new prodexternal.ServiceClient(base)
        this.prodinternal = new prodinternal.ServiceClient(base)
        this.reportingexternal = new reportingexternal.ServiceClient(base)
        this.reportinginternal = new reportinginternal.ServiceClient(base)
        this.scexternal = new scexternal.ServiceClient(base)
        this.scinternal = new scinternal.ServiceClient(base)
        this.seeding = new seeding.ServiceClient(base)
        this.sessions = new sessions.ServiceClient(base)
        this.trialmanagementexternal = new trialmanagementexternal.ServiceClient(base)
        this.trialmanagementinternal = new trialmanagementinternal.ServiceClient(base)
        this.usersubmission = new usersubmission.ServiceClient(base)
        this.venomcodeinternal = new venomcodeinternal.ServiceClient(base)
        this.vetaichatexternal = new vetaichatexternal.ServiceClient(base)
        this.vetaichatinternal = new vetaichatinternal.ServiceClient(base)
    }

    /**
     * Creates a new Encore client with the given client options set.
     *
     * @param options Client options to set. They are merged with existing options.
     **/
    public with(options: ClientOptions): Client {
        return new Client(this.target, {
            ...this.options,
            ...options,
        })
    }
}

/**
 * ClientOptions allows you to override any default behaviour within the generated Encore client.
 */
export interface ClientOptions {
    /**
     * By default the client will use the inbuilt fetch function for making the API requests.
     * however you can override it with your own implementation here if you want to run custom
     * code on each API request made or response received.
     */
    fetcher?: Fetcher

    /** Default RequestInit to be used for the client */
    requestInit?: Omit<RequestInit, "headers"> & { headers?: Record<string, string> }

    /**
     * Allows you to set the authentication data to be used for each
     * request either by passing in a static object or by passing in
     * a function which returns a new object for each request.
     */
    auth?: accountinternal.MyAuthParams | AuthDataGenerator
}

export namespace accountexternal {
    export interface AddressDetailsResponse {
        /**
         * PostCode
         * The postal code.
         */
        postcode: string

        /**
         * Line1
         * The first line of the address.
         */
        "line_1": string

        /**
         * Line2
         * The second line of the address.
         */
        "line_2": string

        /**
         * TownOrCity
         * The town or city.
         */
        "town_or_city": string

        /**
         * County
         * The county.
         */
        county: string

        /**
         * Country
         * The country name.
         */
        country: string
    }

    export interface AddressSuggestion {
        /**
         * Address
         * The suggested address text.
         */
        address: string

        /**
         * ID
         * The unique identifier for this suggestion, used to retrieve full details.
         */
        id: string
    }

    export interface AddressSuggestionsRequest {
        /**
         * SearchTerm
         * The partial address text to search for.
         */
        SearchTerm: string
    }

    export interface AddressSuggestionsResponse {
        /**
         * Suggestions
         * A list of matching address suggestions.
         */
        suggestions: AddressSuggestion[]
    }

    /**
     * ApplyMembershipRequest is the request body for applying membership from a provider.
     */
    export interface ApplyMembershipRequest {
        /**
         * Provider
         * The membership provider. Accepted values: **MOCKINTEGRATION**, **KENNELCLUB**.
         */
        provider: string

        /**
         * FirstName
         * The member's first name used for provider lookup.
         */
        "first_name": string

        /**
         * LastName
         * The member's last name used for provider lookup.
         */
        "last_name": string

        /**
         * Email
         * The member's email address used for provider lookup.
         */
        email: string

        /**
         * Postcode
         * The member's postcode used for provider lookup.
         */
        postcode: string
    }

    /**
     * ApplyMembershipResponse is the response after applying membership.
     */
    export interface ApplyMembershipResponse {
        /**
         * MemberID
         * The external member ID from the provider.
         */
        "member_id": string

        /**
         * MembershipsApplied
         * A list of memberships that were successfully applied.
         */
        "memberships_applied"?: services.ApplyMembershipResult[]
    }

    export interface CountryResponse {
        /**
         * Countries
         * A list of valid country names.
         */
        countries: string[]
    }

    export interface CreateAddressRequest {
        /**
         * Line1
         * The first line of the address.
         */
        "line_1": string

        /**
         * Line2
         * The second line of the address (optional).
         */
        "line_2": string

        /**
         * TownCity
         * The town or city.
         */
        "town_or_city": string

        /**
         * County
         * The county (optional).
         */
        county: string

        /**
         * Country
         * The country name.
         */
        country: string

        /**
         * PostCode
         * The postal code.
         */
        postcode: string
    }

    export interface CreateIntegratorPetRequest {
        /**
         * Name
         * The name of the pet. Between 1 and 100 characters.
         */
        name: string

        /**
         * Species
         * The species of the pet as text (e.g. **Dog**). Must match a Joii species.
         */
        species: string

        /**
         * Breed
         * The breed of the pet as text (e.g. **Labrador Retriever**). When it cannot be
         * matched the pet is still created without a breed and **breed_matched** is false.
         */
        breed?: string

        /**
         * BreedDocID
         * The **doc_id** of a Joii breed in **UUID** format. Takes priority over **breed**
         * and is strict: an unknown id or a breed of another species is a **400**.
         */
        "breed_doc_id"?: string

        /**
         * Gender
         * One of **Male**, **Female**, **Unknown**. Defaults to **Unknown**.
         */
        gender?: string

        /**
         * DateOfBirth
         * The pet's date of birth in **YYYY-MM-DD** format.
         */
        "date_of_birth": string

        /**
         * Neutered
         * Whether the pet has been neutered, if known.
         */
        neutered?: boolean

        /**
         * Weight
         * The weight of the pet. **unit** is one of **kg**, **g**, **lbs**.
         */
        weight?: entities.WeightType

        /**
         * Triage
         * Whether triage is enabled for this pet. Defaults to **false**.
         */
        triage?: boolean

        /**
         * PolicyNumber
         * The policy number for this pet, when it has one. Must not already be in use for
         * this user, and the user must have a customer number.
         */
        "policy_number"?: string

        /**
         * PolicyActive
         * Whether the policy is active. Defaults to **true**. Requires **policy_number**.
         */
        "policy_active"?: boolean

        /**
         * PolicyStartDate
         * When the policy started, in UTC (e.g. **2026-01-01T00:00:00Z**). Requires
         * **policy_number**.
         */
        "policy_start_date"?: string

        /**
         * ExternalID
         * Your own identifier for this pet, for integrators that are not insurers. Changes
         * are kept as history; omit it to leave the current value unchanged.
         */
        "external_id"?: string
    }

    export interface CreateIntegratorUserRequest {
        /**
         * CustomerNumber
         * Your customer number for this user. Must be unique within your business.
         */
        "customer_number": string

        /**
         * FirstName
         * The first name of the user. Between 1 and 100 characters.
         */
        "first_name": string

        /**
         * LastName
         * The last name of the user. Between 1 and 100 characters, no numbers.
         */
        "last_name": string

        /**
         * Email
         * The email address of the user.
         */
        email: string

        /**
         * PostCode
         * The post code of the user.
         */
        "post_code": string

        /**
         * PhoneNumber
         * The user's phone number. Stored as given; normalised to **E.164** when it parses
         * against **country_code**.
         */
        "phone_number"?: string

        /**
         * CountryCode
         * The country code of the user in **ISO 3166-1** format (e.g. **GB**).
         */
        "country_code": string
    }

    export interface CreateIntegratorUserResponse {
        /**
         * UserID
         * The Joii identifier of the new user in **UUID** format. Store it against your customer.
         */
        "user_id": string
    }

    export interface CreatePetRequest {
        /**
         * Name
         * The name of the pet.
         */
        name: string

        /**
         * Gender
         * The gender of the pet.
         * 
         * Accepted values are:  **Male**, **Female**, **Unknown**.
         */
        gender: string

        /**
         * Weight
         * The weight of the pet.
         */
        weight?: entities.WeightType

        /**
         * DateOfBirth
         * The pet date of birth.
         * 
         * Accepted date format: **YYYY-MM-DD**.
         */
        "date_of_birth": string

        /**
         * Neutered
         * Indicates if the pet has been neutered.
         */
        neutered?: boolean

        /**
         * SpeciesID
         * The **doc_id** of the species associated with the pet in **UUID** format.
         */
        "species_doc_id": string

        /**
         * BreedDocID
         * The **doc_id** of the breed associated with the pet in **UUID** format.
         */
        "breed_doc_id": string

        /**
         * PolicyNumber
         * The pet's insurance policy number, as supplied by the customer.
         * 
         * Only accepted for insurers whose policy numbers are self-declared.
         */
        "policy_number"?: string
    }

    export interface CreateUserRequest {
        /**
         * Email
         * The email address of the user.
         */
        email: string

        /**
         * FirstName
         * The first name of the user.
         * 
         * Name must be between 1 and 100 characters and must not contain numbers.
         */
        "first_name": string

        /**
         * LastName
         * The last name of the user.
         * 
         * Name must be between 1 and 100 characters and must not contain numbers.
         */
        "last_name": string

        /**
         * PhoneNumber
         * The user's phone number.
         * It should be a valid number for the selected **country_code**.
         */
        "phone_number": string

        /**
         * CountryCode
         * The country code of the user in **ISO 3166-1** format (e.g. **GB**).
         * Phone number can contain **(**, **)**, **-** and spaces.
         */
        "country_code": string

        /**
         * PostCode
         * The post code of the user.
         * 
         * Post code can contain only letters, numbers, hyphens and spaces.
         * Required in non-US environments. Optional in US environments where **zip_code** is used instead.
         */
        "post_code": string

        /**
         * ZipCode
         * The zip code of the user.
         * 
         * Required in US environments. Must be a valid US zip code (e.g. **90210** or **90210-1234**).
         */
        "zip_code"?: string

        /**
         * USState
         * The US state of the user.
         * 
         * Must be a valid two-letter state code (e.g. TX, FL)
         */
        "us_state"?: string

        /**
         * Terms
         * Indicates if the user has accepted the terms and conditions.
         */
        terms: boolean
    }

    export interface CreateUserResponse {
        /**
         * DocID
         * The **doc_id** of the new user in **UUID** format.
         */
        "doc_id": string
    }

    export interface CreateWeightRequest {
        /**
         * Weight
         * The pet's weight. Accepted units: **kg**, **g**, **lbs**.
         */
        weight: entities.WeightType

        /**
         * MeasuredAt
         * The timestamp when the weight was measured in **RFC3339** format (e.g. **2017-09-04T04:00:00Z**). Defaults to current time if not provided.
         */
        "measured_at"?: string
    }

    export interface DeletePetRequest {
        /**
         * ReasonID
         * The ID of the deletion reason (optional). Retrieve available reasons from the pet deletion reasons endpoint.
         */
        ReasonID?: string
    }

    export interface GetAddressResponse {
        /**
         * UserDocID
         * The **doc_id** of the user in **UUID** format.
         */
        "user_doc_id": uuid.UUID

        /**
         * Line1
         * The first line of the address.
         */
        "line_1": string

        /**
         * Line2
         * The second line of the address (optional).
         */
        "line_2"?: string

        /**
         * TownCity
         * The town or city.
         */
        "town_or_city": string

        /**
         * County
         * The county (optional).
         */
        county?: string

        /**
         * Country
         * The country name.
         */
        country: string

        /**
         * PostCode
         * The postal code.
         */
        postcode: string
    }

    export interface GetBreedsQueryParams {
        /**
         * SpeciesDocID
         * The **doc_id** of the species in **UUID** format.
         */
        SpeciesDocID: string
    }

    /**
     * GetPackageByCodeResponse is the response for the get-package-by-code endpoint.
     */
    export interface GetPackageByCodeResponse {
        /**
         * ID
         * The **doc_id** of the package template in **UUID** format.
         */
        id: string

        /**
         * SourceType
         * The source type of the package (e.g. membership, insurance).
         */
        "source_type": string

        /**
         * Code
         * The unique code identifying the package.
         */
        code: string

        /**
         * Name
         * The display name of the package.
         */
        name: string

        /**
         * Description
         * A description of the package (optional).
         */
        description?: string

        /**
         * Active
         * Indicates whether the package is currently active.
         */
        active: boolean

        /**
         * CreatedAt
         * The timestamp when the package was created in **RFC3339** format.
         */
        "created_at": string

        /**
         * UpdatedAt
         * The timestamp when the package was last updated in **RFC3339** format.
         */
        "updated_at": string

        /**
         * Entitlements
         * A list of entitlements included in the package (optional).
         */
        entitlements?: PackageEntitlementResponse[]
    }

    export interface GetPetDeletionReasonResponse {
        /**
         * ID
         * The unique identifier of the deletion reason.
         */
        id: number

        /**
         * Name
         * The name or description of the deletion reason.
         */
        name: string
    }

    export interface GetPolicyNumberRequest {
        /**
         * FirstName
         * The policy holder's first name.
         */
        FirstName: string

        /**
         * LastName
         * The policy holder's last name.
         */
        LastName: string

        /**
         * Email
         * The policy holder's email address.
         */
        Email: string

        /**
         * Postcode
         * The policy holder's postcode.
         */
        Postcode: string
    }

    export interface GetPolicyNumberResponse {
        /**
         * PolicyNumber
         * The policy number retrieved from the insurer.
         */
        "policy_number": string
    }

    /**
     * GetSpeciesResponse contains a list of species.
     */
    export interface GetSpeciesResponse {
        /**
         * Species
         * A list of available species.
         */
        species: GetSpeciesResponseItem[]
    }

    export interface GetSpeciesResponseItem {
        /**
         * DocID
         * The **doc_id** of the species in **UUID** format.
         */
        "doc_id": string

        /**
         * Name
         * The name of the species.
         */
        name: string
    }

    export interface GetUserResponse {
        /**
         * DocID
         * The **doc_id** of the user in **UUID** format.
         */
        "doc_id": string

        /**
         * Email
         * The email address of the user.
         */
        email: string

        /**
         * FirstName
         * The first name of the user.
         */
        "first_name": string

        /**
         * LastName
         * The last name of the user.
         */
        "last_name": string

        /**
         * CreatedAt
         * **created_at** in UTC time format (e.g. **2017-09-04T04:00:00Z**)
         */
        "created_at": string

        /**
         * PhoneNumber
         * The user's phone number.
         */
        "phone_number": string

        /**
         * CountryCode
         * The country code of the user in **ISO 3166-1** format (e.g. **GB**).
         */
        "country_code": string

        /**
         * CurrentPolicyCustomerNo
         * The policy number of the user.
         */
        "current_policy_customer_no"?: string

        /**
         * RequiresVerification
         * Indicates if user's policy data has been verified by the user
         * after it has been retrieved from an insurer.
         */
        "requires_verification": boolean

        /**
         * PostCode
         * The post code of the user.
         */
        "post_code": string

        /**
         * ZipCode
         * The zip code of the user. Populated in US environments instead of **post_code**.
         */
        "zip_code"?: string

        /**
         * USState
         * The US state of the user, if any
         */
        "us_state"?: string

        /**
         * TrialActive
         * Indicates if the user has an active trial.
         */
        "trial_active": boolean

        /**
         * DeletionDate
         * The date and time when the user will be deleted
         */
        "deletion_date"?: string
    }

    export interface IntegratorPetMutationResponse {
        /**
         * PetID
         * The Joii identifier of the pet in **UUID** format. Store it against your policy.
         */
        "pet_id": string

        /**
         * BreedMatched
         * False when a breed was supplied but could not be matched to a Joii breed — the
         * pet was saved without a breed; retry with a cleaner breed name if needed.
         */
        "breed_matched": boolean

        /**
         * ResolvedBreed
         * The Joii breed the supplied breed text resolved to, when it matched.
         */
        "resolved_breed"?: string

        /**
         * ResolvedBreedDocID
         * The **doc_id** of the resolved breed — store it and send it as **breed_doc_id**
         * on later calls for exact matching.
         */
        "resolved_breed_doc_id"?: string
    }

    export interface IntegratorPetResponse {
        /**
         * PetID
         * The Joii identifier of the pet in **UUID** format. Use it in all further calls.
         */
        "pet_id": string

        /**
         * Name
         * The name of the pet.
         */
        name: string

        /**
         * Species
         * The species of the pet (e.g. **Dog**, **Cat**).
         */
        species: string

        /**
         * Breed
         * The breed of the pet, when one is set.
         */
        breed?: string

        /**
         * BreedDocID
         * The **doc_id** of the pet's breed, when one is set — send it back as
         * **breed_doc_id** for exact breed updates.
         */
        "breed_doc_id"?: string

        /**
         * Gender
         * One of **Male**, **Female**, **Unknown**.
         */
        gender: string

        /**
         * DateOfBirth
         * The pet's date of birth in **YYYY-MM-DD** format.
         */
        "date_of_birth": string

        /**
         * Neutered
         * Whether the pet has been neutered, when known.
         */
        neutered?: boolean

        /**
         * Weight
         * The pet's most recent weight in grams, kilograms and pounds, when known.
         */
        weight?: entities.WeightUnitsResponse

        /**
         * PolicyNumber
         * The policy number attached to the pet, when it has one.
         */
        "policy_number"?: string

        /**
         * CustomerNumber
         * The customer number the policy is registered under, when the pet has a policy.
         */
        "customer_number"?: string

        /**
         * PolicyActive
         * Whether the pet's policy is currently active.
         */
        "policy_active": boolean

        /**
         * PolicyStartDate
         * When the pet's policy started, in UTC, when known.
         */
        "policy_start_date"?: string

        /**
         * Triage
         * Whether triage is enabled for this pet.
         */
        triage: boolean

        /**
         * CreatedAt
         * When the pet was created in Joii, in UTC.
         */
        "created_at": string
    }

    export interface IntegratorUserResponse {
        /**
         * UserID
         * The Joii identifier of the user in **UUID** format. Use it in all further calls.
         */
        "user_id": string

        /**
         * CustomerNumber
         * Your customer number for this user.
         */
        "customer_number": string

        /**
         * Email
         * The email address of the user.
         */
        email: string

        /**
         * FirstName
         * The first name of the user.
         */
        "first_name": string

        /**
         * LastName
         * The last name of the user.
         */
        "last_name": string

        /**
         * PostCode
         * The post code of the user.
         */
        "post_code": string

        /**
         * PhoneNumber
         * The user's phone number in **E.164** format (e.g. **+447700900123**).
         */
        "phone_number": string

        /**
         * CreatedAt
         * When the user was created, in UTC (e.g. **2017-09-04T04:00:00Z**).
         */
        "created_at": string
    }

    export interface ListBreedsByIdRequest {
        /**
         * SpeciesID
         * The internal ID of the species.
         */
        SpeciesID: number
    }

    export interface ListIntegratorPetsResponse {
        /**
         * Pets
         * All of the user's pets, including pets without a policy — attach a policy to an
         * existing pet rather than creating a duplicate.
         */
        pets: IntegratorPetResponse[]
    }

    export interface ListPetDeletionReasonsResponse {
        /**
         * Reasons
         * A list of available pet deletion reasons.
         */
        reasons: PetDeletionReasons[]
    }

    export interface ListUserPreferencesResponse {
        /**
         * Push
         * Indicates if the user has opted in to push notifications.
         */
        "push_opted_in": boolean

        /**
         * Email
         * Indicates if the user has opted in to email notifications.
         */
        "email_opted_in": boolean

        /**
         * EmailSubscriptionGroups
         * A list of the user's email subscription group preferences.
         */
        "email_subscriptions": SubscriptionGroup[]

        /**
         * SMSSubscriptionGroups
         * A list of the user's SMS subscription group preferences.
         */
        "sms_subscriptions": SubscriptionGroup[]
    }

    /**
     * PackageEntitlementResponse represents an entitlement linked to a package.
     */
    export interface PackageEntitlementResponse {
        name: string
        description?: string
        type: string
        count?: number
        period?: string
    }

    export interface PatchPetPhotoRequest {
        /**
         * PhotoUrl
         * The location of the pet photo.
         * 
         * Accepted format: **folder_name/file_name.png**
         * 
         * Accepted file extendions: **.jpg**, **.jpeg**, **.png**, **.gif**, **.bmp**, **.svg**, **.tif**, **.tiff**, **.webp**, **.heic**
         */
        "photo_url": string
    }

    export interface PetDeletionReasons {
        /**
         * ID
         * The unique identifier of the deletion reason.
         */
        id: number

        /**
         * Name
         * The name or description of the deletion reason.
         */
        name: string
    }

    export interface PetPracticeRequest {
        /**
         * GooglePlaceId
         * The Google Places ID of the practice.
         */
        "google_place_id": string

        /**
         * Name
         * The name of the veterinary practice.
         */
        name: string

        /**
         * Address
         * The full address of the practice.
         */
        address: string

        /**
         * Long
         * The longitude coordinate of the practice.
         */
        long: string

        /**
         * Lat
         * The latitude coordinate of the practice.
         */
        lat: string

        /**
         * PhoneNumber
         * The practice's phone number (optional).
         */
        "phone_number"?: string

        /**
         * Email
         * The practice's email address (optional).
         */
        email?: string
    }

    export interface PetPracticeResponse {
        /**
         * GooglePlaceId
         * The Google Places ID of the practice.
         */
        "google_place_id": string

        /**
         * Name
         * The name of the veterinary practice.
         */
        name: string

        /**
         * Address
         * The full address of the practice.
         */
        address: string

        /**
         * Long
         * The longitude coordinate of the practice.
         */
        long: string

        /**
         * Lat
         * The latitude coordinate of the practice.
         */
        lat: string

        /**
         * PhoneNumber
         * The practice's phone number (optional).
         */
        "phone_number": string

        /**
         * Email
         * The practice's email address (optional).
         */
        email: string
    }

    export interface SetIntegratorPetPolicyRequest {
        /**
         * PolicyNumber
         * The policy number for this pet. A different number than the pet currently holds
         * replaces it and archives the old policy. Must not belong to another of the
         * user's pets (**409** otherwise).
         */
        "policy_number": string

        /**
         * Active
         * Whether the policy is active. Set **false** to cancel, **true** to (re)activate.
         * Always send it — omitting it is treated as **false**.
         */
        active: boolean

        /**
         * PolicyStartDate
         * When the policy started, in UTC (e.g. **2027-01-01T00:00:00Z**).
         */
        "policy_start_date"?: string
    }

    export interface SetIntegratorPetPolicyResponse {
    }

    export interface SubscriptionGroup {
        /**
         * ID
         * The unique identifier of the subscription group.
         */
        "group_id": string

        /**
         * Name
         * The display name of the subscription group.
         */
        label: string

        /**
         * Subscribed
         * Indicates if the user is subscribed to this group.
         */
        subscribed: boolean
    }

    /**
     * SyncPetsRequest is the request body for syncing pets.
     */
    export interface SyncPetsRequest {
    }

    /**
     * SyncPetsResponse is the response after syncing pets.
     */
    export interface SyncPetsResponse {
    }

    export interface UpdateAddressRequest {
        /**
         * Line1
         * The first line of the address.
         */
        "line_1": string

        /**
         * Line2
         * The second line of the address (optional).
         */
        "line_2": string

        /**
         * TownCity
         * The town or city.
         */
        "town_or_city": string

        /**
         * County
         * The county (optional).
         */
        county: string

        /**
         * Country
         * The country name.
         */
        country: string

        /**
         * PostCode
         * The postal code.
         */
        postcode: string
    }

    export interface UpdateIntegratorPetRequest {
        /**
         * Name
         * The name of the pet. Between 1 and 100 characters.
         */
        name: string

        /**
         * Species
         * The species of the pet as text (e.g. **Dog**). Must match a Joii species.
         */
        species: string

        /**
         * Breed
         * The breed of the pet as text. When it cannot be matched the pet is saved without
         * a breed and **breed_matched** is false in the response.
         */
        breed?: string

        /**
         * BreedDocID
         * The **doc_id** of a Joii breed in **UUID** format. Takes priority over **breed**
         * and is strict: an unknown id or a breed of another species is a **400**.
         */
        "breed_doc_id"?: string

        /**
         * Gender
         * One of **Male**, **Female**, **Unknown**. Defaults to **Unknown**.
         */
        gender?: string

        /**
         * DateOfBirth
         * The pet's date of birth in **YYYY-MM-DD** format.
         */
        "date_of_birth": string

        /**
         * Neutered
         * Whether the pet has been neutered, if known.
         */
        neutered?: boolean

        /**
         * Weight
         * The weight of the pet. **unit** is one of **kg**, **g**, **lbs**. A changed
         * weight is recorded in the pet's weight history.
         */
        weight?: entities.WeightType

        /**
         * Triage
         * When set, updates whether triage is enabled for this pet.
         */
        triage?: boolean

        /**
         * ExternalID
         * Your own identifier for this pet, for integrators that are not insurers. Changes
         * are kept as history; omit it to leave the current value unchanged.
         */
        "external_id"?: string
    }

    export interface UpdateIntegratorUserCustomerNumberRequest {
        /**
         * CustomerNumber
         * The new customer number. Must not belong to another user in your business.
         */
        "customer_number": string
    }

    export interface UpdateIntegratorUserRequest {
        /**
         * FirstName
         * The first name of the user. Between 1 and 100 characters.
         */
        "first_name": string

        /**
         * LastName
         * The last name of the user. Between 1 and 100 characters, no numbers.
         */
        "last_name": string

        /**
         * Email
         * The email address of the user. Unlike the app-facing update, email can change here.
         */
        email: string

        /**
         * PostCode
         * The post code of the user.
         */
        "post_code": string

        /**
         * PhoneNumber
         * The user's phone number. Stored as given; normalised to **E.164** when it parses
         * against **country_code**.
         */
        "phone_number"?: string

        /**
         * CountryCode
         * The country code of the user in **ISO 3166-1** format (e.g. **GB**).
         */
        "country_code": string
    }

    export interface UpdatePetRequest {
        /**
         * Name
         * The name of the pet.
         */
        name: string

        /**
         * Gender
         * The gender of the pet.
         * 
         * Accepted values are:  **Male**, **Female**, **Unknown**.
         */
        gender: string

        /**
         * Weight
         * The weight of the pet.
         */
        weight?: entities.WeightType

        /**
         * DateOfBirth
         * The pet date of birth.
         * 
         * Accepted date format: **YYYY-MM-DD**.
         */
        "date_of_birth": string

        /**
         * Neutered
         * Indicates if the pet has been neutered.
         */
        neutered?: boolean

        /**
         * BreedDocID
         * The **doc_id** of the breed associated with the pet in **UUID** format.
         */
        "breed_doc_id"?: string
    }

    export interface UpdateSubscriptionGroupPreferencesRequest {
        /**
         * Type
         * The subscription type. Accepted values: **email**, **sms**.
         */
        "preference_type": string

        /**
         * Subscribed
         * Set to **true** to subscribe, or **false** to unsubscribe.
         */
        subscribed: boolean

        /**
         * GroupID
         * The unique identifier of the subscription group.
         */
        "group_id": string

        /**
         * GroupName
         * The name of the subscription group.
         */
        "group_name": string
    }

    export interface UpdateUserPreferencesRequest {
        /**
         * Type
         * The preference type to update. Accepted values: **push**, **email**.
         */
        "preference_type": string

        /**
         * OptedIn
         * Set to **true** to opt in, or **false** to unsubscribe.
         */
        "opted_in": boolean
    }

    export interface UpdateUserRequest {
        /**
         * Email
         * The email address of the user.
         */
        email: string

        /**
         * FirstName
         * The first name of the user.
         * 
         * Name must be between 1 and 100 characters and must not contain numbers.
         */
        "first_name": string

        /**
         * LastName
         * The last name of the user.
         * 
         * Name must be between 1 and 100 characters and must not contain numbers.
         */
        "last_name": string

        /**
         * PhoneNumber
         * The user's phone number.
         * It should be a valid number for the selected **country_code**.
         * Phone number can contain **(**, **)**, **-** and spaces.
         */
        "phone_number": string

        /**
         * CountryCode
         * The country code of the user in **ISO 3166-1** format (e.g. **GB**).
         */
        "country_code": string

        /**
         * PostCode
         * The post code of the user.
         * 
         * Post code can contain only letters, numbers, hyphens and spaces.
         * Required in non-US environments. Optional in US environments where **zip_code** is used instead.
         */
        "post_code": string

        /**
         * ZipCode
         * The zip code of the user.
         * 
         * Required in US environments. Must be a valid US zip code (e.g. **90210** or **90210-1234**).
         */
        "zip_code"?: string

        /**
         * USState
         * The US state of the user.
         * 
         * Must be a valid two-letter state code (e.g. TX, FL)
         */
        "us_state"?: string
    }

    export interface UpdateUserResponse {
        /**
         * DocID
         * The **doc_id** of the user in **UUID** format.
         */
        "doc_id": string

        /**
         * Email
         * The email address of the user.
         */
        email: string

        /**
         * FirstName
         * The first name of the user.
         */
        "first_name": string

        /**
         * LastName
         * The last name of the user.
         */
        "last_name": string

        /**
         * PhoneNumber
         * The user's phone number containing the country code (e.g. +441204151617).
         */
        "phone_number": string

        /**
         * PostCode
         * The post code of the user.
         */
        "post_code": string

        /**
         * ZipCode
         * The zip code of the user. Populated in US environments instead of **post_code**.
         */
        "zip_code"?: string

        /**
         * USState
         * The US state of the user.
         */
        "us_state"?: string
    }

    export interface UpsertSSOUserRequest {
        placeholder?: string
    }

    export interface UpsertSSOUserResponse {
        placeholder?: string
    }

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.AdminSyncPets = this.AdminSyncPets.bind(this)
            this.ApplyMembership = this.ApplyMembership.bind(this)
            this.CancelDeleteUser = this.CancelDeleteUser.bind(this)
            this.CreateAddress = this.CreateAddress.bind(this)
            this.CreatePet = this.CreatePet.bind(this)
            this.CreateUser = this.CreateUser.bind(this)
            this.CreateWeight = this.CreateWeight.bind(this)
            this.DeleteAddress = this.DeleteAddress.bind(this)
            this.DeletePet = this.DeletePet.bind(this)
            this.DeleteUser = this.DeleteUser.bind(this)
            this.GenerateEmailVerificationLink = this.GenerateEmailVerificationLink.bind(this)
            this.GetAddress = this.GetAddress.bind(this)
            this.GetAddressDetails = this.GetAddressDetails.bind(this)
            this.GetAddressSuggestions = this.GetAddressSuggestions.bind(this)
            this.GetPackageByCode = this.GetPackageByCode.bind(this)
            this.GetPet = this.GetPet.bind(this)
            this.GetPetDeletionReasonById = this.GetPetDeletionReasonById.bind(this)
            this.GetPetEntitlements = this.GetPetEntitlements.bind(this)
            this.GetPetPractice = this.GetPetPractice.bind(this)
            this.GetPoliciesByPolicyNumber = this.GetPoliciesByPolicyNumber.bind(this)
            this.GetPolicyNumberByPolicyDetails = this.GetPolicyNumberByPolicyDetails.bind(this)
            this.GetUser = this.GetUser.bind(this)
            this.GetUserByPolicyNumber = this.GetUserByPolicyNumber.bind(this)
            this.GetUserEntitlements = this.GetUserEntitlements.bind(this)
            this.ListBreeds = this.ListBreeds.bind(this)
            this.ListBreedsById = this.ListBreedsById.bind(this)
            this.ListCountries = this.ListCountries.bind(this)
            this.ListPetDeletionReasons = this.ListPetDeletionReasons.bind(this)
            this.ListPets = this.ListPets.bind(this)
            this.ListPetsSoftSync = this.ListPetsSoftSync.bind(this)
            this.ListSpecies = this.ListSpecies.bind(this)
            this.ListUserPreferences = this.ListUserPreferences.bind(this)
            this.ListWeights = this.ListWeights.bind(this)
            this.PatchPetPhoto = this.PatchPetPhoto.bind(this)
            this.SyncMembership = this.SyncMembership.bind(this)
            this.SyncPets = this.SyncPets.bind(this)
            this.UpdateAddress = this.UpdateAddress.bind(this)
            this.UpdatePet = this.UpdatePet.bind(this)
            this.UpdatePetPractice = this.UpdatePetPractice.bind(this)
            this.UpdateSubscriptionGroupPreferences = this.UpdateSubscriptionGroupPreferences.bind(this)
            this.UpdateUser = this.UpdateUser.bind(this)
            this.UpdateUserPreferences = this.UpdateUserPreferences.bind(this)
            this.UpsertSSOUser = this.UpsertSSOUser.bind(this)
        }

        /**
         * Sync Pets (admin)
         * This endpoint allows staff to sync pets and policies for a given user, without relying on the staff member's business.
         */
        public async AdminSyncPets(user_doc_id: string): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/v1/users/${encodeURIComponent(user_doc_id)}/sync-admin`)
        }

        /**
         * Apply Membership
         * Looks up the user's membership with the given provider and grants entitlements for active memberships.
         */
        public async ApplyMembership(user_doc_id: string, params: ApplyMembershipRequest): Promise<ApplyMembershipResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/users/${encodeURIComponent(user_doc_id)}/memberships/apply`, JSON.stringify(params))
            return await resp.json() as ApplyMembershipResponse
        }

        /**
         * Undelete User
         * This endpoint unsets the deletion request for a user.
         */
        public async CancelDeleteUser(user_doc_id: string): Promise<void> {
            await this.baseClient.callTypedAPI("PATCH", `/v1/users/${encodeURIComponent(user_doc_id)}/cancel-delete`)
        }

        /**
         * Create New Address
         * This endpoint creates a new address for an existing user with the provided body parameter values.
         */
        public async CreateAddress(user_doc_id: string, params: CreateAddressRequest): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/v1/users/${encodeURIComponent(user_doc_id)}/address`, JSON.stringify(params))
        }

        /**
         * Create New Pet
         * This endpoint creates a new pet for an existing user with the provided body parameter values.
         */
        public async CreatePet(user_doc_id: string, params: CreatePetRequest): Promise<entities.CreatePetResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/users/${encodeURIComponent(user_doc_id)}/pets`, JSON.stringify(params))
            return await resp.json() as entities.CreatePetResponse
        }

        /**
         * Create New User
         * This endpoint creates a new user with the provided body parameter values.
         */
        public async CreateUser(params: CreateUserRequest): Promise<CreateUserResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/users`, JSON.stringify(params))
            return await resp.json() as CreateUserResponse
        }

        /**
         * Create Pet Weight
         * Records a new weight measurement for a pet.
         */
        public async CreateWeight(user_doc_id: string, pet_doc_id: string, params: CreateWeightRequest): Promise<entities.CreateWeightResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/users/${encodeURIComponent(user_doc_id)}/pets/${encodeURIComponent(pet_doc_id)}/weights`, JSON.stringify(params))
            return await resp.json() as entities.CreateWeightResponse
        }

        /**
         * Delete Address
         * This endpoint deletes an existing address.
         */
        public async DeleteAddress(user_doc_id: string): Promise<void> {
            await this.baseClient.callTypedAPI("DELETE", `/v1/users/${encodeURIComponent(user_doc_id)}/address`)
        }

        /**
         * Delete Pet
         * This endpoint soft deletes an existing pet for an existing user.
         */
        public async DeletePet(user_doc_id: string, pet_doc_id: string, params: DeletePetRequest): Promise<void> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                reasonid: params.ReasonID,
            })

            await this.baseClient.callTypedAPI("DELETE", `/v1/users/${encodeURIComponent(user_doc_id)}/pets/${encodeURIComponent(pet_doc_id)}`, undefined, {query})
        }

        /**
         * Delete User
         * This endpoint soft deletes a user if the user exists.
         */
        public async DeleteUser(user_doc_id: string): Promise<void> {
            await this.baseClient.callTypedAPI("DELETE", `/v1/users/${encodeURIComponent(user_doc_id)}`)
        }

        /**
         * Generate Email Verification Link
         * This endpoint generates an email verification link using Firebase Auth and sends a UserVerifyEmail event.
         */
        public async GenerateEmailVerificationLink(): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/v1/email-verification-link`)
        }

        /**
         * Get Address
         * This endpoint retrieves an existing address.
         */
        public async GetAddress(user_doc_id: string): Promise<GetAddressResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/users/${encodeURIComponent(user_doc_id)}/address`)
            return await resp.json() as GetAddressResponse
        }

        /**
         * Get Address Details
         * This endpoint returns the full address by ID.
         */
        public async GetAddressDetails(id: string): Promise<AddressDetailsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/address/details/${encodeURIComponent(id)}`)
            return await resp.json() as AddressDetailsResponse
        }

        /**
         * Get Address Suggestions
         * This endpoint suggests partial address results for a given term.
         */
        public async GetAddressSuggestions(params: AddressSuggestionsRequest): Promise<AddressSuggestionsResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                term: params.SearchTerm,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/address/suggestions`, undefined, {query})
            return await resp.json() as AddressSuggestionsResponse
        }

        /**
         * Get Package By Code
         * Retrieves a package template by its unique code. Returns 404 if not found.
         */
        public async GetPackageByCode(code: string): Promise<GetPackageByCodeResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/entitlements/packages/${encodeURIComponent(code)}`)
            return await resp.json() as GetPackageByCodeResponse
        }

        /**
         * Get Pet
         * This endpoint retrieves a given pet for a given user.
         */
        public async GetPet(user_doc_id: string, pet_doc_id: string): Promise<entities.PetResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/users/${encodeURIComponent(user_doc_id)}/pets/${encodeURIComponent(pet_doc_id)}`)
            return await resp.json() as entities.PetResponse
        }

        /**
         * Get Pet Deletion Reason By ID
         * Retrieves a pet deletion reason by its ID.
         */
        public async GetPetDeletionReasonById(id: string): Promise<GetPetDeletionReasonResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/petdeletionreason/${encodeURIComponent(id)}`)
            return await resp.json() as GetPetDeletionReasonResponse
        }

        /**
         * Get Pet Entitlements
         * Retrieves entitlements with usage data for a pet, including both direct and cascaded entitlements from the owner.
         * The authenticated user must have access to the pet.
         */
        public async GetPetEntitlements(userDocID: string, petDocID: string): Promise<entities.EntitlementCalculatorResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/users/${encodeURIComponent(userDocID)}/pets/${encodeURIComponent(petDocID)}/entitlements`)
            return await resp.json() as entities.EntitlementCalculatorResponse
        }

        /**
         * Get Pet Practice
         * Retrieves the veterinary practice associated with a pet, or null if none is set.
         */
        public async GetPetPractice(user_doc_id: string, pet_doc_id: string): Promise<PetPracticeResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/users/${encodeURIComponent(user_doc_id)}/pet/${encodeURIComponent(pet_doc_id)}/practice`)
            return await resp.json() as PetPracticeResponse
        }

        /**
         * Get Policies By Policy Number
         * This endpoint retrieves policies by given policy number.
         */
        public async GetPoliciesByPolicyNumber(insurer: string, policy_number: string): Promise<integrations.InsurancePolicies> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/policies/${encodeURIComponent(insurer)}/${encodeURIComponent(policy_number)}`)
            return await resp.json() as integrations.InsurancePolicies
        }

        /**
         * Get Policy Number By Policy Details
         * This endpoint retrieves a policy number by given policy details such as first name, last name, and postcode.
         */
        public async GetPolicyNumberByPolicyDetails(insurer: string, params: GetPolicyNumberRequest): Promise<GetPolicyNumberResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                email:        params.Email,
                "first_name": params.FirstName,
                "last_name":  params.LastName,
                postcode:     params.Postcode,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/policies/${encodeURIComponent(insurer)}`, undefined, {query})
            return await resp.json() as GetPolicyNumberResponse
        }

        /**
         * Get User
         * This endpoint retrieves user's data if the user exists.
         */
        public async GetUser(user_doc_id: string): Promise<GetUserResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/users/${encodeURIComponent(user_doc_id)}`)
            return await resp.json() as GetUserResponse
        }

        /**
         * Get User By Policy Number
         * Retrieves user details by policy number. It returns the same details as the GetUser request.
         */
        public async GetUserByPolicyNumber(policy_number: string): Promise<GetUserResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/users/${encodeURIComponent(policy_number)}/by-policy-number`)
            return await resp.json() as GetUserResponse
        }

        /**
         * Get User Entitlements
         * Retrieves entitlements with usage data for a user. Use **me** as the userDocID to get the current user's entitlements.
         */
        public async GetUserEntitlements(userDocID: string): Promise<entities.EntitlementCalculatorResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/users/${encodeURIComponent(userDocID)}/entitlements`)
            return await resp.json() as entities.EntitlementCalculatorResponse
        }

        /**
         * List Breeds
         * Retrieves a list of breeds for the requested species.
         * Breeds are supported in multiple languages (e.g. English, German).
         * If no language is provided in the authentication data, English is used by default.
         */
        public async ListBreeds(params: GetBreedsQueryParams): Promise<entities.GetBreedsResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "species_doc_id": params.SpeciesDocID,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/breeds`, undefined, {query})
            return await resp.json() as entities.GetBreedsResponse
        }

        /**
         * List Breeds By ID
         * Retrieves a list of breeds for the requested species using internal ID.
         */
        public async ListBreedsById(params: ListBreedsByIdRequest): Promise<entities.GetBreedsResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "species_doc_id": String(params.SpeciesID),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/breedsById`, undefined, {query})
            return await resp.json() as entities.GetBreedsResponse
        }

        /**
         * List Countries
         * This endpoint returns list of valid countries
         */
        public async ListCountries(): Promise<CountryResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/countries`)
            return await resp.json() as CountryResponse
        }

        /**
         * List Pet Deletion Reasons
         * Retrieves all available pet deletion reasons.
         */
        public async ListPetDeletionReasons(): Promise<ListPetDeletionReasonsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/petdeletionreason`)
            return await resp.json() as ListPetDeletionReasonsResponse
        }

        /**
         * List Pets
         * This endpoint retrieves a list of all pets for a given user.
         */
        public async ListPets(user_doc_id: string): Promise<entities.ListPetsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/users/${encodeURIComponent(user_doc_id)}/pets`)
            return await resp.json() as entities.ListPetsResponse
        }

        /**
         * List Pets Soft Sync
         * Retrieves a list of all pets for a user without forcing a policy sync.
         * Policies are only synced if data is older than one hour.
         */
        public async ListPetsSoftSync(user_doc_id: string): Promise<entities.ListPetsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/users/${encodeURIComponent(user_doc_id)}/pets-soft-sync`)
            return await resp.json() as entities.ListPetsResponse
        }

        /**
         * List Species
         * This endpoint retrieves a list of species.
         * Species are supported in both English and German.
         * If no language is provided in the authentication data, the default language is used, which is English.
         */
        public async ListSpecies(): Promise<GetSpeciesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/species`)
            return await resp.json() as GetSpeciesResponse
        }

        /**
         * List User Preferences
         * Retrieves a user's notification preferences including push, email, and SMS subscription groups.
         */
        public async ListUserPreferences(user_doc_id: string): Promise<ListUserPreferencesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/users/${encodeURIComponent(user_doc_id)}/preferences`)
            return await resp.json() as ListUserPreferencesResponse
        }

        /**
         * List Pet Weights
         * Retrieves all stored weight measurements for a pet.
         */
        public async ListWeights(user_doc_id: string, pet_doc_id: string): Promise<entities.ListWeightsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/users/${encodeURIComponent(user_doc_id)}/pets/${encodeURIComponent(pet_doc_id)}/weights`)
            return await resp.json() as entities.ListWeightsResponse
        }

        /**
         * Update Pet With Photo
         * This endpoint updates an existing pet's photo.
         */
        public async PatchPetPhoto(user_doc_id: string, pet_doc_id: string, params: PatchPetPhotoRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PATCH", `/v1/users/${encodeURIComponent(user_doc_id)}/pets/${encodeURIComponent(pet_doc_id)}/photo`, JSON.stringify(params))
        }

        /**
         * Sync Membership
         * Re-fetches membership details from the provider and deactivates grants if membership became inactive.
         */
        public async SyncMembership(user_doc_id: string): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/v1/users/${encodeURIComponent(user_doc_id)}/memberships/sync`)
        }

        /**
         * Sync Pets
         * This endpoint syncs pets and their policies with the insurer for a given user.
         */
        public async SyncPets(user_doc_id: string, params: SyncPetsRequest): Promise<SyncPetsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/users/${encodeURIComponent(user_doc_id)}/sync`)
            return await resp.json() as SyncPetsResponse
        }

        /**
         * Update Address
         * This endpoint updates an existing address with the provided body parameter values.
         */
        public async UpdateAddress(user_doc_id: string, params: UpdateAddressRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PUT", `/v1/users/${encodeURIComponent(user_doc_id)}/address`, JSON.stringify(params))
        }

        /**
         * Update Pet
         * This endpoint updates a given pet for a given user with the provided body parameter values.
         */
        public async UpdatePet(user_doc_id: string, pet_doc_id: string, params: UpdatePetRequest): Promise<entities.UpdatePetResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/users/${encodeURIComponent(user_doc_id)}/pets/${encodeURIComponent(pet_doc_id)}`, JSON.stringify(params))
            return await resp.json() as entities.UpdatePetResponse
        }

        /**
         * Update Pet Practice
         * Updates the veterinary practice associated with a pet.
         */
        public async UpdatePetPractice(user_doc_id: string, pet_doc_id: string, params: PetPracticeRequest): Promise<PetPracticeResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/users/${encodeURIComponent(user_doc_id)}/pet/${encodeURIComponent(pet_doc_id)}/practice`, JSON.stringify(params))
            return await resp.json() as PetPracticeResponse
        }

        /**
         * Update Subscription Group Preferences
         * Updates a user's subscription status for a specific email or SMS group.
         */
        public async UpdateSubscriptionGroupPreferences(user_doc_id: string, params: UpdateSubscriptionGroupPreferencesRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PUT", `/v1/users/${encodeURIComponent(user_doc_id)}/group-preferences`, JSON.stringify(params))
        }

        /**
         * Update User
         * This endpoint updates user's data if the user exists.
         */
        public async UpdateUser(user_doc_id: string, params: UpdateUserRequest): Promise<UpdateUserResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("PUT", `/v1/users/${encodeURIComponent(user_doc_id)}`, JSON.stringify(params))
            return await resp.json() as UpdateUserResponse
        }

        /**
         * Update User Preferences
         * Updates a user's global push or email notification preferences.
         */
        public async UpdateUserPreferences(user_doc_id: string, params: UpdateUserPreferencesRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PUT", `/v1/users/${encodeURIComponent(user_doc_id)}/preferences`, JSON.stringify(params))
        }

        /**
         * UpsertSSOUser
         * Currently used just as part of the manypets integration, but could be extended to any other provider
         * relies on a user id or email (TBC) in the JWT, and checks that that user exists with their pets in our
         * system. If not, creates the user and their pets. This allows us to sync users from an SSO provider on demand.
         */
        public async UpsertSSOUser(params: UpsertSSOUserRequest): Promise<UpsertSSOUserResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/users-sso`, JSON.stringify(params))
            return await resp.json() as UpsertSSOUserResponse
        }
    }
}

export namespace accountinternal {
    export interface AFIDocuments {
        url: string
    }

    export interface AFIPolicyAddress {
        building: string
        postcode: string
        street: string
        town: string
    }

    export interface Address {
        "line_1": string
        "line_2": string
        "town_or_city": string
        county: string
        country: string
        postcode: string
    }

    export interface AddressDetailsResponse {
        postcode: string
        "line_1": string
        "line_2": string
        "town_or_city": string
        county: string
        country: string
    }

    export interface AddressSuggestion {
        address: string
        id: string
    }

    export interface AddressSuggestionsRequest {
        SearchTerm: string
    }

    export interface AddressSuggestionsResponse {
        suggestions: AddressSuggestion[]
    }

    export interface BusinessResponse {
        "internal_id": number
        id: string
        name: string
        "external_id"?: string
        "partner_integration": string
    }

    export interface CountryResponse {
        countries: string[]
    }

    export interface CreateAPIKeyRequest {
        "business_id": string
        /**
         * Name will be a free text field for values like “Live”, “Dev', “User only access” etc.
         */
        name: string

        "symptom_checker_integrator"?: boolean
        "booking_integrator"?: boolean
        "users_read_integrator"?: boolean
        "users_write_integrator"?: boolean
        "shop_read_integrator"?: boolean
        "clinical_admin_integrator"?: boolean
        "user_submissions_write_integrator"?: boolean
        "chat_integrator"?: boolean
        /**
         * ExpiresInDays is how long the key remains valid for, in days from creation.
         */
        "expires_in_days": number
    }

    export interface CreateAPIKeyResponse {
        id: string
        key: string
    }

    export interface CreateAddressRequest {
        "line_1": string
        "line_2": string
        "town_or_city": string
        county: string
        country: string
        postcode: string
    }

    export interface CreateBodyConditionScoreRequest {
        score: number
        "measured_at"?: string
    }

    export interface CreateBodyConditionScoreResponse {
        "doc_id": uuid.UUID
    }

    export interface CreateDemoPetRequest {
        name: string
        /**
         * Male, Female or Unknown
         */
        gender: string

        /**
         * YYYY-MM-DD
         */
        "date_of_birth": string

        "breed_doc_id": string
        weight?: entities.WeightType
    }

    export interface CreateDemoUserRequest {
        email: string
        "first_name": string
        "last_name": string
        /**
         * who the demo account is for
         */
        notes: string

        pets?: CreateDemoPetRequest[]
    }

    export interface CreateDemoUserResponse {
        "user_doc_id": uuid.UUID
        email: string
        /**
         * generated login password; only ever returned here
         */
        password: string
    }

    export interface CreateEntitlementTypeRequest {
        code: string
        name: string
        description?: string
        unit: string
    }

    /**
     * CreateGrantRequest accepts exactly one of user_doc_id or pet_doc_id (UUIDs).
     * The backend resolves the doc_id to the internal integer ID before saving.
     */
    export interface CreateGrantRequest {
        "user_doc_id"?: string
        "pet_doc_id"?: string
        "package_template_doc_id": string
        "source_type": string
        "source_doc_id": string
        active: boolean
        "effective_date": string
        "expiry_date"?: string
    }

    export interface CreateHistoryRequestRequest {
        "consultation_id": uuid.UUID
    }

    export interface CreateHistoryRequestResponse {
        id: number
    }

    export interface CreatePackageTemplateRequest {
        "source_type": string
        code: string
        name: string
        description?: string
        active: boolean
    }

    export interface CreatePetDeletionRequest {
        name: string
    }

    export interface CreateSubscriptionGroupRequest {
        "group_id": string
        "group_label": string
        channel: string
        active: boolean
    }

    export interface CreateSubscriptionGroupResponse {
        "doc_id": string
    }

    export interface CreateTempUserRequest {
        "first_name": string
        "last_name": string
        email?: string
        postcode: string
        "phone_number"?: string
        "call_doc_id"?: string
    }

    export interface CreateTempUserResponse {
        "doc_id": string
    }

    export interface CreateUserAuthAccountResponse {
        /**
         * the auth-provider uid now stored as the user's external id
         */
        uid: string

        /**
         * the email the auth account was created for
         */
        email: string

        /**
         * the generated password, returned once for testing/relay
         */
        password: string
    }

    export interface CreateWeightRequest {
        /**
         * the weight of the pet in grams
         */
        weight: entities.WeightType

        /**
         * the timestamp when the weight was measured
         */
        "measured_at"?: string
    }

    export interface DeletePetRequest {
        ReasonID?: string
    }

    export interface DeleteUserRequest {
        IsMarked: boolean
    }

    export interface DemoPetResponse {
        "doc_id": uuid.UUID
        name: string
        species: string
        breed?: string
    }

    export interface DemoUserResponse {
        "doc_id": uuid.UUID
        email: string
        "first_name": string
        "last_name": string
        notes?: string
        "created_at": string
        pets: DemoPetResponse[]
    }

    export interface EntitlementTypeResponse {
        id: string
        code: string
        name: string
        description?: string
        unit: string
        "created_at": string
    }

    export interface GetAFIClinicalHistoryDocumentRequest {
        Url: string
    }

    export interface GetAFIClinicalHistoryDocumentResponse {
        response: string
    }

    export interface GetAFIClinicalHistoryRequest {
        PetName: string
        PolicyHolderSurname: string
        PolicyNoLong: string
    }

    export interface GetAFIClinicalHistoryResponse {
        documents: AFIDocuments[]
        errorMessages: string[]
        hasError: boolean
        policyAddress: AFIPolicyAddress
    }

    export interface GetAPIKeyResponse {
        id: string
        key: string
        /**
         * Name will be a free text field for values like “Live”, “Dev', “User only access” etc.
         */
        name: string

        "symptom_checker_integrator": boolean
        "booking_integrator": boolean
        "users_read_integrator": boolean
        "users_write_integrator": boolean
        "shop_read_integrator": boolean
        "clinical_admin_integrator": boolean
        "user_submissions_write_integrator": boolean
        "chat_integrator": boolean
        "created_at"?: string
        "created_by"?: string
        "created_by_email"?: string
        "updated_at"?: string
        "updated_by"?: string
        "updated_by_email"?: string
        "expiry_date"?: string
    }

    export interface GetBrazeExternalIDRequest {
        ShopifyCustomerID?: string
        EmailAddress?: string
        ShopifyStorefront?: string
    }

    export interface GetBrazeExternalIDResponse {
        /**
         * ExternalID is our UserDocID
         */
        "external_id": string
    }

    export interface GetUsersByCustomerNumberRequest {
        CustomerNumber: string
    }

    export interface GetUsersByCustomerNumberResponse {
        users: UserResponse[]
    }

    export interface GrantResponse {
        id: string
        "user_id"?: number
        "pet_id"?: number
        "entity_name"?: string
        "package_template_doc_id": string
        "source_type": string
        "source_doc_id": string
        active: boolean
        "effective_date": string
        "expiry_date"?: string
        "created_at": string
        "updated_at": string
    }

    /**
     * GrantStatsResponse contains aggregate counts for grants
     */
    export interface GrantStatsResponse {
        total: number
        active: number
        inactive: number
        users: number
        pets: number
    }

    /**
     * KnownEntitlementCodeResponse is a known entitlement type code for portal dropdown and validation.
     */
    export interface KnownEntitlementCodeResponse {
        code: string
        name: string
        unit: string
    }

    export interface LinkToUserRequest {
        "user_doc_id": string
    }

    export interface ListAPIKeyResponse {
        "api_keys": GetAPIKeyResponse[]
    }

    export interface ListDemoUsersRequest {
        /**
         * 1-based; defaults to 1
         */
        Page?: number
    }

    export interface ListDemoUsersResponse {
        users: DemoUserResponse[]
        total: number
        "page_size": number
    }

    export interface ListEntitlementTypesResponse {
        types?: EntitlementTypeResponse[]
    }

    /**
     * ListGrantsRequest defines query parameters for listing grants with pagination and filters
     */
    export interface ListGrantsRequest {
        /**
         * Pagination
         */
        RequestedItemsPerPage: number

        RequestedPageNumber: number
        /**
         * Filters
         */
        Active: string

        /**
         * "all", "user", "pet" (default: "all")
         */
        EntityType: string

        /**
         * "all" or specific source type (default: "all")
         */
        SourceType: string

        /**
         * search term for entity name (min 3 chars)
         */
        Search: string
    }

    export interface ListGrantsResponse {
        grants?: GrantResponse[]
        pagination: Pagination
        stats: GrantStatsResponse
    }

    export interface ListKnownEntitlementTypeCodesResponse {
        codes?: KnownEntitlementCodeResponse[]
    }

    export interface ListPackageTemplateEntitlementsResponse {
        entitlements?: PackageTemplateEntitlementResponse[]
    }

    export interface ListPackageTemplatesRequest {
        SourceType: string
    }

    export interface ListPackageTemplatesResponse {
        templates?: PackageTemplateResponse[]
    }

    export interface ListPetsResponse {
        pets: PetResponse[]
    }

    export interface ListPracticeRequest {
        /**
         * the number of results requested for the page
         */
        RequestedItemsPerPage: number

        /**
         * the page number requested
         */
        RequestedPageNumber: number

        Name: string
    }

    export interface ListPracticeResponse {
        practices: PetPracticeResponse[]
        pagination: Pagination
    }

    export interface ListSubscriptionGroupsResponse {
        "subscription_groups": SubscriptionGroup[]
    }

    export interface ListUserAddressesResponse {
        addresses: Address[]
    }

    export interface ListUsersRequest {
        /**
         * the number of results requested for the page
         */
        RequestedItemsPerPage: number

        /**
         * the page number requested
         */
        RequestedPageNumber: number

        Name: string
        Email: string
    }

    export interface ListUsersResponse {
        users: UserResponse[]
        pagination: Pagination
    }

    export interface MyAuthParams {
        /**
         * Accept-Language indicates the natural language and locale that the client prefers
         */
        Language: string

        /**
         * Authorization is the raw value of the "Authorization" header
         * without any parsing.
         */
        Token: string

        /**
         * ClientOperatingSystem is the operating system of the client such as iOS, Android, Windows, etc.
         */
        ClientOperatingSystem: string

        /**
         * ClientOSVersion is the version of the operating system of the client such as 14.0, 10.0, etc.
         */
        ClientOSVersion: string

        /**
         * ClientBuildNumber is the build number of the client application. such as 1.0.0, 2.0.0, etc.
         */
        ClientBuildNumber: string
    }

    export interface PackageTemplateEntitlementInput {
        "entitlement_type_doc_id": string
        value?: number
        period?: string
    }

    export interface PackageTemplateEntitlementResponse {
        id: string
        "entitlement_type_doc_id": string
        value?: number
        period?: string
    }

    export interface PackageTemplateResponse {
        id: string
        "source_type": string
        code: string
        name: string
        description?: string
        active: boolean
        "created_at": string
        "updated_at": string
    }

    export interface Pagination {
        total: number
        "current_page": number
        pages: number
    }

    export interface PetDataResponse {
        "doc_id": string
        name: string
        gender: string
        weight?: entities.WeightUnitsResponse
        neutered?: boolean
        "date_of_birth": string
        breed?: string
        species: string
        "policy_customer_no"?: string
        "policy_no"?: string
        "policy_active": boolean
        "policy_registered_date"?: string
        "policy_start_date"?: string
        "policy_disabled_date"?: string
        age: entities.Age
    }

    export interface PetPracticeRequest {
        "google_place_id": string
        name: string
        address: string
        long: string
        lat: string
        "phone_number"?: string
        email?: string
    }

    export interface PetPracticeResponse {
        "google_place_id": string
        name: string
        address: string
        long: string
        lat: string
        "phone_number": string
        email: string
        id: number
    }

    export interface PetResponse {
        /**
         * the id of the pet
         */
        "doc_id": string

        /**
         * the name of the pet
         */
        name: string

        /**
         * the gender of the pet
         */
        gender: string

        /**
         * the weight of the pet in different units
         */
        weight?: entities.WeightUnitsResponse

        /**
         * whether or not the pet has been neutered
         */
        neutered?: boolean

        /**
         * the date of birth of the pet
         */
        "date_of_birth": string

        /**
         * the breed associated with the pet
         */
        breed?: entities.GetBreedsResponseItem

        /**
         * the timestamp when the pet was created
         */
        "created_at": string

        /**
         * the species associated with the pet
         */
        species: string

        /**
         * the species id associated with the pet
         */
        "species_id": uuid.UUID

        /**
         * the photo of the pet
         */
        "photo_url"?: string

        /**
         * the policy customer number of the user associated with the pet
         */
        "policy_customer_no"?: string

        /**
         * the policy number of the pet
         */
        "policy_no"?: string

        /**
         * is policy of the pet active
         */
        "policy_active": boolean

        /**
         * the timestamp when the pet's policy was registered
         */
        "policy_registered_date"?: string

        /**
         * the timestamp when the pet's policy was disabled
         */
        "policy_disabled_date"?: string

        /**
         * does policy require verification
         */
        "requires_verification": boolean

        /**
         * does pet have triage
         */
        triage: boolean

        /**
         * the age of the pet
         */
        age: entities.Age

        /**
         * the start date of the pet's policy
         */
        "policy_start_date"?: string
    }

    export interface ResetUserPasswordResponse {
        /**
         * the one-time temporary password to relay to the customer
         */
        "temporary_password": string
    }

    export interface SearchPetResponse {
        /**
         * the id of the pet
         */
        "pet_doc_id": string

        "pet_name": string
        /**
         * the id of the user
         */
        "user_doc_id": string

        "user_name": string
        "user_email_address": string
        breed?: string
        "breed_doc_id"?: string
        species: string
        "species_doc_id": string
        gender: string
        age: entities.Age
        deleted: boolean
        "partner_name": string
        "most_recent_access": string
    }

    export interface SearchPetsRequestPaginated {
        RequestedItemsPerPage: number
        RequestedPageNumber: number
        SearchTerm: string
        IncludeDeleted: boolean
    }

    export interface SearchPetsResponsePaginated {
        pagination: shared.Pagination
        pets: SearchPetResponse[]
    }

    export interface SetPackageTemplateEntitlementsRequest {
        entitlements?: PackageTemplateEntitlementInput[]
    }

    export interface SignUrlRequest {
        URLS: string[]
    }

    export interface SignUrlResponse {
        urls: string[]
    }

    export interface SubscriptionGroup {
        "doc_id": string
        "group_id": string
        "group_label": string
        channel: string
        active: boolean
    }

    export interface TempUserResponse {
        "doc_id": string
        "first_name": string
        "last_name": string
        email: string
        postcode: string
        "phone_number": string
        "call_doc_id": string
        "linked_to_user_doc_id": string
        "matched_at": string
        "created_at": string
        "updated_at": string
    }

    export interface UpdateAddressRequest {
        "line_1": string
        "line_2": string
        "town_or_city": string
        county: string
        country: string
        postcode: string
    }

    export interface UpdateApiKeysRequest {
        /**
         * Name will be a free text field for values like “Live”, “Dev', “User only access” etc.
         */
        name: string

        "symptom_checker_integrator": boolean
        "booking_integrator": boolean
        "users_read_integrator": boolean
        "users_write_integrator": boolean
        "shop_read_integrator": boolean
        "clinical_admin_integrator": boolean
        "user_submissions_write_integrator": boolean
        "chat_integrator": boolean
    }

    export interface UpdateEntitlementTypeRequest {
        code: string
        name: string
        description?: string
        unit: string
    }

    export interface UpdatePackageTemplateRequest {
        "source_type": string
        code: string
        name: string
        description?: string
        active: boolean
    }

    export interface UpdatePetBreedRequest {
        "breed_doc_id": string
    }

    export interface UpdatePetDeletionRequest {
        "new_name": string
    }

    export interface UpdatePracticeRequest {
        "phone_number": string
        email: string
    }

    export interface UpdateSubscriptionGroupRequest {
        "doc_id": uuid.UUID
        "group_id": string
        "group_label": string
        channel: string
        active: boolean
    }

    export interface UpdateUserCustomerNumberRequest {
        /**
         * the new insurance customer number for the user
         */
        "customer_number": string
    }

    export interface UpdateUserEmailRequest {
        /**
         * the new email address for the user
         */
        email: string
    }

    export interface UpdateUserRequest {
        email: string
        "first_name": string
        "last_name": string
        "phone_number": string
        "post_code": string
        "us_state"?: string
    }

    export interface UserAddress {
        "line_1": string
        "line_2": string
        "town_or_city": string
        county: string
        country: string
        postcode: string
    }

    export interface UserDataResponse {
        "doc_id": uuid.UUID
        "external_id"?: string
        email: string
        "first_name": string
        "last_name": string
        "phone_number"?: string
        "current_policy_customer_no"?: string
        "post_code"?: string
        "us_state"?: string
        "partner_integration": string
    }

    export interface UserResponse {
        /**
         * the id of the user
         */
        id: number

        /**
         * the doc id of the user
         */
        "doc_id": uuid.UUID

        /**
         * the external id of the user
         */
        "external_id"?: string

        /**
         * the email of the user
         */
        email: string

        /**
         * the first name of the user
         */
        "first_name": string

        /**
         * the last name of the user
         */
        "last_name": string

        /**
         * the phone number of the user
         */
        "phone_number"?: string

        /**
         * the raw phone number of the user
         */
        "phone_number_raw"?: string

        /**
         * the phone number country code of the user
         */
        "phone_number_cc"?: string

        /**
         * the current policy number for user
         */
        "current_policy_customer_no"?: string

        /**
         * does policy require verification
         */
        "requires_verification": boolean

        /**
         * the post code of the user
         */
        "post_code": string

        /**
         * the zip code of the user (US environments)
         */
        "zip_code"?: string

        /**
         * the us state of the user, if any
         */
        "us_state"?: string

        /**
         * user marked for deletion flag
         */
        "mark_for_deletion"?: boolean

        /**
         * when user was marked for deletion
         */
        "mark_for_deletion_at"?: string

        /**
         * the actual deletion date
         */
        "mark_for_deletion_date"?: string

        /**
         * the actual deletion date
         */
        address?: UserAddress

        /**
         * the name (if any) of the business partner
         */
        "partner_name"?: string

        /**
         * when the account was most recently used (if available)
         */
        "most_recent_access"?: string

        /**
         * who the user is for, e.g. a demo account's prospect
         */
        notes?: string
    }

    export interface ValidateCallInsuranceRequest {
        "first_name": string
        "last_name": string
        email: string
        postcode: string
        "phone_number": string
        "business_doc_id": string
    }

    export interface ValidateCallInsuranceResponse {
        "is_insured": boolean
        user?: UserDataResponse
        pets?: PetDataResponse[]
        "is_new_user": boolean
    }

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.AdminUpdatePetBreed = this.AdminUpdatePetBreed.bind(this)
            this.CancelDeleteUser = this.CancelDeleteUser.bind(this)
            this.CreateAPIKey = this.CreateAPIKey.bind(this)
            this.CreateAddress = this.CreateAddress.bind(this)
            this.CreateBodyConditionScore = this.CreateBodyConditionScore.bind(this)
            this.CreateBusiness = this.CreateBusiness.bind(this)
            this.CreateDemoUser = this.CreateDemoUser.bind(this)
            this.CreateEntitlementType = this.CreateEntitlementType.bind(this)
            this.CreateGrant = this.CreateGrant.bind(this)
            this.CreateHistoryRequest = this.CreateHistoryRequest.bind(this)
            this.CreateMyStaff = this.CreateMyStaff.bind(this)
            this.CreatePackageTemplate = this.CreatePackageTemplate.bind(this)
            this.CreatePetDeletionReason = this.CreatePetDeletionReason.bind(this)
            this.CreateSubscriptionGroup = this.CreateSubscriptionGroup.bind(this)
            this.CreateTemporaryUser = this.CreateTemporaryUser.bind(this)
            this.CreateUserAuthAccount = this.CreateUserAuthAccount.bind(this)
            this.CreateWebhook = this.CreateWebhook.bind(this)
            this.CreateWebhookEvent = this.CreateWebhookEvent.bind(this)
            this.CreateWebhookEventMapping = this.CreateWebhookEventMapping.bind(this)
            this.CreateWeight = this.CreateWeight.bind(this)
            this.DeactivateGrant = this.DeactivateGrant.bind(this)
            this.DeactivateMembership = this.DeactivateMembership.bind(this)
            this.DeleteAPIKey = this.DeleteAPIKey.bind(this)
            this.DeleteAddress = this.DeleteAddress.bind(this)
            this.DeleteBusiness = this.DeleteBusiness.bind(this)
            this.DeleteDemoUser = this.DeleteDemoUser.bind(this)
            this.DeleteEntitlementType = this.DeleteEntitlementType.bind(this)
            this.DeletePackageTemplate = this.DeletePackageTemplate.bind(this)
            this.DeletePet = this.DeletePet.bind(this)
            this.DeletePetDeletionReason = this.DeletePetDeletionReason.bind(this)
            this.DeletePetPractice = this.DeletePetPractice.bind(this)
            this.DeleteUser = this.DeleteUser.bind(this)
            this.DeleteUsersMarkedForDeletion = this.DeleteUsersMarkedForDeletion.bind(this)
            this.DeleteWebhookEventMapping = this.DeleteWebhookEventMapping.bind(this)
            this.EntitlementCalculatorForPet = this.EntitlementCalculatorForPet.bind(this)
            this.EntitlementCalculatorForUser = this.EntitlementCalculatorForUser.bind(this)
            this.GetAFIClinicaHistoryDocument = this.GetAFIClinicaHistoryDocument.bind(this)
            this.GetAFIClinicalHistory = this.GetAFIClinicalHistory.bind(this)
            this.GetAPIKey = this.GetAPIKey.bind(this)
            this.GetAddressDetails = this.GetAddressDetails.bind(this)
            this.GetAddressSuggestions = this.GetAddressSuggestions.bind(this)
            this.GetBrazeExternalID = this.GetBrazeExternalID.bind(this)
            this.GetBusiness = this.GetBusiness.bind(this)
            this.GetBusinessByUserDocID = this.GetBusinessByUserDocID.bind(this)
            this.GetEntitlementType = this.GetEntitlementType.bind(this)
            this.GetGrant = this.GetGrant.bind(this)
            this.GetMyStaff = this.GetMyStaff.bind(this)
            this.GetPackageTemplate = this.GetPackageTemplate.bind(this)
            this.GetPet = this.GetPet.bind(this)
            this.GetPetPractice = this.GetPetPractice.bind(this)
            this.GetPractice = this.GetPractice.bind(this)
            this.GetSubscriptionGroup = this.GetSubscriptionGroup.bind(this)
            this.GetTemporaryUser = this.GetTemporaryUser.bind(this)
            this.GetUser = this.GetUser.bind(this)
            this.GetUsersByCustomerNumber = this.GetUsersByCustomerNumber.bind(this)
            this.GetWebhook = this.GetWebhook.bind(this)
            this.GetWebhookEvent = this.GetWebhookEvent.bind(this)
            this.LinkTemporaryUserToExistingUser = this.LinkTemporaryUserToExistingUser.bind(this)
            this.ListAPIKeys = this.ListAPIKeys.bind(this)
            this.ListBusinesses = this.ListBusinesses.bind(this)
            this.ListBusinessesWithPartnerIntegration = this.ListBusinessesWithPartnerIntegration.bind(this)
            this.ListCountries = this.ListCountries.bind(this)
            this.ListDemoUsers = this.ListDemoUsers.bind(this)
            this.ListEntitlementTypes = this.ListEntitlementTypes.bind(this)
            this.ListGrants = this.ListGrants.bind(this)
            this.ListKnownEntitlementTypeCodes = this.ListKnownEntitlementTypeCodes.bind(this)
            this.ListPackageTemplateEntitlements = this.ListPackageTemplateEntitlements.bind(this)
            this.ListPackageTemplates = this.ListPackageTemplates.bind(this)
            this.ListPets = this.ListPets.bind(this)
            this.ListPractices = this.ListPractices.bind(this)
            this.ListSubscriptionGroups = this.ListSubscriptionGroups.bind(this)
            this.ListUserAddresses = this.ListUserAddresses.bind(this)
            this.ListUsers = this.ListUsers.bind(this)
            this.ListWebhookEventMapping = this.ListWebhookEventMapping.bind(this)
            this.ListWebhookEvents = this.ListWebhookEvents.bind(this)
            this.ListWebhooks = this.ListWebhooks.bind(this)
            this.NotifyAFIOfRegistration = this.NotifyAFIOfRegistration.bind(this)
            this.PatchPet = this.PatchPet.bind(this)
            this.RemovePackageTemplateEntitlement = this.RemovePackageTemplateEntitlement.bind(this)
            this.ResetUserPassword = this.ResetUserPassword.bind(this)
            this.SearchPets = this.SearchPets.bind(this)
            this.SetPackageTemplateEntitlements = this.SetPackageTemplateEntitlements.bind(this)
            this.SignURL = this.SignURL.bind(this)
            this.UpdateAPIKey = this.UpdateAPIKey.bind(this)
            this.UpdateAddress = this.UpdateAddress.bind(this)
            this.UpdateBusiness = this.UpdateBusiness.bind(this)
            this.UpdateEntitlementType = this.UpdateEntitlementType.bind(this)
            this.UpdatePackageTemplate = this.UpdatePackageTemplate.bind(this)
            this.UpdatePetDeletionReason = this.UpdatePetDeletionReason.bind(this)
            this.UpdatePetPractice = this.UpdatePetPractice.bind(this)
            this.UpdatePractice = this.UpdatePractice.bind(this)
            this.UpdateSubscriptionGroup = this.UpdateSubscriptionGroup.bind(this)
            this.UpdateUser = this.UpdateUser.bind(this)
            this.UpdateUserCustomerNumber = this.UpdateUserCustomerNumber.bind(this)
            this.UpdateUserEmail = this.UpdateUserEmail.bind(this)
            this.UpdateWebhook = this.UpdateWebhook.bind(this)
            this.UpdateWebhookEvent = this.UpdateWebhookEvent.bind(this)
            this.ValidateCallInsurance = this.ValidateCallInsurance.bind(this)
            this.VerifyUserEmail = this.VerifyUserEmail.bind(this)
        }

        /**
         * UpdatePetBreed
         * Sets a pet's breed. Reuses petService.PatchPet with only the breed set, so
         * customer support (tag:admin) can update breed without the clinician-tagged PatchPet.
         */
        public async AdminUpdatePetBreed(petDocID: string, params: UpdatePetBreedRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PUT", `/v1/petsinternal/${encodeURIComponent(petDocID)}/breed`, JSON.stringify(params))
        }

        /**
         * Undelete User
         * This endpoint unsets the deletion request for a user.
         */
        public async CancelDeleteUser(doc_id: string): Promise<void> {
            await this.baseClient.callTypedAPI("PATCH", `/v1/usersinternal/${encodeURIComponent(doc_id)}/cancel-delete`)
        }

        /**
         * Create API Key
         * This endpoint adds a new API key to the database.
         * Obviously this will eventually need auth itself, but is useful to get us going with test.
         */
        public async CreateAPIKey(params: CreateAPIKeyRequest): Promise<CreateAPIKeyResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/api-key/generate`, JSON.stringify(params))
            return await resp.json() as CreateAPIKeyResponse
        }

        /**
         * Create New Address
         * This endpoint creates a new address for an existing user with the provided body parameter values.
         */
        public async CreateAddress(user_doc_id: string, params: CreateAddressRequest): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/v1/usersinternal/${encodeURIComponent(user_doc_id)}/address`, JSON.stringify(params))
        }

        /**
         * Create New Pet BodyConditionScore
         * This endpoint creates a new stored BodyConditionScore for a pet. A valid pet_doc_id path parameter is required.
         */
        public async CreateBodyConditionScore(user_doc_id: string, pet_doc_id: string, params: CreateBodyConditionScoreRequest): Promise<CreateBodyConditionScoreResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/users/${encodeURIComponent(user_doc_id)}/pets/${encodeURIComponent(pet_doc_id)}/bcs`, JSON.stringify(params))
            return await resp.json() as CreateBodyConditionScoreResponse
        }

        /**
         * Create business
         */
        public async CreateBusiness(params: entities.CreateBusinessRequest): Promise<entities.CreateBusinessResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/business`, JSON.stringify(params))
            return await resp.json() as entities.CreateBusinessResponse
        }

        /**
         * CreateDemoUser creates a user, their pets and a pre-verified Firebase login in the DEMO tenant.
         */
        public async CreateDemoUser(params: CreateDemoUserRequest): Promise<CreateDemoUserResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/demo/users`, JSON.stringify(params))
            return await resp.json() as CreateDemoUserResponse
        }

        /**
         * CreateEntitlementType creates a new entitlement type.
         * Only known entitlement type codes are allowed; see ListKnownEntitlementTypeCodes.
         */
        public async CreateEntitlementType(params: CreateEntitlementTypeRequest): Promise<EntitlementTypeResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/internal/entitlement-types`, JSON.stringify(params))
            return await resp.json() as EntitlementTypeResponse
        }

        /**
         * CreateGrant creates a new grant
         */
        public async CreateGrant(params: CreateGrantRequest): Promise<GrantResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/internal/grants`, JSON.stringify(params))
            return await resp.json() as GrantResponse
        }

        /**
         * Create History Request
         * Creates a request for a pet's clinical history from their veterinary practice.
         */
        public async CreateHistoryRequest(pet_doc_id: string, params: CreateHistoryRequestRequest): Promise<CreateHistoryRequestResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/petsinternal/${encodeURIComponent(pet_doc_id)}/history-request`, JSON.stringify(params))
            return await resp.json() as CreateHistoryRequestResponse
        }

        /**
         * Fetches an existing user.
         * Fetches an existing user with the given id.
         */
        public async CreateMyStaff(params: entities.CreateStaffRequest): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/v1/my-staff`)
        }

        /**
         * CreatePackageTemplate creates a new package template
         */
        public async CreatePackageTemplate(params: CreatePackageTemplateRequest): Promise<PackageTemplateResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/internal/package-templates`, JSON.stringify(params))
            return await resp.json() as PackageTemplateResponse
        }

        /**
         * Create Pet deletion reason
         * This endpoint creates a new pet deletion reason
         */
        public async CreatePetDeletionReason(params: CreatePetDeletionRequest): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/v1/petdeletionreason`, JSON.stringify(params))
        }

        /**
         * Create Subscription Group
         * CreateSubscriptionGroup creates new user preferences subscription group
         */
        public async CreateSubscriptionGroup(params: CreateSubscriptionGroupRequest): Promise<CreateSubscriptionGroupResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/user-preferences/subscription-group`, JSON.stringify(params))
            return await resp.json() as CreateSubscriptionGroupResponse
        }

        /**
         * Create Temporary User
         * This endpoint creates a temporary user.
         */
        public async CreateTemporaryUser(params: CreateTempUserRequest): Promise<CreateTempUserResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("PUT", `/v1/temporary-users`, JSON.stringify(params))
            return await resp.json() as CreateTempUserResponse
        }

        /**
         * CreateUserAuthAccount creates an auth-provider (Firebase) account for a user that has
         * none — e.g. one created through the integrator API — with a generated password, and
         * links it by setting the user's external id. The password is returned once and not stored.
         */
        public async CreateUserAuthAccount(userDocID: string): Promise<CreateUserAuthAccountResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/usersinternal/${encodeURIComponent(userDocID)}/auth-user`)
            return await resp.json() as CreateUserAuthAccountResponse
        }

        /**
         * Create webhook for business
         */
        public async CreateWebhook(businessId: string, params: entities.WebhookRequest): Promise<entities.WebhookResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/businesses/${encodeURIComponent(businessId)}/webhooks`, JSON.stringify(params))
            return await resp.json() as entities.WebhookResponse
        }

        /**
         * Create webhook event
         */
        public async CreateWebhookEvent(params: entities.WebhookEventRequest): Promise<entities.WebhookEventResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/webhookevents`, JSON.stringify(params))
            return await resp.json() as entities.WebhookEventResponse
        }

        /**
         * Create webhook event for business
         */
        public async CreateWebhookEventMapping(businessId: string, webhookId: string, params: entities.WebhookEventMappingRequest): Promise<entities.WebhookEventMappingResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/businesses/${encodeURIComponent(businessId)}/webhooks/${encodeURIComponent(webhookId)}/events`, JSON.stringify(params))
            return await resp.json() as entities.WebhookEventMappingResponse
        }

        /**
         * Create New Pet Weight
         * This endpoint creates a new stored weight for a pet.
         */
        public async CreateWeight(user_doc_id: string, pet_doc_id: string, params: CreateWeightRequest): Promise<entities.CreateWeightResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/usersinternal/${encodeURIComponent(user_doc_id)}/pets/${encodeURIComponent(pet_doc_id)}/weights`, JSON.stringify(params))
            return await resp.json() as entities.CreateWeightResponse
        }

        /**
         * DeactivateGrant deactivates a grant
         */
        public async DeactivateGrant(docID: string): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/internal/grants/${encodeURIComponent(docID)}/deactivate`)
        }

        /**
         * DeactivateMembership deactivates a membership
         */
        public async DeactivateMembership(docID: string): Promise<void> {
            await this.baseClient.callTypedAPI("DELETE", `/internal/memberships/${encodeURIComponent(docID)}`)
        }

        /**
         * Delete API Key
         * This endpoint deletes an api key. Valid **api_key_doc_id** path parameter is required.
         */
        public async DeleteAPIKey(api_key_doc_id: string): Promise<void> {
            await this.baseClient.callTypedAPI("DELETE", `/api-key/${encodeURIComponent(api_key_doc_id)}`)
        }

        /**
         * Delete Address
         * This endpoint deletes an existing address.
         */
        public async DeleteAddress(user_doc_id: string): Promise<void> {
            await this.baseClient.callTypedAPI("DELETE", `/v1/usersinternal/${encodeURIComponent(user_doc_id)}/address`)
        }

        /**
         * DeleteBusiness deletes an existing business.
         */
        public async DeleteBusiness(params: entities.DeleteBusinessRequest): Promise<void> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                id: params.DocID,
            })

            await this.baseClient.callTypedAPI("DELETE", `/v1/business`, undefined, {query})
        }

        /**
         * DeleteDemoUser deletes a DEMO user, their pets and their Firebase login.
         */
        public async DeleteDemoUser(userDocID: string): Promise<void> {
            await this.baseClient.callTypedAPI("DELETE", `/v1/demo/users/${encodeURIComponent(userDocID)}`)
        }

        /**
         * DeleteEntitlementType deletes an entitlement type
         */
        public async DeleteEntitlementType(docID: string): Promise<void> {
            await this.baseClient.callTypedAPI("DELETE", `/internal/entitlement-types/${encodeURIComponent(docID)}`)
        }

        /**
         * DeletePackageTemplate deletes a package template.
         * It fails with FailedPrecondition if any active entitlement grants are linked to this package.
         */
        public async DeletePackageTemplate(docID: string): Promise<void> {
            await this.baseClient.callTypedAPI("DELETE", `/internal/package-templates/${encodeURIComponent(docID)}`)
        }

        public async DeletePet(user_doc_id: string, pet_doc_id: string, params: DeletePetRequest): Promise<void> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                reasonid: params.ReasonID,
            })

            await this.baseClient.callTypedAPI("DELETE", `/v1/usersinternal/${encodeURIComponent(user_doc_id)}/pets/${encodeURIComponent(pet_doc_id)}`, undefined, {query})
        }

        /**
         * Delete Pet deletion reason
         * This endpoint deletes the pet deletion reason by ID
         */
        public async DeletePetDeletionReason(id: string): Promise<void> {
            await this.baseClient.callTypedAPI("DELETE", `/v1/petdeletionreason/${encodeURIComponent(id)}`)
        }

        /**
         * Delete Pet Practice
         * Removes the veterinary practice link from a pet.
         */
        public async DeletePetPractice(pet_doc_id: string): Promise<void> {
            await this.baseClient.callTypedAPI("DELETE", `/v1/petsinternal/${encodeURIComponent(pet_doc_id)}/practice`)
        }

        /**
         * DeleteUser deletes a user by docID
         */
        public async DeleteUser(doc_id: string, params: DeleteUserRequest): Promise<void> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "is_marked": String(params.IsMarked),
            })

            await this.baseClient.callTypedAPI("DELETE", `/v1/usersinternal/${encodeURIComponent(doc_id)}`, undefined, {query})
        }

        /**
         * Run CRON job from portal
         * 
         * Automatically delete all users marked for deletion.
         */
        public async DeleteUsersMarkedForDeletion(): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/v1/cron/delete-users-marked-for-deletion`)
        }

        /**
         * Create webhook event for business
         */
        public async DeleteWebhookEventMapping(businessId: string, webhookId: string, webhookEventId: string): Promise<void> {
            await this.baseClient.callTypedAPI("DELETE", `/v1/businesses/${encodeURIComponent(businessId)}/webhooks/${encodeURIComponent(webhookId)}/events/${encodeURIComponent(webhookEventId)}`)
        }

        /**
         * EntitlementCalculatorForPet returns calculated entitlements for a pet (including cascade from owner)
         */
        public async EntitlementCalculatorForPet(pet_doc_id: string): Promise<entities.EntitlementCalculatorResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/internal/entitlement-calculator/pet/${encodeURIComponent(pet_doc_id)}`)
            return await resp.json() as entities.EntitlementCalculatorResponse
        }

        /**
         * EntitlementCalculatorForUser returns calculated entitlements for a user
         */
        public async EntitlementCalculatorForUser(userDocID: string): Promise<entities.EntitlementCalculatorResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/internal/entitlement-calculator/user/${encodeURIComponent(userDocID)}`)
            return await resp.json() as entities.EntitlementCalculatorResponse
        }

        /**
         * GetAFIDocument
         * This endpoint makes a request to afi for the specified url
         */
        public async GetAFIClinicaHistoryDocument(params: GetAFIClinicalHistoryDocumentRequest): Promise<GetAFIClinicalHistoryDocumentResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                url: params.Url,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/clinical-history-document/afi`, undefined, {query})
            return await resp.json() as GetAFIClinicalHistoryDocumentResponse
        }

        /**
         * GetAFICLinicalHistory
         * This endpoint calls Animal Friends to get the pets clinical histroy
         */
        public async GetAFIClinicalHistory(params: GetAFIClinicalHistoryRequest): Promise<GetAFIClinicalHistoryResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                petName:             params.PetName,
                policyHolderSurname: params.PolicyHolderSurname,
                policyNoLong:        params.PolicyNoLong,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/clinical-history/afi`, undefined, {query})
            return await resp.json() as GetAFIClinicalHistoryResponse
        }

        /**
         * Get API Key
         * This endpoint returns an api key. Valid **api_key_doc_id** path parameter is required.
         */
        public async GetAPIKey(api_key_doc_id: string): Promise<GetAPIKeyResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/api-key/${encodeURIComponent(api_key_doc_id)}`)
            return await resp.json() as GetAPIKeyResponse
        }

        /**
         * Get Address Details
         * This endpoint returns the full address by ID.
         */
        public async GetAddressDetails(id: string): Promise<AddressDetailsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/internal/address/details/${encodeURIComponent(id)}`)
            return await resp.json() as AddressDetailsResponse
        }

        /**
         * Get Address Suggestions
         * This endpoint suggests partial address results for a given term.
         */
        public async GetAddressSuggestions(params: AddressSuggestionsRequest): Promise<AddressSuggestionsResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                term: params.SearchTerm,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/internal/address/suggestions`, undefined, {query})
            return await resp.json() as AddressSuggestionsResponse
        }

        /**
         * GetBrazeExternalID is a temporary endpoint for allowing braze to perform a lookup from email to our user doc id.
         */
        public async GetBrazeExternalID(params: GetBrazeExternalIDRequest): Promise<GetBrazeExternalIDResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "email_address":       params.EmailAddress,
                "shopify_customer_id": params.ShopifyCustomerID,
                "shopify_storefront":  params.ShopifyStorefront,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/braze-external-id`, undefined, {query})
            return await resp.json() as GetBrazeExternalIDResponse
        }

        /**
         * Fetches an existing business by its ID to check if it exists.
         */
        public async GetBusiness(params: entities.GetBusinessRequest): Promise<entities.BusinessResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                id: params.DocID,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/business`, undefined, {query})
            return await resp.json() as entities.BusinessResponse
        }

        /**
         * GetBusinessByUserDocID fetches a business by user doc ID
         */
        public async GetBusinessByUserDocID(user_doc_id: string): Promise<BusinessResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/business/user/${encodeURIComponent(user_doc_id)}`)
            return await resp.json() as BusinessResponse
        }

        /**
         * GetEntitlementType gets an entitlement type by doc ID
         */
        public async GetEntitlementType(docID: string): Promise<EntitlementTypeResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/internal/entitlement-types/${encodeURIComponent(docID)}`)
            return await resp.json() as EntitlementTypeResponse
        }

        /**
         * GetGrant gets a grant by doc ID
         */
        public async GetGrant(docID: string): Promise<GrantResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/internal/grants/${encodeURIComponent(docID)}`)
            return await resp.json() as GrantResponse
        }

        /**
         * Fetches an existing staff member.
         * Fetches an existing staff member to check they exist.
         */
        public async GetMyStaff(): Promise<void> {
            await this.baseClient.callTypedAPI("GET", `/v1/my-staff`)
        }

        /**
         * GetPackageTemplate gets a package template by doc ID
         */
        public async GetPackageTemplate(docID: string): Promise<PackageTemplateResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/internal/package-templates/${encodeURIComponent(docID)}`)
            return await resp.json() as PackageTemplateResponse
        }

        /**
         * Get Pet
         * This endpoint returns a given pet for a given user.
         */
        public async GetPet(user_doc_id: string, pet_doc_id: string): Promise<PetResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/usersinternal/${encodeURIComponent(user_doc_id)}/pets/${encodeURIComponent(pet_doc_id)}`)
            return await resp.json() as PetResponse
        }

        /**
         * Get pet Practice
         * This endpoint retrieves pet's data if the pet exists.
         */
        public async GetPetPractice(pet_doc_id: string): Promise<PetPracticeResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/petsinternal/${encodeURIComponent(pet_doc_id)}/practice`)
            return await resp.json() as PetPracticeResponse
        }

        /**
         * Get Practice
         * This endpoint retrieves a practice.
         */
        public async GetPractice(id: string): Promise<PetPracticeResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/practices/${encodeURIComponent(id)}`)
            return await resp.json() as PetPracticeResponse
        }

        /**
         * Get Subscription Group
         * GetSubscriptionGroups retrieves  existing user preferences subscription group by doc_id
         */
        public async GetSubscriptionGroup(doc_id: string): Promise<SubscriptionGroup> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/user-preferences/subscription-group/${encodeURIComponent(doc_id)}`)
            return await resp.json() as SubscriptionGroup
        }

        /**
         * Get Temporary User
         * This endpoint gets existing temporary user by doc_id.
         */
        public async GetTemporaryUser(doc_id: string): Promise<TempUserResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/temporary-users/${encodeURIComponent(doc_id)}`)
            return await resp.json() as TempUserResponse
        }

        /**
         * Fetches a user
         * Fetches a user with the given id
         */
        public async GetUser(userDocID: string): Promise<UserResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/usersinternal/${encodeURIComponent(userDocID)}`)
            return await resp.json() as UserResponse
        }

        /**
         * GetUsersByCustomerNumber lists Joii users holding the given insurance customer number.
         */
        public async GetUsersByCustomerNumber(params: GetUsersByCustomerNumberRequest): Promise<GetUsersByCustomerNumberResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "customer_number": params.CustomerNumber,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/users-by-customer-number`, undefined, {query})
            return await resp.json() as GetUsersByCustomerNumberResponse
        }

        /**
         * Get webhook for business
         */
        public async GetWebhook(businessId: string, id: string): Promise<entities.WebhookResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/businesses/${encodeURIComponent(businessId)}/webhooks/${encodeURIComponent(id)}`)
            return await resp.json() as entities.WebhookResponse
        }

        /**
         * Get webhook event
         */
        public async GetWebhookEvent(id: string): Promise<entities.WebhookEventResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/webhookevents/${encodeURIComponent(id)}`)
            return await resp.json() as entities.WebhookEventResponse
        }

        /**
         * Map To User
         * This endpoint maps a temporary user to existing one.
         */
        public async LinkTemporaryUserToExistingUser(doc_id: string, params: LinkToUserRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PATCH", `/v1/temporary-users/${encodeURIComponent(doc_id)}/link`, JSON.stringify(params))
        }

        /**
         * List API Key
         * This endpoint returns a list of api keys for given **business_doc_id**.
         */
        public async ListAPIKeys(business_doc_id: string): Promise<ListAPIKeyResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/business/${encodeURIComponent(business_doc_id)}/api-keys`)
            return await resp.json() as ListAPIKeyResponse
        }

        /**
         * Lists all businesses by name
         */
        public async ListBusinesses(params: entities.ListBusinessesRequest): Promise<entities.ListBusinessesResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "items_per_page": String(params.RequestedItemsPerPage),
                name:             params.Name,
                "page_number":    String(params.RequestedPageNumber),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/businesses`, undefined, {query})
            return await resp.json() as entities.ListBusinessesResponse
        }

        /**
         * Lists all businesses with partner integration
         */
        public async ListBusinessesWithPartnerIntegration(): Promise<entities.ListBusinessesWithNoPaginationResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/business/partners`)
            return await resp.json() as entities.ListBusinessesWithNoPaginationResponse
        }

        /**
         * List Countries
         * This endpoint returns list of valid countries
         */
        public async ListCountries(): Promise<CountryResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/internal/countries`)
            return await resp.json() as CountryResponse
        }

        /**
         * ListDemoUsers lists a page of the users in the DEMO tenant, newest first, with their pets.
         */
        public async ListDemoUsers(params: ListDemoUsersRequest): Promise<ListDemoUsersResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                page: params.Page === undefined ? undefined : String(params.Page),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/demo/users`, undefined, {query})
            return await resp.json() as ListDemoUsersResponse
        }

        /**
         * ListEntitlementTypes lists all entitlement types
         */
        public async ListEntitlementTypes(): Promise<ListEntitlementTypesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/internal/entitlement-types`)
            return await resp.json() as ListEntitlementTypesResponse
        }

        /**
         * ListGrants lists grants with pagination, filters, and search
         */
        public async ListGrants(params: ListGrantsRequest): Promise<ListGrantsResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                active:           params.Active,
                "entity_type":    params.EntityType,
                "items_per_page": String(params.RequestedItemsPerPage),
                "page_number":    String(params.RequestedPageNumber),
                search:           params.Search,
                "source_type":    params.SourceType,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/internal/grants`, undefined, {query})
            return await resp.json() as ListGrantsResponse
        }

        /**
         * ListKnownEntitlementTypeCodes returns the allowed entitlement type codes for create/edit forms.
         * Only these codes may be used when creating or updating entitlement types.
         */
        public async ListKnownEntitlementTypeCodes(): Promise<ListKnownEntitlementTypeCodesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/internal/entitlement-type-codes`)
            return await resp.json() as ListKnownEntitlementTypeCodesResponse
        }

        /**
         * ListPackageTemplateEntitlements lists entitlements for a package template
         */
        public async ListPackageTemplateEntitlements(docID: string): Promise<ListPackageTemplateEntitlementsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/internal/package-templates/${encodeURIComponent(docID)}/entitlements`)
            return await resp.json() as ListPackageTemplateEntitlementsResponse
        }

        /**
         * ListPackageTemplates lists all package templates
         */
        public async ListPackageTemplates(params: ListPackageTemplatesRequest): Promise<ListPackageTemplatesResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "source_type": params.SourceType,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/internal/package-templates`, undefined, {query})
            return await resp.json() as ListPackageTemplatesResponse
        }

        /**
         * List Pets
         * This endpoint returns a list of all pets for the requested **user_doc_id**.
         */
        public async ListPets(user_doc_id: string): Promise<ListPetsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/usersinternal/${encodeURIComponent(user_doc_id)}/pets`)
            return await resp.json() as ListPetsResponse
        }

        /**
         * List Practices
         * This endpoint retrieves all practices.
         */
        public async ListPractices(params: ListPracticeRequest): Promise<ListPracticeResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "items_per_page": String(params.RequestedItemsPerPage),
                name:             params.Name,
                "page_number":    String(params.RequestedPageNumber),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/practices`, undefined, {query})
            return await resp.json() as ListPracticeResponse
        }

        /**
         * List Subscription Group
         * ListSubscriptionGroups retrieves all existing user preferences subscription groups
         */
        public async ListSubscriptionGroups(): Promise<ListSubscriptionGroupsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/user-preferences/subscription-group`)
            return await resp.json() as ListSubscriptionGroupsResponse
        }

        /**
         * Lists addresses for user
         */
        public async ListUserAddresses(user_doc_id: string): Promise<ListUserAddressesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/usersinternal/${encodeURIComponent(user_doc_id)}/addresses`)
            return await resp.json() as ListUserAddressesResponse
        }

        /**
         * Lists users
         * Lists users with pagination support.
         * Staff (user_admin) see all users. API keys see only users in their business.
         */
        public async ListUsers(params: ListUsersRequest): Promise<ListUsersResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                email:            params.Email,
                "items_per_page": String(params.RequestedItemsPerPage),
                name:             params.Name,
                "page_number":    String(params.RequestedPageNumber),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/users`, undefined, {query})
            return await resp.json() as ListUsersResponse
        }

        /**
         * List webhooks and events for business
         */
        public async ListWebhookEventMapping(businessId: string, webhookId: string): Promise<entities.ListWebhookEventsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/businesses/${encodeURIComponent(businessId)}/webhooks/${encodeURIComponent(webhookId)}/events`)
            return await resp.json() as entities.ListWebhookEventsResponse
        }

        /**
         * List webhook events
         */
        public async ListWebhookEvents(): Promise<entities.ListWebhookEventsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/webhookevents`)
            return await resp.json() as entities.ListWebhookEventsResponse
        }

        /**
         * List webhooks
         */
        public async ListWebhooks(businessId: string): Promise<entities.ListWebhookResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/businesses/${encodeURIComponent(businessId)}/webhooks`)
            return await resp.json() as entities.ListWebhookResponse
        }

        /**
         * NotifyAFIOfRegistration
         * This endpoint notifies Animal Friends whenever one of their clients registers with us
         * It publishes the notification to a topic for async processing with automatic retries
         */
        public async NotifyAFIOfRegistration(method: "POST", body?: RequestInit["body"], options?: CallParameters): Promise<globalThis.Response> {
            return this.baseClient.callAPI(method, `/v1/notify-registration/afi`, body, options)
        }

        /**
         * PatchPet
         * This endpoint patches a given pet with any of the optional parameters that are set.
         * It supports unsetting breed or neutered by setting them as a blank string.
         * Gender accepts Female, Male, or Unknown as usual.
         */
        public async PatchPet(petDocID: string, params: entities.PatchPet): Promise<void> {
            await this.baseClient.callTypedAPI("PATCH", `/v1/petsinternal/${encodeURIComponent(petDocID)}`, JSON.stringify(params))
        }

        /**
         * RemovePackageTemplateEntitlement removes a single entitlement type from a package template.
         * Returns NotFound if the package template does not have that entitlement.
         */
        public async RemovePackageTemplateEntitlement(docID: string, entitlementTypeDocID: string): Promise<ListPackageTemplateEntitlementsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("DELETE", `/internal/package-templates/${encodeURIComponent(docID)}/entitlements/${encodeURIComponent(entitlementTypeDocID)}`)
            return await resp.json() as ListPackageTemplateEntitlementsResponse
        }

        /**
         * ResetUserPassword sets a new one-time temporary password on the user (in the auth
         * provider) and returns it for the agent to relay. The password is not stored.
         */
        public async ResetUserPassword(userDocID: string): Promise<ResetUserPasswordResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("PUT", `/v1/usersinternal/${encodeURIComponent(userDocID)}/password`)
            return await resp.json() as ResetUserPasswordResponse
        }

        /**
         * Search Pets
         * This endpoint returns a list of pets that meets the search term
         */
        public async SearchPets(params: SearchPetsRequestPaginated): Promise<SearchPetsResponsePaginated> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "include_deleted": String(params.IncludeDeleted),
                "items_per_page":  String(params.RequestedItemsPerPage),
                "page_number":     String(params.RequestedPageNumber),
                "search_term":     params.SearchTerm,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/pets/search`, undefined, {query})
            return await resp.json() as SearchPetsResponsePaginated
        }

        /**
         * SetPackageTemplateEntitlements sets the entitlements for a package template.
         * Request must not contain the same entitlement type more than once.
         */
        public async SetPackageTemplateEntitlements(docID: string, params: SetPackageTemplateEntitlementsRequest): Promise<ListPackageTemplateEntitlementsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("PUT", `/internal/package-templates/${encodeURIComponent(docID)}/entitlements`, JSON.stringify(params))
            return await resp.json() as ListPackageTemplateEntitlementsResponse
        }

        /**
         * Sign URL
         */
        public async SignURL(params: SignUrlRequest): Promise<SignUrlResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                urls: params.URLS.map((v) => v),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/sign-url`, undefined, {query})
            return await resp.json() as SignUrlResponse
        }

        /**
         * Update API Key
         * This endpoint updates api key name and role based permissions.
         */
        public async UpdateAPIKey(api_key_doc_id: string, params: UpdateApiKeysRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PUT", `/api-key/${encodeURIComponent(api_key_doc_id)}`, JSON.stringify(params))
        }

        /**
         * Update Address
         * This endpoint updates an existing address with the provided body parameter values.
         */
        public async UpdateAddress(user_doc_id: string, params: UpdateAddressRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PUT", `/v1/usersinternal/${encodeURIComponent(user_doc_id)}/address`, JSON.stringify(params))
        }

        /**
         * UpdateBusiness updates an existing business.
         */
        public async UpdateBusiness(params: entities.UpdateBusinessRequest): Promise<entities.BusinessResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("PUT", `/v1/business`, JSON.stringify(params))
            return await resp.json() as entities.BusinessResponse
        }

        /**
         * UpdateEntitlementType updates an existing entitlement type.
         * Only known entitlement type codes are allowed.
         */
        public async UpdateEntitlementType(docID: string, params: UpdateEntitlementTypeRequest): Promise<EntitlementTypeResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("PUT", `/internal/entitlement-types/${encodeURIComponent(docID)}`, JSON.stringify(params))
            return await resp.json() as EntitlementTypeResponse
        }

        /**
         * UpdatePackageTemplate updates an existing package template
         */
        public async UpdatePackageTemplate(docID: string, params: UpdatePackageTemplateRequest): Promise<PackageTemplateResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("PUT", `/internal/package-templates/${encodeURIComponent(docID)}`, JSON.stringify(params))
            return await resp.json() as PackageTemplateResponse
        }

        /**
         * Update Pet deletion reason by ID
         * This endpoint takes an ID of a pet deletion reason, and allows you to edit the name of the reason
         */
        public async UpdatePetDeletionReason(id: string, params: UpdatePetDeletionRequest): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/v1/petdeletionreason/${encodeURIComponent(id)}`, JSON.stringify(params))
        }

        /**
         * Get Pet Practice
         * This endpoint retrieves pet's data if the pet exists.
         */
        public async UpdatePetPractice(pet_doc_id: string, params: PetPracticeRequest): Promise<PetPracticeResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/petsinternal/${encodeURIComponent(pet_doc_id)}/practice`, JSON.stringify(params))
            return await resp.json() as PetPracticeResponse
        }

        /**
         * Update Practice
         * This endpoint lets you update a practice
         */
        public async UpdatePractice(id: number, params: UpdatePracticeRequest): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/v1/practices/${encodeURIComponent(id)}`, JSON.stringify(params))
        }

        /**
         * Update Subscription Group
         * UpdateSubscriptionGroup updates existing user preferences subscription group
         */
        public async UpdateSubscriptionGroup(doc_id: string, params: UpdateSubscriptionGroupRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PUT", `/v1/user-preferences/subscription-group/${encodeURIComponent(doc_id)}`, JSON.stringify(params))
        }

        /**
         * UpdateUser given a user id, it updates the user
         * Updates a user with a given ID
         */
        public async UpdateUser(userDocID: string, params: UpdateUserRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PUT", `/v1/usersinternal/${encodeURIComponent(userDocID)}`, JSON.stringify(params))
        }

        /**
         * UpdateUserCustomerNumber sets a user's insurance customer number, after verifying it
         * resolves at the insurer and isn't already used by another account.
         */
        public async UpdateUserCustomerNumber(userDocID: string, params: UpdateUserCustomerNumberRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PUT", `/v1/usersinternal/${encodeURIComponent(userDocID)}/customer-number`, JSON.stringify(params))
        }

        /**
         * UpdateUserEmail updates only the email address of a user
         */
        public async UpdateUserEmail(userDocID: string, params: UpdateUserEmailRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PUT", `/v1/usersinternal/${encodeURIComponent(userDocID)}/email`, JSON.stringify(params))
        }

        /**
         * Update webhook for business
         */
        public async UpdateWebhook(businessId: string, id: string, params: entities.WebhookRequest): Promise<entities.WebhookResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("PUT", `/v1/businesses/${encodeURIComponent(businessId)}/webhooks/${encodeURIComponent(id)}`, JSON.stringify(params))
            return await resp.json() as entities.WebhookResponse
        }

        /**
         * Update webhook event
         */
        public async UpdateWebhookEvent(id: string, params: entities.WebhookEventRequest): Promise<entities.WebhookEventResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("PUT", `/v1/webhookevents/${encodeURIComponent(id)}`, JSON.stringify(params))
            return await resp.json() as entities.WebhookEventResponse
        }

        /**
         * ValidateCallInsurance verifies whether a caller has valid insurance information.
         * 
         * This endpoint performs a multi-step validation process for an active or incoming call:
         *  1. Checks if the user associated with the call already exists in the system.
         *  2. If no user record is found, queries the external insurance system to determine
         *     whether the user's insurance data exists.
         *  3. If matching insurance data is found, automatically creates a corresponding
         *     user and pet profile within the system.
         * 
         * Returns the created or existing user and pet details if validation succeeds.
         */
        public async ValidateCallInsurance(params: ValidateCallInsuranceRequest): Promise<ValidateCallInsuranceResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/calls/validate-insurance`, JSON.stringify(params))
            return await resp.json() as ValidateCallInsuranceResponse
        }

        /**
         * VerifyUserEmail marks a user's email as verified with the auth provider (Firebase),
         * without them completing Firebase's own verification-link flow. Intended for support
         * cases where ownership of the account has already been confirmed through another channel.
         */
        public async VerifyUserEmail(userDocID: string): Promise<void> {
            await this.baseClient.callTypedAPI("PUT", `/v1/usersinternal/${encodeURIComponent(userDocID)}/verify-email`)
        }
    }
}

export namespace bookingexternal {
    /**
     * BookingScreenPageViewRequest contains parameters for tracking a page view.
     */
    export interface BookingScreenPageViewRequest {
        /**
         * PetDocID
         * The **doc_id** of the pet in **UUID** format.
         */
        "pet_doc_id": string
    }

    /**
     * ChatAvailabilityRequest contains parameters for checking chat availability.
     */
    export interface ChatAvailabilityRequest {
        /**
         * ChatServiceID
         * The **doc_id** of the chat service in **UUID** format.
         */
        ChatServiceID: string
    }

    /**
     * ChatAvailabilityResponse contains chat availability information.
     */
    export interface ChatAvailabilityResponse {
        /**
         * Available
         * Indicates if chat is currently available.
         */
        available: boolean

        /**
         * Busy
         * Indicates if the chat service is busy.
         */
        busy: boolean

        /**
         * NextChatAvailableInMinutes
         * Estimated minutes until the next available chat slot.
         */
        "next_chat_available_in_minutes": number
    }

    /**
     * CreateAppointmentPhotoRequest contains the photo URL to add to an appointment.
     */
    export interface CreateAppointmentPhotoRequest {
        /**
         * PhotoURL
         * The photo path in the format **folder_name/file_name.png**.
         * Supported extensions: **.jpg**, **.jpeg**, **.png**, **.gif**, **.bmp**, **.svg**, **.tif**, **.tiff**, **.webp**, **.heic**.
         */
        "photo_url": string
    }

    /**
     * CreateAppointmentRequest contains the parameters for creating a new appointment.
     */
    export interface CreateAppointmentRequest {
        /**
         * AvailabilityID
         * The **doc_id** of an available slot for booking in **UUID** format.
         */
        "availability_doc_id": string

        /**
         * PetID
         * The **doc_id** of the pet for the appointment in **UUID** format.
         */
        "pet_doc_id": string

        /**
         * SCSessionID
         * The **doc_id** of the symptom checker session in **UUID** format (optional).
         * Only provided when booking through the Symptom Checker flow.
         */
        "sc_session_id"?: string

        /**
         * OnDemand
         * Indicates if this is an on-demand appointment.
         */
        "on_demand"?: boolean

        /**
         * PreviousChatDocID
         * The **doc_id** of a preceding chat to link to this appointment in **UUID** format (optional).
         */
        "previous_chat_doc_id"?: string

        /**
         * ParticipantStepDocID
         * The **doc_id** of the trial participant step when booking from a Studies Consultation step (optional).
         * When set, the appointment is linked for staff to open a trial consultation from the call.
         */
        "participant_step_doc_id"?: string
    }

    /**
     * CreateAppointmentResponse contains the details of a newly created appointment.
     */
    export interface CreateAppointmentResponse {
        /**
         * DocId
         * The **doc_id** of the new appointment in **UUID** format.
         */
        "doc_id": string

        /**
         * CreatedAt
         * The timestamp when the appointment was created in **RFC3339** format.
         */
        "created_at": string
    }

    /**
     * CreateChatRequest contains parameters for creating a new chat.
     */
    export interface CreateChatRequest {
        /**
         * ChatServiceID
         * The **doc_id** of the chat service in **UUID** format.
         */
        "chat_service_id": string

        /**
         * PetDocID
         * The **doc_id** of the pet in **UUID** format.
         */
        "pet_doc_id": string

        /**
         * TimeZone
         * Timezone in **IANA** format (e.g. **Europe/London**, **UTC**).
         */
        timezone: string

        /**
         * Status
         * Initial chat status (optional). Valid values: **curious**, **llm-chat-triage**, **llm-call-triage**. Defaults to **curious**.
         */
        status?: string

        /**
         * SCSessionDocID
         * The **doc_id** of the symptom checker session in **UUID** format (optional).
         */
        "sc_session_doc_id"?: string

        /**
         * IsWhatsapp
         * Whether this is a WhatsApp chat (internal use).
         */
        "_"?: boolean

        /**
         * WhatsappExternalID
         * ID for WhatsApp chats (optional).
         * Lines up with WhatsappChatUser.ExternalID
         * Previously PhoneNumber, json of phone_number remains the same to prevent a breaking change on the API.
         */
        "phone_number"?: string

        /**
         * CurrentLocationUSStateShortCode
         * This represents the US State that the user is currently in at the time they start the chat
         * It will be used for EVCPR rules in relation to the vets location.
         * ignored if the server location is not in the US
         * must be a valid ISO3166 US state shortcode
         */
        "current_location_us_state_shortcode"?: string

        /**
         * IsFollowup
         * Whether this chat is a follow-up to a previous consultation (optional).
         */
        "is_followup"?: boolean
    }

    /**
     * CreateChatRequestV2 contains parameters for creating a new chat.
     */
    export interface CreateChatRequestV2 {
        /**
         * ChatServiceID
         * The **doc_id** of the chat service in **UUID** format.
         */
        "chat_service_id": string

        /**
         * PetDocID
         * The **doc_id** of the pet in **UUID** format.
         */
        "pet_doc_id": string

        /**
         * TimeZone
         * Timezone in **IANA** format (e.g. **Europe/London**, **UTC**).
         */
        timezone: string

        /**
         * Status
         * Initial chat status (optional). Valid values: **curious**, **llm-chat-triage**, **llm-call-triage**. Defaults to **curious**.
         */
        status?: string

        /**
         * SCSessionDocID
         * The **doc_id** of the symptom checker session in **UUID** format (optional).
         */
        "sc_session_doc_id"?: string

        /**
         * IsWhatsapp
         * Whether this is a WhatsApp chat (internal use).
         */
        "_"?: boolean

        /**
         * WhatsappExternalID
         * ID for WhatsApp chats (optional).
         * Lines up with WhatsappChatUser.ExternalID
         */
        "whats_app_external_id"?: string

        /**
         * PhoneNumber
         * The phone number associated with the chat (optional).
         */
        "phone_number"?: string

        /**
         * CurrentLocationUSStateShortCode
         * This represents the US State that the user is currently in at the time they start the chat
         * It will be used for EVCPR rules in relation to the vets location.
         * ignored if the server location is not in the US
         * must be a valid ISO3166 US state shortcode
         */
        "current_location_us_state_shortcode"?: string

        /**
         * IsFollowup
         * Whether this chat is a follow-up to a previous consultation (optional).
         */
        "is_followup"?: boolean
    }

    /**
     * CreateChatResponse contains the details of a newly created chat.
     */
    export interface CreateChatResponse {
        /**
         * DocID
         * The **doc_id** of the new chat in **UUID** format.
         */
        "doc_id": string

        /**
         * ChannelID
         * The channel identifier for the chat room.
         */
        "channel_id": string

        /**
         * ChatVideoRoomDocID
         * The **doc_id** of the video room in **UUID** format.
         */
        "chat_video_room_doc_id": string

        /**
         * Token
         * User's authentication token for the chat service.
         */
        token: string
    }

    /**
     * CreateOnDemandAppointmentRequest contains parameters for creating an on-demand appointment.
     */
    export interface CreateOnDemandAppointmentRequest {
        /**
         * ServiceDocID
         * The **doc_id** of the service for the appointment in **UUID** format.
         */
        "sevice_doc_id": string

        /**
         * PetID
         * The **doc_id** of the pet for the appointment in **UUID** format.
         */
        "pet_doc_id": string

        /**
         * SCSessionID
         * The **doc_id** of the symptom checker session in **UUID** format (optional).
         * Only provided when booking through the Symptom Checker flow.
         */
        "sc_session_id"?: string

        /**
         * TimeZone
         * The timezone in **IANA** format (e.g. **Europe/London**, **UTC**).
         */
        timezone: string

        /**
         * PreviousChatDocID
         * The **doc_id** of a preceding chat to link to this appointment in **UUID** format (optional).
         */
        "previous_chat_doc_id"?: string
    }

    /**
     * CreateWhatsappChatRequest contains parameters for starting a WhatsApp chat.
     */
    export interface CreateWhatsappChatRequest {
        /**
         * ChatServiceID
         * The **doc_id** of the chat service in **UUID** format.
         */
        "chat_service_id": string

        /**
         * PetDocID
         * The **doc_id** of the pet in **UUID** format.
         */
        "pet_doc_id": string

        /**
         * PetName
         * The name of the pet.
         */
        "pet_name": string

        /**
         * TimeZone
         * Timezone in **IANA** format (e.g. **Europe/London**, **UTC**).
         */
        timezone: string

        /**
         * WhatsAppUserDocID
         * The **doc_id** of the WhatsApp user in **UUID** format.
         */
        "whatsapp_user_doc_id": string
    }

    /**
     * GetAppointmentPhotoResponse contains the details of an appointment photo.
     */
    export interface GetAppointmentPhotoResponse {
        /**
         * DocId
         * The **doc_id** of the photo in **UUID** format.
         */
        "doc_id": string

        /**
         * PhotoURL
         * Signed URL for retrieving the photo. Valid for one hour.
         */
        "photo_url": string
    }

    /**
     * GetAppointmentResponse contains the details of an appointment.
     */
    export interface GetAppointmentResponse {
        /**
         * DocId
         * The **doc_id** of the appointment in **UUID** format.
         */
        "doc_id": string

        /**
         * Start
         * The scheduled start time of the appointment.
         */
        start: utilities.Dates

        /**
         * End
         * The scheduled end time of the appointment.
         */
        end: utilities.Dates

        /**
         * ActualStart
         * The actual start time of the appointment (optional).
         */
        "actual_start"?: utilities.Dates

        /**
         * ActualEnd
         * The actual end time of the appointment (optional).
         */
        "actual_end"?: utilities.Dates

        /**
         * Status
         * Current status of the appointment.
         * Valid values: **Reserved**, **PaymentRequired**, **Booked**, **Waiting**, **Abandoned**, **Cancelled**, **DidNotAttend**.
         */
        status: string

        /**
         * ConsultStatus
         * Current consultation status.
         * Valid values: **Ready**, **InProgress**, **Complete**, **Disrupted**.
         */
        "consult_status"?: string

        /**
         * DisruptedReason
         * The reason the consultation was disrupted. Only present when ConsultStatus is **Disrupted**.
         */
        "disrupted_reason"?: string

        /**
         * PetDocID
         * The **doc_id** of the pet in **UUID** format.
         */
        "pet_id": string

        /**
         * PreviousChatDocID
         * The **doc_id** of the preceding chat in **UUID** format (optional).
         */
        "previous_chat_doc_id"?: string

        /**
         * PreviousAppointmentDocID
         * The **doc_id** of the previous appointment in **UUID** format (optional).
         */
        "previous_appointment_doc_id"?: string

        /**
         * StaffProfileName
         * The name of the staff member for the consultation.
         */
        "staff_profile_name"?: string

        /**
         * StaffProfileDescription
         * The description of the staff member.
         */
        "staff_profile_description"?: string

        /**
         * StaffProfilePhotoUrl
         * The photo URL of the staff member. Valid for one hour.
         */
        "staff_profile_photo_url"?: string

        /**
         * ServiceName
         * The name of the service (e.g. **Vet**).
         */
        "service_name": string

        /**
         * RoomID
         * The ID of the virtual waiting room for the consultation.
         */
        "room_id"?: string

        /**
         * SessionID
         * The session ID for the video call.
         */
        "session_id"?: string

        /**
         * PaymentLink
         * URL for payment. Only present for uninsured users with payment required.
         */
        "payment_link"?: string

        /**
         * PaymentStatus
         * Payment status. Valid values: **Paid**, **Unpaid**.
         */
        "payment_status"?: string

        /**
         * CanStartWaiting
         * Indicates if the user can join the waiting room.
         */
        "can_start_waiting"?: boolean

        /**
         * WaitTime
         * Estimated wait time in minutes before the consultation starts.
         */
        "wait_time"?: number

        /**
         * CanStartWaitingBefore
         * Time in minutes until the user can enter the waiting room.
         */
        "can_start_waiting_before"?: number

        /**
         * WaitingRoomPollingIntervalInMilliSeconds
         * Suggested polling interval in milliseconds for waiting room status updates.
         */
        "waiting_room_polling_interval_in_milliseconds": number

        /**
         * WaitingRoomFetchAppointmentIntervalInMilliSeconds
         * Suggested interval in milliseconds for fetching appointment updates.
         */
        "waiting_room_fetch_appointment_interval_in_milliseconds": number

        /**
         * Total
         * Total price of the appointment.
         */
        total?: string

        /**
         * SubTotal
         * Subtotal before discounts and tax.
         */
        "sub_total"?: string

        /**
         * Discount
         * Discount amount applied.
         */
        discount?: string

        /**
         * Tax
         * Tax amount.
         */
        tax?: string

        /**
         * RefundedAmount
         * Amount refunded (if applicable).
         */
        "refunded_amount"?: string

        /**
         * TreatmentPlanReady
         * Indicates if the treatment plan is available.
         */
        "treatment_plan_ready": boolean

        /**
         * ServiceDocID
         * The **doc_id** of the service in **UUID** format.
         */
        "service_doc_id": string

        /**
         * VideoProvider
         * The video streaming provider.
         */
        "video_stream_provider"?: string
    }

    /**
     * GetChatResponse contains the details of a chat session.
     */
    export interface GetChatResponse {
        /**
         * DocID
         * The **doc_id** of the chat in **UUID** format.
         */
        "doc_id": string

        /**
         * ChannelID
         * The channel identifier for the chat room.
         */
        "channel_id": string

        /**
         * Status
         * Current status of the chat.
         */
        status: string

        /**
         * StatusHistory
         * History of status changes (optional).
         */
        "status_history"?: string[]

        /**
         * PetDocID
         * The **doc_id** of the pet in **UUID** format.
         */
        "pet_doc_id": string

        /**
         * ChatVideoRoom
         * Video room details (optional).
         */
        "chat_video_room"?: entities.ChatVideoRoom

        /**
         * SymptomCheckerSessionDocID
         * The **doc_id** of the linked symptom checker session in **UUID** format (optional).
         */
        "symptom_checker_session_doc_id"?: string

        /**
         * PaymentLink
         * URL for payment (optional).
         */
        "payment_link"?: string

        /**
         * PaymentStatus
         * Payment status (optional).
         */
        "payment_status"?: string

        /**
         * IsWhatsapp
         * Indicates if this is a WhatsApp chat (optional).
         */
        "is_whatsapp"?: boolean

        /**
         * TrialDocID
         * The **doc_id** of the trial when the chat was created in a trial context (optional).
         */
        "trial_doc_id"?: string

        /**
         * ConsultStatus
         * Consultation workflow status when applicable (e.g. **Complete**, **InProgress**).
         */
        "consult_status"?: string

        /**
         * CreatedAt
         * When the chat session was created (RFC3339).
         */
        "created_at"?: string
    }

    /**
     * GetChatServiceResponseWithPrice contains chat service details with pricing.
     */
    export interface GetChatServiceResponseWithPrice {
        /**
         * DocID
         * The **doc_id** of the chat service in **UUID** format.
         */
        "doc_id": string

        /**
         * Name
         * The name of the chat service.
         */
        name: string

        /**
         * Description
         * The description of the chat service.
         */
        description: string

        /**
         * Price
         * The price of the chat service in minor units.
         */
        price: number

        /**
         * Currency
         * The currency code (e.g. **GBP**).
         */
        currency: string

        /**
         * Included
         * True when covered by the user's entitlement (no purchase required).
         */
        included: boolean
    }

    /**
     * GetServiceWithPriceResponse contains service details with pricing.
     */
    export interface GetServiceWithPriceResponse {
        /**
         * DocId
         * The **doc_id** of the service in **UUID** format.
         */
        "doc_id": string

        /**
         * Name
         * The name of the service.
         */
        name: string

        /**
         * Description
         * The description of the service.
         */
        description: string

        /**
         * Price
         * The price of the service in minor units.
         */
        price: number

        /**
         * Currency
         * The currency code (e.g. **GBP**).
         */
        currency: string

        /**
         * Included
         * True when covered by the user's entitlement (no purchase required).
         */
        included: boolean

        /**
         * SkipScreening
         * Trial users are not required to add notes or photos before booking.
         */
        "skip_screening": boolean

        /**
         * PreventDoubleBookings
         * Prevents double bookings for this service.
         */
        "prevent_double_bookings": boolean

        /**
         * IsTrialService
         * Indicates if this is a trial service.
         */
        "is_trial_service": boolean

        /**
         * UserBookable
         * Indicates if the user can book this service.
         */
        "user_bookable": boolean
    }

    /**
     * GetTokenResponse contains the user's chat service token.
     */
    export interface GetTokenResponse {
        /**
         * Token
         * Authentication token for the chat service.
         */
        token: string
    }

    /**
     * ListAppointmentPhotosResponse contains a list of appointment photos.
     */
    export interface ListAppointmentPhotosResponse {
        /**
         * Photos
         * List of appointment photos.
         */
        "photo_urls": GetAppointmentPhotoResponse[]
    }

    /**
     * ListAppointmentsRequest contains parameters for listing appointments.
     */
    export interface ListAppointmentsRequest {
        /**
         * Desc
         * Sort results in descending order when true.
         */
        Desc: boolean

        /**
         * ExcludeAppointmentsInConsultationStates
         * Exclude appointments with these consultation statuses.
         */
        ExcludeAppointmentsInConsultationStates?: string[]

        /**
         * RequestedItemsPerPage
         * Number of results per page (1-100).
         */
        RequestedItemsPerPage: number

        /**
         * RequestedPageNumber
         * The page number to retrieve (minimum 1).
         */
        RequestedPageNumber: number
    }

    /**
     * ListAppointmentsResponse contains a paginated list of appointments.
     */
    export interface ListAppointmentsResponse {
        /**
         * Appointments
         * The list of appointments.
         */
        appointments: GetAppointmentResponse[]

        /**
         * Pagination
         * Pagination metadata.
         */
        pagination: Pagination
    }

    /**
     * ListAvailabileDaysQueryParams contains parameters for listing available days.
     */
    export interface ListAvailabileDaysQueryParams {
        /**
         * ServiceID
         * The **doc_id** of the service in **UUID** format.
         */
        ServiceID: string

        /**
         * Timezone
         * Timezone in **IANA** format (e.g. **Europe/London**, **UTC**).
         */
        Timezone: string

        /**
         * StartDate
         * Start date in local time format (e.g. **2017-09-04T04:00:00**).
         */
        StartDate: string

        /**
         * EndDate
         * End date in local time format (e.g. **2017-09-04T04:00:00**).
         */
        EndDate: string
    }

    /**
     * ListAvailabilityQueryParams contains parameters for listing available appointment slots.
     */
    export interface ListAvailabilityQueryParams {
        /**
         * StartDate
         * Start date in local time format (e.g. **2017-09-04T04:00:00**).
         */
        StartDate: string

        /**
         * EndDate
         * End date in local time format (e.g. **2017-09-04T04:00:00**).
         */
        EndDate: string

        /**
         * ServiceDocID
         * The **doc_id** of the service in **UUID** format.
         */
        ServiceDocID: string

        /**
         * Timezone
         * Timezone in **IANA** format (e.g. **Europe/London**, **UTC**).
         */
        Timezone: string

        /**
         * AllowPast
         * Allow looking for availabilities in the past (only permitted in certain environments).
         */
        AllowPast: boolean
    }

    /**
     * ListAvailabilityResponse contains a list of available appointment slots.
     */
    export interface ListAvailabilityResponse {
        /**
         * Slots
         * Available appointment slots.
         */
        slots: ListAvailabilitySlotItem[]
    }

    /**
     * ListAvailabilitySlotItem represents an available appointment slot.
     */
    export interface ListAvailabilitySlotItem {
        /**
         * DocId
         * The **doc_id** of the available slot in **UUID** format.
         */
        "doc_id": string

        /**
         * StaffProfileName
         * The name of the available staff member.
         */
        "staff_profile_name": string

        /**
         * StaffProfileDocID
         * The **doc_id** of the staff profile in **UUID** format.
         */
        "staff_profile_doc_id": string

        /**
         * StaffProfileDescription
         * Public biography or role text for the staff member.
         */
        "staff_profile_description"?: string

        /**
         * StaffProfilePhotoURL
         * Signed URL for the staff profile photo, when configured.
         */
        "staff_profile_photo_url"?: string

        /**
         * ServiceID
         * The **doc_id** of the service in **UUID** format.
         */
        "service_id": string

        /**
         * Start
         * The start time of the slot.
         */
        start: utilities.Dates

        /**
         * End
         * The end time of the slot.
         */
        end: utilities.Dates

        /**
         * Duration
         * Duration of the appointment in minutes.
         */
        duration: number
    }

    /**
     * ListAvailableDaysItem represents a day with availability information.
     */
    export interface ListAvailableDaysItem {
        /**
         * Day
         * Day of the week (e.g. **Monday**, **Tuesday**).
         */
        day: string

        /**
         * DateFrom
         * Start of the day in local time format.
         */
        "date_from": string

        /**
         * DateTo
         * End of the day in local time format.
         */
        "date_to": string

        /**
         * SlotsAvailable
         * Indicates if slots are available on this day.
         */
        "slots_available": boolean
    }

    /**
     * ListAvailableDaysResponse contains a list of days with availability.
     */
    export interface ListAvailableDaysResponse {
        /**
         * Days
         * List of days with availability information.
         */
        days: ListAvailableDaysItem[]
    }

    /**
     * ListChatsResponse contains a list of chat sessions.
     */
    export interface ListChatsResponse {
        /**
         * Chats
         * List of chat sessions.
         */
        chats: GetChatResponse[]
    }

    /**
     * ListOnDemandQueryParams contains parameters for listing on-demand availability.
     */
    export interface ListOnDemandQueryParams {
        /**
         * ServiceDocID
         * The **doc_id** of the service in **UUID** format.
         */
        ServiceDocID: string

        /**
         * Timezone
         * Timezone in **IANA** format (e.g. **Europe/London**, **UTC**).
         */
        Timezone: string
    }

    /**
     * ListServicesResponse contains a list of available services.
     */
    export interface ListServicesResponse {
        /**
         * Services
         * List of available services.
         */
        services: GetServiceWithPriceResponse[]
    }

    /**
     * Pagination contains pagination metadata for list responses.
     */
    export interface Pagination {
        /**
         * Total
         * Total count of items.
         */
        total: number

        /**
         * CurrentPage
         * The current page number.
         */
        "current_page": number

        /**
         * Pages
         * Total number of pages.
         */
        pages: number
    }

    /**
     * PatchAppointmentNotesRequest contains the notes to add to an appointment.
     */
    export interface PatchAppointmentNotesRequest {
        /**
         * Notes
         * Notes for the consultant to review during the consultation.
         */
        notes: string
    }

    /**
     * PatchAppointmentTypeformEventIDRequest contains the Typeform event ID to link.
     */
    export interface PatchAppointmentTypeformEventIDRequest {
        /**
         * TypeformEventID
         * The unique ID of the Typeform submission.
         */
        "typeform_event_id": string
    }

    /**
     * SendMessageRequest contains a message to send.
     */
    export interface SendMessageRequest {
        /**
         * Message
         * The message content to send.
         */
        message: string
    }

    /**
     * SendMessageResponse is returned after sending a message.
     */
    export interface SendMessageResponse {
    }

    /**
     * UpdateAppointmentStatusRequest contains the new status for an appointment.
     */
    export interface UpdateAppointmentStatusRequest {
        /**
         * Status
         * The new status for the appointment.
         * Valid values: **Waiting** (user is waiting to be seen),
         * **Booked** (confirms a reserved appointment),
         * **Cancelled** (user no longer wants the appointment).
         */
        status: string
    }

    /**
     * UpdateChatVideoStatusRequest contains the new video status.
     */
    export interface UpdateChatVideoStatusRequest {
        /**
         * Status
         * The video call status to set.
         */
        status: string
    }

    /**
     * UserWhatsAppResponse contains WhatsApp account details for a user.
     */
    export interface UserWhatsAppResponse {
        /**
         * UserDocID
         * The **doc_id** of the user in **UUID** format.
         */
        "user_doc_id": string

        /**
         * ExternalID
         * The external ID of the user, usually a phone number or Meta Business-Scoped User ID (optional).
         * Previously PhoneNumber, the json phone_number remains to avoid a breaking change on the API
         */
        "phone_number": string

        /**
         * Linked
         * Indicates if a WhatsApp account is linked.
         */
        linked: boolean
    }

    /**
     * WhatsAppCodeResponse contains a WhatsApp linking code.
     */
    export interface WhatsAppCodeResponse {
        /**
         * Code
         * The linking code to send via WhatsApp.
         */
        code: string

        /**
         * Url
         * Pre-populated WhatsApp URL for sending the code.
         */
        url: string

        /**
         * PhoneNumber
         * The WhatsApp phone number that the user may send their code to.
         * Lines up with the phone number that the prepopulated message Url points to.
         */
        phoneNumber: string
    }

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.ChatAvailability = this.ChatAvailability.bind(this)
            this.ClearWhatsAppLink = this.ClearWhatsAppLink.bind(this)
            this.CreateAppointment = this.CreateAppointment.bind(this)
            this.CreateAppointmentPhoto = this.CreateAppointmentPhoto.bind(this)
            this.CreateBookingScreenPageView = this.CreateBookingScreenPageView.bind(this)
            this.CreateChat = this.CreateChat.bind(this)
            this.CreateChatV2 = this.CreateChatV2.bind(this)
            this.CreateOnDemandAppointment = this.CreateOnDemandAppointment.bind(this)
            this.DeleteAppointmentPhoto = this.DeleteAppointmentPhoto.bind(this)
            this.DeleteChat = this.DeleteChat.bind(this)
            this.EmailCancelAppointment = this.EmailCancelAppointment.bind(this)
            this.EndChat = this.EndChat.bind(this)
            this.GenerateWhatsAppCode = this.GenerateWhatsAppCode.bind(this)
            this.GetAppointment = this.GetAppointment.bind(this)
            this.GetAppointmentPhoto = this.GetAppointmentPhoto.bind(this)
            this.GetChat = this.GetChat.bind(this)
            this.GetChatService = this.GetChatService.bind(this)
            this.GetService = this.GetService.bind(this)
            this.GetServiceExternal = this.GetServiceExternal.bind(this)
            this.GetToken = this.GetToken.bind(this)
            this.GetUserIdForWhatsAppCode = this.GetUserIdForWhatsAppCode.bind(this)
            this.GetWhatsAppDetails = this.GetWhatsAppDetails.bind(this)
            this.GetstreamWebhook = this.GetstreamWebhook.bind(this)
            this.KillChat = this.KillChat.bind(this)
            this.ListAppointmentPhotos = this.ListAppointmentPhotos.bind(this)
            this.ListAppointments = this.ListAppointments.bind(this)
            this.ListAvailabileDays = this.ListAvailabileDays.bind(this)
            this.ListAvailability = this.ListAvailability.bind(this)
            this.ListChats = this.ListChats.bind(this)
            this.ListOnDemand = this.ListOnDemand.bind(this)
            this.ListServices = this.ListServices.bind(this)
            this.PatchAppointmentNotes = this.PatchAppointmentNotes.bind(this)
            this.PatchAppointmentTypeformEventID = this.PatchAppointmentTypeformEventID.bind(this)
            this.SendChatMessage = this.SendChatMessage.bind(this)
            this.StartWhatsappChat = this.StartWhatsappChat.bind(this)
            this.TokboxWebhook = this.TokboxWebhook.bind(this)
            this.TwilioRawWebhook = this.TwilioRawWebhook.bind(this)
            this.UpdateAppointmentStatus = this.UpdateAppointmentStatus.bind(this)
            this.UpdateChatVideoStatus = this.UpdateChatVideoStatus.bind(this)
            this.WhatsappLoginFlow = this.WhatsappLoginFlow.bind(this)
            this.WhatsappPetVerificationFlow = this.WhatsappPetVerificationFlow.bind(this)
            this.WhatsappVITLOutcomeFlow = this.WhatsappVITLOutcomeFlow.bind(this)
        }

        /**
         * Get Chat Availability
         * Checks if chat is currently available.
         */
        public async ChatAvailability(params: ChatAvailabilityRequest): Promise<ChatAvailabilityResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "chat_service_doc_id": params.ChatServiceID,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/chatavailability`, undefined, {query})
            return await resp.json() as ChatAvailabilityResponse
        }

        /**
         * Clear WhatsApp Link
         * Removes the WhatsApp link for a user.
         */
        public async ClearWhatsAppLink(user_doc_id: string): Promise<void> {
            await this.baseClient.callTypedAPI("DELETE", `/v1/users/${encodeURIComponent(user_doc_id)}/whatsapp`)
        }

        /**
         * Create Appointment
         * Creates a new appointment for a vet consultation.
         */
        public async CreateAppointment(user_doc_id: string, params: CreateAppointmentRequest): Promise<CreateAppointmentResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/users/${encodeURIComponent(user_doc_id)}/appointments`, JSON.stringify(params))
            return await resp.json() as CreateAppointmentResponse
        }

        /**
         * Create Appointment Photo
         * Adds a photo to an existing appointment.
         */
        public async CreateAppointmentPhoto(user_doc_id: string, appointment_doc_id: string, params: CreateAppointmentPhotoRequest): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/v1/users/${encodeURIComponent(user_doc_id)}/appointments/${encodeURIComponent(appointment_doc_id)}/photos`, JSON.stringify(params))
        }

        /**
         * Create Booking Screen Page View
         * Tracks a booking screen page view for analytics.
         */
        public async CreateBookingScreenPageView(user_doc_id: string, params: BookingScreenPageViewRequest): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/v1/user/${encodeURIComponent(user_doc_id)}/bookingscreenpageview`, JSON.stringify(params))
        }

        /**
         * Create Chat
         * Creates a new chat session for a user and their pet.
         */
        public async CreateChat(user_doc_id: string, params: CreateChatRequest): Promise<CreateChatResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/users/${encodeURIComponent(user_doc_id)}/chat`, JSON.stringify(params))
            return await resp.json() as CreateChatResponse
        }

        /**
         * Create Chat V2
         * Creates a new chat session for a user and their pet.
         */
        public async CreateChatV2(user_doc_id: string, params: CreateChatRequestV2): Promise<CreateChatResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v2/users/${encodeURIComponent(user_doc_id)}/chat`, JSON.stringify(params))
            return await resp.json() as CreateChatResponse
        }

        /**
         * Create On-Demand Appointment
         * Creates a new on-demand appointment for a consultation. Returns an error if no on-demand slots are available.
         */
        public async CreateOnDemandAppointment(user_doc_id: string, params: CreateOnDemandAppointmentRequest): Promise<CreateAppointmentResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/users/${encodeURIComponent(user_doc_id)}/ondemand`, JSON.stringify(params))
            return await resp.json() as CreateAppointmentResponse
        }

        /**
         * Delete Appointment Photo
         * Deletes a photo from an appointment.
         */
        public async DeleteAppointmentPhoto(user_doc_id: string, appointment_doc_id: string, photo_doc_id: string): Promise<void> {
            await this.baseClient.callTypedAPI("DELETE", `/v1/users/${encodeURIComponent(user_doc_id)}/appointments/${encodeURIComponent(appointment_doc_id)}/photos/${encodeURIComponent(photo_doc_id)}`)
        }

        /**
         * Delete Chat
         * Soft deletes a chat session.
         */
        public async DeleteChat(user_doc_id: string, chatDocID: string): Promise<void> {
            await this.baseClient.callTypedAPI("DELETE", `/v1/users/${encodeURIComponent(user_doc_id)}/chat/${encodeURIComponent(chatDocID)}`)
        }

        /**
         * EmailCancelAppointment
         * This endpoint terminates an existing appointment, typically triggered via an email link.
         * Temporary endpoint while appointment management is being worked on.
         */
        public async EmailCancelAppointment(method: "GET", appointment_id: string, pet_id: string, body?: RequestInit["body"], options?: CallParameters): Promise<globalThis.Response> {
            return this.baseClient.callAPI(method, `/v1/appointments/${encodeURIComponent(appointment_id)}/${encodeURIComponent(pet_id)}/email-cancel`, body, options)
        }

        /**
         * End Chat
         * Ends a chat session early.
         */
        public async EndChat(userDocID: string, chatDocID: string): Promise<void> {
            await this.baseClient.callTypedAPI("PATCH", `/v1/users/${encodeURIComponent(userDocID)}/chat/${encodeURIComponent(chatDocID)}/end`)
        }

        /**
         * Generate WhatsApp Code
         * Generates a code to link a user's WhatsApp account.
         */
        public async GenerateWhatsAppCode(userDocID: string): Promise<WhatsAppCodeResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/users/${encodeURIComponent(userDocID)}/whatsapp/generate`)
            return await resp.json() as WhatsAppCodeResponse
        }

        /**
         * Get Appointment
         * Retrieves an existing appointment for a user.
         */
        public async GetAppointment(user_doc_id: string, appointment_doc_id: string): Promise<GetAppointmentResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/users/${encodeURIComponent(user_doc_id)}/appointments/${encodeURIComponent(appointment_doc_id)}`)
            return await resp.json() as GetAppointmentResponse
        }

        /**
         * Get Appointment Photo
         * Retrieves a photo for an appointment.
         */
        public async GetAppointmentPhoto(user_doc_id: string, appointment_doc_id: string, photo_doc_id: string): Promise<GetAppointmentPhotoResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/users/${encodeURIComponent(user_doc_id)}/appointments/${encodeURIComponent(appointment_doc_id)}/photos/${encodeURIComponent(photo_doc_id)}`)
            return await resp.json() as GetAppointmentPhotoResponse
        }

        /**
         * Get Chat
         * Retrieves a chat session by its **doc_id**.
         */
        public async GetChat(user_doc_id: string, chatDocID: string): Promise<GetChatResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/users/${encodeURIComponent(user_doc_id)}/chat/${encodeURIComponent(chatDocID)}`)
            return await resp.json() as GetChatResponse
        }

        /**
         * Get Chat Service
         * Retrieves a chat service by its **doc_id**.
         */
        public async GetChatService(doc_id: string): Promise<GetChatServiceResponseWithPrice> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/chat-services/${encodeURIComponent(doc_id)}`)
            return await resp.json() as GetChatServiceResponseWithPrice
        }

        /**
         * Get Service
         * Retrieves a service by its **doc_id**.
         */
        public async GetService(service_doc_id: string): Promise<GetServiceWithPriceResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/services/${encodeURIComponent(service_doc_id)}`)
            return await resp.json() as GetServiceWithPriceResponse
        }

        /**
         * Get Service (Deprecated)
         * Retrieves a service by its **doc_id**. This endpoint will be deprecated.
         */
        public async GetServiceExternal(service_doc_id: string): Promise<GetServiceWithPriceResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/bookingexternal/services/${encodeURIComponent(service_doc_id)}`)
            return await resp.json() as GetServiceWithPriceResponse
        }

        /**
         * Get Chat Token
         * Retrieves a user's authentication token for the chat service.
         */
        public async GetToken(user_doc_id: string): Promise<GetTokenResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/users/${encodeURIComponent(user_doc_id)}/chattoken`)
            return await resp.json() as GetTokenResponse
        }

        /**
         * Get User For WhatsApp Code
         * Retrieves the user associated with a WhatsApp code.
         */
        public async GetUserIdForWhatsAppCode(code: string): Promise<UserWhatsAppResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/whatsapp/code/${encodeURIComponent(code)}`)
            return await resp.json() as UserWhatsAppResponse
        }

        /**
         * Get WhatsApp Details
         * Retrieves WhatsApp account details for a user.
         */
        public async GetWhatsAppDetails(user_doc_id: string): Promise<UserWhatsAppResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/users/${encodeURIComponent(user_doc_id)}/whatsapp`)
            return await resp.json() as UserWhatsAppResponse
        }

        /**
         * Webhook for Getstream chat events
         * This endpoint is not passed through generic auth as the request is validated by its X-Signature and X-Api-Key
         * headers as described in the Getstream docs: https://getstream.io/chat/docs/go-golang/webhooks_overview
         */
        public async GetstreamWebhook(method: "POST", body?: RequestInit["body"], options?: CallParameters): Promise<globalThis.Response> {
            return this.baseClient.callAPI(method, `/v1/getstream`, body, options)
        }

        /**
         * Kill Chat
         * Force deletes a chat without status validation.
         */
        public async KillChat(user_doc_id: string, chatDocID: string): Promise<void> {
            await this.baseClient.callTypedAPI("DELETE", `/v1/users/${encodeURIComponent(user_doc_id)}/chat/${encodeURIComponent(chatDocID)}/kill`)
        }

        /**
         * List Appointment Photos
         * Retrieves all photos for an appointment.
         */
        public async ListAppointmentPhotos(user_doc_id: string, appointment_doc_id: string): Promise<ListAppointmentPhotosResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/users/${encodeURIComponent(user_doc_id)}/appointments/${encodeURIComponent(appointment_doc_id)}/photos`)
            return await resp.json() as ListAppointmentPhotosResponse
        }

        /**
         * List Appointments
         * Retrieves a paginated list of appointments for a user.
         */
        public async ListAppointments(user_doc_id: string, params: ListAppointmentsRequest): Promise<ListAppointmentsResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                desc:                                          String(params.Desc),
                "exclude_appointments_in_consultation_states": params.ExcludeAppointmentsInConsultationStates?.map((v) => v),
                "items_per_page":                              String(params.RequestedItemsPerPage),
                "page_number":                                 String(params.RequestedPageNumber),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/users/${encodeURIComponent(user_doc_id)}/appointments`, undefined, {query})
            return await resp.json() as ListAppointmentsResponse
        }

        /**
         * List Available Appointment Days
         * Returns a list of days with available appointment slots.
         */
        public async ListAvailabileDays(params: ListAvailabileDaysQueryParams): Promise<ListAvailableDaysResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "end_date":       params.EndDate,
                "service_doc_id": params.ServiceID,
                "start_date":     params.StartDate,
                timezone:         params.Timezone,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/availabledays`, undefined, {query})
            return await resp.json() as ListAvailableDaysResponse
        }

        /**
         * List Available Appointments
         * Returns a list of available appointment time slots.
         */
        public async ListAvailability(params: ListAvailabilityQueryParams): Promise<ListAvailabilityResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "allow_past":     String(params.AllowPast),
                "end_date":       params.EndDate,
                "service_doc_id": params.ServiceDocID,
                "start_date":     params.StartDate,
                timezone:         params.Timezone,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/availability`, undefined, {query})
            return await resp.json() as ListAvailabilityResponse
        }

        /**
         * List Chats
         * Retrieves all chat sessions for a user.
         */
        public async ListChats(user_doc_id: string): Promise<ListChatsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/users/${encodeURIComponent(user_doc_id)}/chat`)
            return await resp.json() as ListChatsResponse
        }

        /**
         * List On-Demand Appointments
         * Returns the next available on-demand appointment slot. Returns an empty array if none available.
         */
        public async ListOnDemand(params: ListOnDemandQueryParams): Promise<ListAvailabilityResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "service_doc_id": params.ServiceDocID,
                timezone:         params.Timezone,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/ondemand`, undefined, {query})
            return await resp.json() as ListAvailabilityResponse
        }

        /**
         * List Services
         * Returns a list of available booking service types (e.g. Vet, Nurse, Specialist).
         */
        public async ListServices(): Promise<ListServicesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/services`)
            return await resp.json() as ListServicesResponse
        }

        /**
         * Update Appointment Notes
         * Updates an appointment's notes.
         */
        public async PatchAppointmentNotes(user_doc_id: string, appointment_doc_id: string, params: PatchAppointmentNotesRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PATCH", `/v1/users/${encodeURIComponent(user_doc_id)}/appointments/${encodeURIComponent(appointment_doc_id)}/notes`, JSON.stringify(params))
        }

        /**
         * Update Appointment Typeform Event ID
         * Links a Typeform submission to an appointment.
         */
        public async PatchAppointmentTypeformEventID(user_doc_id: string, appointment_doc_id: string, params: PatchAppointmentTypeformEventIDRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PATCH", `/v1/users/${encodeURIComponent(user_doc_id)}/appointments/${encodeURIComponent(appointment_doc_id)}/typeform-event-id`, JSON.stringify(params))
        }

        /**
         * Send Chat Message
         * Sends a message to a chat.
         */
        public async SendChatMessage(user_doc_id: string, chatDocID: string, params: SendMessageRequest): Promise<SendMessageResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/users/${encodeURIComponent(user_doc_id)}/chat/${encodeURIComponent(chatDocID)}/message`, JSON.stringify(params))
            return await resp.json() as SendMessageResponse
        }

        /**
         * Start WhatsApp Chat
         * Starts a chat session via WhatsApp.
         */
        public async StartWhatsappChat(userDocID: string, params: CreateWhatsappChatRequest): Promise<CreateChatResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/users/${encodeURIComponent(userDocID)}/whatsapp`, JSON.stringify(params))
            return await resp.json() as CreateChatResponse
        }

        public async TokboxWebhook(method: "POST", body?: RequestInit["body"], options?: CallParameters): Promise<globalThis.Response> {
            return this.baseClient.callAPI(method, `/v1/tokbox`, body, options)
        }

        public async TwilioRawWebhook(method: string, body?: RequestInit["body"], options?: CallParameters): Promise<globalThis.Response> {
            return this.baseClient.callAPI(method, `/v1/twilio/message-webhook`, body, options)
        }

        /**
         * Update Appointment Status
         * Updates the status of an existing appointment.
         */
        public async UpdateAppointmentStatus(user_doc_id: string, appointment_doc_id: string, params: UpdateAppointmentStatusRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PATCH", `/v1/users/${encodeURIComponent(user_doc_id)}/appointments/${encodeURIComponent(appointment_doc_id)}/status`, JSON.stringify(params))
        }

        /**
         * Update Chat Video Status
         * Updates the video call status for a chat.
         */
        public async UpdateChatVideoStatus(user_doc_id: string, chatDocID: string, params: UpdateChatVideoStatusRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PUT", `/v1/users/${encodeURIComponent(user_doc_id)}/chat/${encodeURIComponent(chatDocID)}/video`, JSON.stringify(params))
        }

        public async WhatsappLoginFlow(method: "POST", body?: RequestInit["body"], options?: CallParameters): Promise<globalThis.Response> {
            return this.baseClient.callAPI(method, `/v1/whatsapp-login-flow`, body, options)
        }

        public async WhatsappPetVerificationFlow(method: "POST", body?: RequestInit["body"], options?: CallParameters): Promise<globalThis.Response> {
            return this.baseClient.callAPI(method, `/v1/whatsapp-pet-verification-flow`, body, options)
        }

        public async WhatsappVITLOutcomeFlow(method: "POST", body?: RequestInit["body"], options?: CallParameters): Promise<globalThis.Response> {
            return this.baseClient.callAPI(method, `/v1/whatsapp-vitl-outcome-flow`, body, options)
        }
    }
}

export namespace bookinginternal {
    /**
     * For DeactivateServiceSchedule
     */
    export interface ActivateServiceScheduleRequest {
    }

    export interface ActivateServiceScheduleResponse {
    }

    export interface ActiveCall {
        "doc_id": uuid.UUID
        status: string
        "from_number": string
        "started_at": string
        "duration_seconds": number
        "waiting_time": string
        consultationDocId: uuid.UUID
        "consult_status"?: string
        staff?: Staff
        "temporary_user": TempUser
        user?: accountinternal.UserResponse
        pet?: accountinternal.PetResponse
        "staff_profile"?: GetStaffProfileResponse
    }

    export interface AddHandoverReasonRequest {
        reason: string
    }

    export interface AddHandoverReasonResponse {
        "reason_id": number
    }

    export interface AnswerCallResponse {
        call: entities.Call
    }

    export interface AppointmentEventsResponse {
        events: entities.AppointmentEvent[]
    }

    export interface CallTranscriptionResponse {
        "transcription_formatted_text": string
    }

    export interface CancelAppointmentRequest {
        source: string
    }

    export interface ChatAuditMessage {
        "chat_id": number
        "participant_id": number
        "participant_doc_id": string
        "message_id": string
        "sent_at": string
        content: string
        "message_type": string
        "is_pinned": boolean
        attachments: ChatAuditMessageAttachment[]
        /**
         * either the user/staff doc ID, or DR_JOII_AI (llm) or VET_AI (welcome bot)
         */
        "session_user_id": string

        "pet_doc_id": uuid.UUID
        "user_doc_id": uuid.UUID
    }

    export interface ChatAuditMessageAttachment {
        "bucket_path": string
        "mime_type": string
    }

    export interface CheckStaffEligibilityToReassignAppointmentResponse {
        eligible: boolean
    }

    export interface CreateAppointmentRequest {
        /**
         * AvailabilityDocID
         * The id of an available slot for booking.
         */
        "availability_doc_id": string

        /**
         * PetDocID
         * The **doc_id** of the pet, selected for the appointment in **UUID** format.
         */
        "pet_doc_id": string

        /**
         * UserDocID
         * The **doc_id** of the user, selected for the appointment in **UUID** format.
         */
        "user_doc_id": string

        /**
         * Previous appointment doc id
         * The optional **doc_id** of the previous appointment in **UUID** format.
         */
        "previous_appointment_doc_id": string

        /**
         * PreviousChatDocID
         * Indicates that an appointment was preceded by a chat that we would like to link it to.
         */
        "previous_chat_doc_id"?: string
    }

    export interface CreateAppointmentResponse {
        /**
         * DocId
         * The **doc_id** of the new appointment in **UUID** format.
         */
        "doc_id": string

        /**
         * CreatedAt
         * **created_at** in UTC time format (e.g. **2017-09-04T04:00:00.000000Z**)
         */
        "created_at": string
    }

    export interface CreateBusinessServiceRequest {
        "business_doc_id": string
    }

    export interface CreateChatServiceRequest {
        name: string
        description: string
        "is_trials_consultation": boolean
    }

    export interface CreateChatServiceResponse {
        "doc_id": string
    }

    export interface CreateChatServiceStaffRequest {
        "chat_service_doc_id": string
        enabled: boolean
    }

    /**
     * For CreateServicePrice
     */
    export interface CreateServicePriceRequest {
        price: number
        currency: string
        "external_pricing_id": string
    }

    export interface CreateServicePriceResponse {
        id: string
    }

    export interface CreateServicePricesBusinessRequest {
        BusinessDocID: string
    }

    export interface CreateServiceRequest {
        name: string
        description: string
        colour?: string
        "user_bookable": boolean
        "skip_screening": boolean
        "is_trial_service": boolean
        "prevent_double_bookings": boolean
        "hide_from_pms": boolean
        "sling_locations": number[]
    }

    export interface CreateServiceResponse {
        id: string
    }

    /**
     * For CreateServiceSchedule
     */
    export interface CreateServiceScheduleRequest {
        name: string
        duration: number
        "padding_after": number
        "activation_date": string
        active: boolean
    }

    export interface CreateServiceScheduleResponse {
        id: string
    }

    export interface CreateShiftRequest {
        "start_date": string
        "end_date": string
        timezone: string
        chat: boolean
        "shift_type": string
        "shift_status": string
        /**
         * if passed, will create a shift with a staff profile, otherwise will create a shift without a staff profile
         */
        "staff_profile_id": string
    }

    export interface CreateShiftResponse {
        id: string
    }

    export interface CreateStaffProfileRequest {
        name: string
        description: string
        "sling_id"?: string
        "rcvs_number"?: string
        "registered_us_states"?: CreateStaffProfileUSStateRegistration[]
    }

    export interface CreateStaffProfileResponse {
        /**
         * Deprecated: use DocID instead
         */
        id: string

        "doc_id": string
    }

    export interface CreateStaffProfileUSStateRegistration {
        /**
         * ShortCode are ISO3166 US state shortcodes for where the vet is registered
         * they'll be checked for E-VCPR if undertaking a consult in the US.
         */
        shortcode: string

        /**
         * The vets license number for that state
         */
        "license_number": string

        /**
         * The chewy vet ID of the chewy vet profile linked to this vet + state combination
         */
        "chewy_vet_id"?: string
    }

    export interface CreateStaffSkillRequest {
        "service_doc_id": string
        enabled: boolean
    }

    /**
     * CreateVonageUserResponse contains the response data for creating a Vonage user
     */
    export interface CreateVonageUserResponse {
        "vonage_user_id": string
        "vonage_user_created_at": string
        name: string
        "display_name": string
    }

    /**
     * For DeactivateServiceSchedule
     */
    export interface DeactivateServiceScheduleRequest {
    }

    export interface DeactivateServiceScheduleResponse {
    }

    export interface GetAppointmentRequest {
        Timezone: string
    }

    export interface GetAppointmentResponse {
        "doc_id": string
        start: utilities.Dates
        end: utilities.Dates
        status: string
        "pet_id": string
        "user_id": string
        "room_id"?: string
        "session_id"?: string
        "payment_intent_id"?: string
        "staff_profile_id"?: string
        "staff_profile_name"?: string
        "staff_profile_description"?: string
        "staff_profile_photo_url"?: string
        "staff_profile_rcvs_number"?: string
        "is_waiting": boolean
        "is_open": boolean
        "is_late": boolean
        "is_priority": boolean
        /**
         * IsOverdue, if true, means the appointment is overdue and can be considered as missed, (subject to change; 120 minutes after the appointment end time)
         */
        "is_overdue": boolean

        "started_waiting_time"?: string
        "last_seen_waiting"?: string
        "waiting_time_in_minutes"?: number
        "actual_start_time"?: string
        "actual_end_time"?: string
        "consult_status"?: string
        "disrupted_reason"?: string
        pet: accountinternal.PetResponse
        user: accountinternal.UserResponse
        business: entities.BusinessResponse
        notes?: string
        "appointment_photos_urls": string[]
        "symptom_checker_session_doc_id"?: string
        "symptom_checker_session_algorithm_title"?: string
        "symptom_checker_session_outcome_urgency"?: string
        "service_name": string
        "service_doc_id": string
        "service_is_trial": boolean
        "typeform_event_id": string
        "on_demand": boolean
        "created_by_staff_profile_doc_id"?: string
        "video_stream_provider"?: string
        "previous_chat_doc_id"?: string
        reassigned: boolean
        "reason_for_visit"?: entities.ReasonForVisit
        "is_trial_participant": boolean
        "trial_info"?: TrialAppointmentStepInfoResponse
        "linked_participant_step"?: LinkedParticipantStepResponse
        "created_at": string
        /**
         * ptr as an appointment may not have a chat associated
         */
        "is_emergency"?: boolean

        "is_transcription_available": boolean
    }

    /**
     * GetCallByVonageUUIDResponse represents the response when fetching a call by Vonage UUID
     */
    export interface GetCallByVonageUUIDResponse {
        call: entities.Call
        user?: accountinternal.UserResponse
        pet?: accountinternal.PetResponse
        "staff_profile"?: GetStaffProfileResponse
    }

    /**
     * GetCallResponse represents the response when fetching a call by its doc_id
     */
    export interface GetCallResponse {
        call: entities.Call
        user?: accountinternal.UserResponse
        pet?: accountinternal.PetResponse
        business?: entities.BusinessResponse
    }

    export interface GetCallTranscriptionResponse {
        transcription: CallTranscriptionResponse
        "is_available": boolean
    }

    export interface GetChatServiceResponse {
        "doc_id": string
        name: string
        description: string
        "is_trials_consultation": boolean
    }

    export interface GetHandoverReasonsResponse {
        reasons: entities.HandoverReason[]
    }

    export interface GetHandoverResponse {
        id: number
        "doc_id": string
        "chat_doc_id": string
        "from_staff_doc_id": string
        "to_staff_doc_id"?: string
        "reason_id": number
        note: string
        "created_at": string
        "updated_at": string
    }

    export interface GetLiveVideoProviderResponse {
        provider: string
    }

    export interface GetRefundResponse {
        id: string
        amount: number
        total: number
        "fully_refunded": boolean
        "created_at": string
        "updated_at": string
        "payment_intent_id"?: string
    }

    export interface GetServicePriceResponse {
        id: uuid.UUID
        price: number
        "business_id": string
        currency: string
        "external_pricing_id": string
    }

    export interface GetServiceResponse {
        id: string
        name: string
        description: string
        duration: number
        colour?: string
        "business_ids"?: string[]
        "user_bookable": boolean
        "skip_screening": boolean
        "is_trial_service": boolean
        "prevent_double_bookings": boolean
        "hide_from_pms": boolean
        "sling_location_ids": number[]
    }

    export interface GetServiceScheduleResponse {
        id: uuid.UUID
        name: string
        duration: number
        "padding_after": number
        "activation_date": string
        active: boolean
    }

    export interface GetShiftResponse {
        id: string
        "start_date": string
        "local_start_date": string
        "end_date": string
        "local_end_date": string
        timezone: string
        "shift_type": string
        "shift_status": string
        "staff_profile_id"?: string
        "service_id"?: string
        "service_name"?: string
        "service_colour"?: string
        bookable?: boolean
        "chat_available"?: boolean
    }

    export interface GetStaffProfileResponse {
        id: string
        name: string
        description: string
        "sling_id"?: string
        "photo_url"?: string
        "rcvs_number"?: string
        /**
         * Deprecated: use evcpr state-linked chewy vet id instead.
         */
        "chewy_vet_id"?: string

        "registered_us_state_information"?: StaffProfileUSStateRegistration[]
        "video_services": GetServiceResponse[]
        "chat_services": GetChatServiceResponse[]
    }

    export interface GetStaffTokenResponse {
        token: string
    }

    export interface GetStaffVideoTokenResponse {
        token: string
    }

    export interface GetTranscriptionsResponse {
        content: TranscriptionResponse[]
        "is_available": boolean
    }

    export interface HandoverChatRequest {
        "staff_doc_id": string
        "reason_id": number
        note: string
    }

    export interface LinkedParticipantStepResponse {
        "participant_step_doc_id": string
        "trial_doc_id": string
        "trial_name": string
        "participant_doc_id": string
        "step_name": string
        "step_type": string
    }

    export interface ListActiveCallsRequest {
        RequestedItemsPerPage: number
        RequestedPageNumber: number
    }

    export interface ListActiveCallsResponse {
        calls: ActiveCall[]
        pagination: shared.Pagination
    }

    export interface ListAppointmentFollowUpsRequest {
        Timezone: string
    }

    export interface ListAppointmentsResponse {
        appointments: GetAppointmentResponse[]
    }

    export interface ListAppointmentsV2Request {
        ServiceDocID?: string
        UserDocID?: string
        PetDocID?: string
        ShiftDocID?: string
        BusinessDocID?: string
        Status?: string[]
        StartDate?: string
        EndDate?: string
        Timezone: string
        Waiting?: boolean
        Open?: boolean
        StaffProfileDocID?: string
        ListAppointmentWithoutStaffProfiles?: boolean
        OrderBy?: string
        QueueSortMode?: string
        ExcludeAppointmentsInConsultationStates?: string[]
        AppointmentType?: string
        /**
         * If set to true, it filters all appointments
         * whose `start_time` is within the next `TimeBeforeAppointmentAllowedToEnterWaitingRoomInSeconds` seconds
         */
        WaitingRoomEntry?: boolean

        /**
         * the number of results requested for the page
         */
        RequestedItemsPerPage: number

        /**
         * the page number requested
         */
        RequestedPageNumber: number
    }

    export interface ListAppointmentsV2Response {
        appointments: GetAppointmentResponse[]
        pagination: Pagination
    }

    export interface ListAvailabileDaysQueryParams {
        /**
         * The **doc_id** of the service, selected for the appointment in **UUID** format.
         */
        ServiceID: string

        /**
         * **timezone** in IANA format
         * (e.g **Europe/London**, **UTC**, **Europe/Berlin**)
         */
        Timezone: string

        /**
         * **start_date** in local time format (e.g. **2017-09-04T04:00:00**)
         */
        StartDate: string

        /**
         * **end_date** in local time format (e.g. **2017-09-04T04:00:00**)
         */
        EndDate: string
    }

    export interface ListAvailabilityInternalQueryParams {
        /**
         * **start_date** in local time format (e.g. **2017-09-04T04:00:00**)
         */
        StartDate: string

        /**
         * **end_date** in local time format (e.g. **2017-09-04T04:00:00**)
         */
        EndDate: string

        /**
         * The **doc_id** of the service for which availability is needed in **UUID** format.
         */
        ServiceDocID: string

        /**
         * **timezone** in IANA format
         * (e.g **Europe/London**, **UTC**, **Europe/Berlin**)
         */
        Timezone: string
    }

    export interface ListAvailabilityResponse {
        slots: ListAvailabilitySlotItem[]
    }

    export interface ListAvailabilitySlotItem {
        /**
         * DocId
         * The **doc_id** of the available slot.
         */
        "doc_id": string

        /**
         * StaffProfileName
         * The name of the staff available to participate in the vet call.
         */
        "staff_profile_name": string

        /**
         * Start
         */
        start: utilities.Dates

        /**
         * End
         */
        end: utilities.Dates

        /**
         * Duration
         * Duration of the vet call in minutes.
         */
        duration: number
    }

    /**
     * FriendlyDay represents a day in a friendly format
     */
    export interface ListAvailableDaysItem {
        /**
         * Day
         * **day** for the slot (e.g. **Monday**, **Tuesday**, **Wednesday**, **Thursday**, **Friday**, **Saturday**, **Sunday**)
         */
        day: string

        /**
         * DateFrom
         * **date_from** in local time format (e.g. **2017-09-04T04:00:00**)
         */
        "date_from": string

        /**
         * DateTo
         * **date_to** in local time format (e.g. **2017-09-04T04:00:00**)
         */
        "date_to": string

        /**
         * SlotsAvailable
         * **slots_available** indicates if there are available slots for the day.
         */
        "slots_available": boolean
    }

    export interface ListAvailableDaysResponse {
        days: ListAvailableDaysItem[]
    }

    export interface ListChatMessagesResponse {
        messages: ChatAuditMessage[]
    }

    export interface ListChatServicesResponse {
        "chat_services": GetChatServiceResponse[]
    }

    export interface ListRefundsResponse {
        refunds: GetRefundResponse[]
    }

    export interface ListSerciceScheduleResponseItem {
        id: uuid.UUID
        name: string
        duration: number
        "padding_after": number
        "activation_date": string
        active: boolean
    }

    export interface ListServicePricesResponse {
        prices: ListServicePricesResponseItem[]
    }

    export interface ListServicePricesResponseItem {
        id: uuid.UUID
        price: number
        currency: string
        "external_pricing_id": string
    }

    export interface ListServiceSchedulesResponse {
        schedules: ListSerciceScheduleResponseItem[]
    }

    export interface ListServicesByBusinessRequest {
        /**
         * HideFromPMS
         * if this is true, it'll NOT return services where HideFromPMS is true
         */
        HideFromPMS?: boolean
    }

    export interface ListServicesByBusinessResponse {
        services: ServiceResponse[]
    }

    export interface ListServicesRequest {
        ActiveOnly?: boolean
        HideFromPMS?: boolean
    }

    export interface ListServicesResponse {
        services: GetServiceResponse[]
    }

    export interface ListShiftsRequest {
        "start_date": string
        "end_date": string
        timezone: string
        "staff_profile_id": string
        "shift_status": string
    }

    export interface ListShiftsResponse {
        shifts: GetShiftResponse[]
    }

    export interface ListSlingLocationsResponse {
        "sling_locations": SlingLocation[]
    }

    export interface ListStaffChatServicesRequest {
        OnlyEnabled: boolean
    }

    export interface ListStaffChatServicesResponse {
        services: StaffChatServiceResponse[]
    }

    export interface ListStaffProfilesResponse {
        pagination: shared.Pagination
        staffProfiles: GetStaffProfileResponse[]
    }

    export interface ListStaffSkillsRequest {
        OnlyEnabled: boolean
    }

    export interface ListStaffSkillsResponse {
        skills: StaffSkillResponse[]
    }

    export interface Pagination {
        total: number
        "current_page": number
        pages: number
    }

    export interface PatchMyStaffProfilePhotoRequest {
        "photo_url": string
    }

    export interface PatchStaffProfileRcvsNumerRequest {
        "rcvs_number": string
    }

    export interface SendProductMessageRequest {
        sku: string
        name: string
        url: string
        currency: string
        price: number
        description: string
        "photo_url": string
        message: string
    }

    export interface ServiceResponse {
        id: string
        name: string
        description: string
        duration: number
        colour?: string
        "user_bookable": boolean
        "skip_screening": boolean
        "prevent_double_bookings": boolean
    }

    export interface SlingLocation {
        id: number
        name: string
    }

    export interface Staff {
        id: string
        name: string
        description: string
        "sling_id"?: string
        "photo_url"?: string
        "rcvs_number"?: string
        /**
         * Deprecated: use evcpr state-linked chewy vet id instead.
         */
        "chewy_vet_id"?: string
    }

    export interface StaffChatServiceResponse {
        "chat_service_doc_id": string
        "service_name": string
        enabled: boolean
        description: string
    }

    export interface StaffProfileUSStateRegistration {
        "state_information": USStateInformation
        /**
         * The vets license number in that state
         */
        "vet_license_number": string

        "chewy_vet_id"?: string
    }

    export interface StaffSkillResponse {
        "service_doc_id": string
        "service_name": string
        enabled: boolean
        description: string
    }

    export interface StartArchiveRequest {
        "appointment_doc_id": string
    }

    export interface StopArchiveRequest {
        "appointment_doc_id": string
    }

    export interface TempUser {
        "doc_id": string
        "first_name": string
        "last_name": string
        email: string
        postcode: string
        "phone_number": string
        "call_doc_id": string
        "linked_to_user_doc_id": string
        "matched_at": string
    }

    /**
     * TestCreateCallRequest represents the request to initiate a test call
     * This endpoint is for testing click-to-call functionality and should only be used in non-production environments
     */
    export interface TestCreateCallRequest {
        /**
         * Phone number to call (E.164 format, e.g., 447700900002)
         */
        "customer_number": string

        /**
         * Display number (E.164 format)
         */
        "business_number": string

        /**
         * Optional conversation name for testing
         */
        "conversation_name": string
    }

    /**
     * TestCreateCallResponse represents the response from creating a test call
     */
    export interface TestCreateCallResponse {
        uuid: string
        status: string
        direction: string
        "conversation_uuid": string
        /**
         * The webhook URL used for this call
         */
        "answer_webhook_url": string

        /**
         * The event webhook URL used for this call
         */
        "event_webhook_url": string
    }

    export interface TranscriptionResponse {
        "transcription_formatted_text": string
        "transcription_clean_text": string
    }

    export interface TrialAppointmentStepInfoResponse {
        "current_trial"?: TrialInfo
        "other_trials"?: TrialInfo[]
    }

    export interface TrialInfo {
        "trial_name": string
        "step_name": string
        "step_status": string
    }

    export interface TypeformSubmissionsRequest {
        PetDocID: string
    }

    export interface TypeformSubmissionsResponse {
        Submissions: string[]
    }

    /**
     * USStateInformation returns information about a vets registration in that state
     */
    export interface USStateInformation {
        /**
         * ShortCode is the ISO31662 shortcode of the state. e.g. TX
         */
        "state_shortcode": string

        /**
         * DisplayName is the long form of the state, e.g. Texas
         */
        "state_display_name": string
    }

    export interface UpdateAppointmentConsultStatusRequest {
        /**
         * Accepted Values: **Ready**, **InProgress**, **Complete**, **Disrupted**.
         */
        "consult_status": string

        /**
         * Required field only for status **Disrupted**.
         */
        "disrupted_reason"?: string
    }

    export interface UpdateAppointmentSlotRequest {
        "new_availability_doc_id": string
        source: string
    }

    export interface UpdateAppointmentStaffProfileRequest {
        "staff_profile_id"?: string
    }

    export interface UpdateCallConsultStatusRequest {
        /**
         * Accepted Values: **Ready**, **InProgress**, **Complete**, **Disrupted**.
         */
        "consult_status": string

        /**
         * Required field only for status **Disrupted**.
         */
        "disrupted_reason"?: string
    }

    export interface UpdateCallConsultationRequest {
        "consultation_doc_id": string
        "staff_doc_id": string
    }

    export interface UpdateChatCallStateRequest {
        status: string
    }

    export interface UpdateChatConsultStatusRequest {
        /**
         * Accepted Values: **Ready**, **InProgress**, **Complete**, **Disrupted**.
         */
        "consult_status": string

        /**
         * Required field only for status **Disrupted**.
         */
        "disrupted_reason"?: string
    }

    export interface UpdateChatServiceRequest {
        name: string
        description: string
        "is_trials_consultation": boolean
    }

    export interface UpdateChatServiceStaffRequest {
        enabled: boolean
    }

    export interface UpdateChatStatusRequest {
        status: string
    }

    export interface UpdateChatStatusResponse {
    }

    export interface UpdateHandoverReasonRequest {
        reason: string
    }

    export interface UpdateLiveVideoProviderRequest {
        /**
         * STREAM or OPENTOK
         */
        provider: string
    }

    /**
     * For UpdateServicePrice
     */
    export interface UpdateServicePriceRequest {
        price: number
        currency: string
        "external_pricing_id": string
    }

    export interface UpdateServicePriceResponse {
    }

    export interface UpdateServiceRequest {
        name: string
        description: string
        colour?: string
        "user_bookable": boolean
        "skip_screening": boolean
        "is_trial_service": boolean
        "prevent_double_bookings": boolean
        "hide_from_pms": boolean
        "sling_locations": number[]
    }

    export interface UpdateServiceResponse {
    }

    /**
     * For UpdateServiceSchedule
     */
    export interface UpdateServiceScheduleRequest {
        name: string
        duration: number
        "padding_after": number
        "activation_date": string
        active: boolean
    }

    export interface UpdateServiceScheduleResponse {
    }

    export interface UpdateShiftDatesRequest {
        "start_date": string
        "end_date": string
        timezone: string
    }

    export interface UpdateShiftStaffProfileRequest {
        "staff_profile_id": string
    }

    export interface UpdateShiftStatusRequest {
        "shift_status": string
    }

    export interface UpdateStaffProfileRequest {
        name: string
        description: string
        "sling_id"?: string
        "rcvs_number"?: string
        "registered_us_states"?: CreateStaffProfileUSStateRegistration[]
    }

    export interface UpdateStaffProfileResponse {
    }

    export interface UpdateStaffSkillRequest {
        enabled: boolean
    }

    export interface VonageJWTResponse {
        jwt: string
    }

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.AbandonCart = this.AbandonCart.bind(this)
            this.AbandonChatCart = this.AbandonChatCart.bind(this)
            this.ActivateServiceSchedule = this.ActivateServiceSchedule.bind(this)
            this.AddChatParticipant = this.AddChatParticipant.bind(this)
            this.AddHandoverReason = this.AddHandoverReason.bind(this)
            this.AnswerCall = this.AnswerCall.bind(this)
            this.CancelAppointment = this.CancelAppointment.bind(this)
            this.CheckStaffEligibilityToReassignAppointment = this.CheckStaffEligibilityToReassignAppointment.bind(this)
            this.CreateBusinessService = this.CreateBusinessService.bind(this)
            this.CreateChatService = this.CreateChatService.bind(this)
            this.CreateChatServiceStaff = this.CreateChatServiceStaff.bind(this)
            this.CreateInternalAppointment = this.CreateInternalAppointment.bind(this)
            this.CreateMyStaffProfile = this.CreateMyStaffProfile.bind(this)
            this.CreateService = this.CreateService.bind(this)
            this.CreateServicePrice = this.CreateServicePrice.bind(this)
            this.CreateServicePricesBusiness = this.CreateServicePricesBusiness.bind(this)
            this.CreateServiceSchedule = this.CreateServiceSchedule.bind(this)
            this.CreateShift = this.CreateShift.bind(this)
            this.CreateStaffProfile = this.CreateStaffProfile.bind(this)
            this.CreateStaffSkill = this.CreateStaffSkill.bind(this)
            this.CreateVonageUser = this.CreateVonageUser.bind(this)
            this.DeactivateServiceSchedule = this.DeactivateServiceSchedule.bind(this)
            this.DeleteBusinessService = this.DeleteBusinessService.bind(this)
            this.DeleteChatService = this.DeleteChatService.bind(this)
            this.DeleteChatServiceStaff = this.DeleteChatServiceStaff.bind(this)
            this.DeleteHandoverReason = this.DeleteHandoverReason.bind(this)
            this.DeleteService = this.DeleteService.bind(this)
            this.DeleteServicePricesBusiness = this.DeleteServicePricesBusiness.bind(this)
            this.DeleteShift = this.DeleteShift.bind(this)
            this.DeleteStaffProfile = this.DeleteStaffProfile.bind(this)
            this.DeleteStaffSkill = this.DeleteStaffSkill.bind(this)
            this.DynamicallyReassignAppointments = this.DynamicallyReassignAppointments.bind(this)
            this.FreezeChannel = this.FreezeChannel.bind(this)
            this.GetCall = this.GetCall.bind(this)
            this.GetCallByVonageUUID = this.GetCallByVonageUUID.bind(this)
            this.GetChat = this.GetChat.bind(this)
            this.GetChatService = this.GetChatService.bind(this)
            this.GetChatVideoTranscriptionsByChatDocID = this.GetChatVideoTranscriptionsByChatDocID.bind(this)
            this.GetHandover = this.GetHandover.bind(this)
            this.GetHandoverReason = this.GetHandoverReason.bind(this)
            this.GetHandoverReasons = this.GetHandoverReasons.bind(this)
            this.GetInternalAppointment = this.GetInternalAppointment.bind(this)
            this.GetLiveVideoProvider = this.GetLiveVideoProvider.bind(this)
            this.GetMyStaffProfile = this.GetMyStaffProfile.bind(this)
            this.GetPendingChats = this.GetPendingChats.bind(this)
            this.GetRefund = this.GetRefund.bind(this)
            this.GetService = this.GetService.bind(this)
            this.GetServicePrice = this.GetServicePrice.bind(this)
            this.GetServiceSchedule = this.GetServiceSchedule.bind(this)
            this.GetShift = this.GetShift.bind(this)
            this.GetStaffProfile = this.GetStaffProfile.bind(this)
            this.GetStaffToken = this.GetStaffToken.bind(this)
            this.GetStaffVideoToken = this.GetStaffVideoToken.bind(this)
            this.GetTranscriptionsByAppointmentDocID = this.GetTranscriptionsByAppointmentDocID.bind(this)
            this.GetTranscriptionsByCallDocID = this.GetTranscriptionsByCallDocID.bind(this)
            this.GetVonageJWT = this.GetVonageJWT.bind(this)
            this.HandleIncomingCall = this.HandleIncomingCall.bind(this)
            this.HandleRecordingEvent = this.HandleRecordingEvent.bind(this)
            this.HandleVonageEvents = this.HandleVonageEvents.bind(this)
            this.HandoverChat = this.HandoverChat.bind(this)
            this.InitiateCall = this.InitiateCall.bind(this)
            this.ListActiveCalls = this.ListActiveCalls.bind(this)
            this.ListAppointmentsTypeformSubmissions = this.ListAppointmentsTypeformSubmissions.bind(this)
            this.ListAppointmentsV2 = this.ListAppointmentsV2.bind(this)
            this.ListAvailabilityInternal = this.ListAvailabilityInternal.bind(this)
            this.ListAvailableDaysInternal = this.ListAvailableDaysInternal.bind(this)
            this.ListBusinessServiceMapping = this.ListBusinessServiceMapping.bind(this)
            this.ListChatAuditMessages = this.ListChatAuditMessages.bind(this)
            this.ListChatServices = this.ListChatServices.bind(this)
            this.ListFollowUpAppointments = this.ListFollowUpAppointments.bind(this)
            this.ListRefunds = this.ListRefunds.bind(this)
            this.ListRefundsForAppointment = this.ListRefundsForAppointment.bind(this)
            this.ListServicePrices = this.ListServicePrices.bind(this)
            this.ListServicePricesBusinessMapping = this.ListServicePricesBusinessMapping.bind(this)
            this.ListServiceSchedules = this.ListServiceSchedules.bind(this)
            this.ListServices = this.ListServices.bind(this)
            this.ListServicesForBusiness = this.ListServicesForBusiness.bind(this)
            this.ListShifts = this.ListShifts.bind(this)
            this.ListSlingLocations = this.ListSlingLocations.bind(this)
            this.ListStaffChatServices = this.ListStaffChatServices.bind(this)
            this.ListStaffProfiles = this.ListStaffProfiles.bind(this)
            this.ListStaffSkills = this.ListStaffSkills.bind(this)
            this.MarkAppointmentAsDidNotAttend = this.MarkAppointmentAsDidNotAttend.bind(this)
            this.MissedCallsDashboard = this.MissedCallsDashboard.bind(this)
            this.MissedCallsDetail = this.MissedCallsDetail.bind(this)
            this.PatchAppointmentTreatmentPlanReady = this.PatchAppointmentTreatmentPlanReady.bind(this)
            this.PatchMyStaffProfilePhoto = this.PatchMyStaffProfilePhoto.bind(this)
            this.PatchStaffProfilePhoto = this.PatchStaffProfilePhoto.bind(this)
            this.PatchStaffProfileRcvsNumer = this.PatchStaffProfileRcvsNumer.bind(this)
            this.ProcessDidNotAttend = this.ProcessDidNotAttend.bind(this)
            this.ProcessStripeWebhook = this.ProcessStripeWebhook.bind(this)
            this.SendProductMessageToChat = this.SendProductMessageToChat.bind(this)
            this.StartArchive = this.StartArchive.bind(this)
            this.StopArchive = this.StopArchive.bind(this)
            this.SwitchVideoProvider = this.SwitchVideoProvider.bind(this)
            this.SyncShifts = this.SyncShifts.bind(this)
            this.TestCreateCall = this.TestCreateCall.bind(this)
            this.UpdateAppointmentConsultStatus = this.UpdateAppointmentConsultStatus.bind(this)
            this.UpdateAppointmentSlot = this.UpdateAppointmentSlot.bind(this)
            this.UpdateAppointmentStaffProfile = this.UpdateAppointmentStaffProfile.bind(this)
            this.UpdateAppointmentVideoSession = this.UpdateAppointmentVideoSession.bind(this)
            this.UpdateCallConsultStatus = this.UpdateCallConsultStatus.bind(this)
            this.UpdateCallConsultation = this.UpdateCallConsultation.bind(this)
            this.UpdateChatCallState = this.UpdateChatCallState.bind(this)
            this.UpdateChatConsultStatus = this.UpdateChatConsultStatus.bind(this)
            this.UpdateChatService = this.UpdateChatService.bind(this)
            this.UpdateChatServiceStaff = this.UpdateChatServiceStaff.bind(this)
            this.UpdateChatStatus = this.UpdateChatStatus.bind(this)
            this.UpdateHandoverReason = this.UpdateHandoverReason.bind(this)
            this.UpdateLiveVideoProvider = this.UpdateLiveVideoProvider.bind(this)
            this.UpdateMyStaffProfile = this.UpdateMyStaffProfile.bind(this)
            this.UpdateService = this.UpdateService.bind(this)
            this.UpdateServicePrice = this.UpdateServicePrice.bind(this)
            this.UpdateServiceSchedule = this.UpdateServiceSchedule.bind(this)
            this.UpdateShiftDates = this.UpdateShiftDates.bind(this)
            this.UpdateShiftStaffProfile = this.UpdateShiftStaffProfile.bind(this)
            this.UpdateShiftStatus = this.UpdateShiftStatus.bind(this)
            this.UpdateStaffProfile = this.UpdateStaffProfile.bind(this)
            this.UpdateStaffSkill = this.UpdateStaffSkill.bind(this)
        }

        /**
         * Run CRON job from portal
         */
        public async AbandonCart(): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/v1/cron/cart`)
        }

        /**
         * Run CRON job from portal
         */
        public async AbandonChatCart(): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/v1/cron/chatcart`)
        }

        /**
         * DeactivateServiceSchedule deactivates an existing service schedule
         */
        public async ActivateServiceSchedule(serviceId: string, scheduleId: string, params: ActivateServiceScheduleRequest): Promise<ActivateServiceScheduleResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("PATCH", `/v1/bookinginternal/services/${encodeURIComponent(serviceId)}/schedules/${encodeURIComponent(scheduleId)}/activate`)
            return await resp.json() as ActivateServiceScheduleResponse
        }

        /**
         * AddChatParticipant
         * Add participant to a existing chat
         */
        public async AddChatParticipant(chatDocID: string, staffProfileID: string): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/v1/chats/${encodeURIComponent(chatDocID)}/participant/${encodeURIComponent(staffProfileID)}`)
        }

        /**
         * AddHandoverReason
         * Add a new handover reason
         */
        public async AddHandoverReason(params: AddHandoverReasonRequest): Promise<AddHandoverReasonResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/handover/reasons`, JSON.stringify(params))
            return await resp.json() as AddHandoverReasonResponse
        }

        /**
         * AnswerCall handles a staff member answering an incoming call
         * This endpoint:
         * 1. Validates the staff member exists
         * 2. Checks/creates Vonage user for staff
         * 3. Updates call status to 'answered'
         * 4. Connects staff to the call via Vonage API
         * 5. Starts call recording
         * 6. Updates call_state_log
         * 7. Publishes CallAnswered event
         */
        public async AnswerCall(callDocID: string): Promise<AnswerCallResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("PUT", `/v1/calls/${encodeURIComponent(callDocID)}/answer`)
            return await resp.json() as AnswerCallResponse
        }

        /**
         * Cancel an appointment
         */
        public async CancelAppointment(appointmentId: string, params: CancelAppointmentRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PATCH", `/v1/appointments/${encodeURIComponent(appointmentId)}/cancel`, JSON.stringify(params))
        }

        /**
         * CheckStaffEligibilityToReassignAppointment
         * Check if the staff is eligible to be assigned to the appointment
         */
        public async CheckStaffEligibilityToReassignAppointment(appointmentId: string, staffDocID: string): Promise<CheckStaffEligibilityToReassignAppointmentResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/bookinginternal/appointments/${encodeURIComponent(appointmentId)}/staff/${encodeURIComponent(staffDocID)}/eligible-to-reassign`)
            return await resp.json() as CheckStaffEligibilityToReassignAppointmentResponse
        }

        /**
         * CreateBusinessService creates a new service for business
         */
        public async CreateBusinessService(serviceId: string, params: CreateBusinessServiceRequest): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/v1/bookinginternal/services/${encodeURIComponent(serviceId)}/business`, JSON.stringify(params))
        }

        /**
         * CreateChatService
         * Create a chat service
         */
        public async CreateChatService(params: CreateChatServiceRequest): Promise<CreateChatServiceResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/chat-service`, JSON.stringify(params))
            return await resp.json() as CreateChatServiceResponse
        }

        /**
         * Add a chat service to a staff member.
         * 
         * CreateChatServiceStaff adds a new chat service to a staff member.
         */
        public async CreateChatServiceStaff(staffDocID: string, params: CreateChatServiceStaffRequest): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/v1/staff/${encodeURIComponent(staffDocID)}/chat-services`, JSON.stringify(params))
        }

        /**
         * Create appointment
         * This endpoint creates a new appointment for a user and pet.
         */
        public async CreateInternalAppointment(params: CreateAppointmentRequest): Promise<CreateAppointmentResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/appointments`, JSON.stringify(params))
            return await resp.json() as CreateAppointmentResponse
        }

        /**
         * Creates a new staff profile for the current staff user
         */
        public async CreateMyStaffProfile(params: CreateStaffProfileRequest): Promise<CreateStaffProfileResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/mystaffprofiles`, JSON.stringify(params))
            return await resp.json() as CreateStaffProfileResponse
        }

        /**
         * Creates a service for a location
         * Creates a for a location determined by the API region
         */
        public async CreateService(params: CreateServiceRequest): Promise<CreateServiceResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/bookinginternal/services`, JSON.stringify(params))
            return await resp.json() as CreateServiceResponse
        }

        /**
         * CreateServicePrice creates a new service price
         */
        public async CreateServicePrice(serviceId: string, params: CreateServicePriceRequest): Promise<CreateServicePriceResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/bookinginternal/services/${encodeURIComponent(serviceId)}/prices`, JSON.stringify(params))
            return await resp.json() as CreateServicePriceResponse
        }

        /**
         * CreateServicePricesBusiness creates a new service price for business
         */
        public async CreateServicePricesBusiness(serviceId: string, priceId: string, params: CreateServicePricesBusinessRequest): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/v1/bookinginternal/services/${encodeURIComponent(serviceId)}/prices/${encodeURIComponent(priceId)}/businesses`, JSON.stringify(params))
        }

        /**
         * CreateServiceSchedule creates a new service schedule
         */
        public async CreateServiceSchedule(serviceId: string, params: CreateServiceScheduleRequest): Promise<CreateServiceScheduleResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/bookinginternal/services/${encodeURIComponent(serviceId)}/schedules`, JSON.stringify(params))
            return await resp.json() as CreateServiceScheduleResponse
        }

        /**
         * CreateShift creates a shift with a staff profile if staff profile id is passed, otherwise creates a shift without a staff profile
         */
        public async CreateShift(params: CreateShiftRequest): Promise<CreateShiftResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/shifts`, JSON.stringify(params))
            return await resp.json() as CreateShiftResponse
        }

        /**
         * Creates a new staff profile for a JWT user for user in the portal and testing
         */
        public async CreateStaffProfile(params: CreateStaffProfileRequest): Promise<CreateStaffProfileResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/staffprofiles`, JSON.stringify(params))
            return await resp.json() as CreateStaffProfileResponse
        }

        /**
         * Add a service to a staff member.
         * 
         * CreateStaffSkill adds a new service ("skill") to a staff member.
         */
        public async CreateStaffSkill(staffDocID: string, params: CreateStaffSkillRequest): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/v1/staff/${encodeURIComponent(staffDocID)}/services`, JSON.stringify(params))
        }

        /**
         * CreateVonageUser creates a Vonage user for a staff profile
         */
        public async CreateVonageUser(staffProfileID: string): Promise<CreateVonageUserResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/staff/${encodeURIComponent(staffProfileID)}/vonage-user`)
            return await resp.json() as CreateVonageUserResponse
        }

        /**
         * DeactivateServiceSchedule deactivates an existing service schedule
         */
        public async DeactivateServiceSchedule(serviceId: string, scheduleId: string, params: DeactivateServiceScheduleRequest): Promise<DeactivateServiceScheduleResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("PATCH", `/v1/bookinginternal/services/${encodeURIComponent(serviceId)}/schedules/${encodeURIComponent(scheduleId)}/deactivate`)
            return await resp.json() as DeactivateServiceScheduleResponse
        }

        /**
         * DeleteBusinessService deletes service for business
         */
        public async DeleteBusinessService(serviceId: string, businessId: string): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/v1/bookinginternal/services/${encodeURIComponent(serviceId)}/business/${encodeURIComponent(businessId)}`)
        }

        /**
         * DeleteChatService
         * Delete a chat service by doc id
         */
        public async DeleteChatService(docID: string): Promise<void> {
            await this.baseClient.callTypedAPI("DELETE", `/v1/chat-service/${encodeURIComponent(docID)}`)
        }

        /**
         * Remove a chat service from a staff member.
         * 
         * DeleteChatServiceStaff deletes a relationship between a chat service and a staff member
         */
        public async DeleteChatServiceStaff(staffDocID: string, serviceDocID: string): Promise<void> {
            await this.baseClient.callTypedAPI("DELETE", `/v1/staff/${encodeURIComponent(staffDocID)}/chat-services/${encodeURIComponent(serviceDocID)}`)
        }

        /**
         * DeleteHandoverReason
         * Delete a handover reason
         */
        public async DeleteHandoverReason(reasonID: string): Promise<void> {
            await this.baseClient.callTypedAPI("DELETE", `/v1/handover/reasons/${encodeURIComponent(reasonID)}`)
        }

        /**
         * Deletes a service for a location
         */
        public async DeleteService(serviceId: string): Promise<void> {
            await this.baseClient.callTypedAPI("DELETE", `/v1/bookinginternal/services/${encodeURIComponent(serviceId)}`)
        }

        /**
         * DeleteServicePricesBusiness deletes a service price for business
         */
        public async DeleteServicePricesBusiness(serviceId: string, priceId: string, businessId: string): Promise<void> {
            await this.baseClient.callTypedAPI("DELETE", `/v1/bookinginternal/services/${encodeURIComponent(serviceId)}/prices/${encodeURIComponent(priceId)}/businesses/${encodeURIComponent(businessId)}`)
        }

        /**
         * DeleteShift deletes a shift by id
         */
        public async DeleteShift(shiftId: string): Promise<void> {
            await this.baseClient.callTypedAPI("DELETE", `/v1/shifts/${encodeURIComponent(shiftId)}`)
        }

        /**
         * Delete Staff Profile
         * This endpoint deletes an existing staff profile by a provided **staff_profile_doc_id**.
         */
        public async DeleteStaffProfile(staff_profile_doc_id: string): Promise<void> {
            await this.baseClient.callTypedAPI("DELETE", `/v1/staffprofiles/${encodeURIComponent(staff_profile_doc_id)}`)
        }

        /**
         * Remove a service ("skill") from a staff member.
         * 
         * DeleteServiceStaff deletes a relationship between a service and a staff member
         */
        public async DeleteStaffSkill(staffDocID: string, serviceDocID: string): Promise<void> {
            await this.baseClient.callTypedAPI("DELETE", `/v1/staff/${encodeURIComponent(staffDocID)}/services/${encodeURIComponent(serviceDocID)}`)
        }

        /**
         * Run CRON job from portal
         */
        public async DynamicallyReassignAppointments(): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/v1/cron/reassign-appointments`)
        }

        /**
         * FreezeChannel
         * Freeze channel by chat doc ID
         */
        public async FreezeChannel(chatDocID: string): Promise<void> {
            await this.baseClient.callTypedAPI("PUT", `/v1/chats/${encodeURIComponent(chatDocID)}/freeze`)
        }

        /**
         * GetCall retrieves a call by its doc_id
         * This is used to fetch call details for consultations that originated from voice calls
         */
        public async GetCall(callDocID: string): Promise<GetCallResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/calls/by-id/${encodeURIComponent(callDocID)}`)
            return await resp.json() as GetCallResponse
        }

        /**
         * GetCallByVonageUUID looks up a call record by its Vonage call UUID or conversation UUID
         * This is useful for the test phone screen where you have the Vonage UUID from TestCreateCall
         * but need the database doc_id to answer the call
         * 
         * Note: The call record is only created when Vonage hits the incoming-call webhook,
         * so this endpoint may return not found if called immediately after creating the test call.
         * Wait for the customer's phone to ring and be answered before calling this endpoint.
         */
        public async GetCallByVonageUUID(vonageUUID: string): Promise<GetCallByVonageUUIDResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/calls/vonage/${encodeURIComponent(vonageUUID)}`)
            return await resp.json() as GetCallByVonageUUIDResponse
        }

        /**
         * GetChat
         * Get chat by doc ID
         */
        public async GetChat(chatDocID: string): Promise<entities.ChatResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/chats/${encodeURIComponent(chatDocID)}`)
            return await resp.json() as entities.ChatResponse
        }

        /**
         * GetChatService
         * Get a chat service by doc id
         */
        public async GetChatService(docID: string): Promise<GetChatServiceResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/chat-service/${encodeURIComponent(docID)}`)
            return await resp.json() as GetChatServiceResponse
        }

        /**
         * GetChatVideoTranscriptionsByChatDocID returns the transcriptions of video calls
         * held inside a chat that converted to video in-place (no separate appointment).
         * A chat that never converted to video yields an empty, unavailable response.
         */
        public async GetChatVideoTranscriptionsByChatDocID(chatDocID: string): Promise<GetTranscriptionsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/chat-video-transcriptions/${encodeURIComponent(chatDocID)}`)
            return await resp.json() as GetTranscriptionsResponse
        }

        /**
         * GetHandover
         * Get a handover by chat id
         */
        public async GetHandover(chatID: string): Promise<GetHandoverResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/chats/${encodeURIComponent(chatID)}/handover`)
            return await resp.json() as GetHandoverResponse
        }

        /**
         * GetHandoverReason
         * Get handover reason by id
         */
        public async GetHandoverReason(reasonID: string): Promise<entities.HandoverReason> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/handover/reasons/${encodeURIComponent(reasonID)}`)
            return await resp.json() as entities.HandoverReason
        }

        /**
         * GetHandoverReasons
         * Get all handover reasons
         */
        public async GetHandoverReasons(): Promise<GetHandoverReasonsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/handover/reasons`)
            return await resp.json() as GetHandoverReasonsResponse
        }

        /**
         * GetAppointment fetches an appointment by id
         */
        public async GetInternalAppointment(appointmentId: string, params: GetAppointmentRequest): Promise<GetAppointmentResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                timezone: params.Timezone,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/bookinginternal/appointments/${encodeURIComponent(appointmentId)}`, undefined, {query})
            return await resp.json() as GetAppointmentResponse
        }

        /**
         * GetLiveVideoProvider gets the video provider that all new video calls will be made with
         * Currently only affects appointments.
         */
        public async GetLiveVideoProvider(): Promise<GetLiveVideoProviderResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/maintenance/video-provider`)
            return await resp.json() as GetLiveVideoProviderResponse
        }

        /**
         * Fetches the staff profile for the current user
         */
        public async GetMyStaffProfile(): Promise<GetStaffProfileResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/mystaffprofiles`)
            return await resp.json() as GetStaffProfileResponse
        }

        /**
         * Get all pending chats
         * Get all chats with status as pending (ordered by newest first)
         */
        public async GetPendingChats(params: entities.GetPendingChatsRequest): Promise<entities.GetPendingChatsResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "items_per_page": String(params.RequestedItemsPerPage),
                "page_number":    String(params.RequestedPageNumber),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/pending-chats`, undefined, {query})
            return await resp.json() as entities.GetPendingChatsResponse
        }

        /**
         * Get Refund
         */
        public async GetRefund(appointment_doc_id: string, refund_doc_id: string): Promise<GetRefundResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/refunds/${encodeURIComponent(appointment_doc_id)}/refund/${encodeURIComponent(refund_doc_id)}`)
            return await resp.json() as GetRefundResponse
        }

        /**
         * Fetch a service
         */
        public async GetService(serviceId: string): Promise<GetServiceResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/bookinginternal/services/${encodeURIComponent(serviceId)}`)
            return await resp.json() as GetServiceResponse
        }

        /**
         * GetServicePrice fetches a service price by its ID
         */
        public async GetServicePrice(serviceId: string, priceId: string): Promise<GetServicePriceResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/bookinginternal/services/${encodeURIComponent(serviceId)}/prices/${encodeURIComponent(priceId)}`)
            return await resp.json() as GetServicePriceResponse
        }

        /**
         * GetServiceSchedule fetches a service schedule by its ID
         */
        public async GetServiceSchedule(serviceId: string, scheduleId: string): Promise<GetServiceScheduleResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/bookinginternal/services/${encodeURIComponent(serviceId)}/schedules/${encodeURIComponent(scheduleId)}`)
            return await resp.json() as GetServiceScheduleResponse
        }

        /**
         * GetShift fetches a shift by id
         */
        public async GetShift(shiftId: string): Promise<GetShiftResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/shifts/${encodeURIComponent(shiftId)}`)
            return await resp.json() as GetShiftResponse
        }

        /**
         * GetStaffProfile fetches a staff profile by id
         */
        public async GetStaffProfile(staffProfileId: string): Promise<GetStaffProfileResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/staffprofiles/${encodeURIComponent(staffProfileId)}`)
            return await resp.json() as GetStaffProfileResponse
        }

        /**
         * GetStaffToken
         * get the staff token
         */
        public async GetStaffToken(staffDocID: string): Promise<GetStaffTokenResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/staff/${encodeURIComponent(staffDocID)}/staff-token`)
            return await resp.json() as GetStaffTokenResponse
        }

        /**
         * GetStaffVideoToken
         */
        public async GetStaffVideoToken(): Promise<GetStaffVideoTokenResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/staff-video-token`)
            return await resp.json() as GetStaffVideoTokenResponse
        }

        public async GetTranscriptionsByAppointmentDocID(appointmentDocID: string): Promise<GetTranscriptionsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/transcriptions/${encodeURIComponent(appointmentDocID)}`)
            return await resp.json() as GetTranscriptionsResponse
        }

        public async GetTranscriptionsByCallDocID(callDocID: string): Promise<GetCallTranscriptionResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/call-transcriptions/${encodeURIComponent(callDocID)}`)
            return await resp.json() as GetCallTranscriptionResponse
        }

        public async GetVonageJWT(): Promise<VonageJWTResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/vonage/jwt`)
            return await resp.json() as VonageJWTResponse
        }

        /**
         * HandleIncomingCall handles the Vonage webhook for incoming calls
         * This endpoint is called by Vonage when a call comes in
         */
        public async HandleIncomingCall(method: "POST", body?: RequestInit["body"], options?: CallParameters): Promise<globalThis.Response> {
            return this.baseClient.callAPI(method, `/v1/vonage/webhooks/incoming-call`, body, options)
        }

        /**
         * HandleRecordingEvent handles the Vonage webhook for recording events
         * This endpoint is called by Vonage when a recording is completed
         */
        public async HandleRecordingEvent(method: "POST", body?: RequestInit["body"], options?: CallParameters): Promise<globalThis.Response> {
            return this.baseClient.callAPI(method, `/v1/vonage/webhooks/recording-event`, body, options)
        }

        /**
         * HandleVonageEvents handles POST webhooks from Vonage for both call events and transfers
         */
        public async HandleVonageEvents(method: "POST", body?: RequestInit["body"], options?: CallParameters): Promise<globalThis.Response> {
            return this.baseClient.callAPI(method, `/v1/vonage/webhooks/events`, body, options)
        }

        /**
         * HandoverChat
         * Handover chat to another vet
         */
        public async HandoverChat(chatID: string, params: HandoverChatRequest): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/v1/chats/${encodeURIComponent(chatID)}/handover`, JSON.stringify(params))
        }

        /**
         * InitiateCall
         */
        public async InitiateCall(chatID: string): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/v1/chats/${encodeURIComponent(chatID)}/call`)
        }

        /**
         * ListActiveCalls List Active Calls
         * This endpoint lists all active phone calls.
         */
        public async ListActiveCalls(params: ListActiveCallsRequest): Promise<ListActiveCallsResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "items_per_page": String(params.RequestedItemsPerPage),
                "page_number":    String(params.RequestedPageNumber),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/calls/active`, undefined, {query})
            return await resp.json() as ListActiveCallsResponse
        }

        /**
         * List all appointments' typeform submissions for given pet
         */
        public async ListAppointmentsTypeformSubmissions(params: TypeformSubmissionsRequest): Promise<TypeformSubmissionsResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "pet_doc_id": params.PetDocID,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/typeform-submissions`, undefined, {query})
            return await resp.json() as TypeformSubmissionsResponse
        }

        /**
         * List Appointments
         * This endpoint lists all appointments.
         */
        public async ListAppointmentsV2(params: ListAppointmentsV2Request): Promise<ListAppointmentsV2Response> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "appointment_type":                            params.AppointmentType,
                "business_id":                                 params.BusinessDocID,
                "end_date":                                    params.EndDate,
                "exclude_appointments_in_consultation_states": params.ExcludeAppointmentsInConsultationStates?.map((v) => v),
                "items_per_page":                              String(params.RequestedItemsPerPage),
                "list_appointments_without_staff_profile":     params.ListAppointmentWithoutStaffProfiles === undefined ? undefined : String(params.ListAppointmentWithoutStaffProfiles),
                open:                                          params.Open === undefined ? undefined : String(params.Open),
                "order_by":                                    params.OrderBy,
                "page_number":                                 String(params.RequestedPageNumber),
                "pet_id":                                      params.PetDocID,
                "queue_sort_mode":                             params.QueueSortMode,
                "service_id":                                  params.ServiceDocID,
                "shift_id":                                    params.ShiftDocID,
                "staff_profile_id":                            params.StaffProfileDocID,
                "start_date":                                  params.StartDate,
                status:                                        params.Status?.map((v) => v),
                timezone:                                      params.Timezone,
                "user_id":                                     params.UserDocID,
                waiting:                                       params.Waiting === undefined ? undefined : String(params.Waiting),
                "waiting_room_entry":                          params.WaitingRoomEntry === undefined ? undefined : String(params.WaitingRoomEntry),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/bookinginternal/appointments`, undefined, {query})
            return await resp.json() as ListAppointmentsV2Response
        }

        /**
         * List Available Appointments
         * This endpoint returns a list of available appointment time slots.
         */
        public async ListAvailabilityInternal(params: ListAvailabilityInternalQueryParams): Promise<ListAvailabilityResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "end_date":       params.EndDate,
                "service_doc_id": params.ServiceDocID,
                "start_date":     params.StartDate,
                timezone:         params.Timezone,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/schedule/availability`, undefined, {query})
            return await resp.json() as ListAvailabilityResponse
        }

        /**
         * List Available Appointment Days
         * This endpoint returns a list of days with available appointment time slots.
         */
        public async ListAvailableDaysInternal(params: ListAvailabileDaysQueryParams): Promise<ListAvailableDaysResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "end_date":       params.EndDate,
                "service_doc_id": params.ServiceID,
                "start_date":     params.StartDate,
                timezone:         params.Timezone,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/bookinginternal/availabledays`, undefined, {query})
            return await resp.json() as ListAvailableDaysResponse
        }

        /**
         * List business service mappings
         */
        public async ListBusinessServiceMapping(serviceId: string): Promise<entities.ListBusinessServiceMappingResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/bookinginternal/services/${encodeURIComponent(serviceId)}/business`)
            return await resp.json() as entities.ListBusinessServiceMappingResponse
        }

        /**
         * ListChatAuditMessages lists all messages in a chat
         */
        public async ListChatAuditMessages(chatDocID: string): Promise<ListChatMessagesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/chat/${encodeURIComponent(chatDocID)}/messages`)
            return await resp.json() as ListChatMessagesResponse
        }

        /**
         * ListChatServices
         * List all chat services
         */
        public async ListChatServices(): Promise<ListChatServicesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/chat-services`)
            return await resp.json() as ListChatServicesResponse
        }

        /**
         * List all appointments booked from the given appointment
         */
        public async ListFollowUpAppointments(appointmentDocID: string, params: ListAppointmentFollowUpsRequest): Promise<ListAppointmentsResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                timezone: params.Timezone,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/appointment-follow-ups/${encodeURIComponent(appointmentDocID)}`, undefined, {query})
            return await resp.json() as ListAppointmentsResponse
        }

        /**
         * Lists Refunds
         */
        public async ListRefunds(): Promise<ListRefundsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/refunds`)
            return await resp.json() as ListRefundsResponse
        }

        /**
         * Lists refunds
         */
        public async ListRefundsForAppointment(appointment_doc_id: string): Promise<ListRefundsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/refunds/${encodeURIComponent(appointment_doc_id)}`)
            return await resp.json() as ListRefundsResponse
        }

        /**
         * ListServicePrices lists all service prices
         */
        public async ListServicePrices(serviceId: string): Promise<ListServicePricesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/bookinginternal/services/${encodeURIComponent(serviceId)}/prices`)
            return await resp.json() as ListServicePricesResponse
        }

        /**
         * List webhooks and events for business
         */
        public async ListServicePricesBusinessMapping(serviceId: string, priceId: string): Promise<entities.ListServicePricesBusinessMappingResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/bookinginternal/services/${encodeURIComponent(serviceId)}/prices/${encodeURIComponent(priceId)}/businesses`)
            return await resp.json() as entities.ListServicePricesBusinessMappingResponse
        }

        /**
         * ListServiceSchedules lists all service schedules
         */
        public async ListServiceSchedules(serviceId: string): Promise<ListServiceSchedulesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/bookinginternal/services/${encodeURIComponent(serviceId)}/schedules`)
            return await resp.json() as ListServiceSchedulesResponse
        }

        /**
         * List Services
         * This endpoint provides a list of available televet appointment types such as Vet, Nurse or Specialists. These services are used to filter available appointment times.
         */
        public async ListServices(params: ListServicesRequest): Promise<ListServicesResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "hide_from_pms": params.HideFromPMS === undefined ? undefined : String(params.HideFromPMS),
                "only_active":   params.ActiveOnly === undefined ? undefined : String(params.ActiveOnly),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/bookinginternal/services`, undefined, {query})
            return await resp.json() as ListServicesResponse
        }

        /**
         * Lists Services For Business
         * Lists services for user's business.
         */
        public async ListServicesForBusiness(businessId: string, params: ListServicesByBusinessRequest): Promise<ListServicesByBusinessResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "hide_from_pms": params.HideFromPMS === undefined ? undefined : String(params.HideFromPMS),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/bookinginternal/business/${encodeURIComponent(businessId)}/services`, undefined, {query})
            return await resp.json() as ListServicesByBusinessResponse
        }

        /**
         * ListShifts lists all shifts
         */
        public async ListShifts(params: ListShiftsRequest): Promise<ListShiftsResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "end_date":             params["end_date"],
                "shift_status":         params["shift_status"],
                "staff_profile_doc_id": params["staff_profile_id"],
                "start_date":           params["start_date"],
                timezone:               params.timezone,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/shifts`, undefined, {query})
            return await resp.json() as ListShiftsResponse
        }

        /**
         * ListSlingLocations
         * Lists all sling locations for a service
         */
        public async ListSlingLocations(): Promise<ListSlingLocationsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/bookinginternal/video-service/sling-locations`)
            return await resp.json() as ListSlingLocationsResponse
        }

        /**
         * ListChatServicesByStaff lists all chat services associated with a specific staff member
         */
        public async ListStaffChatServices(staffDocID: string, params: ListStaffChatServicesRequest): Promise<ListStaffChatServicesResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "only_enabled": String(params.OnlyEnabled),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/staff/${encodeURIComponent(staffDocID)}/chat-services`, undefined, {query})
            return await resp.json() as ListStaffChatServicesResponse
        }

        /**
         * Lists all staff profiles
         */
        public async ListStaffProfiles(params: entities.ListStaffProfilesRequest): Promise<ListStaffProfilesResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "items_per_page": String(params.RequestedItemsPerPage),
                name:             params.Name,
                "page_number":    String(params.RequestedPageNumber),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/staffprofiles`, undefined, {query})
            return await resp.json() as ListStaffProfilesResponse
        }

        /**
         * ListServicesByStaff lists all services associated with a specific staff member
         */
        public async ListStaffSkills(staffDocID: string, params: ListStaffSkillsRequest): Promise<ListStaffSkillsResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "only_enabled": String(params.OnlyEnabled),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/staff/${encodeURIComponent(staffDocID)}/services`, undefined, {query})
            return await resp.json() as ListStaffSkillsResponse
        }

        /**
         * MarkAppointmentAsDidNotAttend marks an appointment as did not attend
         */
        public async MarkAppointmentAsDidNotAttend(appointment_doc_id: string): Promise<void> {
            await this.baseClient.callTypedAPI("PATCH", `/v1/appointments/${encodeURIComponent(appointment_doc_id)}/did-not-attend`)
        }

        /**
         * MissedCallsDashboard
         * This endpoint returns a dashboard showing recent missed calls & statistics
         */
        public async MissedCallsDashboard(): Promise<entities.MissedCallDashboard> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/diagnostics/missed-calls`)
            return await resp.json() as entities.MissedCallDashboard
        }

        /**
         * MissedCallsDetail
         * This endpoint returns a dashboard showing recent missed calls & statistics
         */
        public async MissedCallsDetail(call_id: number): Promise<AppointmentEventsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/diagnostics/missed-calls/${encodeURIComponent(call_id)}`)
            return await resp.json() as AppointmentEventsResponse
        }

        /**
         * Mark appointment's treatment plan as ready
         */
        public async PatchAppointmentTreatmentPlanReady(appointmentId: string): Promise<void> {
            await this.baseClient.callTypedAPI("PATCH", `/v1/appointments/${encodeURIComponent(appointmentId)}/treatment-plan-ready`)
        }

        /**
         * PatchMyStaffProfilePhoto Update My Staff Profile Photo
         * This endpoint updates the authed staff profiles with a photo url.
         */
        public async PatchMyStaffProfilePhoto(params: PatchMyStaffProfilePhotoRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PATCH", `/v1/mystaffprofiles/photo`, JSON.stringify(params))
        }

        /**
         * PatchStaffProfilePhoto Update Staff Profiles With Photo
         * This endpoint allows a clinical admin to update the staff profiles with a photo url.
         */
        public async PatchStaffProfilePhoto(staffDocID: string, params: PatchMyStaffProfilePhotoRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PATCH", `/v1/staffprofiles/${encodeURIComponent(staffDocID)}/photo`, JSON.stringify(params))
        }

        /**
         * PatchStaffProfileRcvsNumer Update rcvs number of a staff profile
         * This endpoint allows a clinical admin to update the rcvs number of a staff.
         */
        public async PatchStaffProfileRcvsNumer(staffDocID: string, params: PatchStaffProfileRcvsNumerRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PATCH", `/v1/staffprofiles/${encodeURIComponent(staffDocID)}/rcvs`, JSON.stringify(params))
        }

        /**
         * Run CRON job from portal
         */
        public async ProcessDidNotAttend(): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/v1/cron/not-attended-appointments`)
        }

        /**
         * Receives Stripe webhooks
         */
        public async ProcessStripeWebhook(method: "POST", body?: RequestInit["body"], options?: CallParameters): Promise<globalThis.Response> {
            return this.baseClient.callAPI(method, `/v1/stripe/webhook`, body, options)
        }

        /**
         * SendProductMessageToChat
         */
        public async SendProductMessageToChat(chatID: string, params: SendProductMessageRequest): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/v1/chats/${encodeURIComponent(chatID)}/product-message`, JSON.stringify(params))
        }

        public async StartArchive(params: StartArchiveRequest): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/v1/archive/start`, JSON.stringify(params))
        }

        public async StopArchive(params: StopArchiveRequest): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/v1/archive/stop`, JSON.stringify(params))
        }

        /**
         * SwitchVideoProvider switches the video provider on the given appointment to a new provider and then notifies clients.
         * Only for use after an appointment has already begun / has a provider.
         */
        public async SwitchVideoProvider(appointmentDocID: string): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/v1/appointments/${encodeURIComponent(appointmentDocID)}/switch-video-provider`)
        }

        /**
         * SyncShifts syncs shifts with Sling
         */
        public async SyncShifts(): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/v1/shifts/sync`)
        }

        /**
         * TestCreateCall initiates a test outbound call via Vonage Voice API
         * This endpoint is used for testing click-to-call functionality
         * IMPORTANT: This should only be used in local/ephemeral environments for testing
         * The webhook URLs are automatically constructed using the environment's webhook base URL
         */
        public async TestCreateCall(params: TestCreateCallRequest): Promise<TestCreateCallResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/test/vonage/create-call`, JSON.stringify(params))
            return await resp.json() as TestCreateCallResponse
        }

        /**
         * UpdateAppointmentConsultStatus updates an appointment's consult status
         */
        public async UpdateAppointmentConsultStatus(appointmentId: string, params: UpdateAppointmentConsultStatusRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PUT", `/v1/staffappointments/${encodeURIComponent(appointmentId)}/consultstatus`, JSON.stringify(params))
        }

        /**
         * Update appointment time
         */
        public async UpdateAppointmentSlot(appointmentId: string, params: UpdateAppointmentSlotRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PATCH", `/v1/appointments/${encodeURIComponent(appointmentId)}/slot`, JSON.stringify(params))
        }

        /**
         * Update staff profile for an appointment
         */
        public async UpdateAppointmentStaffProfile(appointmentId: string, params: UpdateAppointmentStaffProfileRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PATCH", `/v1/staffappointments/${encodeURIComponent(appointmentId)}/staffprofile`, JSON.stringify(params))
        }

        /**
         * Update appointment video session
         */
        public async UpdateAppointmentVideoSession(appointment_doc_id: string): Promise<void> {
            await this.baseClient.callTypedAPI("PATCH", `/v1/appointments/${encodeURIComponent(appointment_doc_id)}/video-session`)
        }

        /**
         * UpdateCallConsultStatus updates a call's consult status
         */
        public async UpdateCallConsultStatus(callDocID: string, params: UpdateCallConsultStatusRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PUT", `/v1/calls/${encodeURIComponent(callDocID)}/consultstatus`, JSON.stringify(params))
        }

        /**
         * UpdateCallConsultation
         * Update call with consultation doc ID
         */
        public async UpdateCallConsultation(callDocID: string, params: UpdateCallConsultationRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PUT", `/v1/calls/${encodeURIComponent(callDocID)}/consultation`, JSON.stringify(params))
        }

        /**
         * UpdateChatCallState
         */
        public async UpdateChatCallState(chatID: string, params: UpdateChatCallStateRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PUT", `/v1/chats/${encodeURIComponent(chatID)}/call/state`, JSON.stringify(params))
        }

        /**
         * UpdateChatConsultStatus updates a chats consult status
         */
        public async UpdateChatConsultStatus(chatID: string, params: UpdateChatConsultStatusRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PUT", `/v1/chats/${encodeURIComponent(chatID)}/consultstatus`, JSON.stringify(params))
        }

        /**
         * UpdateChatService
         * Update a chat service
         */
        public async UpdateChatService(docID: string, params: UpdateChatServiceRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PUT", `/v1/chat-service/${encodeURIComponent(docID)}`, JSON.stringify(params))
        }

        /**
         * UpdateChatServiceStaff updates the enabled status of a chat service for a staff member
         */
        public async UpdateChatServiceStaff(staffDocID: string, serviceDocID: string, params: UpdateChatServiceStaffRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PUT", `/v1/staff/${encodeURIComponent(staffDocID)}/chat-services/${encodeURIComponent(serviceDocID)}`, JSON.stringify(params))
        }

        /**
         * UpdateChatStatus
         * Update chat status
         */
        public async UpdateChatStatus(chatDocID: string, params: UpdateChatStatusRequest): Promise<UpdateChatStatusResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("PUT", `/v1/user/chat/${encodeURIComponent(chatDocID)}/status`, JSON.stringify(params))
            return await resp.json() as UpdateChatStatusResponse
        }

        /**
         * UpdateHandoverReason
         * Update a chat handover reason
         */
        public async UpdateHandoverReason(reasonID: string, params: UpdateHandoverReasonRequest): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/v1/handover/reasons/${encodeURIComponent(reasonID)}`, JSON.stringify(params))
        }

        /**
         * UpdateLiveVideoProvider gets the video provider that all new video calls will be made with
         * Currently only affects appointments.
         */
        public async UpdateLiveVideoProvider(params: UpdateLiveVideoProviderRequest): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/v1/maintenance/video-provider`, JSON.stringify(params))
        }

        /**
         * Updates an existing staff profile for a JWT user
         */
        public async UpdateMyStaffProfile(params: UpdateStaffProfileRequest): Promise<UpdateStaffProfileResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("PUT", `/v1/mystaffprofiles`, JSON.stringify(params))
            return await resp.json() as UpdateStaffProfileResponse
        }

        /**
         * Updates a service for a location
         * Updates a service for a location determined by the API region
         */
        public async UpdateService(serviceId: string, params: UpdateServiceRequest): Promise<UpdateServiceResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("PUT", `/v1/bookinginternal/services/${encodeURIComponent(serviceId)}`, JSON.stringify(params))
            return await resp.json() as UpdateServiceResponse
        }

        /**
         * UpdateServicePrice updates an existing service price
         */
        public async UpdateServicePrice(serviceId: string, priceId: string, params: UpdateServicePriceRequest): Promise<UpdateServicePriceResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("PUT", `/v1/bookinginternal/services/${encodeURIComponent(serviceId)}/prices/${encodeURIComponent(priceId)}`, JSON.stringify(params))
            return await resp.json() as UpdateServicePriceResponse
        }

        /**
         * UpdateServiceSchedule updates an existing service schedule
         */
        public async UpdateServiceSchedule(serviceId: string, scheduleId: string, params: UpdateServiceScheduleRequest): Promise<UpdateServiceScheduleResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("PUT", `/v1/bookinginternal/services/${encodeURIComponent(serviceId)}/schedules/${encodeURIComponent(scheduleId)}`, JSON.stringify(params))
            return await resp.json() as UpdateServiceScheduleResponse
        }

        /**
         * UpdateShiftDates updates the start and end dates of a shift
         */
        public async UpdateShiftDates(shiftId: string, params: UpdateShiftDatesRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PATCH", `/v1/shifts/${encodeURIComponent(shiftId)}/dates`, JSON.stringify(params))
        }

        /**
         * UpdateShiftStaffProfile updates the staff profile of a shift
         */
        public async UpdateShiftStaffProfile(shiftId: string, params: UpdateShiftStaffProfileRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PATCH", `/v1/shifts/${encodeURIComponent(shiftId)}/staffprofile`, JSON.stringify(params))
        }

        /**
         * UpdateShiftStatus updates the status of a shift
         */
        public async UpdateShiftStatus(shiftId: string, params: UpdateShiftStatusRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PATCH", `/v1/shifts/${encodeURIComponent(shiftId)}/status`, JSON.stringify(params))
        }

        /**
         * Updates an existing staff profile
         */
        public async UpdateStaffProfile(staffProfileId: string, params: UpdateStaffProfileRequest): Promise<UpdateStaffProfileResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("PUT", `/v1/staffprofiles/${encodeURIComponent(staffProfileId)}`, JSON.stringify(params))
            return await resp.json() as UpdateStaffProfileResponse
        }

        /**
         * UpdateStaffSkill updates the enabled status of a service for a staff member
         */
        public async UpdateStaffSkill(staffDocID: string, serviceDocID: string, params: UpdateStaffSkillRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PUT", `/v1/staff/${encodeURIComponent(staffDocID)}/services/${encodeURIComponent(serviceDocID)}`, JSON.stringify(params))
        }
    }
}

/**
 * config service is purely for serving
 * config to the frontend/limited backend services
 */
export namespace config {
    /**
     * serves config up to the mobile apps
     */
    export interface ConfigResponse {
        "chat_service_doc_id": string
        "pre_booked_video_service_doc_id"?: string
        "on_demand_video_service_doc_id": string
    }

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.GetConfig = this.GetConfig.bind(this)
        }

        public async GetConfig(): Promise<ConfigResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/config`)
            return await resp.json() as ConfigResponse
        }
    }
}

export namespace consultationexternal {
    export interface AIOutcomeFollowUp {
        "follow_up_time": string
    }

    /**
     * this is in the product world actually a product variant. I want to maintain
     * the abstraction here thought to avoid leaking that concept through the system
     * as far as we're concerned these are just products.
     */
    export interface AIOutcomeProduct {
        /**
         * ProductTitle
         * Parent product title for the selected variant.
         */
        "product_title"?: string

        /**
         * Title
         * Variant title displayed to the user.
         */
        title?: string

        /**
         * Price
         * Product price string from the commerce provider.
         */
        price?: string

        /**
         * CurrencyCode
         * ISO currency code for Price.
         */
        "currency_code"?: string

        /**
         * ImageURL
         * Product image URL for the selected variant.
         */
        "image_url"?: string

        /**
         * SKU
         * Stock keeping unit of the selected variant.
         */
        sku?: string

        /**
         * URL
         * Product detail URL for the selected variant.
         */
        url?: string

        /**
         * ID
         * Provider-specific variant identifier.
         */
        id?: string

        /**
         * Quantity
         * Recommended quantity for this variant.
         */
        quantity?: number

        /**
         * Instructions
         * Usage instructions associated with this product.
         */
        instructions?: string
    }

    export interface AIOutcomeSection {
        title: string
        body: string
        "icon_url"?: string
        warning?: AIOutcomeWarning
    }

    export interface AIOutcomeStaffProfile {
        name: string
        role: string
        "photo_url": string
    }

    export interface AIOutcomeWarning {
        body: string
    }

    export interface CartLinksWithMultipass {
        /**
         * CartUrl
         * Optional cart URL which will link to a basket with the recommended products added.
         */
        "cart_url"?: string

        /**
         * BasketUrl
         * Checkout URL generated with multipass authentication.
         */
        "basket_url": string

        /**
         * ExpiresAt
         * RFC3339 expiry timestamp for the generated multipass links.
         */
        "expires_at"?: string
    }

    export interface ConsultationTreatmentPlanCountResponse {
        /**
         * TotalUnreadTreatmentPlansCount
         * Total count of treatment plans from vet consultations that the user hasn't read yet.
         */
        "total_unread_treatment_plans": number
    }

    export interface ConsultationTreatmentPlanRequest {
        UTMID?: string
        UTMSource?: string
        UTMMedium?: string
        UTMTerm?: string
        UTMCampaign?: string
        UTMContent?: string
    }

    export interface ConsultationTreatmentPlanResponseV1 {
        /**
         * TreatmentPlan
         * Vet-authored treatment plan content for the consultation.
         */
        "treatment_plan": string

        /**
         * Resources
         * A list of URLs to documents the vet has uploaded during the consultation for the
         * owner to view. These URLs will be signed, and thus the customer should be able to access
         * them. These are typically PDFs, but could be images or other types of files.
         */
        resources?: string[]

        /**
         * RecommendedProductResponses
         * Product recommendations attached to this treatment plan.
         */
        "recommended_products": RecommendedProductResponse[]

        /**
         * Reasons
         * Clinical diagnosis reasons grouped into likely and other categories.
         */
        reasons?: Reason[]

        /**
         * IsTreatmentPlanRead
         * Indicates whether the user has opened or marked the treatment plan as read.
         */
        "is_treatment_plan_read": boolean

        /**
         * BasketUrl
         * Checkout URL that opens the prepared basket directly.
         */
        "basket_url": string

        /**
         * CartUrl
         * Optional cart URL used to add or review items before checkout.
         */
        "cart_url"?: string

        /**
         * ExpiresAt
         * RFC3339 expiry timestamp for temporary cart and basket links.
         */
        "expires_at"?: string

        /**
         * StaffName
         * Display name of the staff member associated with this consultation.
         */
        "staff_name": string

        /**
         * StaffProfileURL
         * Public profile image URL for the associated staff member.
         */
        "staff_profile_url": string

        /**
         * StaffDescription
         * Staff role or description shown to the user.
         */
        "staff_role": string

        /**
         * ConsultationCreatedAt
         * RFC3339 timestamp for when the consultation was created.
         */
        "consultation_created_at": string

        /**
         * ConsultationDocID
         * UUID of the consultation associated with this treatment plan.
         */
        "consultation_doc_id": string

        /**
         * UserDocID
         * UUID of the user associated with this consultation and treatment plan.
         */
        "user_doc_id": string

        /**
         * ChatDocID
         * UUID of the chat associated with this consultation, if applicable.
         * Will be populated if the user selected the chat with a vet CTA
         */
        "chat_doc_id"?: string

        /**
         * AppointmentDocID
         * UUID of the appointment associated with this consultation, if applicable.
         * Will be populated if the consultation was created from an appointment booking
         */
        "appointment_doc_id"?: string

        /**
         * RemotePrescription
         * Prescription payment information, if applicable.
         */
        "remote_prescription"?: RemotePrescriptionResponse
    }

    export interface ConsultationTreatmentPlanResponseV2 {
        /**
         * TreatmentPlan
         * Vet-authored treatment plan content for the consultation.
         */
        "treatment_plan": string

        /**
         * Resources
         * A list of URLs to documents the vet has uploaded during the consultation for the
         * owner to view. These URLs will be signed, and thus the customer should be able to access
         * them. These are typically PDFs, but could be images or other types of files.
         */
        resources?: string[]

        /**
         * RecommendedProductResponses
         * Product recommendations attached to this treatment plan.
         */
        "recommended_products": RecommendedProductResponse[]

        /**
         * Reasons
         * Clinical diagnosis reasons grouped into likely and other categories.
         */
        reasons?: Reason[]

        /**
         * IsTreatmentPlanRead
         * Indicates whether the user has opened or marked the treatment plan as read.
         */
        "is_treatment_plan_read": boolean

        /**
         * BasketUrl
         * Checkout URL that opens the prepared basket directly.
         */
        "basket_url": string

        /**
         * CartUrl
         * Optional cart URL used to add or review items before checkout.
         */
        "cart_url"?: string

        /**
         * ExpiresAt
         * RFC3339 expiry timestamp for temporary cart and basket links.
         */
        "expires_at"?: string

        /**
         * StaffName
         * Display name of the staff member associated with this consultation.
         */
        "staff_name": string

        /**
         * StaffProfileURL
         * Public profile image URL for the associated staff member.
         */
        "staff_profile_url": string

        /**
         * StaffDescription
         * Staff role or description shown to the user.
         */
        "staff_role": string

        /**
         * ConsultationCreatedAt
         * RFC3339 timestamp for when the consultation was created.
         */
        "consultation_created_at": string

        /**
         * ConsultationDocID
         * UUID of the consultation associated with this treatment plan.
         */
        "consultation_doc_id": string

        /**
         * UserDocID
         * UUID of the user associated with this consultation and treatment plan.
         */
        "user_doc_id": string

        /**
         * ChatDocID
         * UUID of the chat associated with this consultation, if applicable.
         * Will be populated if the user selected the chat with a vet CTA
         */
        "chat_doc_id"?: string

        /**
         * AppointmentDocID
         * UUID of the appointment associated with this consultation, if applicable.
         * Will be populated if the consultation was created from an appointment booking
         */
        "appointment_doc_id"?: string

        /**
         * RemotePrescription
         * Prescription payment information, if applicable.
         */
        "remote_prescriptions"?: RemotePrescriptionResponse[]
    }

    export interface CreateAIReviewFeedbackRequest {
        /**
         * Feedback is the feedback payload, owned entirely by the frontend. Any
         * valid JSON value other than null is accepted and stored verbatim; the
         * backend does not inspect its shape.
         */
        feedback: JSONValue
    }

    export interface CreateAIReviewFeedbackResponse {
        /**
         * DocID is the identifier of the stored feedback.
         */
        "doc_id": string
    }

    export interface CreateClinicalHistoryReportRequest {
        /**
         * PetDocID
         * The **doc_id** of the pet in **UUID** format.
         */
        "pet_doc_id": string
    }

    export interface CreateClinicalHistoryReportResponse {
        /**
         * FileLocation
         * Signed URL for downloading the generated clinical history report PDF.
         */
        "file_location": string
    }

    export interface GetRecommendedProductsRequest {
        ConsultationDocID?: string
        AppointmentDocID?: string
        ChatDocID?: string
        UTMID?: string
        UTMSource?: string
        UTMMedium?: string
        UTMTerm?: string
        UTMCampaign?: string
        UTMContent?: string
    }

    export interface GetRenderedAIOutcomeResponse {
        "ai_outcome": RenderedAIOutcome
    }

    export interface InstantRecommendationResponse {
        /**
         * RecommendedProductResponses
         * Recommended products resolved for the requested consultation context.
         */
        "recommended_products": RecommendedProductResponse[]

        /**
         * BasketUrl
         * Checkout URL that opens the prepared basket directly.
         */
        "basket_url": string

        /**
         * CartUrl
         * Optional cart URL which will link to a basket with the recommended products added.
         */
        "cart_url"?: string

        /**
         * StaffName
         * Display name of the recommending staff member.
         */
        "staff_name": string

        /**
         * PetName
         * Display name of the pet associated with this recommendation.
         */
        "pet_name": string

        /**
         * ExpiresAt
         * RFC3339 expiry timestamp for temporary cart and basket links.
         */
        "expires_at"?: string
    }

    export interface InstantRecommendationResponseV2 {
        /**
         * RecommendedProductResponses
         * Recommended products resolved for the requested consultation context.
         */
        "recommended_products": RecommendedProductResponse[]

        /**
         * BasketUrl
         * Optional checkout URL that opens the prepared basket directly.
         */
        "basket_url"?: string

        /**
         * CartUrl
         * Optional cart URL which will link to a basket with the recommended products added.
         */
        "cart_url"?: string

        /**
         * StaffName
         * Optional name of the staff member associated with the recommendation.
         */
        "staff_name"?: string

        /**
         * PetName
         * Optional name of the pet associated with the recommendation.
         */
        "pet_name"?: string

        /**
         * ExpiresAt
         * Optional RFC3339 expiry timestamp for temporary cart and basket links.
         */
        "expires_at"?: string

        /**
         * AllowRetry
         * Indicates whether the client should retry because recommendation generation is still in progress.
         */
        "allow_retry": boolean
    }

    export interface ListTreatmentPlansForPetV2Response {
        "treatment_plans": ConsultationTreatmentPlanResponseV2[]
    }

    export interface ListTreatmentPlansRequest {
        OrderBy: string
        PetDocID: string
        Timezone: string
        RequestedItemsPerPage: number
        RequestedPageNumber: number
    }

    export interface PrescriptionPrice {
        /**
         * CurrencyCode
         * e.g. USD or GBP
         */
        "currency_code": string

        /**
         * Amount
         * This will be the amount in the lowest denomination of the currency
         * e.g. 6012 would be either £60.12 or $60.12 depending on currency
         */
        amount: number
    }

    export interface PrescriptionProgressEvent {
        /**
         * Status can be one of these types
         * prescription-written
         * payment-link-sent
         * awaiting-payment
         */
        status: string
    }

    export interface Reason {
        /**
         * ReasonType
         * The reason for visit the vet recorded for this reason.
         */
        "reason_type": string

        /**
         * LikelyDiagnosisCodes
         * Likely diagnosis venom codes selected for this consultation.
         */
        "likely_diagnosis_codes": VenomCode[]

        /**
         * LikelyDiagnosisGroups
         * Likely diagnosis venom groups selected for this consultation.
         */
        "likely_diagnosis_groups": VenomGroup[]

        /**
         * OtherDiagnosisCodes
         * Additional non-primary diagnosis venom codes.
         */
        "other_diagnosis_codes": VenomCode[]

        /**
         * OtherDiagnosisGroups
         * Additional non-primary diagnosis venom groups.
         */
        "other_diagnosis_groups": VenomGroup[]
    }

    export interface RecommendedProductResponse {
        /**
         * ProductDocID
         * UUID of the recommended product.
         */
        "product_doc_id": string

        /**
         * Frequency
         * Recommended administration frequency for the product.
         */
        frequency: string

        /**
         * Usage
         * Usage instructions entered for the product recommendation.
         */
        usage: string

        /**
         * ProductUrl
         * Product page URL for viewing or purchasing the item.
         */
        "product_url": string

        /**
         * ProductName
         * Display name of the recommended product.
         */
        "product_name": string

        /**
         * ProductImage
         * Product image URL used by clients for rendering.
         */
        "product_image": string

        /**
         * ProductPrice
         * Unit price value for the recommended product.
         */
        "product_price": number

        /**
         * Currency
         * ISO currency code for ProductPrice.
         */
        currency: string

        /**
         * Quantity
         * Recommended quantity for this product.
         */
        quantity: number

        /**
         * SKU
         * Stock keeping unit for the recommended variant.
         */
        sku: string
    }

    export interface RemotePrescriptionDietItem {
        name: string
    }

    export interface RemotePrescriptionMedicationItem {
        name: string
        strength: string
        quantity: number
        refills: number
        "directions_for_use": string
        "dispense_as_written": boolean
    }

    export interface RemotePrescriptionResponse {
        /**
         * PrescriptionType denotes the type of prescription.
         * Currently one of [medication, diet]
         */
        "prescription_type": entities.PrescriptionType

        /**
         * PrescriptionPaymentURL
         * URL to pay for the prescription, if the status is link sent.
         */
        "prescription_payment_url"?: string

        /**
         * CurrentPrescriptionPaymentStatus
         * Current payment status of the prescription.
         */
        "current_prescription_payment_status": string

        /**
         * PrescriptionProgress
         * will be a static timeline of all the payment steps the prescription has to go through
         * prescription-created
         * payment-link-sent
         * payment-received
         * it should be used in conjunction with the current_prescription_payment_status
         * to drive the UI display, with the current status acting as a 'marker'
         * as to which step a user is on.
         */
        "prescription_progress"?: PrescriptionProgressEvent[]

        /**
         * PrescriptionPrice
         * is the amount to pay for the prescription
         * it will be present even if the prescription is paid
         */
        "prescription_price": PrescriptionPrice

        "fulfilment_location": string
        "medication_items_us"?: RemotePrescriptionMedicationItem[]
        "diet_items_us"?: RemotePrescriptionDietItem[]
    }

    export interface RenderedAIOutcome {
        /**
         * OutcomeID is the unique identifier of the outcome. Its
         * format is dependent on the outcome source, being a unique remote ID if
         * from an external host (e.g. Contentful), or the request ID if generated
         * by our internal LLM
         */
        "outcome_id"?: string

        /**
         * OutcomePublishedAt is the timestamp when the outcome was published
         */
        "outcome_published_at"?: string

        /**
         * Preview is a short text preview of the outcome
         * For the internally generated outcome, its the only one thats populated
         */
        preview: string

        introduction?: string
        sections?: AIOutcomeSection[]
        products?: AIOutcomeProduct[]
        /**
         * OutcomeType is an enum with values of either
         * - sections
         * - text
         * this can be used to determine which CTA type to render on the frontend.
         */
        "outcome_type": string

        /**
         * Triage codes generated by the LLM at the time of writing can be one of
         * * emergencyVetVisit - pet owner should seek immediate in-person emergency veterinary care; no delay or home management recommended
         * * referIntoPhysicalPractice - pet owner should book an appointment with a physical veterinary practice as soon as possible; pet needs to be physically examined by a veterinarian but not an emergency
         * * recommendFollowUp - a follow-up appointment with a veterinarian (online or in person) is recommended to reassess the pet's condition and incorporate re-examination finding
         * * monitorAtHome - pet owner can monitor the pet at home and seek veterinary advice if symptoms worsen
         * * noConcern - no immediate health concern identified based on the information provided
         * * prescriptionMedicine - condition is likely to require prescription-only medication following a veterinary examinatio
         * * nonPrescriptionProduct - condition may be managed with non-prescription products or over-the-counter care
         * * labTests - diagnostic laboratory tests are recommended
         * * other - outcome does not fit standard categories e.g. general enquiries, technical support, customer support, insurance enquiries
         */
        "triage_codes"?: string[]

        /**
         * HighestUrgencyTriageCode
         * This is the highest urgency triage code in the array. Given following
         * the same logic as the UrgencyLevel
         */
        "highest_urgency_triage_code"?: string

        /**
         * determined by the triage codes. It can be one of:
         * * high - emergencyVetVisit triage code, or other combinations of triage codes that indicate a high urgency level
         * * medium - referIntoPhysicalPractice
         * * low - monitorAtHome or noConcern triage codes, or other combinations of triage codes that indicate a low urgency level
         * it will always be set, even if the LLM did not provide any triage codes, in which case it will default to low urgency
         */
        "urgency_level": string

        /**
         * AssignedStaff is the staff profile of the vet assigned to this outcome, it will always be present
         */
        "assigned_staff": AIOutcomeStaffProfile

        /**
         * FollowUp is when the vet would like to follow up with the owner, if they have set one.
         */
        "follow_up"?: AIOutcomeFollowUp
    }

    export interface VenomCode {
        /**
         * DisplayName
         * Human-readable diagnosis label for the venom code.
         */
        "display_name": string

        /**
         * VenomCode
         * Canonical venom diagnosis code value.
         */
        "venom_code": string
    }

    export interface VenomGroup {
        /**
         * DisplayName
         * Human-readable diagnosis label for the venom group.
         */
        "display_name": string
    }

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.CreateAIReviewFeedback = this.CreateAIReviewFeedback.bind(this)
            this.CreateClinicalHistoryReport = this.CreateClinicalHistoryReport.bind(this)
            this.GetCartLinksWithMultipass = this.GetCartLinksWithMultipass.bind(this)
            this.GetRecommendedProducts = this.GetRecommendedProducts.bind(this)
            this.GetRecommendedProductsV2 = this.GetRecommendedProductsV2.bind(this)
            this.GetRenderedAIOutcomeByAIReviewDocID = this.GetRenderedAIOutcomeByAIReviewDocID.bind(this)
            this.GetTreatmentPlanByConsultationV1 = this.GetTreatmentPlanByConsultationV1.bind(this)
            this.GetTreatmentPlanByConsultationV2 = this.GetTreatmentPlanByConsultationV2.bind(this)
            this.GetTreatmentPlanV1 = this.GetTreatmentPlanV1.bind(this)
            this.GetTreatmentPlanV2 = this.GetTreatmentPlanV2.bind(this)
            this.GetUnreadTreatmentPlanCountForPet = this.GetUnreadTreatmentPlanCountForPet.bind(this)
            this.ListTreatmentPlansForPet = this.ListTreatmentPlansForPet.bind(this)
            this.ListTreatmentPlansForPetV2 = this.ListTreatmentPlansForPetV2.bind(this)
            this.MarkTreatmentPlanAsRead = this.MarkTreatmentPlanAsRead.bind(this)
            this.MarkTreatmentPlanAsReadByConsultation = this.MarkTreatmentPlanAsReadByConsultation.bind(this)
        }

        /**
         * CreateAIReviewFeedback Submit feedback on an AI review
         * This endpoint stores a user's feedback about the AI review outcome they were
         * shown. The feedback payload is free-form JSON defined by the client, and can
         * be submitted more than once for the same review.
         */
        public async CreateAIReviewFeedback(aiReviewDocID: string, params: CreateAIReviewFeedbackRequest): Promise<CreateAIReviewFeedbackResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/ai-review/${encodeURIComponent(aiReviewDocID)}/feedback`, JSON.stringify(params))
            return await resp.json() as CreateAIReviewFeedbackResponse
        }

        /**
         * Create Clinical History Report
         * This endpoint generates a PDF report of a pet’s history for a particular pet and returns the file location where it is stored.
         */
        public async CreateClinicalHistoryReport(params: CreateClinicalHistoryReportRequest): Promise<CreateClinicalHistoryReportResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/clinical-history-report`, JSON.stringify(params))
            return await resp.json() as CreateClinicalHistoryReportResponse
        }

        /**
         * Get Cart Links With Multipass
         * This endpoint returns the a url with multipass token which then will redirect to the appropriate cart page
         */
        public async GetCartLinksWithMultipass(params: GetRecommendedProductsRequest): Promise<CartLinksWithMultipass> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "appointment_doc_id":  params.AppointmentDocID,
                "chat_doc_id":         params.ChatDocID,
                "consultation_doc_id": params.ConsultationDocID,
                "utm_campaign":        params.UTMCampaign,
                "utm_content":         params.UTMContent,
                "utm_id":              params.UTMID,
                "utm_medium":          params.UTMMedium,
                "utm_source":          params.UTMSource,
                "utm_term":            params.UTMTerm,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/recommended-products/multipass-cart-links`, undefined, {query})
            return await resp.json() as CartLinksWithMultipass
        }

        /**
         * GetRecommendedProducts
         * This endpoint returns the recommended products by a given document ID.
         */
        public async GetRecommendedProducts(params: GetRecommendedProductsRequest): Promise<InstantRecommendationResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "appointment_doc_id":  params.AppointmentDocID,
                "chat_doc_id":         params.ChatDocID,
                "consultation_doc_id": params.ConsultationDocID,
                "utm_campaign":        params.UTMCampaign,
                "utm_content":         params.UTMContent,
                "utm_id":              params.UTMID,
                "utm_medium":          params.UTMMedium,
                "utm_source":          params.UTMSource,
                "utm_term":            params.UTMTerm,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/recommended-products`, undefined, {query})
            return await resp.json() as InstantRecommendationResponse
        }

        /**
         * GetRecommendedProductsV2
         * This endpoint returns the recommended products by a given document ID.
         */
        public async GetRecommendedProductsV2(params: GetRecommendedProductsRequest): Promise<InstantRecommendationResponseV2> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "appointment_doc_id":  params.AppointmentDocID,
                "chat_doc_id":         params.ChatDocID,
                "consultation_doc_id": params.ConsultationDocID,
                "utm_campaign":        params.UTMCampaign,
                "utm_content":         params.UTMContent,
                "utm_id":              params.UTMID,
                "utm_medium":          params.UTMMedium,
                "utm_source":          params.UTMSource,
                "utm_term":            params.UTMTerm,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v2/recommended-products`, undefined, {query})
            return await resp.json() as InstantRecommendationResponseV2
        }

        /**
         * GetRenderedAIOutcomeByAIReviewDocID gets the outcome of a review with a doc_id
         * It uses UserAuthData to get the UserDocID of the calling user.
         */
        public async GetRenderedAIOutcomeByAIReviewDocID(aiReviewDocID: string): Promise<GetRenderedAIOutcomeResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/ai-review/${encodeURIComponent(aiReviewDocID)}/rendered-outcome`)
            return await resp.json() as GetRenderedAIOutcomeResponse
        }

        /**
         * GetTreatmentPlanByConsultationV1
         * returns a treatment plan by consultation docID. Deprecated: use GetTreatmentPlanByConsultationV2
         */
        public async GetTreatmentPlanByConsultationV1(consultation_doc_id: string, params: ConsultationTreatmentPlanRequest): Promise<ConsultationTreatmentPlanResponseV1> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "utm_campaign": params.UTMCampaign,
                "utm_content":  params.UTMContent,
                "utm_id":       params.UTMID,
                "utm_medium":   params.UTMMedium,
                "utm_source":   params.UTMSource,
                "utm_term":     params.UTMTerm,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/treatment-plan/${encodeURIComponent(consultation_doc_id)}`, undefined, {query})
            return await resp.json() as ConsultationTreatmentPlanResponseV1
        }

        /**
         * GetTreatmentPlanByConsultationV2
         * returns a treatment plan by consultation docID.
         */
        public async GetTreatmentPlanByConsultationV2(consultation_doc_id: string, params: ConsultationTreatmentPlanRequest): Promise<ConsultationTreatmentPlanResponseV2> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "utm_campaign": params.UTMCampaign,
                "utm_content":  params.UTMContent,
                "utm_id":       params.UTMID,
                "utm_medium":   params.UTMMedium,
                "utm_source":   params.UTMSource,
                "utm_term":     params.UTMTerm,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v2/treatment-plan/${encodeURIComponent(consultation_doc_id)}`, undefined, {query})
            return await resp.json() as ConsultationTreatmentPlanResponseV2
        }

        /**
         * GetTreatmentPlanV1
         * returns a treatment plan for an existing appointment with completed vet consultation.
         * 
         * Deprecated: use GetTreatmentPlanV2
         */
        public async GetTreatmentPlanV1(appointment_doc_id: string, params: ConsultationTreatmentPlanRequest): Promise<ConsultationTreatmentPlanResponseV1> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "utm_campaign": params.UTMCampaign,
                "utm_content":  params.UTMContent,
                "utm_id":       params.UTMID,
                "utm_medium":   params.UTMMedium,
                "utm_source":   params.UTMSource,
                "utm_term":     params.UTMTerm,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/appointment/${encodeURIComponent(appointment_doc_id)}/treatment-plan`, undefined, {query})
            return await resp.json() as ConsultationTreatmentPlanResponseV1
        }

        /**
         * GetTreatmentPlanV2
         * returns a treatment plan for an existing appointment with completed vet consultation.
         */
        public async GetTreatmentPlanV2(appointment_doc_id: string, params: ConsultationTreatmentPlanRequest): Promise<ConsultationTreatmentPlanResponseV2> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "utm_campaign": params.UTMCampaign,
                "utm_content":  params.UTMContent,
                "utm_id":       params.UTMID,
                "utm_medium":   params.UTMMedium,
                "utm_source":   params.UTMSource,
                "utm_term":     params.UTMTerm,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v2/appointment/${encodeURIComponent(appointment_doc_id)}/treatment-plan`, undefined, {query})
            return await resp.json() as ConsultationTreatmentPlanResponseV2
        }

        /**
         * Get Unread Treatment Plan Count
         * This endpoint returns the count of unread treatment plans for the user.
         */
        public async GetUnreadTreatmentPlanCountForPet(user_doc_id: string, pet_doc_id: string): Promise<ConsultationTreatmentPlanCountResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/users/${encodeURIComponent(user_doc_id)}/pets/${encodeURIComponent(pet_doc_id)}/unread-treatment-plans`)
            return await resp.json() as ConsultationTreatmentPlanCountResponse
        }

        /**
         * ListTreatmentPlansForPet
         * This endpoint returns a list of treatment plans for the user's pet.
         */
        public async ListTreatmentPlansForPet(user_doc_id: string, pet_doc_id: string, params: ListTreatmentPlansRequest): Promise<entities.TreatmentPlanReadyList> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "items_per_page": String(params.RequestedItemsPerPage),
                "order_by":       params.OrderBy,
                "page_number":    String(params.RequestedPageNumber),
                "pet_doc_id":     params.PetDocID,
                timezone:         params.Timezone,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/users/${encodeURIComponent(user_doc_id)}/pets/${encodeURIComponent(pet_doc_id)}/treatment-plans`, undefined, {query})
            return await resp.json() as entities.TreatmentPlanReadyList
        }

        /**
         * ListTreatmentPlansForPetV2
         * returns the treatment plans for the user's pet.
         */
        public async ListTreatmentPlansForPetV2(user_doc_id: string, pet_doc_id: string): Promise<ListTreatmentPlansForPetV2Response> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v2/users/${encodeURIComponent(user_doc_id)}/pets/${encodeURIComponent(pet_doc_id)}/treatment-plans`)
            return await resp.json() as ListTreatmentPlansForPetV2Response
        }

        /**
         * MarkTreatmentPlanAsRead Mark treatment plan as read
         * This endpoint marks a treatment plan as read by the user.
         */
        public async MarkTreatmentPlanAsRead(appointment_doc_id: string): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/v1/appointment/${encodeURIComponent(appointment_doc_id)}/treatment-plan-read`)
        }

        /**
         * MarkTreatmentPlanAsReadByConsultation Mark treatment plan as read
         * This endpoint marks a treatment plan as read by the user, using a consultationDocID.
         */
        public async MarkTreatmentPlanAsReadByConsultation(consultation_doc_id: string): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/v1/treatment-plan/${encodeURIComponent(consultation_doc_id)}/read`)
        }
    }
}

/**
 * consultationinternal houses any endpoints that are designed to be user facing, for
 * vets doing a consultation
 */
export namespace consultationinternal {
    export interface AIOutcome {
        "agent_name": string
        preview: string
        "outcome_description": string
        introduction: string
        "staff_profile": AIOutcomeStaffProfile
        sections: AIOutcomeSection[]
        id: string
        "published_at": string
        products: AIOutcomeProduct[]
    }

    export interface AIOutcomeFollowUp {
        "follow_up_time": string
    }

    export interface AIOutcomeFollowUpRequest {
        "follow_up_time": string
    }

    /**
     * this is in the product world actually a product variant. I want to maintain
     * the abstraction here thought to avoid leaking that concept through the system
     * as far as we're concerned these are just products.
     */
    export interface AIOutcomeProduct {
        /**
         * catalogue product doc ID used for updates
         */
        "doc_id": string

        /**
         * title of the head product e.g. Tick Remover
         */
        "product_title": string

        /**
         * variant title e.g. Small Size
         */
        title: string

        price: string
        "currency_code": string
        "image_url": string
        sku: string
        url: string
        id: string
        quantity: number
        instructions: string
    }

    export interface AIOutcomeSection {
        title: string
        body: string
        "icon_url": string
        warning: AIOutcomeWarning
    }

    export interface AIOutcomeStaffProfile {
        name: string
        role: string
        "photo_url": string
    }

    export interface AIOutcomeStartEditResponse {
    }

    export interface AIOutcomeWarning {
        body: string
    }

    export interface AIReview {
        /**
         * DocID
         * this is the DocID of the actual ai_review
         */
        "doc_id": string

        "consultation_doc_id"?: string
        /**
         * AgentName
         * this is the name of the AI Agent that produced this review. At the moment this will just be
         * LLM Gastro Chat, but in the future there may be others
         */
        "agent_name": string

        /**
         * OutcomeType
         * right now this will just be an enum of 'mild-gastro'.
         */
        "outcome_type": string

        /**
         * OutcomeID
         * this is the ID of the outcome (not the review). The outcome is the thing that gets shown to
         * the user. Right now this will be the ID of the resource in contentful, but in the future
         * these might come from different places.
         */
        "outcome_id": string

        "outcome_published_at": string
        "chat_doc_id": string
        /**
         * AssigneeStaffDocID
         * this is optional as when the ai review is created, its unassigned.
         */
        "assignee_staff_doc_id"?: string

        /**
         * CreatedAt
         * this can be used to derive the wait time
         */
        "created_at": string

        "event_log"?: AIReviewEventLog[]
        /**
         * LatestEvent
         * this is the Event enum from the last entry in the event log, repeated here for convience.
         * In the list endpoint, this will likely only ever be 'created' or 'vet-started-review' as
         * these are the two statuses that are queued.
         */
        "latest_event": string

        pet?: AIReviewPet
        user?: AIReviewUser
        business?: AIReviewBusiness
        /**
         * AIChatSummary
         * this is the ai generated chat summary, like the one that's shown to the vet in the regular
         * PMS. There won't always be one, as if the user is really quick, we don't get it generated.
         */
        "ai_chat_summary"?: string

        "ai_review_assigned_staff_profile"?: AIReviewAssignedStaffProfile
        /**
         * venom codes that have come from the triage step
         */
        "venom_code_names"?: string[]

        /**
         * RejectionDetails
         * this is the details around why an AI review was rejected, if it was. This will be nil if the review was not rejected, and will be populated if it was. This is optional as we only started capturing this for rejected reviews after a certain point in time, so older reviews that were rejected won't have this data.
         */
        "rejection_details"?: AIReviewRejectionDetails

        /**
         * Urgency
         * This is the urgency based on the triage codes that are set on the AI review itself
         * Not the latest AI Outcome. They should be equal to the triage codes of the first AI Outcome
         * It will always be set, defaulting to low.
         */
        urgency: string

        /**
         * AIReviewBusinessConfig
         * any applicable config for this users business.
         * if the business config cannot be found, then there should be no restrictions on the frontend for the AI Review
         */
        "ai_review_business_config"?: AIReviewBusinessConfig

        /**
         * ReasonForVisit
         * the reason for visit associated with the chat this AI review belongs to, if one exists
         */
        "reason_for_visit"?: ReasonForVisit
    }

    export interface AIReviewAcceptResponse {
    }

    export interface AIReviewAssignedStaffProfile {
        "doc_id": string
        name: string
        role: string
        "profile_photo_url"?: string
    }

    export interface AIReviewBusiness {
        "doc_id": string
        name: string
        "partner_integration"?: string
    }

    /**
     * AIReviewBusinessConfig
     * any applicable config for this users business.
     * should be used to guide frontend behaviour.
     * these are pulled from the cue file for consultationsinternal
     */
    export interface AIReviewBusinessConfig {
        /**
         * determines whether the user for this business is meant to have products
         * on their AI Review or not
         */
        "products_allowed": boolean

        /**
         * determines whether to block the triage code edit box on the frontend
         */
        "triage_codes_editable": boolean
    }

    export interface AIReviewEventLog {
        "doc_id": string
        event: string
        "event_description"?: string
        "staff_profile_doc_id"?: string
        "created_at": string
    }

    export interface AIReviewListEntry {
        "ai_review": AIReview
        /**
         * UrgencyLevel is either high, medium or low
         */
        "urgency_level": string
    }

    export interface AIReviewListResponse {
        "ai_reviews": AIReview[]
        pagination: shared.Pagination
    }

    export interface AIReviewListResponseV2 {
        "ai_reviews": AIReviewListEntry[]
        pagination: shared.Pagination
    }

    export interface AIReviewPet {
        "doc_id": string
        name: string
        age?: PetAge
        neutered?: boolean
        "species_doc_id": string
        "species_name": string
        "breed_doc_id"?: string
        "breed_name"?: string
        gender: string
        "weight_grams"?: number
    }

    export interface AIReviewRejectRequest {
        "reasons_for_rejection"?: string[]
        "is_emergency"?: boolean
        "is_referral"?: boolean
        "other_comment"?: string
    }

    export interface AIReviewRejectResponse {
    }

    export interface AIReviewRejectionDetails {
        "reasons_for_rejection"?: string[]
        "is_emergency"?: boolean
        "is_referral"?: boolean
        "other_comment"?: string
    }

    export interface AIReviewResponse {
        "ai_review": AIReview
    }

    export interface AIReviewUser {
        "doc_id": string
        email: string
        "first_name": string
        "last_name": string
    }

    export interface AddChatConsultationResponse {
        /**
         * consultation doc_id
         */
        "doc_id": string
    }

    export interface Chat {
        /**
         * this is the unique identifier for a chat room
         */
        "doc_id": string

        /**
         * channel ID is the identifier for the chat room the users are in
         */
        "channel_id": string

        /**
         * status is the current status of this chat
         */
        status: string

        /**
         * status history of the chat in order from first to current over its lifetime
         */
        "status_history": string[]

        /**
         * Channel Type is the type of chat room the users are in (messaging, video)
         */
        "channel_type": string

        /**
         * the last time the chat room was updated
         */
        "updated_at": Dates

        /**
         * the time the chat room was created
         */
        "created_at": Dates

        /**
         * the participants in the chat
         */
        participants: GetParticipantResponse[]

        /**
         * the pet that is associated with this chat
         */
        pet: ChatPetResponse

        /**
         * the user that is associated with this chat
         */
        user: ChatUserResponse

        /**
         * the business that is associated with this chat
         */
        business: ChatBusinessResponse

        /**
         * the consult status of the chat
         */
        "consult_status": string

        /**
         * the reason the chat was disrupted
         */
        "disrupted_reason": string

        /**
         * the actual start time of the chat
         */
        "actual_start_time": Dates

        /**
         * the actual end time of the chat
         */
        "actual_end_time": Dates

        /**
         * the time the LLM handed over the chat to a human responder
         */
        "llm_triage_handover_time": Dates

        /**
         * the name of the chat service
         */
        "service_name": string

        /**
         * the unique identifier for the chat service
         */
        "service_doc_id": string

        /**
         * the timezone of the chat
         */
        "time_zone": string

        /**
         * the video room associated with the chat
         */
        "chat_video_room": ChatVideoRoom

        /**
         * previous sympsom checker session id, if one exists
         */
        "symptom_checker_session_doc_id"?: string

        /**
         * the reason for the visit
         */
        "reason_for_visit"?: ReasonForVisit

        /**
         * marked by the LLM as an emergency. Not ptr like on appointments as every chat will have this true or false
         */
        "is_emergency": boolean

        /**
         * set when the chat was started as a follow-up to a previous consultation
         */
        "is_followup": boolean

        /**
         * whether the chat is overdue, time waiting exceeds set time, helps indicate if it can be terminated, used for pending chats
         */
        "is_overdue": boolean

        /**
         * whether the chat is a whatsapp chat
         */
        "is_whatsapp": boolean

        /**
         * phone number associated with the chat at creation
         */
        "phone_number"?: string

        /**
         * trial context when chat was created from a trial
         */
        "trial_doc_id": uuid.UUID

        /**
         * trial participant context when chat was created from a trial
         */
        "trial_participant_doc_id": uuid.UUID

        /**
         * client data such as operating system and build number, used for analytics and debugging
         */
        "client_data": ClientData

        /**
         * EVCPRElibility
         * based on the users reported current state, the vets registered state, and state specific configuration records whether the consult is eligible for evcpr
         * if the user has not sent a US State shortcode when they created the chat, its nil
         * if the user sent a US State shortcode and there is no evcpr eligibility, its set to false, and returns the users state
         * if the user sent a US State shortcode and there is evcpr eligibility, its true and returns the users state
         */
        "evcpr_elibility"?: EVCPRChatEligibilityDTO
    }

    /**
     * ChatBusinessResponse is the booking-owned business DTO on ChatResponse.
     */
    export interface ChatBusinessResponse {
        "internal_id": number
        id: string
        name: string
        "external_id"?: string
        "partner_integration": string
    }

    /**
     * ChatPetAgeResponse is the booking-owned age DTO embedded on chat responses.
     */
    export interface ChatPetAgeResponse {
        years: number
        months: number
    }

    /**
     * ChatPetBreedResponse is the booking-owned breed DTO embedded on chat responses.
     */
    export interface ChatPetBreedResponse {
        "doc_id": string
        name: string
    }

    /**
     * ChatPetResponse is the booking-owned pet DTO on ChatResponse.
     */
    export interface ChatPetResponse {
        "doc_id": string
        name: string
        gender: string
        weight?: ChatPetWeightUnitsResponse
        neutered?: boolean
        "date_of_birth": string
        breed?: ChatPetBreedResponse
        "created_at": string
        species: string
        "species_id": uuid.UUID
        "photo_url"?: string
        "policy_customer_no"?: string
        "policy_no"?: string
        "policy_active": boolean
        "policy_registered_date"?: string
        "policy_disabled_date"?: string
        "requires_verification": boolean
        triage: boolean
        age: ChatPetAgeResponse
        "policy_start_date"?: string
    }

    /**
     * ChatPetWeightUnitsResponse is the booking-owned weight DTO embedded on chat responses.
     */
    export interface ChatPetWeightUnitsResponse {
        g: number
        kg: number
        lbs: number
    }

    /**
     * ChatUserAddress is the booking-owned address DTO embedded on chat user responses.
     */
    export interface ChatUserAddress {
        "line_1": string
        "line_2": string
        "town_or_city": string
        county: string
        country: string
        postcode: string
    }

    /**
     * ChatUserResponse is the booking-owned user DTO on ChatResponse.
     */
    export interface ChatUserResponse {
        id: number
        "doc_id": uuid.UUID
        "external_id"?: string
        email: string
        "first_name": string
        "last_name": string
        "phone_number"?: string
        "phone_number_raw"?: string
        "phone_number_cc"?: string
        "current_policy_customer_no"?: string
        "requires_verification": boolean
        "post_code": string
        "zip_code"?: string
        "mark_for_deletion"?: boolean
        "mark_for_deletion_at"?: string
        "mark_for_deletion_date"?: string
        address?: ChatUserAddress
        "partner_name"?: string
        "most_recent_access"?: string
    }

    export interface ChatVideoRoom {
        id: number
        "doc_id": string
        "session_room_id": string
        "current_call_details"?: CurrentCallDetails
    }

    export interface CheckPostcodeEligibilityRequest {
        Postcode: string
    }

    export interface CheckPostcodeEligibilityResponse {
        "is_eligible": boolean
        "covered_by_partner_practice"?: GetPartnerPracticeResponse
    }

    export interface ChewyBreedsRequest {
        SpeciesDocID: string
    }

    export interface ChewyBreedsResponse {
        breeds: ChewyPetBreed[]
    }

    export interface ChewyCustomerAddress {
        city?: string
        country?: string
        id: string
        latitude?: number
        longitude?: number
        postalCode?: string
        state?: string
        street?: string[]
        addressType: string
        shippingAttributes?: ChewyCustomerAddressShippingAttributes
    }

    export interface ChewyCustomerAddressShippingAttributes {
        defaultAddress: boolean
        fullName: string
        phone?: ChewyCustomerAddressShippingAttributesPhone
        userId: string
    }

    export interface ChewyCustomerAddressShippingAttributesPhone {
        country?: string
        number?: string
    }

    export interface ChewyFormatAddressRequest {
        "reference_id": string
    }

    export interface ChewyFormatAddressResponse {
        city?: string
        country?: string
        id: string
        latitude?: number
        longitude?: number
        postalCode?: string
        state?: string
        street?: string[]
    }

    /**
     * ChewyPet and its sub fields / types are direct conversions of the data that comes out of the
     * Chewy API
     */
    export interface ChewyPet {
        allergies: ChewyPetAllergy[]
        /**
         * AssistanceAnimal True if the Pet is an assistance animal, false otherwise.
         */
        assistanceAnimal: boolean

        avatar: ChewyPetAvatar
        bannerPhoto: ChewyPetPhoto
        /**
         * Birthday Pet birthday, which may be an estimate.
         */
        birthday: string

        /**
         * BirthdayEstimated True if the birthday is an estimate, false otherwise.
         */
        birthdayEstimated: boolean

        breeds: ChewyPetBreed[]
        createdAt: string
        customerId: string
        /**
         * Gender The Pet gender.
         */
        gender: ChewyPetGender

        iconPhoto: ChewyPetPhoto
        id: string
        medicalConditions: ChewyPetMedicalCondition[]
        medicationAllergies: ChewyPetMedicationAllergy[]
        medications: ChewyPetMedication[]
        name: string
        photos: ChewyPetPhoto[]
        /**
         * SizeType The Pet size type.
         */
        sizeType: ChewyPetSizeType

        /**
         * Status The Pet status.
         */
        status: ChewyPetStatus

        /**
         * Sterilization True if the Pet is sterilized, false otherwise.
         */
        sterilization: boolean

        submitterId: string
        /**
         * Type The PetType type.
         */
        type: ChewyPetType

        updatedAt: string
        /**
         * Weight The Pet weight in pounds.
         */
        weight: number
    }

    export interface ChewyPetAllergy {
        id: string
        name: string
        /**
         * WriteIn Indicates a custom allergy.
         */
        writeIn: boolean
    }

    export interface ChewyPetAvatar {
        id: string
        uri: string
    }

    export interface ChewyPetBreed {
        id: string
        name: string
        type: ChewyPetType
    }

    export type ChewyPetGender = string

    export interface ChewyPetMedicalCondition {
        id: string
        name: string
    }

    export interface ChewyPetMedication {
        id: string
        name: string
    }

    export interface ChewyPetMedicationAllergy {
        id: string
        name: string
    }

    export interface ChewyPetPhoto {
        id: string
        uri: string
    }

    export type ChewyPetSizeType = string

    export type ChewyPetStatus = string

    export interface ChewyPetType {
        id: string
        name: string
    }

    export interface ChewyPetsResponse {
        "matched_user_id": string
        pets: ChewyPet[]
    }

    export interface ChewySearchAddressesRequest {
        term: string
    }

    export interface ChewySearchAddressesResponse {
        addresses: ChewySearchAddressesResponseItem[]
    }

    export interface ChewySearchAddressesResponseItem {
        "reference_id": string
        address: string
    }

    export interface ClientData {
        "client_os": string
        "client_os_version": string
        "client_build_number": string
    }

    export interface ClinicalHistory {
        "clinical_history_category_doc_id": string
        "clinical_history_category_name": string
        "clinical_history_submission": SubmissionResponse
    }

    export interface ClinicalNoteProductRecommendation {
        frequency: string
        usage: string
        "product_name": string
    }

    export interface CompleteConsultationParameters {
        "chat_id": uuid.UUID
        "appointment_id": uuid.UUID
        "consultation_id": uuid.UUID
    }

    export interface ConfigureReasonsPostClinicalHistoryFormsRequest {
        "post_clinical_history_forms": string[]
    }

    export interface ConfigureReasonsPreClinicalHistoryFormsRequest {
        "pre_clinical_history_forms": string[]
    }

    export interface ConfigureReasonsPreExaminationFormsRequest {
        "pre_examination_forms": string[]
    }

    export interface Consultation {
        "doc_id": uuid.UUID
        "appointment_id": uuid.UUID
        "pet_id": uuid.UUID
        "owner_id": uuid.UUID
        "created_at": string
        state: string
        notes: string
        appointment?: GetConsultationAppointmentResponse
        "chat_doc_id": uuid.UUID
        chat?: GetConsultationChatResponse
        "call_doc_id": uuid.UUID
        call?: bookinginternal.GetCallResponse
        /**
         * SourceType indicates the original source of the consultation. It's always
         * set, and can be one of the following 4 fields at the time of writing on
         * 12-Nov-2025: 'appointment', 'chat', 'call', 'ai-review'
         */
        "source_type": string
    }

    export interface ConsultationHistory {
        "consultation_doc_id": uuid.UUID
        "completed_on": string
        notes: string
        "treatment_plan"?: string
        "staff_doc_id"?: uuid.UUID
        reasons: ConsultationHistoryReason[]
        "recommended_products": RecommendedProductResponse[]
        "external_shopify_order_id"?: number
        "purchased_at"?: string
    }

    export interface ConsultationHistoryAIReviewSummary {
        "latest_event": string
    }

    export interface ConsultationHistoryReason {
        "reason_doc_id": uuid.UUID
        "likely_diagnosis_codes": ReasonDiagnosis[]
        "likely_diagnosis_groups": ReasonDiagnosis[]
        "other_diagnosis_codes": ReasonDiagnosis[]
        "other_diagnosis_groups": ReasonDiagnosis[]
        examinations: Examination[]
        "clinical_history": ClinicalHistory[]
        "pre_clinical_history_submissions": SubmissionResponse[]
        "post_clinical_history_submissions": SubmissionResponse[]
        "pre_examinations_submissions": SubmissionResponse[]
    }

    export interface ConsultationPromptConfigResponse {
        "doc_id": string
        "clinical_note_example": string
        "clinical_note_system_prompt": string
        "prompt_type": entities.PromptType
        "is_active": boolean
        "created_at": string
        "updated_at"?: string
    }

    export interface ConsultationStateResponse {
        state: string
        "state_changed_at": string
    }

    export interface ConsultationTypeResponse {
        "doc_id": uuid.UUID
        type: string
    }

    export interface CreateCallConsultationResponse {
        /**
         * consultation doc_id
         */
        "doc_id": string
    }

    export interface CreateClinicalHistoryCategoryRequest {
        name: string
        "form_name": string
        "group_doc_id": string
    }

    export interface CreateClinicalHistoryCategoryResponse {
        "doc_id": string
    }

    export interface CreateClinicalHistoryGroupRequest {
        name: string
    }

    export interface CreateClinicalHistoryGroupResponse {
        "doc_id": uuid.UUID
    }

    export interface CreateConsultationPromptConfigRequest {
        "clinical_note_example": string
        "clinical_note_system_prompt": string
        "prompt_type"?: entities.PromptType
    }

    export interface CreateConsultationPromptConfigResponse {
        "doc_id": uuid.UUID
    }

    export interface CreateConsultationRequest {
        "appointment_id": string
        "pet_id": string
        "owner_id": string
        notes: string
    }

    export interface CreateConsultationResponse {
        id: uuid.UUID
    }

    export interface CreateConsultationTypeRequest {
        type: string
    }

    export interface CreateConsultationTypeResponse {
        DocID: uuid.UUID
    }

    export interface CreateExaminationCategoryRequest {
        name: string
        "form_name": string
        "group_doc_id": string
    }

    export interface CreateExaminationCategoryResponse {
        "doc_id": string
    }

    export interface CreateExaminationGroupRequest {
        name: string
    }

    export interface CreateExaminationGroupResponse {
        "doc_id": uuid.UUID
    }

    export interface CreateFormRequest {
        name: string
        type: string
    }

    export interface CreateFormResponse {
        DocID: uuid.UUID
    }

    export interface CreatePartnerPracticeRequest {
        address: string
        name: string
        "google_place_id": string
        long: string
        lat: string
    }

    export interface CreatePartnerPracticeResponse {
        "doc_id": uuid.UUID
    }

    export interface CreatePatientRecordRequest {
        "pet_doc_id": string
        "type_id": number
        title: string
        description?: string
        "consultation_doc_id"?: string
        source: entities.PatientRecordSource
        "patient_files": UploadPatientFileRequest[]
    }

    export interface CreatePatientRecordResponse {
        "doc_id": string
    }

    export interface CreatePrescriptionPDFRequest {
        prescription: PrescriptionFormSubmission
        timezone: string
    }

    export interface CreatePrescriptionPDFResponse {
        path: string
    }

    export interface CreateReason {
        "reason_type_doc_id": uuid.UUID
        "likely_diagnosis_codes": uuid.UUID[]
        "likely_diagnosis_groups": uuid.UUID[]
        "other_diagnosis_codes": uuid.UUID[]
        "other_diagnosis_groups": uuid.UUID[]
        examinations: CreateReasonExamination[]
        "clinical_history": CreateReasonClinicalHistory[]
        "pre_clinical_history_submissions": FormSubmission[]
        "post_clinical_history_submissions": FormSubmission[]
        "pre_examinations_submissions": FormSubmission[]
    }

    export interface CreateReasonClinicalHistory {
        "clinical_history_category_doc_id": uuid.UUID
        "form_name": string
        "form_data": FormData
    }

    export interface CreateReasonExamination {
        "examination_category_doc_id": uuid.UUID
        "form_name": string
        "form_data": FormData
    }

    export interface CreateReasonGroupRequest {
        name: string
    }

    export interface CreateReasonGroupResponse {
        "doc_id": uuid.UUID
    }

    export interface CreateReasonTypeRequest {
        name: string
        "group_doc_id": string
    }

    export interface CreateReasonTypeResponse {
        "doc_id": string
    }

    export interface CreateReasonsRequest {
        reasons: CreateReason[]
        timezone: string
    }

    export interface CreateReasonsResponse {
        "created_at"?: utilities.Dates
    }

    export interface CreateSubmissionRequest {
        /**
         * form io payload of the submission including the form version and data
         */
        "form_data": FormData

        /**
         * name of the form that was completed
         */
        "form_name": string

        /**
         * id of the consultation that the form was submitted for
         */
        "consultation_id": uuid.UUID
    }

    export interface CreateSubmissionResponse {
        id: uuid.UUID
    }

    export interface CreateTreatmentPlanTemplateRequest {
        name: string
        template: string
        resources: string[]
    }

    export interface CreateTreatmentPlanTemplateResponse {
        id: uuid.UUID
    }

    export interface CurrentCallDetails {
        "doc_id": string
        "message_id": string
        "staff_name": string
        "staff_picture": string
        status: string
        "created_at": string
        duration: number
    }

    export interface Dates {
        /**
         * UTC
         * Time in UTC (e.g. **2017-09-04T04:00:00Z**)
         */
        utc: string

        /**
         * Local
         * Time in local (e.g. **2017-09-04T04:00:00**)
         */
        local: string

        /**
         * DateFriendly
         * Date (e.g. **04/09/2017**)
         */
        "date_friendly": string

        /**
         * TimeFriendly
         * Time (e.g. **04:00 BST**)
         */
        "time_friendly": string

        /**
         * Timezone
         * **timezone** in IANA format
         * (e.g **Europe/London**, **UTC**, **Europe/Berlin**)
         */
        timezone: string
    }

    /**
     * EVCPREligibilityDTO is a struct representing the EVCPR eligibility
     * it should be in bookinginternal, but because the main chat DTO is here in the entities
     * this must be as well. I've separated it from the business logic struct, so if we do
     * ever move the chat entity to the bookinginternal package, this should be easier as well
     */
    export interface EVCPRChatEligibilityDTO {
        "is_evcpr_eligible": boolean
        "user_current_state": string
    }

    export interface EVCPRStatus {
        DocID: uuid.UUID
        ConsultationDocID: uuid.UUID
        UserUSState: usstates.ISO31662ShortCode
        StaffID: uuid.UUID
        MatchedVetRegistrationUSState: usstates.ISO31662ShortCode
        EVCPREligible: boolean
        SourceOperation: string
        EVCPRConfirmed: boolean
        PrescriptionClarifications?: string
        CreatedAt: string
    }

    export interface EditTreatmentPlanTemplateRequest {
        name: string
        template: string
        resources: string[]
    }

    export interface EditTreatmentPlanTemplateResponse {
        "doc_id": uuid.UUID
    }

    export interface Examination {
        "examination_category_doc_id": string
        "examination_category_name": string
        "examination_submission": SubmissionResponse
    }

    export interface FormData {
        "_fvid": number
        data: JSONValue
    }

    export interface FormResponse {
        "doc_id": uuid.UUID
        name: string
        "consultation_type": string
        "created_at": string
    }

    export interface FormSubmission {
        "form_data": FormData
        "form_name": string
    }

    export interface GenerateClinicalNoteRequest {
        reasons: CreateReason[]
        "treatment_plan"?: string
        "recommended_products"?: ClinicalNoteProductRecommendation[]
        outcome?: JSONValue
    }

    export interface GenerateClinicalNoteResponse {
        "soap_note": string
        "customer_note": string
    }

    export interface GetAIOutcomeRequest {
        PetDocID: string
        OwnerDocID: string
        OutcomeDescription: string
    }

    export interface GetAIOutcomeResponse {
        "ai_outcome": AIOutcome
    }

    export interface GetAIReviewByChatDocIDResponse {
        /**
         * AIReview is specifically nullable here, as it is possible to have a chat
         * without an AI review.
         */
        "ai_review": AIReview
    }

    export interface GetAIReviewByConsultationDocIDResponse {
        /**
         * AIReview is specifically nullable here, as it is possible to have a consultation
         * without an AI review.
         */
        "ai_review"?: AIReview
    }

    export interface GetAllConsultationsResponse {
        pagination: shared.Pagination
        consultations: Consultation[]
    }

    export interface GetClinicalHistoryCategoryResponse {
        "doc_id": string
        name: string
        "form_name": string
        "group_doc_id": string
    }

    export interface GetClinicalHistoryGroupResponse {
        "doc_id": uuid.UUID
        name: string
    }

    export interface GetConsultationAgeResponse {
        years: number
        months: number
    }

    export interface GetConsultationAppointmentDatesResponse {
        utc: string
        local: string
        "date_friendly": string
        "time_friendly": string
        timezone: string
    }

    export interface GetConsultationAppointmentResponse {
        "doc_id": string
        start: GetConsultationAppointmentDatesResponse
        end: GetConsultationAppointmentDatesResponse
        status: string
        "pet_id": string
        "user_id": string
        "room_id"?: string
        "session_id"?: string
        "payment_intent_id"?: string
        "staff_profile_id"?: string
        "staff_profile_name"?: string
        "staff_profile_description"?: string
        "staff_profile_photo_url"?: string
        "staff_profile_rcvs_number"?: string
        "staff_profile_chewy_vet_id"?: string
        "is_waiting": boolean
        "is_open": boolean
        "is_late": boolean
        "is_priority": boolean
        "is_overdue": boolean
        "started_waiting_time"?: string
        "last_seen_waiting"?: string
        "waiting_time_in_minutes"?: number
        "actual_start_time"?: string
        "actual_end_time"?: string
        "consult_status"?: string
        "disrupted_reason"?: string
        pet: GetConsultationPetResponse
        user: GetConsultationUserResponse
        business: GetConsultationBusinessResponse
        notes?: string
        "appointment_photos_urls": string[]
        "symptom_checker_session_doc_id"?: string
        "symptom_checker_session_algorithm_title"?: string
        "symptom_checker_session_outcome_urgency"?: string
        "service_name": string
        "service_doc_id": string
        "service_is_trial": boolean
        "typeform_event_id": string
        "on_demand": boolean
        "video_stream_provider"?: string
        "previous_chat_doc_id"?: string
        "previous_chat"?: GetConsultationChatResponse
        reassigned: boolean
        "is_trial_participant": boolean
        "trial_info"?: TrialAppointmentStepInfoResponse
        "created_at": string
        /**
         * optional here as a consultation appointment may not have a chat.
         */
        "is_emergency"?: boolean

        "is_transcription_available": boolean
    }

    export interface GetConsultationBusinessResponse {
        "internal_id": number
        id: string
        name: string
        "external_id"?: string
        "partner_integration": string
    }

    export interface GetConsultationByAppointmentResponse {
        "consultation_doc_id": string
    }

    export interface GetConsultationByChatResponse {
        "consultation_doc_id": string
    }

    export interface GetConsultationChatResponse {
        "doc_id": string
        "channel_id": string
        status: string
        "status_history": string[]
        "channel_type": string
        "updated_at": utilities.Dates
        pet: GetConsultationPetResponse
        user: GetConsultationUserResponse
        business: GetConsultationBusinessResponse
        participants: entities.GetParticipantResponse[]
        "created_at": utilities.Dates
        "consult_status": utilities.ConsultStatus
        "disrupted_reason": string
        "actual_start_time": utilities.Dates
        "actual_end_time": utilities.Dates
        "service_name": string
        "service_doc_id": string
        "time_zone": string
        "chat_video_room": entities.ChatVideoRoom
        "symptom_checker_session_doc_id"?: string
        "phone_number"?: string
        /**
         * will always be present, as we're getting a chat we know to exist
         */
        "is_emergency": boolean
    }

    export interface GetConsultationHistoryResponse {
        "doc_id": uuid.UUID
        "appointment_id": uuid.UUID
        "pet_id": uuid.UUID
        "owner_id": uuid.UUID
        "created_at": string
        "staff_id"?: uuid.UUID
        "treatment_okan"?: string
        "basket_url": string
        "states_history": ConsultationStateResponse[]
        resources: string[]
        notes: string
        "chat_doc_id": uuid.UUID
    }

    export interface GetConsultationPetBreedsResponseItem {
        "doc_id": string
        name: string
    }

    export interface GetConsultationPetResponse {
        "doc_id": string
        name: string
        gender: string
        weight?: GetConsultationPetWeightUnitsResponse
        neutered?: boolean
        "date_of_birth": string
        breed?: GetConsultationPetBreedsResponseItem
        "created_at": string
        species: string
        "species_id": uuid.UUID
        "photo_url"?: string
        "policy_customer_no"?: string
        "policy_no"?: string
        "policy_active": boolean
        "policy_registered_date"?: string
        "policy_disabled_date"?: string
        "requires_verification": boolean
        triage: boolean
        age: GetConsultationAgeResponse
    }

    export interface GetConsultationPetWeightUnitsResponse {
        g: number
        kg: number
        lbs: number
    }

    export interface GetConsultationRequest {
        Timezone: string
    }

    export interface GetConsultationResponseV1 {
        "doc_id": uuid.UUID
        "appointment_id"?: uuid.UUID
        "pet_id": uuid.UUID
        "owner_id": uuid.UUID
        pet: GetConsultationPetResponse
        user: GetConsultationUserResponse
        business: GetConsultationBusinessResponse
        "created_at": string
        "staff_id"?: uuid.UUID
        state: string
        "treatment_plan"?: string
        resources: string[]
        submissions: SubmissionResponse[]
        notes: string
        appointment?: GetConsultationAppointmentResponse
        reasons: Reason[]
        "reasons_last_saved"?: utilities.Dates
        "termination_reason"?: SubmissionResponse
        "recommended_products": RecommendedProductResponse[]
        outcome?: SubmissionResponse
        "prescription_medication_outcome"?: SubmissionResponse
        prescription: PrescriptionSubmissionResponse
        "prescription_submitted": boolean
        "booked_appointments"?: GetConsultationAppointmentResponse[]
        "chat_doc_id"?: uuid.UUID
        chat?: GetConsultationChatResponse
        "call_doc_id"?: uuid.UUID
        call?: entities.Call
        "patient_media_files": PatientFileResponse[]
        "patient_records": PatientRecordResponse[]
        "recommended_products_locked"?: string
        "nfavps_submission"?: NFAVPSSubmission
        "nfavps_submitted": boolean
        "purchased_at"?: string
        "external_shopify_order_id"?: number
        "source_type"?: entities.ConsultationSourceType
    }

    export interface GetConsultationResponseV2 {
        "doc_id": uuid.UUID
        "appointment_id"?: uuid.UUID
        "pet_id": uuid.UUID
        "owner_id": uuid.UUID
        pet: GetConsultationPetResponse
        user: GetConsultationUserResponse
        business: GetConsultationBusinessResponse
        "created_at": string
        "staff_id"?: uuid.UUID
        state: string
        "treatment_plan"?: string
        resources: string[]
        submissions: SubmissionResponse[]
        notes: string
        appointment?: GetConsultationAppointmentResponse
        reasons: Reason[]
        "reasons_last_saved"?: utilities.Dates
        "termination_reason"?: SubmissionResponse
        "recommended_products": RecommendedProductResponse[]
        outcome?: SubmissionResponse
        "prescription_medication_outcome"?: SubmissionResponse
        prescriptions: PrescriptionSubmissionResponse[]
        "prescription_submitted": boolean
        "booked_appointments"?: GetConsultationAppointmentResponse[]
        "chat_doc_id"?: uuid.UUID
        chat?: GetConsultationChatResponse
        "call_doc_id"?: uuid.UUID
        call?: entities.Call
        "patient_media_files": PatientFileResponse[]
        "patient_records": PatientRecordResponse[]
        "recommended_products_locked"?: string
        "nfavps_submission"?: NFAVPSSubmission
        "nfavps_submitted": boolean
        "purchased_at"?: string
        "external_shopify_order_id"?: number
        "source_type"?: entities.ConsultationSourceType
        "consultation_completed_time"?: string
        "ai_review"?: ConsultationHistoryAIReviewSummary
    }

    export interface GetConsultationTypeResponse {
        "doc_id": uuid.UUID
        type: string
    }

    export interface GetConsultationUserResponse {
        id: number
        "doc_id": uuid.UUID
        email: string
        "first_name": string
        "last_name": string
        "phone_number"?: string
        "phone_number_raw"?: string
        "phone_number_cc"?: string
        "current_policy_customer_no"?: string
        "requires_verification": boolean
        "post_code": string
        "zip_code"?: string
        address?: UserAddress
    }

    export interface GetConsultationsQueryParams {
        /**
         * the id of the pet that is participating in the consultation
         */
        PetID: string

        /**
         * the time before which the consultations were created
         */
        CreatedBefore: string

        /**
         * the time after which the consultations were created
         */
        CreatedAfter: string

        /**
         * the order by field
         */
        OrderBy: string

        /**
         * the consultation status to filter by
         */
        ConsultStatus: string

        /**
         * the number of results requested for the page
         */
        RequestedItemsPerPage: number

        /**
         * the page number requested
         */
        RequestedPageNumber: number

        Timezone: string
    }

    export interface GetExaminationCategoryResponse {
        "doc_id": string
        name: string
        "form_name": string
    }

    export interface GetExaminationGroupResponse {
        "doc_id": uuid.UUID
        name: string
    }

    export interface GetFormsResponse {
        forms: FormResponse[]
    }

    export interface GetParticipantResponse {
        "session_user_id": string
        "user_doc_id": string
        "pet_doc_id": string
        "staff_profile_doc_id": string
        "business_doc_id": string
        "staff_profile_name": string
        "staff_profile_description": string
        "staff_profile_photo_url": string
    }

    export interface GetPartnerPracticeResponse {
        "doc_id": uuid.UUID
        address: string
        name: string
        "google_place_id": string
        long: string
        lat: string
    }

    export interface GetPetConsultationsHistoryResposnse {
        "consultations_history": ConsultationHistory[]
    }

    export interface GetReasonGroupResponse {
        "doc_id": uuid.UUID
        name: string
    }

    export interface GetReasonPostClinicalHistoryFormConfigResponse {
        "post_clinical_history_forms": string[]
    }

    export interface GetReasonPreClinicalHistoryFormConfigResponse {
        "pre_clinical_history_forms": string[]
    }

    export interface GetReasonPreExaminationFormConfigResponse {
        "pre_examination_forms": string[]
    }

    export interface GetRenderedAIOutcomeResponse {
        "ai_outcome": RenderedAIOutcome
    }

    export interface GetSubmissionsResponse {
        submissions: uuid.UUID[]
    }

    export interface HandleAIReviewCreateRequest {
        "owner_doc_id"?: string
        "owner_name": string
        "chat_doc_id"?: string
        "pet_doc_id"?: string
        /**
         * e.g. LLM Gastro Chat
         */
        "agent_name": string

        /**
         * e.g. Mild Gastro
         */
        "outcome_description": string

        "business_doc_id": string
        PetInformation: HandleAIReviewCreateRequestPetInformation
        triage?: string
        "outcome_text"?: string
        "is_ghost_mode"?: boolean
    }

    export interface HandleAIReviewCreateRequestPetInformation {
        name: string
        "date_of_birth"?: string
        neutered?: boolean
        "species_doc_id": string
        "species_name": string
        "breed_doc_id": string
        "breed_name": string
        gender: string
        "weight_grams"?: number
    }

    export interface HandleAIReviewCreateResponse {
        AIReviewDocID: string
    }

    export interface HealthCheckReportRequest {
        "health_score": HealthScoreForm
    }

    export interface HealthCheckReportResponse {
        "file_location": string
    }

    export interface HealthScoreForm {
        "form_data": FormData
        "form_name": string
    }

    export interface JoinAIOutcomeReviewRequest {
        "ai_review_doc_id": string
    }

    export interface JoinAIOutcomeReviewResponse {
        "ai_review_doc_id": string
    }

    export interface ListAIReviewsRequest {
        RequestedItemsPerPage: number
        RequestedPageNumber: number
    }

    export interface ListChewyAddressesByUserDocIDResponse {
        "matched_user_id"?: string
        addresses: ChewyCustomerAddress[]
    }

    export interface ListClinicalHistoryCategoriesResponse {
        "clinical_history_categories": GetClinicalHistoryCategoryResponse[]
    }

    export interface ListClinicalHistoryGroupWithCategoriesResponse {
        "clinical_history_groups_with_categories": entities.ListClinicalHistoryGroupWithCategories[]
    }

    export interface ListConsultationTypesResponse {
        "consultation_type": ConsultationTypeResponse[]
    }

    export interface ListExaminationCategoriesResponse {
        "examination_categories": GetExaminationCategoryResponse[]
    }

    export interface ListExaminationCategoryResponse {
        "doc_id": uuid.UUID
        name: string
        "form_name": string
    }

    export interface ListExaminationGroupWithCategories {
        "group_doc_id": uuid.UUID
        "group_name": string
        "examination_categories": ListExaminationCategoryResponse[]
    }

    export interface ListExaminationGroupWithCategoriesResponse {
        "examination_groups_with_categories": ListExaminationGroupWithCategories[]
    }

    export interface ListPartnerPracticesReponse {
        practices: entities.PartnerPractice[]
    }

    export interface ListPatientFilesRequest {
        PetDocID: string
        RequestedItemsPerPage: number
        RequestedPageNumber: number
        FileName: string
        MediaType: string
        StartDate: string
        EndDate: string
        ConsultationDocID: string
    }

    export interface ListPatientFilesResponse {
        "patient_files": PatientFileResponse[]
        pagination: shared.Pagination
    }

    export interface ListPatientRecordsRequest {
        ConsultationDocID?: string
        PetDocID?: string
        RequestedItemsPerPage: number
        RequestedPageNumber: number
    }

    export interface ListPatientRecordsResponse {
        records: PatientRecordResponse[]
        pagination: shared.Pagination
    }

    /**
     * ListPendingChatsRequest is the public API request for GET /v2/pending-chats.
     */
    export interface ListPendingChatsRequest {
        RequestedItemsPerPage: number
        RequestedPageNumber: number
    }

    /**
     * ListPendingChatsResponse is the public API response for GET /v2/pending-chats.
     */
    export interface ListPendingChatsResponse {
        pagination: shared.Pagination
        chats: PendingChat[]
    }

    export interface ListPrescriptionsRequest {
        RequestedItemsPerPage: number
        RequestedPageNumber: number
        UserDocID?: string
        PetDocID?: string
        IssuedAfter?: string
        IssuedBefore?: string
        PrescriptionType?: string
        AdminStatus?: string
    }

    export interface ListPrescriptionsResponse {
        prescriptions: PrescriptionListItemResponse[]
        pagination: shared.Pagination
    }

    export interface ListPromptConfigsRequest {
        PromptType: string
    }

    export interface ListPromptConfigsResponse {
        "clinical_note_prompt_configs": ConsultationPromptConfigResponse[]
    }

    export interface ListReasonGroupWithTypesResponse {
        "reason_groups_with_types": entities.ListReasonGroupWithTypes[]
    }

    export interface ListReasonTypesResponse {
        "reason_types": entities.ListReasonTypesResponse[]
    }

    export interface ListRecordTypesResponse {
        "record_types": RecordTypeResponse[]
    }

    export interface ListTreatmentPlanTemplatesResponse {
        templates: TemplateResponse[]
    }

    export interface NFAVPSFormRequest {
        "form_data": FormData
        "form_name": string
    }

    export interface NFAVPSSubmission {
        "submission_doc_id": string
        "form_data": FormData
        "form_name": string
    }

    export interface NewAIOutcomeProduct {
        "doc_id": string
        quantity: number
        instructions: string
    }

    export interface OutcomeSubmission {
        "form_data": FormData
        "form_name": string
    }

    export interface PaginatedConsultationHistoryV1 {
        "consultations_history": GetConsultationResponseV1[]
        pagination: shared.Pagination
    }

    export interface PaginatedConsultationHistoryV2 {
        "consultations_history": GetConsultationResponseV2[]
        pagination: shared.Pagination
    }

    export interface PaginatedConsultationsHistoryRequest {
        /**
         * the number of results requested for the page
         */
        RequestedItemsPerPage: number

        /**
         * the page number requested
         */
        RequestedPageNumber: number

        /**
         * order by "asc" or "desc" based on created consultation date
         */
        OrderBy: string

        /**
         * venom category doc ID to filter by
         */
        VenomCategoryDocID?: string

        /**
         * list of venom code doc IDs to filter by
         */
        VenomCodeDocIDs?: string[]

        /**
         * list of venom group doc IDs to filter by
         */
        VenomGroupDocIDs?: string[]
    }

    export interface PatientFileResponse {
        /**
         * The unique identifier for the file
         */
        "doc_id": string

        /**
         * The pet this file is associated with
         */
        "pet_doc_id": string

        /**
         * Name of the file
         */
        "file_name": string

        /**
         * URL to the file
         */
        "file_url": string

        /**
         * Possible values are: lab_report, photo, video
         */
        "media_type": string

        /**
         * The consultation this file is associated with
         */
        "consultation_doc_id"?: string
    }

    export interface PatientRecordResponse {
        "doc_id": uuid.UUID
        "pet_doc_id": uuid.UUID
        "staff_profile_doc_id": uuid.UUID
        "staff_profile_name": string
        "staff_profile_photo_url"?: string
        "type_id": number
        "type_label": string
        title: string
        description?: string
        "consultation_doc_id"?: uuid.UUID
        source: entities.PatientRecordSource
        "created_at": string
        "patient_files": PatientFileResponse[]
    }

    /**
     * PendingChatResponse is the consultation-owned public DTO for a pending chat.
     */
    export interface PendingChat {
        chat: Chat
        "pending_chat_ai_review"?: PendingChatAIReview
    }

    export interface PendingChatAIReview {
        "doc_id": string
        "chat_doc_id": string
        "outcome_type": string
        /**
         * The latest thing that happened in this AI review
         * at the time of writing, this will either be the vet rejecting the AI review
         * or the user requesting a chat anyway.
         * It will always be present on this object.
         */
        "latest_ai_review_event": AIReviewEventLog

        /**
         * RejectionDetails will only be present if the latest event log is the vet rejecting the AI review
         * Otherwise, it will be nil.
         */
        "rejection_details"?: AIReviewRejectionDetails
    }

    export interface PetAge {
        years: number
        months: number
    }

    export interface PrescriptionCartResponse {
        "checkout_url": string
        "cart_url": string
    }

    export interface PrescriptionFormSubmission {
        "form_data": FormData
        "form_name": string
    }

    export interface PrescriptionItem {
        "doc_id": uuid.UUID
        "external_id": string
        "created_at": string
        "latest_status": PrescriptionItemStatus
    }

    export interface PrescriptionItemDefect {
        DocID: string
        PrescriptionItemStatusDocID: uuid.UUID
        ExternalID: string
        Type: string
        Status: string
        BlocksApproval: boolean
        Category: string
        Notes: string[]
    }

    export interface PrescriptionItemStatus {
        DocID: uuid.UUID
        Status: string
        Defects: PrescriptionItemDefect[]
        CreatedAt: string
    }

    export interface PrescriptionListItemResponse {
        type: entities.PrescriptionType
        "prescription_doc_id": string
        "consultation_doc_id": string
        user: GetConsultationUserResponse
        pet: GetConsultationPetResponse
        "date_issued": string
        status?: string
        "prescription_items"?: PrescriptionItem[]
        "document_url"?: string
        "admin_status"?: string
        "fulfilment_location": string
        notes: string
    }

    export interface PrescriptionSubmission {
        "form_data": FormData
        "form_name": string
        "partner_practice_name": string
        "share_document": boolean
        "document_url"?: string
    }

    export interface PrescriptionSubmissionResponse {
        "prescription_type": entities.PrescriptionType
        "form_data": FormData
        "form_name": string
        "partner_practice_name": string
        "share_document": boolean
        "document_url"?: string
        "submission_doc_id": string
    }

    export interface Reason {
        "likely_diagnosis_codes": VenomCode[]
        "likely_diagnosis_groups": VenomGroup[]
        "other_diagnosis_codes": VenomCode[]
        "other_diagnosis_groups": VenomGroup[]
        "reason_type_doc_id": uuid.UUID
        "reason_type_name": string
        examinations: Examination[]
        "clinical_history": ClinicalHistory[]
        "pre_clinical_history_submissions": SubmissionResponse[]
        "post_clinical_history_submissions": SubmissionResponse[]
        "pre_examinations_submissions": SubmissionResponse[]
    }

    export interface ReasonDiagnosis {
        "doc_id": uuid.UUID
        name: string
    }

    export interface ReasonForVisit {
        summary: string
        source: string
    }

    export interface ReasonFormConfigResponse {
        "pre_clinical_history_forms": string[]
        "post_clinical_history_forms": string[]
        "pre_examination_forms": string[]
    }

    export interface RecommendedProduct {
        "product_doc_id": uuid.UUID
        frequency: string
        usage: string
        "product_url": string
        "product_name": string
        "product_image": string
        "product_price": number
        currency: string
        quantity: number
        sku: string
    }

    export interface RecommendedProductResponse {
        "product_doc_id": uuid.UUID
        frequency: string
        usage: string
        "product_url": string
        "product_name": string
        "product_image": string
        "product_price": number
        currency: string
        quantity: number
        sku: string
        purchased: boolean
        "purchased_quantity": number
        "legal_category"?: string
    }

    export interface RecordTypeResponse {
        id: number
        code: string
        label: string
    }

    export interface RenderedAIOutcome {
        /**
         * OutcomeID is the unique identifier of the outcome. Its
         * format is dependent on the outcome source, being a unique remote ID if
         * from an external host (e.g. Contentful), or the request ID if generated
         * by our internal LLM
         */
        "outcome_id"?: string

        /**
         * OutcomePublishedAt is the timestamp when the outcome was published
         */
        "outcome_published_at"?: string

        /**
         * Preview is a short text preview of the outcome
         * For the internally generated outcome, its the only one thats populated
         */
        preview: string

        introduction?: string
        sections?: AIOutcomeSection[]
        products?: AIOutcomeProduct[]
        /**
         * OutcomeType is an enum with values of either
         * - sections
         * - text
         * this can be used to determine which CTA type to render on the frontend.
         */
        "outcome_type": string

        /**
         * Triage codes generated by the LLM at the time of writing can be one of
         * * emergencyVetVisit - pet owner should seek immediate in-person emergency veterinary care; no delay or home management recommended
         * * referIntoPhysicalPractice - pet owner should book an appointment with a physical veterinary practice as soon as possible; pet needs to be physically examined by a veterinarian but not an emergency
         * * recommendFollowUp - a follow-up appointment with a veterinarian (online or in person) is recommended to reassess the pet's condition and incorporate re-examination finding
         * * monitorAtHome - pet owner can monitor the pet at home and seek veterinary advice if symptoms worsen
         * * noConcern - no immediate health concern identified based on the information provided
         * * prescriptionMedicine - condition is likely to require prescription-only medication following a veterinary examinatio
         * * nonPrescriptionProduct - condition may be managed with non-prescription products or over-the-counter care
         * * labTests - diagnostic laboratory tests are recommended
         * * other - outcome does not fit standard categories e.g. general enquiries, technical support, customer support, insurance enquiries
         */
        "triage_codes"?: string[]

        /**
         * HighestUrgencyTriageCode
         * This is the highest urgency triage code in the array. Given following
         * the same logic as the UrgencyLevel
         */
        "highest_urgency_triage_code"?: string

        /**
         * determined by the triage codes. It can be one of:
         * * high - emergencyVetVisit triage code, or other combinations of triage codes that indicate a high urgency level
         * * medium - referIntoPhysicalPractice
         * * low - monitorAtHome or noConcern triage codes, or other combinations of triage codes that indicate a low urgency level
         * it will always be set, even if the LLM did not provide any triage codes, in which case it will default to low urgency
         */
        "urgency_level": string

        /**
         * VenomGroupDocIDs are the doc IDs of the venom groups selected as the most likely diagnoses.
         */
        "venom_group_doc_ids"?: string[]

        /**
         * VenomCodeDocIDs are the doc IDs of the individual venom codes selected within those groups.
         */
        "venom_code_doc_ids"?: string[]

        /**
         * FollowUp is when the vet would like to follow up with the owner, if they have set one.
         */
        "follow_up"?: AIOutcomeFollowUp
    }

    export interface SetConsultationEVCPRRequest {
        confirmed: boolean
    }

    export interface SetTerminatedConsultationStateRequest {
        "form_data": FormData
        "form_name": string
    }

    export interface SubmissionResponse {
        "doc_id": uuid.UUID
        "form_data": FormData
        "form_name": string
    }

    export interface TemplateResponse {
        "doc_id": uuid.UUID
        name: string
        template: string
        resources: string[]
    }

    export interface TrialAppointmentStepInfoResponse {
        "current_trial"?: TrialInfo
        "other_trials"?: TrialInfo[]
    }

    export interface TrialInfo {
        "trial_name": string
        "step_name": string
        "step_status": string
    }

    export interface UpdateAIOutcomeRequest {
        /**
         * NewAIOutcomeBody is markdown representing the text of the new AI outcome body
         * it will completely overwrtite the existing body
         */
        "ai_outcome_body": string

        /**
         * NewAIOutcomeProducts is a list of products to associate with the outcome.
         */
        "new_ai_outcome_products"?: NewAIOutcomeProduct[]

        /**
         * The triage codes to associate with the outcome. It will completely overwrite the existing triage codes.
         */
        "new_ai_outcome_triage_codes"?: string[]

        /**
         * The venom group doc IDs to associate with the outcome as the most likely diagnoses.
         */
        "new_ai_outcome_venom_group_doc_ids"?: string[]

        /**
         * The venom code doc IDs to associate with the outcome as the specific diagnoses within those groups.
         * It will completely overwrite the existing venom codes.
         */
        "new_ai_outcome_venom_code_doc_ids"?: string[]

        /**
         * FollowUp is when the vet would like to follow up with the owner.
         * It will completely overwrite the existing follow up, so omitting it clears it.
         */
        "follow_up"?: AIOutcomeFollowUpRequest
    }

    /**
     * UpdateAIOutcomeResponse is a dummy struct provided for better client generation
     */
    export interface UpdateAIOutcomeResponse {
        placeholder: string
    }

    export interface UpdateClinicalHistoryCategoryRequest {
        name: string
        "form_name": string
        "group_doc_id": string
    }

    export interface UpdateClinicalHistoryCategoryResponse {
        "doc_id": string
    }

    export interface UpdateClinicalHistoryGroupRequest {
        name: string
    }

    export interface UpdateConsultationRequest {
        /**
         * the id of the staff member that is participating in the consultation
         */
        "staff_id": string

        /**
         * the treatment plan of the consultation
         */
        "treatment_plan": string

        /**
         * the resources of the consultation
         */
        resources: string[]

        /**
         * the internal resources of the consultation. This is additive and not accessable via any endpoint.
         */
        "internal_resources": string[]

        /**
         * the internal notes of the consultation
         */
        notes: string

        /**
         * the recommended products of the consultation
         */
        "recommended_products": RecommendedProduct[]

        /**
         * the outcome form submission
         */
        outcome?: OutcomeSubmission

        /**
         * the prescription form submission
         */
        prescription?: PrescriptionSubmission
    }

    export interface UpdateConsultationRequestV2 {
        /**
         * the id of the staff member that is participating in the consultation
         */
        "staff_id": string

        /**
         * the treatment plan of the consultation
         */
        "treatment_plan": string

        /**
         * the resources of the consultation
         */
        resources: string[]

        /**
         * the internal resources of the consultation. This is additive and not accessable via any endpoint.
         */
        "internal_resources": string[]

        /**
         * the internal notes of the consultation
         */
        notes: string

        /**
         * the recommended products of the consultation
         */
        "recommended_products": RecommendedProduct[]

        /**
         * the outcome form submission
         */
        outcome?: OutcomeSubmission

        /**
         * the prescription form submission
         */
        prescriptions?: PrescriptionSubmission[]
    }

    export interface UpdateConsultationStateRequest {
        /**
         * the state of the consultation
         */
        state: string
    }

    export interface UpdateConsultationTypeRequest {
        type: string
    }

    export interface UpdateExaminationCategoryRequest {
        name: string
        "form_name": string
        "group_doc_id": string
    }

    export interface UpdateExaminationCategoryResponse {
        "doc_id": string
    }

    export interface UpdateExaminationGroupRequest {
        name: string
    }

    export interface UpdateFormRequest {
        name: string
        type: string
    }

    export interface UpdatePartnerPracticeRequest {
        address: string
        name: string
        "google_place_id": string
        long: string
        lat: string
    }

    export interface UpdatePetRequest {
        "owner_doc_id": string
        "pet_doc_id": string
    }

    export interface UpdatePrescriptionAdminStatusRequest {
        "admin_status"?: string
    }

    export interface UpdatePrescriptionNotesRequest {
        notes: string
    }

    export interface UpdateReasonGroupRequest {
        name: string
    }

    export interface UpdateReasonTypeRequest {
        name: string
        "group_doc_id": string
    }

    export interface UpdateSubmissionRequest {
        "form_name": string
        "form_data": FormData
        "is_completed": boolean
    }

    export interface UpdateUserUSStateRequest {
        "user_us_state_shortcode": string
    }

    /**
     * UploadPatientFileRequest represents the request payload
     */
    export interface UploadPatientFileRequest {
        "pet_doc_id": string
        "media_type": string
        "file_name": string
        "file_url": string
        "consultation_doc_id"?: string
    }

    /**
     * UploadPatientFileResponse represents the response payload
     */
    export interface UploadPatientFileResponse {
        "doc_id": uuid.UUID
    }

    /**
     * ====== END OF PET RESPONSE ======
     */
    export interface UserAddress {
        "line_1": string
        "line_2": string
        "town_or_city": string
        county: string
        country: string
        postcode: string
    }

    export interface VenomCode {
        "display_name": string
        "venom_code": string
        "venom_code_doc_id": uuid.UUID
    }

    export interface VenomGroup {
        "display_name": string
        "venom_group_doc_id": uuid.UUID
    }

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.AIOutcomeStartEdit = this.AIOutcomeStartEdit.bind(this)
            this.AIOutcomeUpdate = this.AIOutcomeUpdate.bind(this)
            this.AIReviewCreateAuth = this.AIReviewCreateAuth.bind(this)
            this.AIReviewVetAccept = this.AIReviewVetAccept.bind(this)
            this.AIReviewVetReject = this.AIReviewVetReject.bind(this)
            this.AIReviewsList = this.AIReviewsList.bind(this)
            this.AIReviewsListV2 = this.AIReviewsListV2.bind(this)
            this.ActivatePromptConfig = this.ActivatePromptConfig.bind(this)
            this.AddChatConsultation = this.AddChatConsultation.bind(this)
            this.CheckPostcodeEligibility = this.CheckPostcodeEligibility.bind(this)
            this.ChewyFormatAddress = this.ChewyFormatAddress.bind(this)
            this.ChewySearchAddresses = this.ChewySearchAddresses.bind(this)
            this.CompleteConsultation = this.CompleteConsultation.bind(this)
            this.CompleteHandover = this.CompleteHandover.bind(this)
            this.CreateCallConsultation = this.CreateCallConsultation.bind(this)
            this.CreateClinicalHistoryCategory = this.CreateClinicalHistoryCategory.bind(this)
            this.CreateClinicalHistoryGroup = this.CreateClinicalHistoryGroup.bind(this)
            this.CreateConsultation = this.CreateConsultation.bind(this)
            this.CreateConsultationPromptConfig = this.CreateConsultationPromptConfig.bind(this)
            this.CreateConsultationType = this.CreateConsultationType.bind(this)
            this.CreateExaminationCategory = this.CreateExaminationCategory.bind(this)
            this.CreateExaminationGroup = this.CreateExaminationGroup.bind(this)
            this.CreateForm = this.CreateForm.bind(this)
            this.CreateHealthCheckReport = this.CreateHealthCheckReport.bind(this)
            this.CreateNFAVPSSubmission = this.CreateNFAVPSSubmission.bind(this)
            this.CreatePartnerPractice = this.CreatePartnerPractice.bind(this)
            this.CreatePatientRecord = this.CreatePatientRecord.bind(this)
            this.CreatePrescriptionPDF = this.CreatePrescriptionPDF.bind(this)
            this.CreateReasonGroup = this.CreateReasonGroup.bind(this)
            this.CreateReasonType = this.CreateReasonType.bind(this)
            this.CreateReasons = this.CreateReasons.bind(this)
            this.CreateReasonsPostClinicalHistoryFormsConfig = this.CreateReasonsPostClinicalHistoryFormsConfig.bind(this)
            this.CreateReasonsPreClinicalHistoryFormsConfig = this.CreateReasonsPreClinicalHistoryFormsConfig.bind(this)
            this.CreateReasonsPreExaminationFormsConfig = this.CreateReasonsPreExaminationFormsConfig.bind(this)
            this.CreateShopifyCartLink = this.CreateShopifyCartLink.bind(this)
            this.CreateSubmission = this.CreateSubmission.bind(this)
            this.CreateTreatmentPlanTemplate = this.CreateTreatmentPlanTemplate.bind(this)
            this.DeleteClinicalHistoryCategory = this.DeleteClinicalHistoryCategory.bind(this)
            this.DeleteClinicalHistoryGroup = this.DeleteClinicalHistoryGroup.bind(this)
            this.DeleteExaminationCategory = this.DeleteExaminationCategory.bind(this)
            this.DeleteExaminationGroup = this.DeleteExaminationGroup.bind(this)
            this.DeleteForm = this.DeleteForm.bind(this)
            this.DeletePartnerPractice = this.DeletePartnerPractice.bind(this)
            this.DeletePatientFile = this.DeletePatientFile.bind(this)
            this.DeletePatientRecordByDocID = this.DeletePatientRecordByDocID.bind(this)
            this.DeleteReasonGroup = this.DeleteReasonGroup.bind(this)
            this.DeleteReasonType = this.DeleteReasonType.bind(this)
            this.DeleteTreatmentPlanTemplate = this.DeleteTreatmentPlanTemplate.bind(this)
            this.EditTreatmentPlanTemplate = this.EditTreatmentPlanTemplate.bind(this)
            this.GenerateClinicalNote = this.GenerateClinicalNote.bind(this)
            this.GetAIOutcome = this.GetAIOutcome.bind(this)
            this.GetAIOutcomeRenderedByAIReviewDocID = this.GetAIOutcomeRenderedByAIReviewDocID.bind(this)
            this.GetAIReviewByChatDocID = this.GetAIReviewByChatDocID.bind(this)
            this.GetAIReviewByConsultationDocID = this.GetAIReviewByConsultationDocID.bind(this)
            this.GetAIReviewByDocID = this.GetAIReviewByDocID.bind(this)
            this.GetClinicalHistoryGroup = this.GetClinicalHistoryGroup.bind(this)
            this.GetConsultationByAppointment = this.GetConsultationByAppointment.bind(this)
            this.GetConsultationByChat = this.GetConsultationByChat.bind(this)
            this.GetConsultationHistory = this.GetConsultationHistory.bind(this)
            this.GetConsultationType = this.GetConsultationType.bind(this)
            this.GetConsultationV1 = this.GetConsultationV1.bind(this)
            this.GetConsultationV2 = this.GetConsultationV2.bind(this)
            this.GetExaminationGroup = this.GetExaminationGroup.bind(this)
            this.GetForm = this.GetForm.bind(this)
            this.GetFormsByType = this.GetFormsByType.bind(this)
            this.GetLatestConsultationEVCPRStatus = this.GetLatestConsultationEVCPRStatus.bind(this)
            this.GetPaginatedConsultationsHistoryByPetIDV1 = this.GetPaginatedConsultationsHistoryByPetIDV1.bind(this)
            this.GetPaginatedConsultationsHistoryByPetIDV2 = this.GetPaginatedConsultationsHistoryByPetIDV2.bind(this)
            this.GetPartnerPractice = this.GetPartnerPractice.bind(this)
            this.GetPatientFile = this.GetPatientFile.bind(this)
            this.GetPatientRecordByDocID = this.GetPatientRecordByDocID.bind(this)
            this.GetPetConsultationsHistory = this.GetPetConsultationsHistory.bind(this)
            this.GetPromptConfigByDocID = this.GetPromptConfigByDocID.bind(this)
            this.GetReasonFormConfigs = this.GetReasonFormConfigs.bind(this)
            this.GetReasonGroup = this.GetReasonGroup.bind(this)
            this.GetReasonPostClinicalHistoryFormConfig = this.GetReasonPostClinicalHistoryFormConfig.bind(this)
            this.GetReasonPreClinicalHistoryFormConfig = this.GetReasonPreClinicalHistoryFormConfig.bind(this)
            this.GetReasonPreExaminationFormConfig = this.GetReasonPreExaminationFormConfig.bind(this)
            this.GetSubmission = this.GetSubmission.bind(this)
            this.GetSubmissions = this.GetSubmissions.bind(this)
            this.HandleShopifyCreateOrderWebhook = this.HandleShopifyCreateOrderWebhook.bind(this)
            this.JoinAIOutcomeReview = this.JoinAIOutcomeReview.bind(this)
            this.ListChewyAddressesByUserDocID = this.ListChewyAddressesByUserDocID.bind(this)
            this.ListChewyBreedsBySpecies = this.ListChewyBreedsBySpecies.bind(this)
            this.ListChewyPetsByUserDocIDPaginated = this.ListChewyPetsByUserDocIDPaginated.bind(this)
            this.ListClinicalHistoryCategories = this.ListClinicalHistoryCategories.bind(this)
            this.ListClinicalHistoryGroupsWithCategories = this.ListClinicalHistoryGroupsWithCategories.bind(this)
            this.ListConsultationTypes = this.ListConsultationTypes.bind(this)
            this.ListConsultations = this.ListConsultations.bind(this)
            this.ListExaminationCategories = this.ListExaminationCategories.bind(this)
            this.ListExaminationGroupsWithCategories = this.ListExaminationGroupsWithCategories.bind(this)
            this.ListForms = this.ListForms.bind(this)
            this.ListPatientFiles = this.ListPatientFiles.bind(this)
            this.ListPatientRecords = this.ListPatientRecords.bind(this)
            this.ListPendingChats = this.ListPendingChats.bind(this)
            this.ListPractices = this.ListPractices.bind(this)
            this.ListPrescriptions = this.ListPrescriptions.bind(this)
            this.ListPromptConfigs = this.ListPromptConfigs.bind(this)
            this.ListReasonGroupsWithTypes = this.ListReasonGroupsWithTypes.bind(this)
            this.ListReasonTypes = this.ListReasonTypes.bind(this)
            this.ListReasonTypesByRecommendedProductID = this.ListReasonTypesByRecommendedProductID.bind(this)
            this.ListRecordTypes = this.ListRecordTypes.bind(this)
            this.ListTreatmentPlanTemplates = this.ListTreatmentPlanTemplates.bind(this)
            this.ProcessStripeWebhookConsultations = this.ProcessStripeWebhookConsultations.bind(this)
            this.ResendPrescriptionPaymentLink = this.ResendPrescriptionPaymentLink.bind(this)
            this.SetConsultationEVCPRConfirmation = this.SetConsultationEVCPRConfirmation.bind(this)
            this.SetTerminatedConsultationState = this.SetTerminatedConsultationState.bind(this)
            this.UpdateCallConsultationPet = this.UpdateCallConsultationPet.bind(this)
            this.UpdateClinicalHistoryCategory = this.UpdateClinicalHistoryCategory.bind(this)
            this.UpdateClinicalHistoryGroup = this.UpdateClinicalHistoryGroup.bind(this)
            this.UpdateConsultation = this.UpdateConsultation.bind(this)
            this.UpdateConsultationState = this.UpdateConsultationState.bind(this)
            this.UpdateConsultationType = this.UpdateConsultationType.bind(this)
            this.UpdateConsultationUserUSState = this.UpdateConsultationUserUSState.bind(this)
            this.UpdateConsultationV2 = this.UpdateConsultationV2.bind(this)
            this.UpdateExaminationCategory = this.UpdateExaminationCategory.bind(this)
            this.UpdateExaminationGroup = this.UpdateExaminationGroup.bind(this)
            this.UpdateForm = this.UpdateForm.bind(this)
            this.UpdatePartnerPractice = this.UpdatePartnerPractice.bind(this)
            this.UpdatePrescriptionAdminStatus = this.UpdatePrescriptionAdminStatus.bind(this)
            this.UpdatePrescriptionNotes = this.UpdatePrescriptionNotes.bind(this)
            this.UpdateReasonGroup = this.UpdateReasonGroup.bind(this)
            this.UpdateReasonType = this.UpdateReasonType.bind(this)
            this.UpdateSubmission = this.UpdateSubmission.bind(this)
            this.UploadPatientFile = this.UploadPatientFile.bind(this)
        }

        /**
         * Publishes an event when a vet starts editing an ai review
         */
        public async AIOutcomeStartEdit(aiReviewDocID: string): Promise<AIOutcomeStartEditResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("PUT", `/v1/ai-review/${encodeURIComponent(aiReviewDocID)}/start-edit`)
            return await resp.json() as AIOutcomeStartEditResponse
        }

        /**
         * AIOutcomeUpdate Updates the AI outcome for a given AI review.
         */
        public async AIOutcomeUpdate(aiReviewDocID: string, params: UpdateAIOutcomeRequest): Promise<UpdateAIOutcomeResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("PUT", `/v1/ai-review/${encodeURIComponent(aiReviewDocID)}/ai-outcome`, JSON.stringify(params))
            return await resp.json() as UpdateAIOutcomeResponse
        }

        /**
         * Create a new AI review. This is used at the moment purely for cypress. Consumers should use the
         * private method below
         */
        public async AIReviewCreateAuth(params: HandleAIReviewCreateRequest): Promise<HandleAIReviewCreateResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/ai-review`, JSON.stringify(params))
            return await resp.json() as HandleAIReviewCreateResponse
        }

        /**
         * Called from the PMS when the vet enters the AI Review Review
         * Does several things, such as notifying the user that the review is underway, and also creating
         * a consultation with the ai Review type being set
         */
        public async AIReviewVetAccept(aiReviewDocID: string): Promise<AIReviewAcceptResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("PUT", `/v1/ai-review/${encodeURIComponent(aiReviewDocID)}/accept`)
            return await resp.json() as AIReviewAcceptResponse
        }

        /**
         * Called from the PMS when the vet rejects the AI review.
         */
        public async AIReviewVetReject(aiReviewDocID: string, params: AIReviewRejectRequest): Promise<AIReviewRejectResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("PUT", `/v1/ai-review/${encodeURIComponent(aiReviewDocID)}/reject`, JSON.stringify(params))
            return await resp.json() as AIReviewRejectResponse
        }

        /**
         * AIReviewsList retrieves a list of AI reviews
         * this is effectively what drives the queue section of the AI Review part
         * of the PMS
         */
        public async AIReviewsList(params: ListAIReviewsRequest): Promise<AIReviewListResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "items_per_page": String(params.RequestedItemsPerPage),
                "page_number":    String(params.RequestedPageNumber),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/ai-reviews`, undefined, {query})
            return await resp.json() as AIReviewListResponse
        }

        /**
         * AIReviewsList retrieves a list of AI reviews
         * along with an urgency level
         * of the PMS
         */
        public async AIReviewsListV2(params: ListAIReviewsRequest): Promise<AIReviewListResponseV2> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "items_per_page": String(params.RequestedItemsPerPage),
                "page_number":    String(params.RequestedPageNumber),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v2/ai-reviews`, undefined, {query})
            return await resp.json() as AIReviewListResponseV2
        }

        /**
         * Activate Prompt Config
         */
        public async ActivatePromptConfig(doc_id: string): Promise<void> {
            await this.baseClient.callTypedAPI("PATCH", `/v1/clinical-note-prompts-config/${encodeURIComponent(doc_id)}/activate`)
        }

        /**
         * AddChatConsultation
         * Create chat consultation
         */
        public async AddChatConsultation(params: entities.CreateChatConsultationRequest): Promise<AddChatConsultationResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/consultation/chat`, JSON.stringify(params))
            return await resp.json() as AddChatConsultationResponse
        }

        /**
         * CheckPostcodeEligibility checks if a postcode is eligible for prescriptions
         */
        public async CheckPostcodeEligibility(params: CheckPostcodeEligibilityRequest): Promise<CheckPostcodeEligibilityResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                postcode: params.Postcode,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/consultationinternal/check_postcode_eligibility`, undefined, {query})
            return await resp.json() as CheckPostcodeEligibilityResponse
        }

        /**
         * ChewyFormatAddress uses Chewy's API to get structured US address data based on a previous search ReferenceID.
         * It is intended to follow up by a call from ChewySearchAddresses.
         * 
         * It should NOT be used outside of the Chewy US Prescription flows.
         */
        public async ChewyFormatAddress(params: ChewyFormatAddressRequest): Promise<ChewyFormatAddressResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "reference_id": params["reference_id"],
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/chewy-address-format`, undefined, {query})
            return await resp.json() as ChewyFormatAddressResponse
        }

        /**
         * ChewySearchAddresses uses Chewy's API to search for addresses in the US based on a searc term.
         * It is intended to be followed up by a call to ChewyFormatAddress using the reference ID to get a
         * structured-data version of the address.
         * 
         * It should NOT be used outside of the Chewy US Prescription flows.
         */
        public async ChewySearchAddresses(params: ChewySearchAddressesRequest): Promise<ChewySearchAddressesResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                term: params.term,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/chewy-address-search`, undefined, {query})
            return await resp.json() as ChewySearchAddressesResponse
        }

        public async CompleteConsultation(params: CompleteConsultationParameters): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/v1/consultation/complete`, JSON.stringify(params))
        }

        /**
         * CompleteHandover updates the status of a handover and store staff member who picked up the handover.
         * It also regenerates an initial EVCPR status for the new vet when in the US region.
         */
        public async CompleteHandover(chatDocID: string, staffDocID: string): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/v1/chats/${encodeURIComponent(chatDocID)}/handover/complete/${encodeURIComponent(staffDocID)}`)
        }

        /**
         * CreateCallConsultation
         * Create call consultation
         */
        public async CreateCallConsultation(params: entities.CreateCallConsultationRequest): Promise<CreateCallConsultationResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/consultation/call`, JSON.stringify(params))
            return await resp.json() as CreateCallConsultationResponse
        }

        /**
         * Create Clinical History Category
         * Add a new Clinical History Category
         */
        public async CreateClinicalHistoryCategory(params: CreateClinicalHistoryCategoryRequest): Promise<CreateClinicalHistoryCategoryResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/clinical-history-category`, JSON.stringify(params))
            return await resp.json() as CreateClinicalHistoryCategoryResponse
        }

        /**
         * Create Clinical History Group
         */
        public async CreateClinicalHistoryGroup(params: CreateClinicalHistoryGroupRequest): Promise<CreateClinicalHistoryGroupResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/clinical-history-group`, JSON.stringify(params))
            return await resp.json() as CreateClinicalHistoryGroupResponse
        }

        /**
         * Create Consultation
         * Add a new appointment consultation
         */
        public async CreateConsultation(params: CreateConsultationRequest): Promise<CreateConsultationResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/consultation`, JSON.stringify(params))
            return await resp.json() as CreateConsultationResponse
        }

        /**
         * Create Prompt Config
         * Add a new Clinical Note Chat Prompt Config to the system for the chatbot to use
         */
        public async CreateConsultationPromptConfig(params: CreateConsultationPromptConfigRequest): Promise<CreateConsultationPromptConfigResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/clinical-note-prompts-config`, JSON.stringify(params))
            return await resp.json() as CreateConsultationPromptConfigResponse
        }

        /**
         * Creates a new consultation type.
         */
        public async CreateConsultationType(params: CreateConsultationTypeRequest): Promise<CreateConsultationTypeResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/consultation-type`, JSON.stringify(params))
            return await resp.json() as CreateConsultationTypeResponse
        }

        /**
         * Create Examination Category
         * Add a new Examination Category
         */
        public async CreateExaminationCategory(params: CreateExaminationCategoryRequest): Promise<CreateExaminationCategoryResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/examinationCategory`, JSON.stringify(params))
            return await resp.json() as CreateExaminationCategoryResponse
        }

        /**
         * Create Examination Group
         */
        public async CreateExaminationGroup(params: CreateExaminationGroupRequest): Promise<CreateExaminationGroupResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/examination-group`, JSON.stringify(params))
            return await resp.json() as CreateExaminationGroupResponse
        }

        /**
         * Creates a new form.
         */
        public async CreateForm(params: CreateFormRequest): Promise<CreateFormResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/form`, JSON.stringify(params))
            return await resp.json() as CreateFormResponse
        }

        /**
         * Create Health Check Report
         */
        public async CreateHealthCheckReport(docID: string, params: HealthCheckReportRequest): Promise<HealthCheckReportResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/consultations/${encodeURIComponent(docID)}/health-check-report`, JSON.stringify(params))
            return await resp.json() as HealthCheckReportResponse
        }

        /**
         * CreateNFAVPSSubmission
         * creates a new NFA-VPS form submission entry
         */
        public async CreateNFAVPSSubmission(consultationDocID: string, params: NFAVPSFormRequest): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/v1/consultationinternal/consultations/${encodeURIComponent(consultationDocID)}/forms/nfa-vps`, JSON.stringify(params))
        }

        /**
         * CreatePartnerPractice
         * Creates a new partner practice
         */
        public async CreatePartnerPractice(params: CreatePartnerPracticeRequest): Promise<CreatePartnerPracticeResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/consultation/partner-practice`, JSON.stringify(params))
            return await resp.json() as CreatePartnerPracticeResponse
        }

        public async CreatePatientRecord(params: CreatePatientRecordRequest): Promise<CreatePatientRecordResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/consultationinternal/patient_records`, JSON.stringify(params))
            return await resp.json() as CreatePatientRecordResponse
        }

        /**
         * Generate prescription PDF and upload it to bucket
         * This endpoint generates and uploads the prescription pdf to our bucket. Then returns the URL
         */
        public async CreatePrescriptionPDF(consultationID: string, params: CreatePrescriptionPDFRequest): Promise<CreatePrescriptionPDFResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/consultations/${encodeURIComponent(consultationID)}/upload-prescription`, JSON.stringify(params))
            return await resp.json() as CreatePrescriptionPDFResponse
        }

        /**
         * Create Reason Group
         */
        public async CreateReasonGroup(params: CreateReasonGroupRequest): Promise<CreateReasonGroupResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/reason-group`, JSON.stringify(params))
            return await resp.json() as CreateReasonGroupResponse
        }

        /**
         * Create Reason Type
         * Add a new Reason Type
         */
        public async CreateReasonType(params: CreateReasonTypeRequest): Promise<CreateReasonTypeResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/reason-type`, JSON.stringify(params))
            return await resp.json() as CreateReasonTypeResponse
        }

        /**
         * Add reason with venom code diagnosis
         * Add reason with venom code diagnosis to consultation
         */
        public async CreateReasons(docID: string, params: CreateReasonsRequest): Promise<CreateReasonsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/consultations/${encodeURIComponent(docID)}/reasons`, JSON.stringify(params))
            return await resp.json() as CreateReasonsResponse
        }

        /**
         * Configure Post Clinical History Forms
         * Configure the post clinical history forms and the order they appear
         */
        public async CreateReasonsPostClinicalHistoryFormsConfig(params: ConfigureReasonsPostClinicalHistoryFormsRequest): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/v1/reasons-config/post-clinical-history-forms`, JSON.stringify(params))
        }

        /**
         * Configure Pre Clinical History Forms
         * Configure the pre clinical history forms and the order they appear
         */
        public async CreateReasonsPreClinicalHistoryFormsConfig(params: ConfigureReasonsPreClinicalHistoryFormsRequest): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/v1/reasons-config/pre-clinical-history-forms`, JSON.stringify(params))
        }

        /**
         * Configure Pre General Examination Forms
         * Configure the pre clinical history forms and the order they appear
         */
        public async CreateReasonsPreExaminationFormsConfig(params: ConfigureReasonsPreExaminationFormsRequest): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/v1/reasons-config/pre-examination-forms`, JSON.stringify(params))
        }

        /**
         * CreateShopifyCartLink
         * Generates a shopify cart link for a consultation
         */
        public async CreateShopifyCartLink(docID: string, params: entities.PrescriptionCartRequest): Promise<PrescriptionCartResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/consultation/cart/${encodeURIComponent(docID)}`, JSON.stringify(params))
            return await resp.json() as PrescriptionCartResponse
        }

        /**
         * Create Submission
         * Add a new form submission containing the data and the form that was submitted
         */
        public async CreateSubmission(params: CreateSubmissionRequest): Promise<CreateSubmissionResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/submission`, JSON.stringify(params))
            return await resp.json() as CreateSubmissionResponse
        }

        /**
         * CreateTreatmentPlanTemplate adds a new treatment plan template.
         */
        public async CreateTreatmentPlanTemplate(params: CreateTreatmentPlanTemplateRequest): Promise<CreateTreatmentPlanTemplateResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/treatment-plan-templates`, JSON.stringify(params))
            return await resp.json() as CreateTreatmentPlanTemplateResponse
        }

        /**
         * Delete Clinical History Category
         * Delete an Clinical History Category
         */
        public async DeleteClinicalHistoryCategory(docID: string): Promise<void> {
            await this.baseClient.callTypedAPI("DELETE", `/v1/clinical-history-category/${encodeURIComponent(docID)}`)
        }

        /**
         * Delete Clinical History Group
         */
        public async DeleteClinicalHistoryGroup(docID: string): Promise<void> {
            await this.baseClient.callTypedAPI("DELETE", `/v1/clinical-history-group/${encodeURIComponent(docID)}`)
        }

        /**
         * Delete Examination Category
         * Delete an Examination Category
         */
        public async DeleteExaminationCategory(docID: string): Promise<void> {
            await this.baseClient.callTypedAPI("DELETE", `/v1/examination-categories/${encodeURIComponent(docID)}`)
        }

        /**
         * Delete Examination Group
         */
        public async DeleteExaminationGroup(docID: string): Promise<void> {
            await this.baseClient.callTypedAPI("DELETE", `/v1/examination-group/${encodeURIComponent(docID)}`)
        }

        /**
         * Deletes an existing form.
         */
        public async DeleteForm(docID: string): Promise<void> {
            await this.baseClient.callTypedAPI("DELETE", `/v1/form/${encodeURIComponent(docID)}`)
        }

        /**
         * DeletePartnerPractice
         * Delete Partner Practice
         */
        public async DeletePartnerPractice(docID: string): Promise<void> {
            await this.baseClient.callTypedAPI("DELETE", `/v1/consultation/partner-practice/${encodeURIComponent(docID)}`)
        }

        /**
         * DeletePatientFile deletes a media file for a pet
         */
        public async DeletePatientFile(docID: string): Promise<void> {
            await this.baseClient.callTypedAPI("DELETE", `/v1/consultationinternal/patient_files/${encodeURIComponent(docID)}`)
        }

        public async DeletePatientRecordByDocID(recordDocID: string): Promise<void> {
            await this.baseClient.callTypedAPI("DELETE", `/v1/consultationinternal/patient_records/${encodeURIComponent(recordDocID)}`)
        }

        /**
         * Delete Reason Group
         */
        public async DeleteReasonGroup(docID: string): Promise<void> {
            await this.baseClient.callTypedAPI("DELETE", `/v1/reason-group/${encodeURIComponent(docID)}`)
        }

        /**
         * Delete Reason Type
         * Delete an Reason Type
         */
        public async DeleteReasonType(docID: string): Promise<void> {
            await this.baseClient.callTypedAPI("DELETE", `/v1/reason-type/${encodeURIComponent(docID)}`)
        }

        /**
         * Delete treatment plan template
         */
        public async DeleteTreatmentPlanTemplate(docID: string): Promise<void> {
            await this.baseClient.callTypedAPI("DELETE", `/v1/treatment-plan-templates/${encodeURIComponent(docID)}`)
        }

        /**
         * EditTreatmentPlanTemplate edits a given treatment plan template.
         */
        public async EditTreatmentPlanTemplate(docID: string, params: EditTreatmentPlanTemplateRequest): Promise<EditTreatmentPlanTemplateResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("PUT", `/v1/treatment-plan-templates/${encodeURIComponent(docID)}`, JSON.stringify(params))
            return await resp.json() as EditTreatmentPlanTemplateResponse
        }

        /**
         * Generates SOAP-style clinical notes and a customer-facing summary
         */
        public async GenerateClinicalNote(docID: string, params: GenerateClinicalNoteRequest): Promise<GenerateClinicalNoteResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v2/consultations/${encodeURIComponent(docID)}/generate-clinical-note`, JSON.stringify(params))
            return await resp.json() as GenerateClinicalNoteResponse
        }

        /**
         * RenderAIOutcome gets the latest active agent version for a specific agent.
         * then it substitutes in all the staff, owner details etc to provide a rendered outcome.
         * It does NOT store any of this information, it is just rendered on the fly.
         */
        public async GetAIOutcome(agentName: string, params: GetAIOutcomeRequest): Promise<GetAIOutcomeResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "outcome_description": params.OutcomeDescription,
                "owner_doc_id":        params.OwnerDocID,
                "pet_doc_id":          params.PetDocID,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/ai-outcomes/${encodeURIComponent(agentName)}`, undefined, {query})
            return await resp.json() as GetAIOutcomeResponse
        }

        /**
         * GetAIOutcomeRenderedByAIReviewDocID assumes there is a staff assignee on the AI review
         * it can return an AI outcome of either type (sections or text) with any rendering done.
         */
        public async GetAIOutcomeRenderedByAIReviewDocID(aiReviewDocID: string): Promise<GetRenderedAIOutcomeResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/internal/ai-review/${encodeURIComponent(aiReviewDocID)}/rendered-outcome`)
            return await resp.json() as GetRenderedAIOutcomeResponse
        }

        /**
         * GetAIOutcomeByChatDocID returns the ai review associated with the chat
         * it returns an empty outcome if there is no ai review associated with the chat
         */
        public async GetAIReviewByChatDocID(chatDocID: string): Promise<GetAIReviewByChatDocIDResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/chat/${encodeURIComponent(chatDocID)}/ai-review`)
            return await resp.json() as GetAIReviewByChatDocIDResponse
        }

        /**
         * GetAIOutcomeByConsultationDocID assumes that there is a consultation with an AI review
         * it returns an empty outcome if there is no AI review associated with the consultation
         */
        public async GetAIReviewByConsultationDocID(consultationDocID: string): Promise<GetAIReviewByConsultationDocIDResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/consultations/${encodeURIComponent(consultationDocID)}/ai-review`)
            return await resp.json() as GetAIReviewByConsultationDocIDResponse
        }

        /**
         * A private method for now used for validation under test, but I suspect thi
         */
        public async GetAIReviewByDocID(docID: string): Promise<AIReviewResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/ai-review/${encodeURIComponent(docID)}`)
            return await resp.json() as AIReviewResponse
        }

        /**
         * Get Clinical History Group
         */
        public async GetClinicalHistoryGroup(docID: string): Promise<GetClinicalHistoryGroupResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/clinical-history-group/${encodeURIComponent(docID)}`)
            return await resp.json() as GetClinicalHistoryGroupResponse
        }

        /**
         * Get consultation ID for appointment
         */
        public async GetConsultationByAppointment(docID: string): Promise<GetConsultationByAppointmentResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("PUT", `/v1/appointments/${encodeURIComponent(docID)}/consultation`)
            return await resp.json() as GetConsultationByAppointmentResponse
        }

        /**
         * GetConsultationByChat Get consultation ID for Chat
         */
        public async GetConsultationByChat(docID: string): Promise<GetConsultationByChatResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/chats/${encodeURIComponent(docID)}/consultation`)
            return await resp.json() as GetConsultationByChatResponse
        }

        /**
         * Get consultation history
         * Audit log of consultation history
         */
        public async GetConsultationHistory(docID: string): Promise<GetConsultationHistoryResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("PUT", `/v1/consultations/${encodeURIComponent(docID)}/history`)
            return await resp.json() as GetConsultationHistoryResponse
        }

        public async GetConsultationType(docID: string): Promise<GetConsultationTypeResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/consultation-type/${encodeURIComponent(docID)}`)
            return await resp.json() as GetConsultationTypeResponse
        }

        /**
         * GetConsultationV1 Get a consultation
         * Get a consultation by doc_id
         * 
         * Deprecated: use GetConsultationV2
         */
        public async GetConsultationV1(docID: string, params: GetConsultationRequest): Promise<GetConsultationResponseV1> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                timezone: params.Timezone,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/consultations/${encodeURIComponent(docID)}`, undefined, {query})
            return await resp.json() as GetConsultationResponseV1
        }

        public async GetConsultationV2(docID: string, params: GetConsultationRequest): Promise<GetConsultationResponseV2> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                timezone: params.Timezone,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v2/consultations/${encodeURIComponent(docID)}`, undefined, {query})
            return await resp.json() as GetConsultationResponseV2
        }

        /**
         * Get Examination Group
         */
        public async GetExaminationGroup(docID: string): Promise<GetExaminationGroupResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/examination-group/${encodeURIComponent(docID)}`)
            return await resp.json() as GetExaminationGroupResponse
        }

        /**
         * Retrieves a form by its document ID.
         */
        public async GetForm(docID: string): Promise<FormResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/form/${encodeURIComponent(docID)}`)
            return await resp.json() as FormResponse
        }

        /**
         * Retrieves forms by their consultation type.
         */
        public async GetFormsByType(consultationType: string): Promise<GetFormsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/forms/type/${encodeURIComponent(consultationType)}`)
            return await resp.json() as GetFormsResponse
        }

        /**
         * GetLatestConsultationEVCPRStatus gets the latest EVCPR status for the given consultation.
         * 
         * It does _not_ generate an EVCPR status for the calling staff member and should not be used to answer
         * questions such as 'Can I confirm EVCPR?' unless the calling staff member matches the StaffID in the response.
         * 
         * Best used to get the consultation's EVCPR status from an overview or moderation perspective rather than as a currently-consulting vet.
         */
        public async GetLatestConsultationEVCPRStatus(consultationDocID: string): Promise<EVCPRStatus> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/consultations/${encodeURIComponent(consultationDocID)}/evcpr-status`)
            return await resp.json() as EVCPRStatus
        }

        /**
         * GetPaginatedConsultationsHistoryByPetIDV1 Get paginated consultation history for a pet
         * 
         * Deprecated: Use GetPaginatedConsultationsHistoryByPetIDV2
         */
        public async GetPaginatedConsultationsHistoryByPetIDV1(petDocID: string, params: PaginatedConsultationsHistoryRequest): Promise<PaginatedConsultationHistoryV1> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "items_per_page":        String(params.RequestedItemsPerPage),
                "order_by":              params.OrderBy,
                "page_number":           String(params.RequestedPageNumber),
                "venom_category_doc_id": params.VenomCategoryDocID,
                "venom_code_doc_ids":    params.VenomCodeDocIDs?.map((v) => v),
                "venom_group_doc_ids":   params.VenomGroupDocIDs?.map((v) => v),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/consultations-history/${encodeURIComponent(petDocID)}/paginated`, undefined, {query})
            return await resp.json() as PaginatedConsultationHistoryV1
        }

        public async GetPaginatedConsultationsHistoryByPetIDV2(petDocID: string, params: PaginatedConsultationsHistoryRequest): Promise<PaginatedConsultationHistoryV2> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "items_per_page":        String(params.RequestedItemsPerPage),
                "order_by":              params.OrderBy,
                "page_number":           String(params.RequestedPageNumber),
                "venom_category_doc_id": params.VenomCategoryDocID,
                "venom_code_doc_ids":    params.VenomCodeDocIDs?.map((v) => v),
                "venom_group_doc_ids":   params.VenomGroupDocIDs?.map((v) => v),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v2/consultations-history/${encodeURIComponent(petDocID)}/paginated`, undefined, {query})
            return await resp.json() as PaginatedConsultationHistoryV2
        }

        /**
         * GetPartnerPractice
         * Get a partner practice
         */
        public async GetPartnerPractice(docID: string): Promise<GetPartnerPracticeResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/consultation/partner-practice/${encodeURIComponent(docID)}`)
            return await resp.json() as GetPartnerPracticeResponse
        }

        /**
         * GetPatientFile retrieves a media file for a pet
         */
        public async GetPatientFile(docID: string): Promise<PatientFileResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/consultationinternal/patient_files/${encodeURIComponent(docID)}`)
            return await resp.json() as PatientFileResponse
        }

        public async GetPatientRecordByDocID(recordDocID: string): Promise<PatientRecordResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/consultationinternal/patient_records/${encodeURIComponent(recordDocID)}`)
            return await resp.json() as PatientRecordResponse
        }

        /**
         * Get consultation history for a pet
         */
        public async GetPetConsultationsHistory(pet_doc_id: string): Promise<GetPetConsultationsHistoryResposnse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/consultations-history/${encodeURIComponent(pet_doc_id)}`)
            return await resp.json() as GetPetConsultationsHistoryResposnse
        }

        /**
         * Get Prompt Config By Doc ID
         */
        public async GetPromptConfigByDocID(doc_id: string): Promise<ConsultationPromptConfigResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/clinical-note-prompts-config/${encodeURIComponent(doc_id)}`)
            return await resp.json() as ConsultationPromptConfigResponse
        }

        /**
         * Get Reason Form Configurations
         * Get the configured reason form configurations
         */
        public async GetReasonFormConfigs(): Promise<ReasonFormConfigResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/reasons-config`)
            return await resp.json() as ReasonFormConfigResponse
        }

        /**
         * Get Reason Group
         */
        public async GetReasonGroup(docID: string): Promise<GetReasonGroupResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/reason-group/${encodeURIComponent(docID)}`)
            return await resp.json() as GetReasonGroupResponse
        }

        /**
         * Get Post Clinical History Forms Config
         * Get the post clinical history forms configuration
         */
        public async GetReasonPostClinicalHistoryFormConfig(): Promise<GetReasonPostClinicalHistoryFormConfigResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/reasons-config/post-clinical-history-forms`)
            return await resp.json() as GetReasonPostClinicalHistoryFormConfigResponse
        }

        /**
         * Get Pre Clinical History Forms Config
         * Get the pre clinical history forms configuration
         */
        public async GetReasonPreClinicalHistoryFormConfig(): Promise<GetReasonPreClinicalHistoryFormConfigResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/reasons-config/pre-clinical-history-forms`)
            return await resp.json() as GetReasonPreClinicalHistoryFormConfigResponse
        }

        /**
         * Get Pre Examination Forms Config
         * Get the pre examination forms configuration
         */
        public async GetReasonPreExaminationFormConfig(): Promise<GetReasonPreExaminationFormConfigResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/reasons-config/pre-examination-forms`)
            return await resp.json() as GetReasonPreExaminationFormConfigResponse
        }

        /**
         * Get Submission
         * Gets a submission from docId
         */
        public async GetSubmission(docID: string): Promise<SubmissionResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/submission/${encodeURIComponent(docID)}`)
            return await resp.json() as SubmissionResponse
        }

        /**
         * Get all submissions
         * Gets all submissions
         */
        public async GetSubmissions(): Promise<GetSubmissionsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/submissions`)
            return await resp.json() as GetSubmissionsResponse
        }

        /**
         * HandleShopifyCreateOrderWebhook
         * Processes Shopify's orders/create webhooks. It searches in the attribute notes for a consultation doc id.
         */
        public async HandleShopifyCreateOrderWebhook(method: "POST", body?: RequestInit["body"], options?: CallParameters): Promise<globalThis.Response> {
            return this.baseClient.callAPI(method, `/v1/consultationinternal/shopify-webhook/create-order`, body, options)
        }

        /**
         * Called from the PMS when the vet enters the AI Outcome Review
         * Does several things, such as notifying the user that the review is underway, and also creating
         * a consultation with the ai outcome type being set
         */
        public async JoinAIOutcomeReview(params: JoinAIOutcomeReviewRequest): Promise<JoinAIOutcomeReviewResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("PUT", `/v1/ai-review`, JSON.stringify(params))
            return await resp.json() as JoinAIOutcomeReviewResponse
        }

        /**
         * ListChewyAddressesByUserDocID uses Chewy's API to get structured US address data for a customer.
         * 
         * It should NOT be used outside of the Chewy US Prescription flows.
         */
        public async ListChewyAddressesByUserDocID(userDocID: string): Promise<ListChewyAddressesByUserDocIDResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/users/${encodeURIComponent(userDocID)}/chewy-addresses`)
            return await resp.json() as ListChewyAddressesByUserDocIDResponse
        }

        /**
         * ListChewyBreedsBySpecies returns the a list of chewy breeds, given one of our species doc ids
         * it does this by matching on the chewy breed types, which are the same names as ours (dog and cat)
         */
        public async ListChewyBreedsBySpecies(params: ChewyBreedsRequest): Promise<ChewyBreedsResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "species_doc_id": params.SpeciesDocID,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/chewy-breeds`, undefined, {query})
            return await resp.json() as ChewyBreedsResponse
        }

        /**
         * ListChewyPetsByUserDocIDPaginated returns the chewy api response for a user's pets directly.
         * Will 404 if the user is not matched by email (they don't exist); will return an empty list if
         * they have no pets.
         */
        public async ListChewyPetsByUserDocIDPaginated(userDocID: string): Promise<ChewyPetsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/users/${encodeURIComponent(userDocID)}/chewy-pets`)
            return await resp.json() as ChewyPetsResponse
        }

        /**
         * List Clinical History Categories
         * List all Clinical History Categories
         */
        public async ListClinicalHistoryCategories(): Promise<ListClinicalHistoryCategoriesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/clinical-history-categories`)
            return await resp.json() as ListClinicalHistoryCategoriesResponse
        }

        /**
         * GetClinicalHistoryGroupsWithTypes returns all clinicalHistory groups with their associated clinicalHistory types.
         */
        public async ListClinicalHistoryGroupsWithCategories(): Promise<ListClinicalHistoryGroupWithCategoriesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/clinical-history-groups-with-categories`)
            return await resp.json() as ListClinicalHistoryGroupWithCategoriesResponse
        }

        /**
         * Retrieves all consultation types.
         */
        public async ListConsultationTypes(): Promise<ListConsultationTypesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/consultation-types`)
            return await resp.json() as ListConsultationTypesResponse
        }

        /**
         * List consultations
         */
        public async ListConsultations(params: GetConsultationsQueryParams): Promise<GetAllConsultationsResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "consult_status": params.ConsultStatus,
                "created_after":  String(params.CreatedAfter),
                "created_before": String(params.CreatedBefore),
                "items_per_page": String(params.RequestedItemsPerPage),
                "order_by":       params.OrderBy,
                "page_number":    String(params.RequestedPageNumber),
                "pet_id":         params.PetID,
                timezone:         params.Timezone,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/consultations`, undefined, {query})
            return await resp.json() as GetAllConsultationsResponse
        }

        /**
         * List Examination Categories
         * List all Examination Categories
         */
        public async ListExaminationCategories(): Promise<ListExaminationCategoriesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/examination-categories`)
            return await resp.json() as ListExaminationCategoriesResponse
        }

        /**
         * GetExaminationGroupsWithCategories returns all examination groups with their associated examination categories.
         */
        public async ListExaminationGroupsWithCategories(): Promise<ListExaminationGroupWithCategoriesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/examination-groups-with-categories`)
            return await resp.json() as ListExaminationGroupWithCategoriesResponse
        }

        /**
         * Retrieves all forms.
         */
        public async ListForms(): Promise<GetFormsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/forms/all`)
            return await resp.json() as GetFormsResponse
        }

        /**
         * ListPatientFiles retrieves all media files for a pet
         */
        public async ListPatientFiles(params: ListPatientFilesRequest): Promise<ListPatientFilesResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "consultation_doc_id": params.ConsultationDocID,
                "end_date":            params.EndDate,
                "file_name":           params.FileName,
                "items_per_page":      String(params.RequestedItemsPerPage),
                "media_type":          params.MediaType,
                "page_number":         String(params.RequestedPageNumber),
                "pet_doc_id":          params.PetDocID,
                "start_date":          params.StartDate,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/consultationinternal/patient_files`, undefined, {query})
            return await resp.json() as ListPatientFilesResponse
        }

        public async ListPatientRecords(params: ListPatientRecordsRequest): Promise<ListPatientRecordsResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "consultation_doc_id":      params.ConsultationDocID,
                "pet_doc_id":               params.PetDocID,
                "requested_items_per_page": String(params.RequestedItemsPerPage),
                "requested_page_number":    String(params.RequestedPageNumber),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/consultationinternal/patient_records`, undefined, {query})
            return await resp.json() as ListPatientRecordsResponse
        }

        /**
         * ListPendingChats returns pending chats for the clinician queue with AI review data attached.
         */
        public async ListPendingChats(params: ListPendingChatsRequest): Promise<ListPendingChatsResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "items_per_page": String(params.RequestedItemsPerPage),
                "page_number":    String(params.RequestedPageNumber),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v2/pending-chats`, undefined, {query})
            return await resp.json() as ListPendingChatsResponse
        }

        /**
         * ListPractices
         * List partner practices
         */
        public async ListPractices(): Promise<ListPartnerPracticesReponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/consultation/partner-practice`)
            return await resp.json() as ListPartnerPracticesReponse
        }

        /**
         * ListPrescriptions
         * Lists prescriptions with pagination and optional filters.
         */
        public async ListPrescriptions(params: ListPrescriptionsRequest): Promise<ListPrescriptionsResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "admin_status":      params.AdminStatus,
                "issued_after":      params.IssuedAfter,
                "issued_before":     params.IssuedBefore,
                "items_per_page":    String(params.RequestedItemsPerPage),
                "page_number":       String(params.RequestedPageNumber),
                "pet_doc_id":        params.PetDocID,
                "prescription_type": params.PrescriptionType,
                "user_doc_id":       params.UserDocID,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/consultationinternal/prescriptions`, undefined, {query})
            return await resp.json() as ListPrescriptionsResponse
        }

        /**
         * List Prompt Configs
         */
        public async ListPromptConfigs(params: ListPromptConfigsRequest): Promise<ListPromptConfigsResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "prompt_type": params.PromptType,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/clinical-note-prompts-config`, undefined, {query})
            return await resp.json() as ListPromptConfigsResponse
        }

        /**
         * ListReasonGroupsWithTypes returns all reason groups with their associated reason types.
         */
        public async ListReasonGroupsWithTypes(): Promise<ListReasonGroupWithTypesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/reason-groups-with-types`)
            return await resp.json() as ListReasonGroupWithTypesResponse
        }

        /**
         * List Reason Type
         * List all Reason Type
         */
        public async ListReasonTypes(): Promise<ListReasonTypesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/reason-types`)
            return await resp.json() as ListReasonTypesResponse
        }

        /**
         * ListReasonTypesByRecommendedProductID
         * Lists reason types which recommendations include the product with the given doc id
         */
        public async ListReasonTypesByRecommendedProductID(product_doc_id: string): Promise<ListReasonTypesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/consultationinternal/products/${encodeURIComponent(product_doc_id)}/reason-types`)
            return await resp.json() as ListReasonTypesResponse
        }

        public async ListRecordTypes(): Promise<ListRecordTypesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/consultationinternal/record_types`)
            return await resp.json() as ListRecordTypesResponse
        }

        /**
         * Lists treatment plan templates.
         */
        public async ListTreatmentPlanTemplates(): Promise<ListTreatmentPlanTemplatesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/treatment-plan-templates`)
            return await resp.json() as ListTreatmentPlanTemplatesResponse
        }

        /**
         * Receives Stripe webhooks intended for consultations
         * both this one and the one in bookings will receive all stripe webhooks
         * we rely on filtering within the receiver to listen only for required events
         * we use v2 thin events here as recommended, but bookings currently does not
         */
        public async ProcessStripeWebhookConsultations(method: "POST", body?: RequestInit["body"], options?: CallParameters): Promise<globalThis.Response> {
            return this.baseClient.callAPI(method, `/v1/consultation/stripe-webhook`, body, options)
        }

        /**
         * ResendPrescriptionPaymentLink regenerates and resends the prescription payment link for a consultation.
         */
        public async ResendPrescriptionPaymentLink(consultationDocID: string): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/v1/consultations/${encodeURIComponent(consultationDocID)}/prescription-payment-link/resend`)
        }

        /**
         * SetConsultationEVCPRConfirmation creates a new EVCPR status based on the latest one, confirming or unconfirming EVCPR as appropriate.
         */
        public async SetConsultationEVCPRConfirmation(consultationDocID: string, params: SetConsultationEVCPRRequest): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/consultations/${encodeURIComponent(consultationDocID)}/evcpr-confirmation`, JSON.stringify(params))
        }

        /**
         * Terminate consultation
         * Set consultation Termination with reason form
         */
        public async SetTerminatedConsultationState(docID: string, params: SetTerminatedConsultationStateRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PUT", `/v1/consultations/${encodeURIComponent(docID)}/terminate`, JSON.stringify(params))
        }

        /**
         * UpdateCallConsultationPet Update call consultation pet.
         */
        public async UpdateCallConsultationPet(consultation_doc_id: string, params: UpdatePetRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PUT", `/v1/consultations/${encodeURIComponent(consultation_doc_id)}/pet`, JSON.stringify(params))
        }

        /**
         * Update Clinical History Category
         * Update an Clinical History Category
         */
        public async UpdateClinicalHistoryCategory(docID: string, params: UpdateClinicalHistoryCategoryRequest): Promise<UpdateClinicalHistoryCategoryResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("PUT", `/v1/clinical-history-category/${encodeURIComponent(docID)}`, JSON.stringify(params))
            return await resp.json() as UpdateClinicalHistoryCategoryResponse
        }

        /**
         * Update Clinical History Group
         */
        public async UpdateClinicalHistoryGroup(docID: string, params: UpdateClinicalHistoryGroupRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PUT", `/v1/clinical-history-group/${encodeURIComponent(docID)}`, JSON.stringify(params))
        }

        /**
         * Update consultation
         */
        public async UpdateConsultation(docID: string, params: UpdateConsultationRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PUT", `/v1/consultations/${encodeURIComponent(docID)}`, JSON.stringify(params))
        }

        /**
         * Update consultation state
         * Update the state of the consultation
         */
        public async UpdateConsultationState(docID: string, params: UpdateConsultationStateRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PUT", `/v1/consultations/${encodeURIComponent(docID)}/state`, JSON.stringify(params))
        }

        /**
         * Updates an existing consultation type.
         */
        public async UpdateConsultationType(docID: string, params: UpdateConsultationTypeRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PUT", `/v1/consultation-type/${encodeURIComponent(docID)}`, JSON.stringify(params))
        }

        /**
         * UpdateConsultationUserUSState updates the recorded user US state for the consultation and recalculates EVCPR eligibility.
         */
        public async UpdateConsultationUserUSState(consultationDocID: string, params: UpdateUserUSStateRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PUT", `/v1/consultations/${encodeURIComponent(consultationDocID)}/us-state`, JSON.stringify(params))
        }

        /**
         * Update consultation V2
         * this version takes the prescriptions as an array, to set compatiability with the new
         * prescription diet form.
         */
        public async UpdateConsultationV2(docID: string, params: UpdateConsultationRequestV2): Promise<void> {
            await this.baseClient.callTypedAPI("PUT", `/v2/consultations/${encodeURIComponent(docID)}`, JSON.stringify(params))
        }

        /**
         * Update Examination Category
         * Update an Examination Category
         */
        public async UpdateExaminationCategory(docID: string, params: UpdateExaminationCategoryRequest): Promise<UpdateExaminationCategoryResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("PUT", `/v1/examination-categories/${encodeURIComponent(docID)}`, JSON.stringify(params))
            return await resp.json() as UpdateExaminationCategoryResponse
        }

        /**
         * Update Examination Group
         */
        public async UpdateExaminationGroup(docID: string, params: UpdateExaminationGroupRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PUT", `/v1/examination-group/${encodeURIComponent(docID)}`, JSON.stringify(params))
        }

        /**
         * Updates an existing form.
         */
        public async UpdateForm(docID: string, params: UpdateFormRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PUT", `/v1/form/${encodeURIComponent(docID)}`, JSON.stringify(params))
        }

        /**
         * UpdatePartnerPractice
         * Update partner practice
         */
        public async UpdatePartnerPractice(docID: string, params: UpdatePartnerPracticeRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PUT", `/v1/consultation/partner-practice/${encodeURIComponent(docID)}`, JSON.stringify(params))
        }

        /**
         * UpdatePrescriptionAdminStatus
         * Updates the admin status for a prescription.
         */
        public async UpdatePrescriptionAdminStatus(prescriptionDocID: string, params: UpdatePrescriptionAdminStatusRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PATCH", `/v1/consultationinternal/prescriptions/${encodeURIComponent(prescriptionDocID)}/admin-status`, JSON.stringify(params))
        }

        /**
         * UpdatePrescriptionNotes
         * Updates the notes for a prescription.
         */
        public async UpdatePrescriptionNotes(prescriptionDocID: string, params: UpdatePrescriptionNotesRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PATCH", `/v1/consultationinternal/prescriptions/${encodeURIComponent(prescriptionDocID)}/notes`, JSON.stringify(params))
        }

        /**
         * Update Reason Group
         */
        public async UpdateReasonGroup(docID: string, params: UpdateReasonGroupRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PUT", `/v1/reason-group/${encodeURIComponent(docID)}`, JSON.stringify(params))
        }

        /**
         * Update Reason Type
         * Update an Reason Type
         */
        public async UpdateReasonType(docID: string, params: UpdateReasonTypeRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PUT", `/v1/reason-type/${encodeURIComponent(docID)}`, JSON.stringify(params))
        }

        /**
         * Updates an existing form submission with new data.
         */
        public async UpdateSubmission(docID: string, params: UpdateSubmissionRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PUT", `/v1/submission/${encodeURIComponent(docID)}`, JSON.stringify(params))
        }

        /**
         * UploadPatientFile uploads a media file to a pet record
         */
        public async UploadPatientFile(params: UploadPatientFileRequest): Promise<UploadPatientFileResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/consultationinternal/patient_files`, JSON.stringify(params))
            return await resp.json() as UploadPatientFileResponse
        }
    }
}

export namespace crmexternal {

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.HandleCRM = this.HandleCRM.bind(this)
            this.SendCallKitNotification = this.SendCallKitNotification.bind(this)
        }

        /**
         * HandleCRM handles incoming CRMs from Joii.
         * 
         * This endpoint is used to handle incoming CRMs from Joii. It will decode the request body and then pass it to the CRM service to handle the CRM event.
         * The CRM will then be processed and sent to the CRM provider (Braze).
         * If the CRM event is successfully handled, it will return a 200 status code. If there is an error, it will return a 500 status code with an error message
         */
        public async HandleCRM(method: "POST", body?: RequestInit["body"], options?: CallParameters): Promise<globalThis.Response> {
            return this.baseClient.callAPI(method, `/v1/webhook`, body, options)
        }

        /**
         * SendCallKitNotification sends a call kit notification to the user.
         * 
         * This endpoint is used to send a call kit notification to the user. Uses APNs to signal iOS devices to start a call.
         */
        public async SendCallKitNotification(params: entities.SendCallKitNotificationRequest): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/v1/callkit`, JSON.stringify(params))
        }
    }
}

export namespace prodexternal {
    export interface GenerateShopifyBasketLinksProductVariant {
        "variant_id": string
        quantity: number
    }

    export interface GenerateShopifyBasketLinksRequest {
        UTMSource?: string
        UTMMedium?: string
        UTMCampaign?: string
        UTMTerm?: string
        UTMContent?: string
        UTMID?: string
        products: GenerateShopifyBasketLinksProductVariant[]
    }

    export interface GenerateShopifyBasketLinksResponse {
        "buy_it_now_link": string
        "add_to_cart_link": string
    }

    export interface GetShopifyCollectionRequest {
        UTMSource?: string
        UTMMedium?: string
        UTMCampaign?: string
        UTMTerm?: string
        UTMContent?: string
        UTMID?: string
    }

    export interface GetShopifyCollectionResponse {
        title: string
        products: GetShopifyProductResponse[]
    }

    export interface GetShopifyNavigationLinkRequest {
        UTMSource?: string
        UTMMedium?: string
        UTMCampaign?: string
        UTMTerm?: string
        UTMContent?: string
        UTMID?: string
    }

    export interface GetShopifyNavigationLinkResponse {
        link: string
        "expires_at": string
    }

    export interface GetShopifyProductRequest {
        UTMSource?: string
        UTMMedium?: string
        UTMCampaign?: string
        UTMTerm?: string
        UTMContent?: string
        UTMID?: string
    }

    export interface GetShopifyProductResponse {
        title: string
        "image_url": string
        "max_price": number
        "min_price": number
        "currency_code": string
        handle: string
        skus: string[]
        url: string
        expiry: string
        id: string
        tags: string[]
    }

    export interface GetShopifyProductVariantRequest {
        UTMSource?: string
        UTMMedium?: string
        UTMCampaign?: string
        UTMTerm?: string
        UTMContent?: string
        UTMID?: string
    }

    export interface GetShopifyVariantResponse {
        id: string
        title: string
        /**
         * A string representation of the price to preserve formatting
         */
        "price_str": string

        price: number
        "currency_code": string
        "image_url": string
        sku: string
        "product_title": string
        handle: string
        url: string
        expiry?: string
        "buy_it_now_link"?: string
        "add_to_cart_link"?: string
    }

    export interface ListRecommendationsRequest {
        /**
         * The **doc_id** of the product.
         */
        ProductDocID: string[]

        /**
         * The **doc_id** of the venom code to search for.
         */
        VenomCodeDocID: string[]

        /**
         * The **doc_id** of the venom group to search for.
         */
        VenomGroupDocID: string[]

        /**
         * The **doc_id** of the category to search for.
         */
        VenomCategoryDocID: string[]

        UTMID?: string
        UTMSource?: string
        UTMMedium?: string
        UTMTerm?: string
        UTMCampaign?: string
        UTMContent?: string
    }

    export interface ListRecommendationsResponse {
        recommendations: Recommendation[]
    }

    export interface Recommendation {
        "doc_id": uuid.UUID
        sku: string
        name: string
        url: string
        /**
         * TODO - create a friendly price here - refer to the appointment response that has a friendly price
         */
        currency: string

        price: number
        description: string
        "photo_url": string
    }

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.GenerateShopifyBasketLinks = this.GenerateShopifyBasketLinks.bind(this)
            this.GetShopifyCollection = this.GetShopifyCollection.bind(this)
            this.GetShopifyNavigationLink = this.GetShopifyNavigationLink.bind(this)
            this.GetShopifyProduct = this.GetShopifyProduct.bind(this)
            this.GetShopifyProductVariant = this.GetShopifyProductVariant.bind(this)
            this.ListRecommendations = this.ListRecommendations.bind(this)
        }

        /**
         * GenerateShopifyBasketLinks returns 2 links to the shopify site for bringing
         * the user to the basket with the variants in it, or to the cart
         */
        public async GenerateShopifyBasketLinks(params: GenerateShopifyBasketLinksRequest): Promise<GenerateShopifyBasketLinksResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "utm_campaign": params.UTMCampaign,
                "utm_content":  params.UTMContent,
                "utm_id":       params.UTMID,
                "utm_medium":   params.UTMMedium,
                "utm_source":   params.UTMSource,
                "utm_term":     params.UTMTerm,
            })

            // Construct the body with only the fields which we want encoded within the body (excluding query string or header fields)
            const body: Record<string, any> = {
                products: params.products,
            }

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/shopify-basket-links`, JSON.stringify(body), {query})
            return await resp.json() as GenerateShopifyBasketLinksResponse
        }

        /**
         * Get Shopify Collection
         * This endpoint returns product details from a shopify collection ID
         */
        public async GetShopifyCollection(ID: string, params: GetShopifyCollectionRequest): Promise<GetShopifyCollectionResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "utm_campaign": params.UTMCampaign,
                "utm_content":  params.UTMContent,
                "utm_id":       params.UTMID,
                "utm_medium":   params.UTMMedium,
                "utm_source":   params.UTMSource,
                "utm_term":     params.UTMTerm,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/shopifyCollection/${encodeURIComponent(ID)}`, undefined, {query})
            return await resp.json() as GetShopifyCollectionResponse
        }

        /**
         * Get shopify navigation link
         * This endpoint returns multipass link for insured users or ordinary link for non insured users to provided endpoint
         */
        public async GetShopifyNavigationLink(params: GetShopifyNavigationLinkRequest): Promise<GetShopifyNavigationLinkResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "utm_campaign": params.UTMCampaign,
                "utm_content":  params.UTMContent,
                "utm_id":       params.UTMID,
                "utm_medium":   params.UTMMedium,
                "utm_source":   params.UTMSource,
                "utm_term":     params.UTMTerm,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/shopifyNavigationLink`, undefined, {query})
            return await resp.json() as GetShopifyNavigationLinkResponse
        }

        /**
         * Get shopify product
         * This endpoint returns product details from a shopify ID
         */
        public async GetShopifyProduct(ID: string, params: GetShopifyProductRequest): Promise<GetShopifyProductResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "utm_campaign": params.UTMCampaign,
                "utm_content":  params.UTMContent,
                "utm_id":       params.UTMID,
                "utm_medium":   params.UTMMedium,
                "utm_source":   params.UTMSource,
                "utm_term":     params.UTMTerm,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/shopifyProduct/${encodeURIComponent(ID)}`, undefined, {query})
            return await resp.json() as GetShopifyProductResponse
        }

        /**
         * Get shopify details for variant
         * This endpoint returns product details from a shopify variant ID
         */
        public async GetShopifyProductVariant(ID: string, params: GetShopifyProductVariantRequest): Promise<GetShopifyVariantResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "utm_campaign": params.UTMCampaign,
                "utm_content":  params.UTMContent,
                "utm_id":       params.UTMID,
                "utm_medium":   params.UTMMedium,
                "utm_source":   params.UTMSource,
                "utm_term":     params.UTMTerm,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/shopifyProductVariant/${encodeURIComponent(ID)}`, undefined, {query})
            return await resp.json() as GetShopifyVariantResponse
        }

        /**
         * List Recommended Products
         * This endpoint returns a list of recommended products for the respective **product_doc_id**'s and relevant venom codes.
         */
        public async ListRecommendations(params: ListRecommendationsRequest): Promise<ListRecommendationsResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "product_doc_id":        params.ProductDocID.map((v) => v),
                "utm_campaign":          params.UTMCampaign,
                "utm_content":           params.UTMContent,
                "utm_id":                params.UTMID,
                "utm_medium":            params.UTMMedium,
                "utm_source":            params.UTMSource,
                "utm_term":              params.UTMTerm,
                "venom_category_doc_id": params.VenomCategoryDocID.map((v) => v),
                "venom_code_doc_id":     params.VenomCodeDocID.map((v) => v),
                "venom_group_doc_id":    params.VenomGroupDocID.map((v) => v),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/recommendations`, undefined, {query})
            return await resp.json() as ListRecommendationsResponse
        }
    }
}

export namespace prodinternal {
    export interface CatalogueProductResponse {
        "doc_id": uuid.UUID
        sku: string
        name: string
        url: string
        currency: string
        price: number
        description: string
        "photo_url": string
        "legal_category": string
        "catalogue_id": uuid.UUID
        "created_at": string
        "updated_at": string
        "classification_description": string
        "classification_doc_id": string
        "out_of_stock": boolean
        "external_product_variant_id"?: string
        "external_inventory_item_id"?: string
        "external_inventory_policy"?: string
        "stock_source"?: entities.StockSource
    }

    export interface ClassificationResponse {
        "doc_id": string
        name: string
        description: string
    }

    export interface CreateCatalogueProductRequest {
        sku: string
        name: string
        url: string
        "catalogue_id": uuid.UUID
        currency: string
        price: number
        description: string
        "photo_url": string
        "legal_category": string
    }

    export interface CreateProdResponse {
        id: uuid.UUID
    }

    export interface CreateProductReasonRecommendationRequest {
        "reason_doc_id": string
        "product_doc_ids": string[]
        species: string
    }

    export interface CreateProductRecommendationForReasonsRequest {
        recommendations: CreateProductReasonRecommendationRequest[]
    }

    export interface CreateProductRequest {
        gtin: string
        name: string
        "product_desc": string
    }

    export interface DeleteProductRecommendationsForReasonRequest {
        "reason_doc_id": string
        "product_ids": string[]
        species: string
    }

    export interface GetProdResponse {
        id: number
        "doc_id": uuid.UUID
        gtin: string
        name: string
        "product_desc": string
        "created_at": string
        "updated_at": string
        deleted: boolean
        "deleted_at": string
        "catalogue_products": entities.CatalogueProduct[]
    }

    export interface GetProductRequest {
        "doc_id": string
    }

    export interface ListClassificationsResponse {
        classifications: ClassificationResponse[]
    }

    export interface ListProductCategoriesV2Request {
        ProductSourceOverride?: string
    }

    export interface ListProductCategoriesV2Response {
        categories: ProductCategoryV2[]
    }

    export interface ListReasonTypesResponse {
        "reason_type_doc_ids": uuid.UUID[]
    }

    export interface ListRecommendationsRequest {
        ProductDocID: string[]
        VenomCodeDocID: string[]
        VenomGroupDocID: string[]
        VenomCategoryDocID: string[]
    }

    export interface ListRecommendationsResponse {
        recommendations: Recommendation[]
    }

    export interface ListRecommendedProductsByReasonParams {
        ReasonDocID: string
        Species: string
        BusinessDocID: string
        RequestedItemsPerPage: number
        RequestedPageNumber: number
    }

    export interface ListRecommendedProductsByReasonResponse {
        recommendations: Recommendation[]
        pagination: shared.Pagination
    }

    export interface MapVenomCodeRequest {
        "venom_group_id": uuid.UUID
    }

    export interface Price {
        currency: string
        amount: number
    }

    export interface ProductCategoryV2 {
        id: string
        name: string
        image?: string
        "product_source": string
        subcategories?: ProductSubcategoryV2[]
    }

    /**
     * ProductSearchResult
     * represents a product from any product provider system. Right now these are
     * 1. us, using the catalogue product system
     * 2. chewy
     */
    export interface ProductSearchResult {
        "product_type": string
        "product_summary"?: ProductSummary
        "product_variant"?: ProductVariantSummary
    }

    export interface ProductSubcategoryV2 {
        id: string
        name: string
        image?: string
        "product_source": string
    }

    export interface ProductSummary {
        /**
         * UniqueIdentifier
         * This is the unique identifer for the product variant in the product provider system.
         * chewy: its the 'part number' which is a numeric string
         * us: the catalogue products doc_id
         */
        "unique_identifier": string

        /**
         * GTIN
         * The global trade item number for the product.
         * this is nullable as not all product variants have a GTIN
         */
        gtin?: string

        name: string
        description?: string
        "product_source": string
        "photo_url"?: string
    }

    export interface ProductVariantSummary {
        /**
         * UniqueIdentifier
         * This is the unique identifer for the product variant in the product provider system.
         * chewy: its the 'part number' which is a numeric string
         * us: the catalogue products doc_id
         */
        "unique_identifier": string

        /**
         * GTIN
         * The global trade item number for the product.
         * this is nullable as not all product variants have a GTIN
         */
        gtin?: string

        name: string
        description?: string
        price: Price
        "photo_url"?: string
        "product_source": string
    }

    export interface ProductVariantsResponse {
        variants: ProductVariantSummary[]
    }

    export interface Recommendation {
        "doc_id": uuid.UUID
        sku: string
        name: string
        url: string
        /**
         * TODO - create a friendly price here - refer to the appointment response that has a friendly price
         */
        currency: string

        price: number
        description: string
        "photo_url": string
        "out_of_stock": boolean
        "classification_id": number
        "classification_doc_id": uuid.UUID
        "legal_category": string
        "classification_description": string
    }

    export interface SearchProductsRequest {
        SearchTerm: string
        RequestedItemsPerPage: number
        RequestedPageNumber: number
        ProductSourceOverride?: string
        BusinessDocIDs?: string[]
        CategoryID?: string
    }

    export interface SearchProductsResponse {
        total: number
        pagination: shared.Pagination
        "product_search_results"?: ProductSearchResult[]
    }

    export interface UpdateCatalogueProductRequest {
        sku: string
        name: string
        url: string
        "catalogue_id": uuid.UUID
        currency: string
        price: number
        description: string
        "photo_url": string
        "legal_category": string
        "out_of_stock": boolean
        "external_product_variant_id"?: string
        "external_inventory_item_id"?: string
        "external_inventory_policy"?: string
    }

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.CreateCatalogue = this.CreateCatalogue.bind(this)
            this.CreateCatalogueBusinessMapping = this.CreateCatalogueBusinessMapping.bind(this)
            this.CreateCategory = this.CreateCategory.bind(this)
            this.CreateProduct = this.CreateProduct.bind(this)
            this.CreateProductCatalogue = this.CreateProductCatalogue.bind(this)
            this.CreateProductCatalogueMapping = this.CreateProductCatalogueMapping.bind(this)
            this.CreateProductRecommendationForReason = this.CreateProductRecommendationForReason.bind(this)
            this.CreateProductSubcategory = this.CreateProductSubcategory.bind(this)
            this.CreateProductVenomCode = this.CreateProductVenomCode.bind(this)
            this.CreateSubcategory = this.CreateSubcategory.bind(this)
            this.CreateVenomProductCategory = this.CreateVenomProductCategory.bind(this)
            this.DeleteCatalogueBusinessMapping = this.DeleteCatalogueBusinessMapping.bind(this)
            this.DeleteCatalogueProduct = this.DeleteCatalogueProduct.bind(this)
            this.DeleteCategory = this.DeleteCategory.bind(this)
            this.DeleteProduct = this.DeleteProduct.bind(this)
            this.DeleteProductCatalogueMapping = this.DeleteProductCatalogueMapping.bind(this)
            this.DeleteProductRecommendationForReason = this.DeleteProductRecommendationForReason.bind(this)
            this.DeleteProductSubcategory = this.DeleteProductSubcategory.bind(this)
            this.DeleteProductVenomCode = this.DeleteProductVenomCode.bind(this)
            this.DeleteSubcategory = this.DeleteSubcategory.bind(this)
            this.DeleteVenomGroupToProduct = this.DeleteVenomGroupToProduct.bind(this)
            this.DeleteVenomProductCategory = this.DeleteVenomProductCategory.bind(this)
            this.GetCatalogue = this.GetCatalogue.bind(this)
            this.GetCatalogueProduct = this.GetCatalogueProduct.bind(this)
            this.GetCategory = this.GetCategory.bind(this)
            this.GetProduct = this.GetProduct.bind(this)
            this.GetProductCatalogueMapping = this.GetProductCatalogueMapping.bind(this)
            this.GetProductCataloguesByDocIDs = this.GetProductCataloguesByDocIDs.bind(this)
            this.GetProductSubcategories = this.GetProductSubcategories.bind(this)
            this.GetSubcategory = this.GetSubcategory.bind(this)
            this.HandleShopifyInventoryUpdateWebhook = this.HandleShopifyInventoryUpdateWebhook.bind(this)
            this.ListCatalogueBusinessesMapping = this.ListCatalogueBusinessesMapping.bind(this)
            this.ListCatalogues = this.ListCatalogues.bind(this)
            this.ListCategories = this.ListCategories.bind(this)
            this.ListCategoriesSubcategories = this.ListCategoriesSubcategories.bind(this)
            this.ListMappedSubCategoriesForCategory = this.ListMappedSubCategoriesForCategory.bind(this)
            this.ListProductCatalogue = this.ListProductCatalogue.bind(this)
            this.ListProductCatalogueClassifications = this.ListProductCatalogueClassifications.bind(this)
            this.ListProductCatalogueProductMapping = this.ListProductCatalogueProductMapping.bind(this)
            this.ListProductCatalogues = this.ListProductCatalogues.bind(this)
            this.ListProductCategoriesV2 = this.ListProductCategoriesV2.bind(this)
            this.ListProductVenomCategories = this.ListProductVenomCategories.bind(this)
            this.ListProductVenomCodes = this.ListProductVenomCodes.bind(this)
            this.ListProductVenomGroups = this.ListProductVenomGroups.bind(this)
            this.ListProducts = this.ListProducts.bind(this)
            this.ListProductsBySubCategory = this.ListProductsBySubCategory.bind(this)
            this.ListRecommendationsUserDocId = this.ListRecommendationsUserDocId.bind(this)
            this.ListRecommendedProductsByReason = this.ListRecommendedProductsByReason.bind(this)
            this.ListRecommendedReasonTypesByProductDocID = this.ListRecommendedReasonTypesByProductDocID.bind(this)
            this.ListSubcategories = this.ListSubcategories.bind(this)
            this.MapVenomGroupToProduct = this.MapVenomGroupToProduct.bind(this)
            this.ProductVariants = this.ProductVariants.bind(this)
            this.SearchProducts = this.SearchProducts.bind(this)
            this.UpdateCatalogue = this.UpdateCatalogue.bind(this)
            this.UpdateCatalogueProduct = this.UpdateCatalogueProduct.bind(this)
            this.UpdateCategory = this.UpdateCategory.bind(this)
            this.UpdateProduct = this.UpdateProduct.bind(this)
            this.UpdateSubcategory = this.UpdateSubcategory.bind(this)
            this.UploadCatalogueProducts = this.UploadCatalogueProducts.bind(this)
        }

        /**
         * Create catalogue
         * Creates a standard catalogue to map against
         */
        public async CreateCatalogue(params: entities.CreateCatalogueRequest): Promise<entities.CreateCatalogueResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/products/catalogue`, JSON.stringify(params))
            return await resp.json() as entities.CreateCatalogueResponse
        }

        /**
         * CreateCatalogueBusinessMapping
         * Creates catalogue business mapping
         */
        public async CreateCatalogueBusinessMapping(catalogueId: string, params: entities.CreateCatalogueBusinessRequest): Promise<entities.CreateCatalogueBusinessResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/products/mappers/${encodeURIComponent(catalogueId)}/business-mapper`, JSON.stringify(params))
            return await resp.json() as entities.CreateCatalogueBusinessResponse
        }

        /**
         * CreateCategory
         * Creates a standard category to map against
         */
        public async CreateCategory(params: entities.CreateCategoryRequest): Promise<entities.CreateCategoryResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                name: params.Name,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/product/category`, undefined, {query})
            return await resp.json() as entities.CreateCategoryResponse
        }

        /**
         * CreateProduct
         * Creates a standard product to map against
         */
        public async CreateProduct(params: CreateProductRequest): Promise<CreateProdResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/product`, JSON.stringify(params))
            return await resp.json() as CreateProdResponse
        }

        /**
         * CreateProductCatalogue
         * Creates catalogue product
         */
        public async CreateProductCatalogue(params: CreateCatalogueProductRequest): Promise<entities.CreateCatalogueProductResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/products/product-catalogue`, JSON.stringify(params))
            return await resp.json() as entities.CreateCatalogueProductResponse
        }

        /**
         * CreateProductCatalogueMapping
         * Creates catalogue product mapping
         */
        public async CreateProductCatalogueMapping(productId: string, catalogueId: string): Promise<entities.CreateCatalogueProductMappingResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/products/mappers/${encodeURIComponent(productId)}/catalogue-mapper/${encodeURIComponent(catalogueId)}`)
            return await resp.json() as entities.CreateCatalogueProductMappingResponse
        }

        /**
         * CreateProductRecommendationForReason creates a new ProductRecommendation for a given reason
         */
        public async CreateProductRecommendationForReason(params: CreateProductRecommendationForReasonsRequest): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/v1/productinternal/recommendations/reason`, JSON.stringify(params))
        }

        /**
         * CreateProductSubcategory
         */
        public async CreateProductSubcategory(params: entities.ProductSubcategoryRequest): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/v1/product/product-subcategory-mapping`, JSON.stringify(params))
        }

        /**
         * Create venom code product mapping
         */
        public async CreateProductVenomCode(productId: string, params: entities.CreateProductVenomCodeRequest): Promise<entities.CreateProductVenomCodeResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/products/venomcode/${encodeURIComponent(productId)}`, JSON.stringify(params))
            return await resp.json() as entities.CreateProductVenomCodeResponse
        }

        /**
         * CreateSubcategory
         */
        public async CreateSubcategory(params: entities.CreateSubcategoryRequest): Promise<entities.CreateSubcategoryResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/product/categories/subcategory`, JSON.stringify(params))
            return await resp.json() as entities.CreateSubcategoryResponse
        }

        /**
         * Create venom product category
         * Creates a standard venom product category to map against
         */
        public async CreateVenomProductCategory(id: string, params: entities.CreateProductVenomCategoryRequest): Promise<entities.CreateProductVenomCategoryResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/products/venomcategory/${encodeURIComponent(id)}`, JSON.stringify(params))
            return await resp.json() as entities.CreateProductVenomCategoryResponse
        }

        /**
         * DeleteCatalogueBusinessMapping
         * Delete catalogue business mapping
         */
        public async DeleteCatalogueBusinessMapping(businessId: string, catalogueId: string): Promise<void> {
            await this.baseClient.callTypedAPI("DELETE", `/v1/products/mappers/${encodeURIComponent(businessId)}/business-mapper/${encodeURIComponent(catalogueId)}`)
        }

        /**
         * DeleteCatalogueProduct
         * Delete catalogue product
         */
        public async DeleteCatalogueProduct(catalogueProductId: string): Promise<void> {
            await this.baseClient.callTypedAPI("DELETE", `/v1/products/product-catalogue/${encodeURIComponent(catalogueProductId)}`)
        }

        /**
         * DeleteCategory
         */
        public async DeleteCategory(categoryId: string): Promise<void> {
            await this.baseClient.callTypedAPI("DELETE", `/v1/products/category/${encodeURIComponent(categoryId)}`)
        }

        /**
         * DeleteProduct
         */
        public async DeleteProduct(productId: string): Promise<void> {
            await this.baseClient.callTypedAPI("DELETE", `/v1/product/${encodeURIComponent(productId)}`)
        }

        /**
         * DeleteProductCatalogueMapping
         * Delete catalogue product mapping
         */
        public async DeleteProductCatalogueMapping(productId: string, catalogueProductId: string): Promise<void> {
            await this.baseClient.callTypedAPI("DELETE", `/v1/products/mappers/${encodeURIComponent(productId)}/catalogue-mapper/${encodeURIComponent(catalogueProductId)}`)
        }

        /**
         * DeleteProductRecommendationForReason
         * Delete a product recommendation for a reason
         */
        public async DeleteProductRecommendationForReason(params: DeleteProductRecommendationsForReasonRequest): Promise<void> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "product_doc_i_ds": params["product_ids"].map((v) => v),
                "reason_doc_id":    params["reason_doc_id"],
                species:            params.species,
            })

            await this.baseClient.callTypedAPI("DELETE", `/v1/productinternal/recommendations/reason`, undefined, {query})
        }

        /**
         * DeleteProductSubcategory
         */
        public async DeleteProductSubcategory(productId: string, subcategoryId: string): Promise<void> {
            await this.baseClient.callTypedAPI("DELETE", `/v1/products/product-subcategory-mapping/${encodeURIComponent(productId)}/${encodeURIComponent(subcategoryId)}`)
        }

        /**
         * DeleteProductVenomCode Delete venom code product mapping
         */
        public async DeleteProductVenomCode(venom_code_id: string, prod_id: string): Promise<void> {
            await this.baseClient.callTypedAPI("DELETE", `/v1/products/venomcode/${encodeURIComponent(venom_code_id)}/product/${encodeURIComponent(prod_id)}`)
        }

        /**
         * DeleteSubcategory
         */
        public async DeleteSubcategory(subcategoryId: string): Promise<void> {
            await this.baseClient.callTypedAPI("DELETE", `/v1/products/categories/subcategory/${encodeURIComponent(subcategoryId)}`)
        }

        /**
         * Delete VenomCode to product mapping
         * Delete a venom code group id to a product id
         */
        public async DeleteVenomGroupToProduct(venom_group_id: string, product_id: string): Promise<void> {
            await this.baseClient.callTypedAPI("DELETE", `/v1/products/venomgroup/${encodeURIComponent(venom_group_id)}/product/${encodeURIComponent(product_id)}`)
        }

        /**
         * DeleteVenomProductCategory
         * Delete a standard venom product category to map against
         */
        public async DeleteVenomProductCategory(venon_category_id: string, id: string): Promise<void> {
            await this.baseClient.callTypedAPI("DELETE", `/v1/products/venomcategory/${encodeURIComponent(venon_category_id)}/product/${encodeURIComponent(id)}`)
        }

        /**
         * Get catalogue
         * Returns a single catalogue
         */
        public async GetCatalogue(params: entities.GetCatalogueRequest): Promise<entities.GetCatalogueResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "doc_id": params.DocID,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/products/catalogue`, undefined, {query})
            return await resp.json() as entities.GetCatalogueResponse
        }

        /**
         * GetCatalogueProduct
         * Returns a single catalog-product
         */
        public async GetCatalogueProduct(catalogueId: string): Promise<CatalogueProductResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/products/product-catalogue/${encodeURIComponent(catalogueId)}`)
            return await resp.json() as CatalogueProductResponse
        }

        /**
         * GetCategory
         */
        public async GetCategory(categoryId: string): Promise<entities.Category> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/products/category/${encodeURIComponent(categoryId)}`)
            return await resp.json() as entities.Category
        }

        /**
         * Get product
         */
        public async GetProduct(params: GetProductRequest): Promise<GetProdResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "doc_id": params["doc_id"],
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/product`, undefined, {query})
            return await resp.json() as GetProdResponse
        }

        /**
         * GetProductCatalogueMapping
         * Get products for catalogue mapper
         */
        public async GetProductCatalogueMapping(catalogueProductId: string): Promise<entities.ListProductsForCatalogue> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/products/mappers/catalogue-mapper/${encodeURIComponent(catalogueProductId)}`)
            return await resp.json() as entities.ListProductsForCatalogue
        }

        /**
         * GetProductCataloguesByDocIDs
         * Get product catalogues by doc ids
         */
        public async GetProductCataloguesByDocIDs(params: entities.GetProductCataloguesByDocIDsRequest): Promise<entities.GetProductCatalogueResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "doc_ids": params.DocIDs.map((v) => v),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/products/product-catalogues-by-doc-ids`, undefined, {query})
            return await resp.json() as entities.GetProductCatalogueResponse
        }

        /**
         * GetProductSubcategories
         */
        public async GetProductSubcategories(productId: string): Promise<entities.SubcategoriesResponseWithCat> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/products/product-subcategory-mapping/${encodeURIComponent(productId)}`)
            return await resp.json() as entities.SubcategoriesResponseWithCat
        }

        /**
         * GetSubcategory
         */
        public async GetSubcategory(subcategoryId: string): Promise<entities.SubcategoryResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/products/categories/subcategory/${encodeURIComponent(subcategoryId)}`)
            return await resp.json() as entities.SubcategoryResponse
        }

        /**
         * HandleShopifyInventoryUpdateWebhook
         * Processes Shopify's inventory_levels/update webhooks. Skips if the sku is not found.
         */
        public async HandleShopifyInventoryUpdateWebhook(method: "POST", body?: RequestInit["body"], options?: CallParameters): Promise<globalThis.Response> {
            return this.baseClient.callAPI(method, `/v1/productsinternal/shopify-webhook/inventory-update`, body, options)
        }

        /**
         * ListCatalogueBusinessesMapping
         * List catalogue business mapping
         */
        public async ListCatalogueBusinessesMapping(params: entities.CatalogueBusinessMappingRequest): Promise<entities.ListCatalogueBusinessMappingResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "catalogue_id":   params.CatalogueId,
                "items_per_page": String(params.RequestedItemsPerPage),
                "page_number":    String(params.RequestedPageNumber),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/products/mappers/business-mapper`, undefined, {query})
            return await resp.json() as entities.ListCatalogueBusinessMappingResponse
        }

        /**
         * ListCatalogues
         * Returns a paginated list of catalogues
         */
        public async ListCatalogues(params: entities.ListCataloguesRequest): Promise<entities.ListCataloguesResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "items_per_page": String(params.RequestedItemsPerPage),
                name:             params.Name,
                "page_number":    String(params.RequestedPageNumber),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/products/catalogues`, undefined, {query})
            return await resp.json() as entities.ListCataloguesResponse
        }

        /**
         * ListCategories
         */
        public async ListCategories(params: entities.ListCategoriesRequest): Promise<entities.ListCategoriesResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                name:                       params.name,
                "requested_items_per_page": String(params["items_per_page"]),
                "requested_page_number":    String(params["page_number"]),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/products/categories-list`, undefined, {query})
            return await resp.json() as entities.ListCategoriesResponse
        }

        /**
         * ListCategoriesSubcategories
         */
        public async ListCategoriesSubcategories(): Promise<entities.CategoriesWithSubcategoriesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/products/category-subcategory-listing`)
            return await resp.json() as entities.CategoriesWithSubcategoriesResponse
        }

        /**
         * ListMappedSubCategoriesForCategory
         * List all subcategories for a given category
         */
        public async ListMappedSubCategoriesForCategory(categoryId: string): Promise<entities.ListMappedSubCategoriesForCategoryResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/products/category/${encodeURIComponent(categoryId)}/mapped-subcategories`)
            return await resp.json() as entities.ListMappedSubCategoriesForCategoryResponse
        }

        /**
         * ListProductCatalogue
         * Lists all products in catalogue
         */
        public async ListProductCatalogue(params: entities.ListProductCatalogueRequest): Promise<entities.ListProductCatalogueResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "catalogue_id":   params.CatalogueID,
                "items_per_page": String(params.RequestedItemsPerPage),
                name:             params.Name,
                "page_number":    String(params.RequestedPageNumber),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/products/catalogue-list`, undefined, {query})
            return await resp.json() as entities.ListProductCatalogueResponse
        }

        /**
         * List Product Catalogues Classifications
         * List all product catalogue classifications
         */
        public async ListProductCatalogueClassifications(): Promise<ListClassificationsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/prodinternal/catalogue/classifications`)
            return await resp.json() as ListClassificationsResponse
        }

        /**
         * ListProductCatalogueMapping
         * List catalogue products mapped to a product
         */
        public async ListProductCatalogueProductMapping(productID: string): Promise<entities.ListCatalogueProductsMappedToProductResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/products/mappers/product-catalogue-mapper/${encodeURIComponent(productID)}`)
            return await resp.json() as entities.ListCatalogueProductsMappedToProductResponse
        }

        /**
         * ListProductCatalogues
         * List all catalogues that a product is in
         */
        public async ListProductCatalogues(params: entities.ListProductCataloguesRequest): Promise<entities.ListProductCataloguesResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "items_per_page": String(params.RequestedItemsPerPage),
                "page_number":    String(params.RequestedPageNumber),
                "product_id":     params.ProductID,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/products/product-catalogues`, undefined, {query})
            return await resp.json() as entities.ListProductCataloguesResponse
        }

        /**
         * ListProductCategoriesV2
         * Returns product categories and their subcategories from the configured
         * product source. Supports both Chewy and the internal product catalogue.
         */
        public async ListProductCategoriesV2(params: ListProductCategoriesV2Request): Promise<ListProductCategoriesV2Response> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "product_source_override": params.ProductSourceOverride,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v2/products/categories`, undefined, {query})
            return await resp.json() as ListProductCategoriesV2Response
        }

        /**
         * List venom code category product mappings
         */
        public async ListProductVenomCategories(product_id: string): Promise<entities.ListProductVenomCategoriesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/products/venomcategories/${encodeURIComponent(product_id)}`)
            return await resp.json() as entities.ListProductVenomCategoriesResponse
        }

        /**
         * List venom code product mappings
         */
        public async ListProductVenomCodes(product_id: string): Promise<entities.ListProductVenomCodesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/products/venomcodes/${encodeURIComponent(product_id)}`)
            return await resp.json() as entities.ListProductVenomCodesResponse
        }

        /**
         * List venom code groups product mappings
         */
        public async ListProductVenomGroups(product_id: string): Promise<entities.ListProductVenomGroupsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/products/venomgroups/${encodeURIComponent(product_id)}`)
            return await resp.json() as entities.ListProductVenomGroupsResponse
        }

        /**
         * ListProducts Lists all products by name
         * Returns a paginaged list of products
         */
        public async ListProducts(params: entities.ListProductsRequest): Promise<entities.ListProductsResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "items_per_page": String(params.RequestedItemsPerPage),
                name:             params.Name,
                "page_number":    String(params.RequestedPageNumber),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/product-list`, undefined, {query})
            return await resp.json() as entities.ListProductsResponse
        }

        /**
         * ListProductsBySubCategory
         */
        public async ListProductsBySubCategory(params: entities.ProductSubCategoriesRequest): Promise<entities.ListProductsBySubcategory> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "items_per_page":             String(params.RequestedItemsPerPage),
                "page_number":                String(params.RequestedPageNumber),
                "subcategories_doc_ids_list": params.SubcatDocIDs.map((v) => v),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/products/subcategory-products-listing`, undefined, {query})
            return await resp.json() as entities.ListProductsBySubcategory
        }

        /**
         * List Recommended Products
         */
        public async ListRecommendationsUserDocId(user_doc_id: string, params: ListRecommendationsRequest): Promise<ListRecommendationsResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "product_doc_id":        params.ProductDocID.map((v) => v),
                "venom_category_doc_id": params.VenomCategoryDocID.map((v) => v),
                "venom_code_doc_id":     params.VenomCodeDocID.map((v) => v),
                "venom_group_doc_id":    params.VenomGroupDocID.map((v) => v),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/users/${encodeURIComponent(user_doc_id)}/recommendations`, undefined, {query})
            return await resp.json() as ListRecommendationsResponse
        }

        /**
         * ListRecommendedProductsByReason
         * lists recommended products by consultation reason for visit, paginated
         */
        public async ListRecommendedProductsByReason(params: ListRecommendedProductsByReasonParams): Promise<ListRecommendedProductsByReasonResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "business_doc_id": params.BusinessDocID,
                "items_per_page":  String(params.RequestedItemsPerPage),
                "page_number":     String(params.RequestedPageNumber),
                "reason_doc_id":   params.ReasonDocID,
                species:           params.Species,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/productinternal/recommendations/reason`, undefined, {query})
            return await resp.json() as ListRecommendedProductsByReasonResponse
        }

        /**
         * ListRecommendedReasonTypesByProductDocID
         * Lists recommended reason types by product doc id
         */
        public async ListRecommendedReasonTypesByProductDocID(doc_id: string): Promise<ListReasonTypesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/productinternal/products/${encodeURIComponent(doc_id)}/reason-types`)
            return await resp.json() as ListReasonTypesResponse
        }

        /**
         * ListSubcategories
         */
        public async ListSubcategories(params: entities.ListSubcategoriesRequest): Promise<entities.ListSubcategoriesResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                name:                       params.name,
                "requested_items_per_page": String(params["items_per_page"]),
                "requested_page_number":    String(params["page_number"]),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/products/categories/subcategories-list`, undefined, {query})
            return await resp.json() as entities.ListSubcategoriesResponse
        }

        /**
         * Create VenomCode to product mapping
         * Links a venom code group id to a product id
         */
        public async MapVenomGroupToProduct(product_id: string, params: MapVenomCodeRequest): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/v1/products/venomgroup/${encodeURIComponent(product_id)}`, JSON.stringify(params))
        }

        /**
         * ProductVariants
         * searches for product variants for a given product unique identifier
         */
        public async ProductVariants(uniqueIdentifier: string): Promise<ProductVariantsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/product/${encodeURIComponent(uniqueIdentifier)}/variants`)
            return await resp.json() as ProductVariantsResponse
        }

        /**
         * SearchProducts
         * searchs products with pagination and optional filters.
         * it returns products from one of the two providers. Either chewy or our catalogue, based on the location and insurer
         */
        public async SearchProducts(params: SearchProductsRequest): Promise<SearchProductsResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "business_doc_ids":        params.BusinessDocIDs?.map((v) => v),
                "category_id":             params.CategoryID,
                "items_per_page":          String(params.RequestedItemsPerPage),
                "page_number":             String(params.RequestedPageNumber),
                "product_source_override": params.ProductSourceOverride,
                "search_term":             params.SearchTerm,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/product-search`, undefined, {query})
            return await resp.json() as SearchProductsResponse
        }

        /**
         * Updates a catalogue
         */
        public async UpdateCatalogue(catalogueID: string, params: entities.UpdateCatalogueRequest): Promise<entities.UpdateCatalogueResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("PUT", `/v1/products/catalogue/${encodeURIComponent(catalogueID)}`, JSON.stringify(params))
            return await resp.json() as entities.UpdateCatalogueResponse
        }

        /**
         * UpdateCatalogueProduct
         * Returns an updated single catalog-product
         */
        public async UpdateCatalogueProduct(catalogueProductId: string, params: UpdateCatalogueProductRequest): Promise<CatalogueProductResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("PUT", `/v1/products/product-catalogue/${encodeURIComponent(catalogueProductId)}`, JSON.stringify(params))
            return await resp.json() as CatalogueProductResponse
        }

        /**
         * UpdateCategory
         */
        public async UpdateCategory(categoryId: string, params: entities.UpdateCategoryRequest): Promise<entities.UpdateCategoryResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                name: params.Name,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("PUT", `/v1/products/category/${encodeURIComponent(categoryId)}`, undefined, {query})
            return await resp.json() as entities.UpdateCategoryResponse
        }

        /**
         * UpdateProduct
         * Updates a product authenticated with a JWT
         */
        public async UpdateProduct(params: entities.UpdateProductRequest): Promise<entities.UpdateProductResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("PUT", `/v1/product`, JSON.stringify(params))
            return await resp.json() as entities.UpdateProductResponse
        }

        /**
         * UpdateSubcategory
         */
        public async UpdateSubcategory(subcategoryId: string, params: entities.UpdateSubcategoryRequest): Promise<entities.UpdateSubcategoryResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("PUT", `/v1/product/categories/subcategory/${encodeURIComponent(subcategoryId)}`, JSON.stringify(params))
            return await resp.json() as entities.UpdateSubcategoryResponse
        }

        /**
         * Upload Products
         * Upload products to catalogue through csv file
         */
        public async UploadCatalogueProducts(params: entities.UploadProductsRequest): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/v1/catalogue/csv-upload-products`, JSON.stringify(params))
        }
    }
}

export namespace reportingexternal {
    export interface ConsultationsReportRequest {
        /**
         * This parameter specifies the location for which you want to retrieve (e.g., "uk").
         */
        Location: string

        /**
         * This parameter defines the starting date for the reporting data you want.
         */
        StartDate: string

        /**
         * This parameter defines the ending date for the reporting data you want.
         */
        EndDate: string

        /**
         * This parameter indicates the version of the reporting data you want to retrieve.This should be a positive integer value (e.g., 1, 2, 3).
         */
        Version: number
    }

    export interface ConsultationsReportRequestByCustomerReference {
        /**
         * This parameter specifies the location for which you want to retrieve (e.g., "uk").
         */
        Location: string

        /**
         * This parameter defines the starting date for the reporting data you want.
         */
        StartDate: string

        /**
         * This parameter defines the ending date for the reporting data you want.
         */
        EndDate: string

        /**
         * This parameter indicates the version of the reporting data you want to retrieve.This should be a positive integer value (e.g., 1, 2, 3).
         */
        Version: number

        /**
         * This parameter defines either the customer policy number or customer reference of the data you want to retrieve.
         */
        "Customer_ref": string
    }

    /**
     * Response represents the entire JSON structure
     */
    export interface ConsultationsReportResponse {
        result: ConsultationsReportResponseResult[]
    }

    export interface ConsultationsReportResponseDiagnosis {
        id: string
        diagnosis: string
        likelihood: string
        "diagnosis_groups": ConsultationsReportResponseDiagnosisGroups[]
    }

    export interface ConsultationsReportResponseDiagnosisGroups {
        "diagnosis_group_id": string
        "diagnosis_group": string
    }

    export interface ConsultationsReportResponsePrescriptionFulfilled {
        Id: string
        SKU: string
        Vendor: string
        VariantTitle: string
        Name: string
        Quantity: string
        Price: string
        Categories: string
    }

    export interface ConsultationsReportResponsePrescriptionGiven {
        Id: string
        Repeats: string
        Directions: string
        MedicationName: string
        Quantity: string
        Strength: string
    }

    export interface ConsultationsReportResponseResult {
        "Interaction_id": string
        GUID: string
        PolicyNo: string
        InteractionType: string
        InteractionDate: string
        Diagnoses: ConsultationsReportResponseDiagnosis[]
        FoodPurchasesCount: number
        TotalFoodPurchases: string
        TotalMedicationPurchases: string
        RiskType: string
        RiskName: string
        Breed: string
        "Age_months": number
        "Weight_kg": number
        rating: number
        "rating_count": number
        "actual_queue_time": number
        "Vol_Previous_Pet_Consultations": number
        "follow_up_consultation_id": number
        "Products_purchased": string
        "Price_paid": number
        Reasons: string[]
        "Treatment_plan": string
        "Patient_notes": string
        Resolved: number
        outcome: string[]
        PrescriptionOutcome: string
        PrescriptionGiven: ConsultationsReportResponsePrescriptionGiven[]
        PrescriptionFulfilled: ConsultationsReportResponsePrescriptionFulfilled[]
        "staff_id": string
        "average_response_time_staff": number
        "actual_queue_time_seconds": number
    }

    /**
     * Response represents the entire JSON structure
     */
    export interface PupStartReportResponse {
        result: PupStartReportResponseResult[]
    }

    export interface PupStartReportResponseResult {
        /**
         * pup start fields
         */
        "Interaction_id": string

        InteractionDate: string
        PolicyNo: string
    }

    export interface PupStartRequest {
        /**
         * This parameter specifies the location for which you want to retrieve (e.g., "uk").
         */
        Location: string

        /**
         * This parameter defines the starting date for the reporting data you want.
         */
        StartDate: string

        /**
         * This parameter defines the ending date for the reporting data you want.
         */
        EndDate: string

        /**
         * This parameter indicates the version of the reporting data you want to retrieve.This should be a positive integer value (e.g., 1, 2, 3).
         */
        Version: number
    }

    export interface ReportingsRequest {
        /**
         * This parameter specifies the location for which you want to retrieve (e.g., "uk").
         */
        Location: string

        /**
         * This parameter indicates the version of the reportings data you want to retrieve.This should be a positive integer value (e.g., 1, 2, 3).
         */
        Version: number

        /**
         * This parameter specifies the interaction id, as returned in the consultations endpoint
         */
        InteractionId: string
    }

    export interface ResponsePDFReportings {
        "file_location": string
    }

    export interface SymptomCheckerSessionsReportRequest {
        /**
         * This parameter specifies the location for which you want to retrieve (e.g., "uk").
         */
        Location: string

        /**
         * This parameter defines the starting date for the reporting data you want.
         */
        StartDate: string

        /**
         * This parameter defines the ending date for the reporting data you want.
         */
        EndDate: string

        /**
         * This parameter indicates the version of the reporting data you want to retrieve.This should be a positive integer value (e.g., 1, 2, 3).
         */
        Version: number
    }

    export interface SymptomCheckerSessionsReportRequestByCustomerReference {
        /**
         * This parameter specifies the location for which you want to retrieve (e.g., "uk").
         */
        Location: string

        /**
         * This parameter defines the starting date for the reporting data you want.
         */
        StartDate: string

        /**
         * This parameter defines the ending date for the reporting data you want.
         */
        EndDate: string

        /**
         * This parameter indicates the version of the reporting data you want to retrieve.This should be a positive integer value (e.g., 1, 2, 3).
         */
        Version: number

        /**
         * This parameter defines either the customer policy number or customer reference of the data you want to retrieve.
         */
        "Customer_ref": string
    }

    /**
     * Response represents the entire JSON structure
     */
    export interface SymptomCheckerSessionsReportResponse {
        result: SymptomCheckerSessionsReportResponseResult[]
    }

    export interface SymptomCheckerSessionsReportResponseResult {
        "policy_num": string
        "session_id": string
        time: string
        "algo_name": string
        "products_ordered": string
        outcome: string[]
        reachedoutcome: number
        diruptedreason: string
    }

    export interface UsersReportRequest {
        /**
         * This parameter specifies the location for which you want to retrieve (e.g., "uk").
         */
        Location: string

        /**
         * This parameter defines the starting date for the reporting data you want.
         */
        StartDate: string

        /**
         * This parameter defines the ending date for the reporting data you want.
         */
        EndDate: string

        /**
         * This parameter indicates the version of the reporting data you want to retrieve.This should be a positive integer value (e.g., 1, 2, 3).
         */
        Version: number
    }

    export interface UsersReportRequestByCustomerReference {
        /**
         * This parameter specifies the location for which you want to retrieve (e.g., "uk").
         */
        Location: string

        /**
         * This parameter defines the starting date for the reporting data you want.
         */
        StartDate: string

        /**
         * This parameter defines the ending date for the reporting data you want.
         */
        EndDate: string

        /**
         * This parameter indicates the version of the reporting data you want to retrieve.This should be a positive integer value (e.g., 1, 2, 3).
         */
        Version: number

        /**
         * This parameter defines either the customer policy number or customer reference of the data you want to retrieve.
         */
        "Customer_ref": string
    }

    /**
     * Response represents the entire JSON structure
     */
    export interface UsersReportResponse {
        result: UsersReportResponseResult[]
    }

    export interface UsersReportResponseResult {
        /**
         * user fields
         */
        "doc_id": string

        "user_id": string
        "policy_customer_no": string
        "policy_no": string
        "created_at": string
        "user_created_date": string
        "pet_created_date": string
    }

    export interface abandonedReportRequest {
        /**
         * This parameter specifies the location for which you want to retrieve (e.g., "uk").
         */
        Location: string

        /**
         * This parameter defines the starting date for the reporting data you want.
         */
        StartDate: string

        /**
         * This parameter defines the ending date for the reporting data you want.
         */
        EndDate: string

        /**
         * This parameter indicates the version of the reporting data you want to retrieve.This should be a positive integer value (e.g., 1, 2, 3).
         */
        Version: number
    }

    export interface abandonedReportRequestByCustomerReference {
        /**
         * This parameter specifies the location for which you want to retrieve (e.g., "uk").
         */
        Location: string

        /**
         * This parameter defines the starting date for the reporting data you want.
         */
        StartDate: string

        /**
         * This parameter defines the ending date for the reporting data you want.
         */
        EndDate: string

        /**
         * This parameter indicates the version of the reporting data you want to retrieve.This should be a positive integer value (e.g., 1, 2, 3).
         */
        Version: number

        /**
         * This parameter defines either the customer policy number or customer reference of the data you want to retrieve.
         */
        "Customer_ref": string
    }

    /**
     * Response represents the entire JSON structure
     */
    export interface abandonedReportResponse {
        result: abandonedReportResponseResult[]
    }

    export interface abandonedReportResponseResult {
        /**
         * abandoned consultation fields
         */
        "Interaction_id": string

        PolicyNo: string
        InteractionDate: string
        "Disrupted_reason": string
        InteractionType: string
        TimeToAbandon: number
        ReturnedWithin7days: number
    }

    export interface aiReportRequest {
        /**
         * This parameter specifies the location for which you want to retrieve (e.g., "uk").
         */
        Location: string

        /**
         * This parameter defines the starting date for the reporting data you want.
         */
        StartDate: string

        /**
         * This parameter defines the ending date for the reporting data you want.
         */
        EndDate: string

        /**
         * This parameter indicates the version of the reporting data you want to retrieve.This should be a positive integer value (e.g., 1, 2, 3).
         */
        Version: number
    }

    export interface aiReportRequestByCustomerReference {
        /**
         * This parameter specifies the location for which you want to retrieve (e.g., "uk").
         */
        Location: string

        /**
         * This parameter defines the starting date for the reporting data you want.
         */
        StartDate: string

        /**
         * This parameter defines the ending date for the reporting data you want.
         */
        EndDate: string

        /**
         * This parameter indicates the version of the reporting data you want to retrieve.This should be a positive integer value (e.g., 1, 2, 3).
         */
        Version: number

        /**
         * This parameter defines either the customer policy number or customer reference of the data you want to retrieve.
         */
        "Customer_ref": string
    }

    /**
     * Response represents the entire JSON structure
     */
    export interface aiReportResponse {
        result: aiReportResponseResult[]
    }

    export interface aiReportResponseResult {
        /**
         * llm fields
         */
        "ai_session_id": string

        "policy_num": string
        "created_at": string
        "model_triggered": string
    }

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.AbandonedReportByCustomerReference = this.AbandonedReportByCustomerReference.bind(this)
            this.AiReportByCustomerReference = this.AiReportByCustomerReference.bind(this)
            this.ConsultationsReport = this.ConsultationsReport.bind(this)
            this.ConsultationsReportByCustomerReference = this.ConsultationsReportByCustomerReference.bind(this)
            this.PupStartReport = this.PupStartReport.bind(this)
            this.ReportingPetConsultationPDF = this.ReportingPetConsultationPDF.bind(this)
            this.ReportingPrescriptionPDF = this.ReportingPrescriptionPDF.bind(this)
            this.SymptomCheckerSessionsReport = this.SymptomCheckerSessionsReport.bind(this)
            this.SymptomCheckerSessionsReportByCustomerReference = this.SymptomCheckerSessionsReportByCustomerReference.bind(this)
            this.UsersReport = this.UsersReport.bind(this)
            this.UsersReportByCustomerReference = this.UsersReportByCustomerReference.bind(this)
            this.abandonedReport = this.abandonedReport.bind(this)
            this.aiReport = this.aiReport.bind(this)
        }

        /**
         * AbandonedReportByCustomerReference
         * This endpoint facilitates the retrieval of reporting data, such as analytics or statistics, based on specified parameters.
         * It requires parameters including location, start date, end date, endpoint, version and customer reference to be provided.
         * Upon successful validation and retrieval, it returns the abandoned consultations in which a vet has tried to connect with a customer but has been unsuccessful.
         * Customer reference can either be the pet policy number or the customer reference number
         */
        public async AbandonedReportByCustomerReference(params: abandonedReportRequestByCustomerReference): Promise<abandonedReportResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "customer_ref": params["Customer_ref"],
                "end_date":     params.EndDate,
                location:       params.Location,
                "start_date":   params.StartDate,
                version:        String(params.Version),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/reporting/abandonedReportByCustomerReference`, undefined, {query})
            return await resp.json() as abandonedReportResponse
        }

        /**
         * AIReportByCustomerReference
         * This endpoint facilitates the retrieval of reporting data, such as analytics or statistics, based on specified parameters.
         * It requires parameters including location, start date, end date, endpoint, and version to be provided.
         * Upon successful validation and retrieval, it returns the sessions within the llm in which a customer has been given advice.
         * Customer reference can either be the pet policy number or the customer reference number
         */
        public async AiReportByCustomerReference(params: aiReportRequestByCustomerReference): Promise<aiReportResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "customer_ref": params["Customer_ref"],
                "end_date":     params.EndDate,
                location:       params.Location,
                "start_date":   params.StartDate,
                version:        String(params.Version),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/reporting/aiByCustomerReference`, undefined, {query})
            return await resp.json() as aiReportResponse
        }

        /**
         * ConsultationsReport
         * This endpoint facilitates the retrieval of reporting data, such as analytics or statistics, based on specified parameters.
         * It requires parameters including location, start date, end date, endpoint, and version to be provided.
         * Upon successful validation and retrieval, it returns the requested reporting data for consultations.
         */
        public async ConsultationsReport(params: ConsultationsReportRequest): Promise<ConsultationsReportResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "end_date":   params.EndDate,
                location:     params.Location,
                "start_date": params.StartDate,
                version:      String(params.Version),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/reporting/consultations`, undefined, {query})
            return await resp.json() as ConsultationsReportResponse
        }

        /**
         * ConsultationsReportByCustomerReference
         * This endpoint facilitates the retrieval of reporting data, such as analytics or statistics, based on specified parameters.
         * It requires parameters including location, start date, end date, endpoint, version and customer reference to be provided.
         * Upon successful validation and retrieval, it returns the requested reporting data for consultations.
         * Customer reference can either be the pet policy number or the customer reference number
         */
        public async ConsultationsReportByCustomerReference(params: ConsultationsReportRequestByCustomerReference): Promise<ConsultationsReportResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "customer_ref": params["Customer_ref"],
                "end_date":     params.EndDate,
                location:       params.Location,
                "start_date":   params.StartDate,
                version:        String(params.Version),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/reporting/consultationsByCustomerReference`, undefined, {query})
            return await resp.json() as ConsultationsReportResponse
        }

        /**
         * PupStartReport
         * This endpoint facilitates the retrieval of reporting data, such as analytics or statistics, based on specified parameters.
         * It requires parameters including location, start date, end date, endpoint, and version to be provided.
         * Upon successful validation and retrieval, it returns the requested reporting data for pup start consultations.
         */
        public async PupStartReport(params: PupStartRequest): Promise<PupStartReportResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "end_date":   params.EndDate,
                location:     params.Location,
                "start_date": params.StartDate,
                version:      String(params.Version),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/reporting/pupStart`, undefined, {query})
            return await resp.json() as PupStartReportResponse
        }

        /**
         * Get PDF Consultation Report
         * This endpoint retrieves PDF reports for consultations based on specified parameters such as **location**, **interactionId** and **version**.
         * Upon successful retrieval, it returns the PDF report for the consultation.
         */
        public async ReportingPetConsultationPDF(params: ReportingsRequest): Promise<ResponsePDFReportings> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                interactionId: params.InteractionId,
                location:      params.Location,
                version:       String(params.Version),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/reportingPetConsultationPDF`, undefined, {query})
            return await resp.json() as ResponsePDFReportings
        }

        /**
         * Get PDF Prescription Report
         * This endpoint retrieves the prescription PDF given within a consultation based on specified parameters such as **location**, **interactionId** and **version**.
         * Upon successful retrieval, it returns the prescription PDF report for the consultation.
         */
        public async ReportingPrescriptionPDF(params: ReportingsRequest): Promise<ResponsePDFReportings> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                interactionId: params.InteractionId,
                location:      params.Location,
                version:       String(params.Version),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/reportingPrescriptionPDF`, undefined, {query})
            return await resp.json() as ResponsePDFReportings
        }

        /**
         * SymptomCheckerSessionsReport
         * This endpoint facilitates the retrieval of reporting data, such as analytics or statistics, based on specified parameters.
         * It requires parameters including location, start date, end date, endpoint, and version to be provided.
         * Upon successful validation and retrieval, it returns the requested reporting data for symptom checker.
         */
        public async SymptomCheckerSessionsReport(params: SymptomCheckerSessionsReportRequest): Promise<SymptomCheckerSessionsReportResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "end_date":   params.EndDate,
                location:     params.Location,
                "start_date": params.StartDate,
                version:      String(params.Version),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/symptomcheckersessions`, undefined, {query})
            return await resp.json() as SymptomCheckerSessionsReportResponse
        }

        /**
         * SymptomCheckerSessionsReportByCustomerReference
         * This endpoint facilitates the retrieval of reporting data, such as analytics or statistics, based on specified parameters.
         * It requires parameters including location, start date, end date, endpoint, version and customer reference to be provided.
         * Upon successful validation and retrieval, it returns the requested reporting data for symptom checker.
         * Customer reference can either be the pet policy number or the customer reference number
         */
        public async SymptomCheckerSessionsReportByCustomerReference(params: SymptomCheckerSessionsReportRequestByCustomerReference): Promise<SymptomCheckerSessionsReportResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "customer_ref": params["Customer_ref"],
                "end_date":     params.EndDate,
                location:       params.Location,
                "start_date":   params.StartDate,
                version:        String(params.Version),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/reporting/symptomcheckersessionsByCustomerReference`, undefined, {query})
            return await resp.json() as SymptomCheckerSessionsReportResponse
        }

        /**
         * UsersReport
         * This endpoint facilitates the retrieval of reporting data, such as analytics or statistics, based on specified parameters.
         * It requires parameters including location, start date, end date, endpoint, and version to be provided.
         * Upon successful validation and retrieval, it returns the requested reporting data for users.
         */
        public async UsersReport(params: UsersReportRequest): Promise<UsersReportResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "end_date":   params.EndDate,
                location:     params.Location,
                "start_date": params.StartDate,
                version:      String(params.Version),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/reporting/users`, undefined, {query})
            return await resp.json() as UsersReportResponse
        }

        /**
         * UsersReportByCustomerReference
         * This endpoint facilitates the retrieval of reporting data, such as analytics or statistics, based on specified parameters.
         * It requires parameters including location, start date, end date, endpoint, version and customer reference to be provided.
         * Upon successful validation and retrieval, it returns the requested reporting data for users.
         * Customer reference can either be the pet policy number or the customer reference number
         */
        public async UsersReportByCustomerReference(params: UsersReportRequestByCustomerReference): Promise<UsersReportResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "customer_ref": params["Customer_ref"],
                "end_date":     params.EndDate,
                location:       params.Location,
                "start_date":   params.StartDate,
                version:        String(params.Version),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/reporting/usersByCustomerReference`, undefined, {query})
            return await resp.json() as UsersReportResponse
        }

        /**
         * abandonedReport
         * This endpoint facilitates the retrieval of reporting data, such as analytics or statistics, based on specified parameters.
         * It requires parameters including location, start date, end date, endpoint, and version to be provided.
         * Upon successful validation and retrieval, it returns the abandoned consultations in which a vet has tried to connect with a customer but has been unsuccessful.
         */
        public async abandonedReport(params: abandonedReportRequest): Promise<abandonedReportResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "end_date":   params.EndDate,
                location:     params.Location,
                "start_date": params.StartDate,
                version:      String(params.Version),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/reporting/abandonedReport`, undefined, {query})
            return await resp.json() as abandonedReportResponse
        }

        /**
         * AIReport
         * This endpoint facilitates the retrieval of reporting data, such as analytics or statistics, based on specified parameters.
         * It requires parameters including location, start date, end date, endpoint, and version to be provided.
         * Upon successful validation and retrieval, it returns the sessions within the llm in which a customer has been given advice.
         */
        public async aiReport(params: aiReportRequest): Promise<aiReportResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "end_date":   params.EndDate,
                location:     params.Location,
                "start_date": params.StartDate,
                version:      String(params.Version),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/reporting/ai`, undefined, {query})
            return await resp.json() as aiReportResponse
        }
    }
}

export namespace reportinginternal {
    export interface PlatformEventRequest {
        platform: string
        key: string
    }

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.ReportPlatformEvent = this.ReportPlatformEvent.bind(this)
        }

        public async ReportPlatformEvent(params: PlatformEventRequest): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/v1/platform/events`, JSON.stringify(params))
        }
    }
}

/**
 * scexternal houses any endpoints that are designed to be user facing, for
 * users actually doing the algorithm
 */
export namespace scexternal {
    export interface AIBackendJob {
        /**
         * Model
         * This is the model that the job is pending on.
         */
        model: string

        /**
         * Status
         * This is the status of the pending job. Status can be success,received or
         * failure. If failure, failure message will be populated with a user facing
         * error message
         */
        status: string

        /**
         * FailureMessage
         * This is a user facing error message that can be shown to the user if
         * the status is failure
         */
        "failure_message"?: string
    }

    /**
     * this is all an algorithm can be to the external services, they should have no
     * further knowledge
     */
    export interface AlgorithmDTO {
        order: number
        title: string
        description: string
        "doc_id": uuid.UUID
    }

    export interface CategoryDTO {
        id: number
        order: number
        "doc_id": string
        name: string
        "icon_url": string
    }

    export interface CheckSessionOutcomeHasArticlesResponse {
        "has_articles": boolean
    }

    export interface CreateSessionRequest {
        /**
         * PetID
         * Deprecated. Use PetDocID.
         */
        "pet_id"?: uuid.UUID

        /**
         * PetDocID
         * The DocID of the pet to create the session for.
         */
        "pet_doc_id": uuid.UUID

        /**
         * AlgorithmID
         * The DocID of the algorithm to create the session for.
         */
        "algorithm_id": uuid.UUID
    }

    export interface CreateSessionRequestWithPetDetails {
        /**
         * AlgorithmDocID
         * The ID of the algorithm.
         */
        "algorithm_doc_id": uuid.UUID

        /**
         * Name
         * The name of the pet.
         */
        name: string

        /**
         * Gender
         * The gender of the pet.
         * 
         * Accepted values are:  **Male**, **Female**, **Unknown**.
         */
        gender: string

        /**
         * Weight
         * The weight of the pet.
         */
        weight: SessionPetDetailsWeight

        /**
         * DateOfBirth
         * The pet date of birth.
         * 
         * Accepted date format: **YYYY-MM-DD**.
         */
        "date_of_birth": string

        /**
         * Neutered
         * Indicates if the pet has been neutered.
         */
        neutered: boolean

        /**
         * SpeciesDocID
         * The doc id of the species of the pet
         * Species doc ids are returned from the ListSpecies endpoint
         * /v1/species
         */
        "species_doc_id": string

        /**
         * BreedDocID
         * The doc id of the breed of the pet
         * Breed doc ids are returned from the ListBreeds endpoint
         * /v1/breeds
         */
        "breed_doc_id": string
    }

    export interface CreateSessionResponse {
        session: Session
        "current_node": Node
    }

    export interface CreateSessionUploadsRequest {
        /**
         * SessionDocID
         * The session_doc_id of the session that the user is currently in.
         */
        "session_doc_id": uuid.UUID

        /**
         * DataPointID
         * The id of the form field the media is being uploaded for. It must be a field
         * of type image-upload or video-upload on the node the session is currently on.
         */
        "data_point_id": number

        /**
         * Files
         * One entry for each file the user wants to upload. Between 1 and 10 per request.
         */
        files: SessionUploadFileRequest[]
    }

    export interface CreateSessionUploadsResponse {
        /**
         * Uploads
         * One upload target per requested file, in the order they were requested.
         */
        uploads: SessionUpload[]
    }

    export interface DataPointLabel {
        id: number
        position: string
        value: string
    }

    export interface DataPointOption {
        /**
         * ID
         * Must be sent in the payload to /session/next if the question contained
         * options. Used to record which option the user chose
         */
        id: number

        /**
         * ImageURL
         * If present, this is a URL to an image that should be displayed,
         * for example if the question type is image-single-select, the user is
         * prompted to chose from several images the one that best represents the
         * problem
         */
        "image_url"?: string

        /**
         * Label
         * Label is the user facing text for this option
         */
        label: string

        /**
         * Value
         * Value is the value that should be sent in the payload to
         * /session/next along with the option ID
         */
        value: string

        /**
         * Order
         * represents the order in which the options should be displayed
         */
        order: number

        /**
         * Coordinates
         * Deprecated as issue-location is no longer used
         * will only be present for a question of type issue-location
         * represents the bounding box for a particular location that if the user
         * clicks within, their intention was to select this option
         */
        coordinates?: number[][]

        /**
         * DescriptionPlainText
         * if present, this is a plain text description of the option
         */
        "description_plain_text": string

        /**
         * DescriptionRichText
         * if present, this is a rich text description of the option
         */
        "description_rich_text": string
    }

    export interface FeaturedAlgorithmDTO {
        order: number
        title: string
        "doc_id": uuid.UUID
        description: string
    }

    export interface FeauturedAlgorithmCategoriesRequest {
        SpeciesDocID: string
    }

    /**
     * for the user facing API, we'll flatten data points into "form fields" for now.
     * it'll more closely resemble the proposed API structure here
     * https://miro.com/app/board/uXjVNIFTY9w=/?moveToWidget=3458764573945885963&cot=14
     * and hopefully removes a layer of confusion for the consumer
     */
    export interface FormField {
        "is_default"?: boolean
        /**
         * ID
         * ID is the unique identifier for the data point. This should be used in
         * the payload to session/next
         */
        id: number

        /**
         * Type
         * The type of the form field. This can be
         * select,text,image-single-select,
         * severity-scale,slider,number,image-upload,video-upload
         */
        type: string

        /**
         * ValueType
         * ValueType gives an indication of what form the response should
         * take when submitted possible values are.
         * text,
         * number,
         * currency,
         * age,
         * weight,
         * text-array,
         * issue-location,
         */
        "value_type": string

        /**
         * Placeholder
         * if present, used to represent any text that should be used as
         * a placeholder for text inputs
         */
        placeholder: string

        /**
         * Placeholder
         * if present, contains a URL to an image that should be used as
         * the background for the issue-location question type.
         */
        "image_map_url"?: string

        /**
         * Options
         * Options is an array of possible answers to the question. If
         * present, the payload to /next must have the option_id field filled with
         * one of the IDs from this array
         */
        options: DataPointOption[]

        /**
         * Labels
         * labels are used in conjunction with the severity-scale question.
         */
        labels: DataPointLabel[]

        /**
         * Upload Bucket
         * The name of the bucket which the response will be uploaded to
         */
        "upload_bucket"?: string

        /**
         * AI Backend
         * This is an optional field that, if not empty, will contain the
         * name of the AI backend that this datapoint will be sent to. For now we
         * only support a single model called "gait". If this field contains the
         * word "gait", the data point will invariably be of type video-upload.
         * Frontend validation should be applied to ensure that only a single video
         * is being uploaded in this case.
         */
        "ai_backend"?: string

        /**
         * AI Backend Dependency
         * This is an optional field that, if not empty, will contain the
         * name of the AI backend dependency that this datapoint relies on.
         * If this is populated, and an earlier node previously called the named model,
         * the response from that model will be populated into the node.
         */
        "ai_backend_dependency"?: string

        /**
         * AI Backend Dependency Response
         */
        "ai_backend_dependency_response"?: JSONValue
    }

    export interface FormFieldInformation {
        /**
         * Type
         * This can be either text, image or video. This should be used as
         * guidance on how to render the rest of the information
         */
        type: string

        /**
         * ID
         * Should be included in the response to /session/next as the data_point_id
         */
        id: number

        /**
         * ImageURLs
         * An array of URLs to images that should be displayed on the
         * screen if present. Will only contain data if the type is image
         */
        "image_urls"?: string[]

        /**
         * VideoURL
         * A single URL to a video that should be displayed on the
         * screen if present. Will only contain data if the type is video
         */
        "video_url"?: string

        /**
         * TextBody
         * Deprecated. Will be removed.
         */
        "text_body"?: string
    }

    export interface GetFeaturedAlgorithmRequest {
        /**
         * SpeciesDocID
         * The **doc_id** of the species in **UUID** format.
         */
        SpeciesDocID: string
    }

    export interface GetFeaturedAlgorithmResponse {
        "featured_algorithm": FeaturedAlgorithmDTO
    }

    export interface GetFeaturedAlgorithmResponseV2 {
        "featured_algorithm"?: FeaturedAlgorithmDTO
    }

    export interface GetFeaturedCategoriesResponse {
        "algorithm_category": CategoryDTO[]
    }

    export interface HealthScore {
        /**
         * Score
         * Score is the health score e.g. 18
         */
        score: number

        /**
         * ScoreLabel
         * ScoreLabel is the label for the health score e.g. "Good"
         */
        "score_label": string

        /**
         * UsefullnessScore
         * UsefullnessScore is the score that indicates how useful the video is
         */
        "usefulness_score"?: number

        /**
         * ScoreRanges
         * ScoreRanges is an array of score ranges.
         */
        "score_ranges": ScoreRange[]
    }

    export interface InformationSection {
        /**
         * Type
         * Type for an information section will always be "information"
         */
        type: string

        /**
         * FormFields
         * FormFields is an array containing different parts of the
         * information screen that must be presented to inform the user. In the current
         * version of the symptom checker there will only ever be one form_field
         * element in the array, but this is designed to be extensible for the
         * future
         */
        "form_fields": FormFieldInformation[]
    }

    export interface ListAlgorithmCategoriesRequest {
        SpeciesDocID: string
    }

    export interface ListAlgorithmCategoriesResponse {
        categories: CategoryDTO[]
    }

    export interface ListAlgorithmsInCategoryRequest {
        CategoryDocID: string
        SpeciesDocID: string
    }

    export interface ListAlgorithmsInCategoryResponse {
        algorithms: AlgorithmDTO[]
    }

    export interface ListAlgorithmsRequest {
        Name: string
    }

    export interface ListAlgorithmsResponse {
        algorithms: AlgorithmDTO[]
    }

    export interface ListUserSessionsRequest {
        ItemsPerPage: number
        PageNumber: number
        PetDocID?: string
    }

    export interface ListUserSessionsResponse {
        sessions?: SessionResponse[]
        pagination: Pagination
    }

    /**
     * represents the data to display on a screen during a symptom checker session
     */
    export interface Node {
        /**
         * Title
         * Title is the title of the node. This provides a clinical reference
         * for the node, but should not be shown to the user
         */
        title: string

        /**
         * DescriptionPlainText
         * A plain text description of the node. This should be
         * shown to the user if the rich text one cannot be used
         */
        "description_plain_text": string

        /**
         * DescriptionRichText
         * A rich text description of the node using markdown. This should be shown to the user.
         */
        "description_rich_text": string

        /**
         * QuestionSections
         * QuestionSections is an array containing different
         * sections of the form that require user input. If there are questions,
         * there won't be any information sections
         */
        "question_sections"?: QuestionSection[]

        /**
         * InformationSections
         * InformationSections is an array containing different
         * sections of the form that contain information to show to a user. If there
         * are information sections, , there won't be any question sections
         */
        "information_sections"?: InformationSection[]

        "is_skippable": boolean
        /**
         * IsRootNode
         * IsRootNode is a boolean that indicates if the node is the first one in the algorithm
         */
        "is_root_node": boolean
    }

    /**
     * represents a user facing outcome. This model is deliberately different to the
     * scinternal outcome aggregate, as whilst that one is intended to give a full
     * view of the outcome for administration (multi language, creator etc), this
     * one is a lot thinner, representing just what the customer should know
     */
    export interface Outcome {
        /**
         * Urgency
         * Represents how urgently the clinicians believe action should be
         * taken. Can be "low", "medium" or "high
         * this is marked as optional in order to support algorithms for our own clinical trials
         * for external integrators this will always be set
         */
        urgency: string

        /**
         * OutcomeType
         * OutcomeType can be either default, ai_gait or trial. For external
         * integrators it will always be default, and can be ignored. For our
         * internal clinical trials, it will be set to trial. For the gait AI model
         * it will be set to ai_gait, but the ai gait model is not available
         * externally to integrators.
         */
        "outcome_type": string

        /**
         * PrimaryRecommendation
         * The primary recommendation that the user should take away from outcome
         */
        "primary_recommendation": OutcomePrimaryRecommendation

        /**
         * Advice
         * Complimentary advice that the user should take away from the outcome
         */
        advice: OutcomeAdvice

        /**
         * VenomCodes
         * An extension of the standard venom code set that the
         * clinicians believe pertain to this particular outcome.
         */
        "venom_codes"?: VenomCode[]

        /**
         * ProductRecommendation
         * Outcomes may contain products that the clinicans believe are relevant
         */
        "product_recommendations": ProductRecommendation[]

        /**
         * WhatYouNeedToKnow
         * a section of the outcome that should be shown on the
         * outcome providing them with secondary information and a potential
         * call-to-action
         */
        "what_you_need_to_know"?: WhatYouNeedToKnow

        "what_to_do_next"?: WhatToDoNext
        "wtdn_product_recommendations": ProductRecommendation[]
        "wyntk_product_recommendations": ProductRecommendation[]
        sections?: OutcomeSection[]
    }

    export interface OutcomeAdvice {
        /**
         * RichText
         * RichText is the rich text representation of the advice in markdown
         */
        "rich_text": string

        /**
         * PlainText PlainText is the plain text representation of the advice. Can
         * be used as a fallback for the rich text
         */
        "plain_text": string
    }

    export interface OutcomePrimaryRecommendation {
        /**
         * RichText
         * RichText is the rich text representation of the primary recommendation
         */
        "rich_text": string

        /**
         * PlainText
         * PlainText is the plain text representation of the primary recommendation
         */
        "plain_text": string

        /**
         * Type
         * Type is the type of the primary recommendation. This can be
         * vet-call, nurse-call, visit-vet-practice, products, care-at-home
         */
        type: string
    }

    export interface OutcomeSection {
        type: string
        title: string
        language: entities.LanguageISO639
        "rich_text": string
        "plain_text": string
        "image_url"?: string
        "health_score"?: HealthScore
        "gait_result"?: string
        /**
         * UserGaitVideo
         * this is a link to the original video upload by the user for the gait model
         */
        "original_media_url"?: string
    }

    export interface Pagination {
        total: number
        "current_page": number
        pages: number
    }

    export interface ProductRecommendation {
        /**
         * DocID
         * DocID is the unique internal vet-ai identifier for the product,
         * this should be used in conjunction with the /recommendations endpoint for
         * products to get the products mapped to a particular integrator
         */
        "doc_id": uuid.UUID

        /**
         * Name
         * Name is the human readable name for the product
         */
        name: string

        /**
         * SKU
         * Deprecated. Please use GTIN instead. To be removed once frontend catches up.
         */
        sku: string

        /**
         * GTIN
         * GTIN is the Global Trade Item Number which is a unique identifier for a product.
         */
        gtin: string

        /**
         * Description
         * Description is a human readable description of the product
         */
        description: string
    }

    export interface QuestionSection {
        /**
         * Type
         * Type for a question section will always be "question"
         */
        type: string

        /**
         * FormFields
         * FormFields is an array containing different parts of the
         * question that must be presented for the user to answer. In the current
         * version of the symptom checker there will only ever be one form_field
         * element in the array, but this is designed to be extensible for the
         * future
         */
        "form_fields": FormField[]

        "is_skippable": boolean
    }

    export interface RateLimitedResponse {
        message: string
    }

    export interface ScoreRange {
        min: number
        max: number
        label: string
    }

    export interface Session {
        /**
         * SessionID
         * SessionID is the unique identifier for the session. This should
         * be saved on the client and is repeatedly used every time there is an API
         * request to facilitate the session. e.g. through using session/next
         */
        "session_id": uuid.UUID
    }

    export interface SessionCurrentNodeResponse {
        "current_node": Node
        outcome: Outcome
    }

    export interface SessionNextRequest {
        /**
         * IsSkipped
         * if the question is marked as skippable, and the user elects to skip, set
         * this to true in the request for the next resource.
         */
        "is_skipped": boolean

        /**
         * SessionID
         * The session_doc_id of the session that the user is currently in.
         * Deprecated. Use SessionDocID.
         */
        "session_id": uuid.UUID

        /**
         * SessionDocID
         * The session_doc_id of the session that the user is currently in.
         * Deprecated. Use SessionDocID.
         */
        "session_doc_id"?: uuid.UUID

        /**
         * DataPoints
         * DataPoints is an array of the user's responses. In the initial version of
         * The API, there will only ever be one data point in this array.
         */
        "data_points": SubmittedDataPoint[]
    }

    /**
     * if you've reached the end of the algo, it'll be the outcome, otherwise the
     * question
     */
    export interface SessionNextResponse {
        /**
         * Node
         * The next node in the session. This can be either a question or an
         * information node. If it is an outcome node, the outcome section of this
         * payload will be populated
         */
        node?: Node

        /**
         * Outcome
         * If the next node is an outcome, this will be populated.
         */
        outcome?: Outcome

        /**
         * PendingJobs
         * Used as part of an asyncronous algorithm. These are for internal use only
         * at joii, and are not available for external integrators.
         */
        "pending_jobs"?: AIBackendJob[]
    }

    export interface SessionOutcomeResponse {
        outcome: Outcome
    }

    export interface SessionPetDetailsWeight {
        /**
         * WeightQuantity
         * The weight of the pet as a floating point number
         */
        "weight_quantity": number

        /**
         * Unit
         * The unit of the weight. This should be "kg", "g" or "lbs"
         */
        unit: string
    }

    export interface SessionPreviousRequest {
        "session_doc_id": uuid.UUID
    }

    export interface SessionPreviousResponse {
        node: Node
    }

    export interface SessionResponse {
        "algorithm_name": string
        complete: boolean
        "started_at": string
        "completed_at": string
        "session_doc_id": string
        category: CategoryDTO
        "pet_doc_id": string
        "algorithm_doc_id": string
    }

    export interface SessionUpload {
        /**
         * UploadURL
         * Send the raw bytes of the file to this URL with a PUT request. No
         * authorization header is needed, the URL carries its own signature.
         */
        "upload_url": string

        /**
         * Headers
         * The PUT request must carry every one of these headers, with exactly these
         * values. They are part of the signature, so the upload is rejected if any of
         * them is missing or different.
         */
        headers: SessionUploadHeader[]

        /**
         * FilePath
         * Once the file has been uploaded, submit this path back to /v1/session/next as
         * (an element of) the value for the data point.
         */
        "file_path": string

        /**
         * MaxBytes
         * The largest the file is allowed to be. Check this before starting the upload,
         * otherwise the user waits for the whole thing before it is rejected.
         */
        "max_bytes": number

        /**
         * ExpiresAt
         * After this time the upload URL stops working and a new one must be requested.
         */
        "expires_at": string
    }

    export interface SessionUploadFileRequest {
        /**
         * ContentType
         * The MIME type of the file that will be uploaded. Accepted values are
         * image/jpeg, image/png, image/heic and image/webp for an image-upload field,
         * and video/mp4 and video/quicktime for a video-upload field.
         */
        "content_type": string
    }

    export interface SessionUploadHeader {
        name: string
        value: string
    }

    export interface SubmittedDataPoint {
        /**
         * DataPointID
         * The id of the received question/information node.
         */
        "data_point_id": number

        /**
         * Value
         * This is the raw value of the users response. The type is JSON, as the
         * value type here will be determined by the data point value type that is
         * received.
         * age - "string" with the format YYYY, YYYY-MM, YYYY-MM-DD
         * weight - int or float
         * text-array - an array of strings.
         * number - a floating point number, or a string.
         */
        value: JSONValue

        /**
         * SelectedOptionID
         * If the data point is a question and the user has selected an option, this
         * should be set to the ID of the selected option.
         */
        "selected_option_id": number
    }

    export interface VenomCode {
        /**
         * DocID
         * DocID is the unique internal vet-ai identifier for the venom code.
         */
        "doc_id": uuid.UUID

        /**
         * VenomID
         * VenomID is part of a superset of the standard venom codes. It
         * _may_ contain a venomcode from the standard set.
         */
        "venom_id": string

        /**
         * TermName
         * TermName is the human readable name for the venom code. Can be shown to the user
         */
        "term_name": string
    }

    export interface WhatToDoNext {
        /**
         * Type
         * Type is used to determine the call to action associated with this
         * section, possible values are. products, vet-call nurse-call visit-vet-practice
         */
        type?: string

        /**
         * PlainText
         * PlainText is the plain text representation showing the user "what to do next"
         */
        "plain_text": string

        /**
         * RichText
         * RichText is the rich text representation showing the user "what to do next"
         */
        "rich_text": string
    }

    export interface WhatYouNeedToKnow {
        /**
         * Type
         * Type is used to determine the call to action associated with this
         * section, possible values are. products, vet-call, visit-vet-practice
         */
        type?: string

        /**
         * PlainText
         * PlainText is the plain text representation showing the user "what you need to know"
         */
        "plain_text": string

        /**
         * RichText
         * RichText is the rich text representation showing the user "what you need to know"
         */
        "rich_text": string
    }

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.CheckSessionOutcomeHasArticles = this.CheckSessionOutcomeHasArticles.bind(this)
            this.CreateSessionUploads = this.CreateSessionUploads.bind(this)
            this.GetFeaturedAlgorithm = this.GetFeaturedAlgorithm.bind(this)
            this.GetFeaturedAlgorithmV2 = this.GetFeaturedAlgorithmV2.bind(this)
            this.GetFeaturedCategories = this.GetFeaturedCategories.bind(this)
            this.GetSessionCurrentNode = this.GetSessionCurrentNode.bind(this)
            this.GetUserSession = this.GetUserSession.bind(this)
            this.GetUserSessionOutcome = this.GetUserSessionOutcome.bind(this)
            this.ListAlgorithmCategories = this.ListAlgorithmCategories.bind(this)
            this.ListAlgorithms = this.ListAlgorithms.bind(this)
            this.ListAlgorithmsInCategory = this.ListAlgorithmsInCategory.bind(this)
            this.ListUserSessions = this.ListUserSessions.bind(this)
            this.RateLimited = this.RateLimited.bind(this)
            this.SessionNext = this.SessionNext.bind(this)
            this.SessionPrevious = this.SessionPrevious.bind(this)
            this.StartSession = this.StartSession.bind(this)
            this.StartSessionWithPetDetails = this.StartSessionWithPetDetails.bind(this)
        }

        /**
         * CheckSessionOutcomeHasHarticles
         * Returns whether or not a session's outcome has articles associated with it.
         * This is usually based on the species of the pet the outcome is for, and the outcome's venom codes.
         * Errors if the session is incomplete / doesn't have an outcome.
         */
        public async CheckSessionOutcomeHasArticles(sessionDocID: string): Promise<CheckSessionOutcomeHasArticlesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/session/${encodeURIComponent(sessionDocID)}/outcome-has-articles`)
            return await resp.json() as CheckSessionOutcomeHasArticlesResponse
        }

        /**
         * Create Media Upload URLs
         * This endpoint returns short lived URLs that a user's device can upload media to
         * directly, for use when the session reaches a question of type **image-upload** or
         * **video-upload**.
         * 
         * Request one entry in **files** for each file the user wants to upload. For each one
         * you get back an **upload_url** to PUT the file to, and a **file_path** to submit to
         * /v1/session/next once the upload has finished. The value submitted for the data point
         * is the array of **file_path** values.
         * 
         * The PUT must send every header in **headers** exactly as given, must be no larger
         * than **max_bytes**, and must happen before **expires_at**.
         */
        public async CreateSessionUploads(params: CreateSessionUploadsRequest): Promise<CreateSessionUploadsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/session/uploads`, JSON.stringify(params))
            return await resp.json() as CreateSessionUploadsResponse
        }

        public async GetFeaturedAlgorithm(params: GetFeaturedAlgorithmRequest): Promise<GetFeaturedAlgorithmResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "species_doc_id": params.SpeciesDocID,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/featured-algorithm`, undefined, {query})
            return await resp.json() as GetFeaturedAlgorithmResponse
        }

        public async GetFeaturedAlgorithmV2(params: GetFeaturedAlgorithmRequest): Promise<GetFeaturedAlgorithmResponseV2> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "species_doc_id": params.SpeciesDocID,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v2/featured-algorithm`, undefined, {query})
            return await resp.json() as GetFeaturedAlgorithmResponseV2
        }

        public async GetFeaturedCategories(params: FeauturedAlgorithmCategoriesRequest): Promise<GetFeaturedCategoriesResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "species_doc_id": params.SpeciesDocID,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/featured-categories`, undefined, {query})
            return await resp.json() as GetFeaturedCategoriesResponse
        }

        /**
         * Get Current Session Node
         * This endpoint returns the user's current node in the algorithm for that session. Used to facilitate refresh/session resumption.
         */
        public async GetSessionCurrentNode(sessionID: string): Promise<SessionCurrentNodeResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/session/${encodeURIComponent(sessionID)}/current`)
            return await resp.json() as SessionCurrentNodeResponse
        }

        /**
         * Get User Session
         * returns a user session
         */
        public async GetUserSession(session_doc_id: string): Promise<SessionResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/session/${encodeURIComponent(session_doc_id)}`)
            return await resp.json() as SessionResponse
        }

        /**
         * Get User Session Outcome
         * returns a outcome reached from a user session
         */
        public async GetUserSessionOutcome(session_doc_id: string): Promise<SessionOutcomeResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/session/${encodeURIComponent(session_doc_id)}/summary`)
            return await resp.json() as SessionOutcomeResponse
        }

        /**
         * List Algorithm Categories
         * This endpoint returns a list of all algorithm categories in the requested language.
         * If no language is provided, the default language is used, which is English.
         * 
         * An algorithm category may be "breathing" for example, and the algorithms in that category may be "coughing" or "sneezing”.
         */
        public async ListAlgorithmCategories(params: ListAlgorithmCategoriesRequest): Promise<ListAlgorithmCategoriesResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "species_doc_id": params.SpeciesDocID,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/algorithm-categories`, undefined, {query})
            return await resp.json() as ListAlgorithmCategoriesResponse
        }

        /**
         * List Algorithms
         * This endpoint returns all published algorithms in the requested language.
         * If no language is provided, the default language is used, which is English.
         */
        public async ListAlgorithms(params: ListAlgorithmsRequest): Promise<ListAlgorithmsResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                name: params.Name,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/algorithms`, undefined, {query})
            return await resp.json() as ListAlgorithmsResponse
        }

        /**
         * List Algorithms in Category
         * This endpoint returns a list of all algorithms in the requested category in the requested language.
         * If no language is provided, the default language is used, which is English.
         */
        public async ListAlgorithmsInCategory(params: ListAlgorithmsInCategoryRequest): Promise<ListAlgorithmsInCategoryResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "category_doc_id": params.CategoryDocID,
                "species_doc_id":  params.SpeciesDocID,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/algorithm-categories/algorithms`, undefined, {query})
            return await resp.json() as ListAlgorithmsInCategoryResponse
        }

        /**
         * List User Sessions
         * returns a list of user sessions. Defaults to complete, but will be extended with query params at a later date
         */
        public async ListUserSessions(params: ListUserSessionsRequest): Promise<ListUserSessionsResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "items_per_page": String(params.ItemsPerPage),
                "page_number":    String(params.PageNumber),
                "pet_doc_id":     params.PetDocID,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/user/sessions`, undefined, {query})
            return await resp.json() as ListUserSessionsResponse
        }

        public async RateLimited(): Promise<RateLimitedResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/rate-limited`)
            return await resp.json() as RateLimitedResponse
        }

        /**
         * Get Next Session Node
         * This endpoint is used to move the user through their session.
         * It takes in the **session_doc_id** and the answer that should be submitted for the question the user is currently on.
         * Then, it returns the next node of the user's session. This may be either a question, information or outcome node.
         * If it is an outcome, that indicates that the user has reached the end of the session.
         */
        public async SessionNext(params: SessionNextRequest): Promise<SessionNextResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/session/next`, JSON.stringify(params))
            return await resp.json() as SessionNextResponse
        }

        /**
         * Get Previous Session Node.
         * Moves the user back to the previous node in the session. This marks their
         * answer to the current question as invalid, meaning it won't be considered for
         * deciding their next question.
         */
        public async SessionPrevious(params: SessionPreviousRequest): Promise<SessionPreviousResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/session/previous`, JSON.stringify(params))
            return await resp.json() as SessionPreviousResponse
        }

        /**
         * Start Session
         * This endpoint starts a new session with the symptom checker on the given algorithm, with the given pet after performing some preliminary validation around the user.
         * 
         * It returns a **session_doc_id**, which is a UUID that must be resubmitted on all future requests to move through the session.
         * 
         * It also returns the first node encountered in the algorithm, which may be a question or information.
         */
        public async StartSession(params: CreateSessionRequest): Promise<CreateSessionResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/session`, JSON.stringify(params))
            return await resp.json() as CreateSessionResponse
        }

        /**
         * Start Session With Pet Details
         * 
         * Similar to the start session endpoint, but does not require the pet to
         * already exist in the system. Instead, the pet details such as name, age,
         * gender etc are provided in this request and used to run the session. The
         * intention is that the user is presented with a form capturing the pet
         * details before filtering algorithms and starting a session for example,
         * as lead generation/prospects.
         */
        public async StartSessionWithPetDetails(params: CreateSessionRequestWithPetDetails): Promise<CreateSessionResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/guests/session`, JSON.stringify(params))
            return await resp.json() as CreateSessionResponse
        }
    }
}

/**
 * scinternal houses any endpoints that are designed to be user facing, for
 * users actually doing the algorithm
 */
export namespace scinternal {
    export interface AIBackend {
        name: string
    }

    export interface AddAlgorithmToCategoryRequest {
        "algorithm_doc_id": string
        "category_doc_id": string
    }

    export interface Algorithm {
        "doc_id": uuid.UUID
        id: number
        texts: AlgorithmText[]
        name: string
        "created_at": string
        status: entities.LifecycleStatus
        nodes: Node[]
        connections: Connection[]
        availability: Availability
        formulas?: AlgorithmFormula[]
    }

    export interface AlgorithmBusinessExclusion {
        "doc_id": uuid.UUID
        name: string
    }

    export interface AlgorithmCategory {
        id: number
        order: number
        "doc_id": uuid.UUID
        texts: AlgorithmCategoryText[]
        "icon_entry_id": string
        hidden: boolean
    }

    export interface AlgorithmCategoryText {
        language: string
        name: string
    }

    export interface AlgorithmCloneRequest {
        species?: uuid.UUID[]
        regions?: string[]
        businesses?: uuid.UUID[]
        categories?: uuid.UUID[]
    }

    export interface AlgorithmCloneResponse {
        "algorithm_id": number
    }

    /**
     * AlgorithmFormula
     * 
     * A formula represents a way for the ADs to calculate a value, based on
     * previous submissions and the pet profile and reuse that value in both rules
     * and as a templated variable
     */
    export interface AlgorithmFormula {
        /**
         * FormulaTemplate
         * The formula template might be something like "1 + {PET_HEALTH} * 2 / 10"
         */
        "formula_template": string

        /**
         * OutputVariable
         * The output variable is the name of the variable that will be used in the
         * rules and templated variables. For example, "PET_HEALTH"
         */
        "output_variable": string
    }

    /**
     * used to list algorithms right now
     */
    export interface AlgorithmPreview {
        title: string
        order: number
        description: string
        "doc_id": uuid.UUID
        "latest_status": string
        "created_at": string
        categories: CategoryPreview[]
        "latest_id": number
        species: Species[]
    }

    export interface AlgorithmRoot {
        "doc_id": uuid.UUID
        id: number
        name: string
        "created_at": string
        status: entities.LifecycleStatus
    }

    export interface AlgorithmText {
        name: string
        language: string
    }

    export interface AlgorithmTranslatedPreview {
        "algorithm_preview": AlgorithmPreview
        "translation_percentages": TranslationPercentage[]
    }

    export interface AnswerOption {
        "display_value": string
        "was_selected": boolean
        /**
         * ImageURL is set on image select options.
         */
        "image_url"?: string
    }

    export interface ArchiveQuestionResponse {
    }

    export interface Availability {
        species: Species[]
        categories: AlgorithmCategory[]
        Regions: Region[]
        "businesses_exclusions": AlgorithmBusinessExclusion[]
    }

    export interface CategoryPreview {
        "doc_id": string
        name: string
    }

    export interface CheckDataPointKeyResponse {
        "is_unique": boolean
        count: number
    }

    export interface CheckFormulaRequest {
        /**
         * FormulaTemplate
         * The formula to check, without any substitution. For example, "1 + {PET_HEALTH} * 2 / 10"
         */
        "formula_template": string

        /**
         * TemplatedVariables
         * The variables to substitute into the formula. For example, "PET_HEALTH": 5
         * These should be without the curly braces.
         */
        "templated_variables": { [key: string]: number }

        /**
         * AlgorithmID
         * The ID of the algorithm to check the formula against. This
         * will be used to check all data point keys submitted exist in the
         * algorithm, and that the value they come from is numeric.
         */
        "algorithm_id": number
    }

    export interface CheckFormulaResponse {
        result: number
    }

    export interface Connection {
        "target_id": number
        "source_id": number
        "source_resource_id": number
        "target_resource_id": number
        "source_resource_instance_id": uuid.UUID
        "target_resource_instance_id": uuid.UUID
        /**
         * we'll make use of the entities directly in here for now as it's just a
         * read, however, I think we'll eventually need to decouple the DTO here
         * from the actual rule entity
         */
        rules: entities.Rule[]
    }

    export interface CreateAlgorithmCategoryRequest {
        "icon_entry_id": string
        texts: AlgorithmCategoryText[]
        hidden?: boolean
    }

    export interface CreateAlgorithmCategoryResponse {
        "doc_id": uuid.UUID
        id: number
        "created_at": string
    }

    export interface CreateAlgorithmRequest {
        texts: AlgorithmText[]
        /**
         * uuids of the species
         */
        species: string[]

        regions: string[]
        /**
         * this was already there and we'll keep it to save a breaking change to the API
         */
        businesses?: string[]

        categories: string[]
    }

    export interface CreateAlgorithmResponse {
        algorithm: Algorithm
    }

    export interface CreateInformationRequest {
        title: string
        "description_plain_text": string
        "description_rich_text": string
        type: string
        "video_url": string
        "image_urls": string[]
        "text_body": string
        "legacy_id": string
        "resource_label_ids": number[]
    }

    export interface CreateInformationResponse {
        "doc_id": string
        id: number
        "created_at": string
    }

    export interface CreateLabelRequest {
        position: string
        value: string
    }

    export interface CreateOptionRequest {
        value: string
        order: number
        /**
         * optional. used at the moment just for the image-selection questions
         */
        "image_url": string

        /**
         * optional. used for issue-location questions
         */
        coordinates: number[][]

        /**
         * optional. used for drop down questions
         */
        efficacy: number

        "frequency_quantity": number
        "frequency_unit": string
        texts: OptionText[]
    }

    export interface CreateOutcomeRequest {
        urgency: string
        "recommendation_type": string
        "advice_plain_text": string
        "advice_rich_text": string
        "recommendation_rich_text": string
        "recommendation_plain_text": string
        "what_to_do_next_type"?: string
        "what_to_do_next_plain_text"?: string
        "what_to_do_next_rich_text"?: string
        "what_you_need_to_know"?: string
        "what_you_need_to_know_plain_text"?: string
        "what_you_need_to_know_rich_text"?: string
        "venom_code_doc_ids": uuid.UUID[]
        "venom_code_group_doc_ids": uuid.UUID[]
        "product_recommendation_doc_ids": uuid.UUID[]
        "wtdn_product_recommendation_doc_ids": uuid.UUID[]
        "wyntk_product_recommendation_doc_ids": uuid.UUID[]
        /**
         * an internal identifier for the outcome
         */
        name: string

        "resource_labels"?: number[]
        sections?: CreateOutcomeSection[]
        /**
         * IsTrialsOutcome
         * set by a checkbox on the FE when first creating an
         * outcome, if checked, the outcome is a trials outcome and the validation
         * for the presence of most fields is bypassed
         * Deprecated. Use OutcomeType instead
         */
        "is_trials_outcome"?: boolean

        /**
         * OutcomeType
         * OutcomeType can be either default, ai_gait or trial. If this
         * isn't set, the backend will default to default
         */
        "outcome_type": string

        /**
         * TMSStepStatus
         * Deprecated: optional, no longer used by the TMS.
         * If it is set it must be one of Complete/Action Required
         */
        "tms_step_status"?: string
    }

    export interface CreateOutcomeResponse {
        id: number
        "doc_id": uuid.UUID
    }

    export interface CreateOutcomeSection {
        type: string
        title: string
        language: entities.LanguageISO639
        "rich_text": string
        "plain_text": string
    }

    export interface CreateQuestionRequest {
        type: string
        "value_type": string
        /**
         * only populated if its a text input for example
         */
        placeholder: string

        key: string
        options: CreateOptionRequest[]
        /**
         * these are the optional labels for the slider datapoint
         */
        labels: CreateLabelRequest[]

        /**
         * a nullable field requested by Sam D to aid the import
         */
        "legacy_id": string

        /**
         * these are the actual labels to associate with the question
         */
        "question_label_ids": number[]

        /**
         * optional. needed for the issue location image map
         */
        "image_map_url": string

        /**
         * optional. needed for upload file questions
         */
        "upload_bucket": string

        /**
         * AIBackendNames
         * a list of AI backends that can be used to process the data point. e.g.
         * "gait" for gait analysis
         */
        "ai_backend"?: string

        "ai_backend_dependency"?: string
        texts: QuestionText[]
    }

    export interface CreateQuestionResponse {
        Question: Question
    }

    export interface CreateResourceLabelRequest {
        name: string
    }

    export interface CreateResourceLabelResponse {
        "node_label": ResourceLabel
    }

    export interface DataPoint {
        id: number
        type: string
        "value_type": string
        placeholder: string
        options: DataPointOption[]
        labels: DataPointLabel[]
        key: string
        "image_map_url": string
        "upload_bucket": string
        "ai_backend_name"?: string
        "ai_backend_dependency_name"?: string
    }

    export interface DataPointLabel {
        id: number
        position: string
        value: string
    }

    export interface DataPointOption {
        id: number
        value: string
        order: number
        "image_url": string
        "bucket_path": string
        coordinates: number[][]
        efficacy: number
        "frequency_quantity": number
        "frequency_unit": string
        texts: OptionText[]
        /**
         * I have to keep these on here for now so as not to break the algo builder
         * with this change. We'll remove them in a future PR
         */
        label: string

        "description_rich_text"?: string
        "description_plain_text"?: string
    }

    export interface DeclareAndCondition {
        "or_conditions": DeclareOrCondition[]
    }

    /**
     * the frontend declares which nodes should be connected, by referencing the
     * target ID/version and the source ID/version (and eventually any rules). The API will
     * 1. check that those resources are in the algorithm.
     * 2. check if they are already connected.
     * 3. if not, will create a connection between them.
     */
    export interface DeclareConnectionRequest {
        /**
         * modelling in this way saves the frontend having to manage whether they
         * send a node id if one exists, if not etc...
         */
        "source_resource": DeclareConnectionResource

        "target_resource": DeclareConnectionResource
        rules: DeclareRuleRequest[]
    }

    export interface DeclareConnectionResource {
        "resource_id": number
        "resource_type": string
        "resource_instance_id"?: uuid.UUID
        "is_skippable": boolean
    }

    export interface DeclareConnectionResponse {
        "error_message": string
    }

    export interface DeclareFormulaRequest {
        "formula_template": string
        "output_variable": string
    }

    /**
     * the frontend declares "this question/information screen should be in the
     * algorithm. The API will check it is, and if not, add it as a node.
     */
    export interface DeclareNodeRequest {
        /**
         * information or question
         */
        type: string

        /**
         * the id of the question or information screen. Remember an ID uniquely
         * identifies a resource at a particular version.
         */
        "resource_id": number

        "resource_instance_id"?: uuid.UUID
        "is_skippable": boolean
    }

    export interface DeclareNodeResponse {
        "error_message": string
        /**
         * in the response, there should always be an actual nodeid, as the
         * question/information is now part of the algo and therefore has an entry
         * in the nodes.
         */
        "node_id": number
    }

    export interface DeclareOrCondition {
        property: string
        "property_ref": string
        operation: string
        value: string
    }

    export interface DeclareRuleRequest {
        name: string
        "and_conditions": DeclareAndCondition[]
    }

    export interface FilterAIBackends {
        Accepts: string
    }

    export interface GaitModelResponse {
        status: string
        "session_doc_id": string
        "video_section_results": GaitModelVideoSectionResults[]
        "full_url": string
    }

    export interface GaitModelVideoSectionResults {
        result: number
        contextresult: number
        start: number
        end: number
        usefresult: number
    }

    export interface GetAlgorithmCategoryResponse {
        "algorithm_category": AlgorithmCategory
    }

    export interface GetFeaturedAlgorithmResponse {
        "featured_algorithm": Algorithm
    }

    export interface GetFeaturedCategoriesResponse {
        "algorithm_category": AlgorithmCategory[]
    }

    export interface GetOutcomeByIDResponse {
        id: number
        "doc_id": uuid.UUID
        urgency?: string
        "outcome_type": string
        "tms_step_status"?: string
        "created_at": string
        "primary_recommendation": OutcomePrimaryRecommendation
        "outcome_advice_texts": OutcomeAdviceText[]
        "what_to_do_next": OutcomeWhatToDoNext
        "what_you_need_to_know": OutcomeWhatYouNeedToKnow
        "venom_codes": VenomCode[]
        "venom_code_groups": VenomCodeGroup[]
        "product_recommendations": ProductRecommendation[]
        "wtdn_product_recommendations": ProductRecommendation[]
        "wyntk_product_recommendations": ProductRecommendation[]
        name: string
        "resource_labels"?: ResourceLabel[]
        sections?: OutcomeSection[]
    }

    export interface GetOutcomeSectionText {
        title: string
        language: entities.LanguageISO639
        "rich_text": string
        "plain_text": string
    }

    export interface Information {
        id: number
        type: entities.InformationType
        "doc_id": uuid.UUID
        texts: InformationText[]
        "image_urls": InformationImageURL[]
        "video_url": InformationVideoURL
        "legacy_id": string
        "resource_labels": ResourceLabel[]
    }

    export interface InformationCloneResponse {
        "information_doc_id": uuid.UUID
    }

    export interface InformationImageURL {
        "bucket_path": string
        "image_url": string
    }

    export interface InformationText {
        language: string
        title: string
        "description_plain_text": string
        "description_rich_text": string
        "text_body": string
    }

    export interface InformationVideoURL {
        "bucket_path": string
        "video_url": string
    }

    export interface ListAIBackendResponses {
        "ai_backends": AIBackend[]
    }

    export interface ListAlgorithmCategoriesRequest {
        /**
         * the number of results requested for the page
         */
        RequestedItemsPerPage: number

        /**
         * the page number requested
         */
        RequestedPageNumber: number

        /**
         * the filter which we apply to the results
         */
        Filter: string
    }

    export interface ListAlgorithmCategoriesResponse {
        "algorithm_categories": AlgorithmCategory[]
        pagination: Pagination
    }

    export interface ListAlgorithmRevisionsResponse {
        revisions: AlgorithmRoot[]
    }

    export interface ListAlgorithmTranslationPreviewResponse {
        "algorithm_translated_previews": AlgorithmTranslatedPreview[]
        pagination: Pagination
    }

    export interface ListAlgorithmsInCategoryResponse {
        algorithms: AlgorithmPreview[]
    }

    export interface ListAlgorithmsRequest {
        /**
         * the number of results requested for the page
         */
        RequestedItemsPerPage: number

        /**
         * the page number requested
         */
        RequestedPageNumber: number

        /**
         * the name which is searched for
         */
        Name: string

        /**
         * the species to search
         */
        SpeciesDocIDs: string[]
    }

    export interface ListAlgorithmsResponse {
        algorithms: AlgorithmPreview[]
        pagination: Pagination
    }

    export interface ListInformationAlgorithm {
        id: number
        "doc_id": uuid.UUID
        "created_at": string
        name: string
        status: string
        "is_using_latest_version": boolean
    }

    export interface ListInformationAlgorithmsRequest {
        /**
         * the number of results requested for the page
         */
        RequestedItemsPerPage: number

        /**
         * the page number requested
         */
        RequestedPageNumber: number

        /**
         * the filter which we apply to the results
         */
        Filter: string
    }

    /**
     * ListInformationAlgorithms response
     */
    export interface ListInformationAlgorithmsResponse {
        pagination: Pagination
        algorithms: ListInformationAlgorithm[]
    }

    export interface ListInformationsRequest {
        /**
         * the number of results requested for the page
         */
        RequestedItemsPerPage: number

        /**
         * the page number requested
         */
        RequestedPageNumber: number

        /**
         * the filter which we apply to the results
         */
        Filter: string

        /**
         * the label IDs on which to filter
         */
        FilterLabelIDs: number[]
    }

    export interface ListInformationsResponse {
        Pagination: Pagination
        Informations: Information[]
    }

    export interface ListOutcomeAlgorithm {
        id: number
        "doc_id": uuid.UUID
        "created_at": string
        name: string
        status: string
        "is_using_latest_version": boolean
    }

    export interface ListOutcomeAlgorithmsRequest {
        /**
         * the number of results requested for the page
         */
        RequestedItemsPerPage: number

        /**
         * the page number requested
         */
        RequestedPageNumber: number

        /**
         * the filter which we apply to the results
         */
        Filter: string
    }

    /**
     * ListOutcomeAlgorithms response
     */
    export interface ListOutcomeAlgorithmsResponse {
        pagination: Pagination
        algorithms: ListOutcomeAlgorithm[]
    }

    export interface ListOutcomeUrgency {
        "outcome_urgency_levels": string[]
    }

    export interface ListOutcomesRequest {
        /**
         * the number of results requested for the page
         */
        RequestedItemsPerPage: number

        /**
         * the page number requested
         */
        RequestedPageNumber: number

        /**
         * the filter which we apply to the results
         */
        Filter: string

        Language: string
        FilterLabelIDs: number[]
    }

    export interface ListOutcomesResponse {
        Pagination: Pagination
        Outcomes: OutcomePreview[]
    }

    export interface ListQuestionAlgorithm {
        id: number
        "doc_id": uuid.UUID
        "created_at": string
        name: string
        status: string
        "is_using_latest_version": boolean
    }

    export interface ListQuestionAlgorithmsRequest {
        /**
         * the number of results requested for the page
         */
        RequestedItemsPerPage: number

        /**
         * the page number requested
         */
        RequestedPageNumber: number

        /**
         * the filter which we apply to the results
         */
        Filter: string
    }

    /**
     * ListQuestionAlgorithm response
     */
    export interface ListQuestionAlgorithmsResponse {
        pagination: Pagination
        algorithms: ListQuestionAlgorithm[]
    }

    export interface ListQuestionsRequest {
        /**
         * the number of results requested for the page
         */
        RequestedItemsPerPage: number

        /**
         * the page number requested
         */
        RequestedPageNumber: number

        /**
         * the filter which we apply to the results
         */
        Filter: string

        /**
         * the list of label IDs to filter the results by
         */
        FilterLabelIDs: number[]

        LegacyID?: string
    }

    export interface ListQuestionsResponse {
        questions: Question[]
        pagination: Pagination
    }

    export interface ListRecommedationTypes {
        "recommendation_types": string[]
    }

    export interface ListResourceLabelsRequest {
        /**
         * the filter which we apply to the results
         */
        Filter: string
    }

    export interface ListRuleOperationsRequest {
        ConditionProperty: string
    }

    export interface ListRuleOperationsResponse {
        Operations: entities.RuleConditionOperation[]
    }

    export interface ListRulePropertiesResponse {
        Properties: RulePropertyValue[]
    }

    export interface ListRuleValuesRequest {
        ConditionProperty: string
    }

    export interface ListRuleValuesResponse {
        "possible_values": RulePossibleValue[]
    }

    export interface ListSymptomCheckerSummariesParams {
        PetDocID: string
        /**
         * not the vet, but the user that should own the pet
         */
        UserDocID: string

        /**
         * the number of results requested for the page
         */
        RequestedItemsPerPage: number

        /**
         * the page number requested
         */
        RequestedPageNumber: number
    }

    export interface ListSymptomCheckerSummariesResponse {
        "symptom_checker_sessions": SymptomCheckerSummary[]
        pagination: Pagination
    }

    export interface ListWhatToDoNext {
        "what_to_do_next": string[]
    }

    export interface NewAlgorithmDraftResponse {
        id: number
    }

    export interface Node {
        id: number
        "doc_id": uuid.UUID
        "resource_id": number
        "resource_instance_id": uuid.UUID
        type: string
        "dialogue_header": string
        "dialogue_description": string
        "question_view": QuestionView
        "is_latest_version": boolean
        "latest_version_id": number
        "is_skippable": boolean
    }

    export interface OptionText {
        language: string
        label: string
        "description_plain_text"?: string
        "description_rich_text"?: string
    }

    export interface OutcomeAdviceText {
        language: string
        "plain_text": string
        "rich_text": string
    }

    export interface OutcomeCloneResponse {
        "outcome_doc_id": uuid.UUID
    }

    export interface OutcomeData {
        urgency: string
        recommendation: string
        "recommendation_text": string
        "what_to_do_next_text": string
        "advice_text": string
    }

    export interface OutcomePreview {
        id: number
        "doc_id": string
        urgency: string
        "primary_recommendation_type": string
        "created_at": string
        name: string
        "outcome_type": string
    }

    export interface OutcomePrimaryRecommendation {
        type: string
        texts: PrimaryRecommendationText[]
    }

    export interface OutcomeSection {
        type: string
        texts: GetOutcomeSectionText[]
    }

    export interface OutcomeWhatToDoNext {
        type: string
        texts: OutcomeWhatToDoNextText[]
    }

    export interface OutcomeWhatToDoNextText {
        language: string
        "plain_text": string
        "rich_text": string
    }

    export interface OutcomeWhatYouNeedToKnow {
        type: string
        texts: OutcomeWhatYouNeedToKnowText[]
    }

    export interface OutcomeWhatYouNeedToKnowText {
        language: string
        "plain_text": string
        "rich_text": string
    }

    export interface Pagination {
        total: number
        "current_page": number
        pages: number
    }

    export interface PrimaryRecommendationText {
        language: string
        "plain_text": string
        "rich_text": string
    }

    export interface ProductRecommendation {
        DocID: uuid.UUID
        Name: string
    }

    export interface Question {
        id: number
        version: number
        "doc_id": uuid.UUID
        status: string
        "data_points": DataPoint[]
        texts: QuestionText[]
        "legacy_id": string
        "resource_labels": ResourceLabel[]
        "data_point_labels": DataPointLabel[]
    }

    export interface QuestionCloneResponse {
        "question_doc_id": uuid.UUID
    }

    export interface QuestionRevisionsResponse {
        revisions: Question[]
    }

    export interface QuestionText {
        language: string
        title: string
        "description_plain_text": string
        "description_rich_text": string
    }

    export interface QuestionView {
        "answer_options": QuestionViewDataPoint[]
        "outcome_data"?: OutcomeData
    }

    export interface QuestionViewDataPoint {
        DataPoint: DataPoint
    }

    export interface Region {
        "short_code": string
    }

    export interface ReorderAlgorithmCategoriesRequest {
        "source_category_doc_id": string
        "target_category_doc_id": string
    }

    export interface ReorderAlgorithmsInCategoryRequest {
        "source_algorithm_doc_id": string
        "target_algorithm_doc_id": string
    }

    export interface ResourceLabel {
        id: number
        name: string
        "created_at": string
    }

    export interface ResourceLabelsResponse {
        labels: ResourceLabel[]
    }

    export interface ResourceMissingTranslation {
        "doc_id": string
        title: string
    }

    export interface RulePossibleValue {
        display: string
        submit: string
    }

    export interface RulePropertyValue {
        "property_name": string
        "expected_property_value": string
    }

    export interface SessionOutcome {
        "urgency_level": string
        "venom_code": SessionOutcomeVenomCode[]
        "recommended_products": SessionOutcomeRecommendedProduct[]
        /**
         * Recommendation is the outcome's primary recommendation type, e.g. speak to a vet.
         */
        recommendation?: string

        "recommendation_text"?: string
        "advice_text"?: string
        "what_to_do_next_text"?: string
        "what_you_need_to_know_text"?: string
    }

    export interface SessionOutcomeRecommendedProduct {
        "doc_id": uuid.UUID
        sku: string
        name: string
        description: string
    }

    export interface SessionOutcomeVenomCode {
        "venom_id": string
        "doc_id": uuid.UUID
        "term_name": string
        synonym: string
        "customer_synonym": string
    }

    export interface SessionResponse {
        title: string
        "data_point_type": string
        response: string
        "answer_options": AnswerOption[]
        /**
         * ImageURLs and VideoURL are set on information screens (data_point_type "information").
         */
        "image_urls"?: string[]

        "video_url"?: string
        /**
         * AnsweredAt is when the owner answered the question, or saw the information screen.
         */
        "answered_at"?: string
    }

    export interface Species {
        species: string
        "doc_id": uuid.UUID
    }

    export interface SymptomCheckerSummary {
        "algorithm_doc_id": string
        "algorithm_title": string
        "session_responses": SessionResponse[]
        "session_outcome": SessionOutcome
        media: string[]
        /**
         * CompletedAt is when the owner reached the outcome.
         */
        "completed_at"?: string
    }

    export interface TextRequest {
        title: string
        "description_plain_text": string
        "description_rich_text": string
        "text_body": string
        language: entities.LanguageISO639
    }

    export interface ToggleFeatureAlgorithmResponse {
        "algorithm_doc_id": string
        featured: boolean
    }

    export interface ToggleFeatureCategoryResponse {
        "category_doc_id": string
        featured: boolean
    }

    export interface TranslationPercentage {
        language: entities.LanguageISO639
        "missing_outcome_doc_ids": ResourceMissingTranslation[]
        "missing_question_doc_ids": ResourceMissingTranslation[]
        "missing_information_doc_ids": ResourceMissingTranslation[]
        "percent_translated": number
    }

    export interface UnarchiveQuestionResponse {
    }

    export interface UpdateAlgorithmCategoryRequest {
        "icon_entry_id": string
        order: number
        texts: AlgorithmCategoryText[]
        hidden: boolean
    }

    export interface UpdateAlgorithmMetaDataRequest {
        species: uuid.UUID[]
        regions: string[]
        categories: uuid.UUID[]
        texts: AlgorithmText[]
        "business_exclusions"?: uuid.UUID[]
    }

    /**
     * used by the algorithm developers when they hit "save", saves the entire state
     * of the algorithm in the database in a transaction. An algorithm must have an
     * open draft in order to be updated. the concept here is a "declarive" update.
     * The frontend sends what questions, info, rules etc should be in the algorithm
     * and how they are connected, and the backend sets the algorithm to represent
     * that state.
     */
    export interface UpdateAlgorithmRequest {
        nodes: DeclareNodeRequest[]
        connections: DeclareConnectionRequest[]
        formulas?: DeclareFormulaRequest[]
    }

    /**
     * we need to return any errors from the save, for the frontend to display. We
     * can return the same structure that was submitted for response, but compose it
     * with errors.
     */
    export interface UpdateAlgorithmResponse {
        Nodes: DeclareNodeResponse[]
        Connections: DeclareConnectionResponse[]
    }

    export interface UpdateInformationRequest {
        type: string
        "video_url": string
        "image_urls": string[]
        texts: TextRequest[]
    }

    export interface UpdateInformationResponse {
        "doc_id": uuid.UUID
        id: number
    }

    export interface UpdateLabelRequest {
        position: string
        value: string
    }

    export interface UpdateOptionRequest {
        order: number
        /**
         * optional. used at the moment just for the image-selection questions
         */
        "image_url": string

        value: string
        /**
         * optional. currently used for dropdown
         */
        efficacy: number

        "frequency_quantity": number
        "frequency_unit": string
        texts: OptionText[]
    }

    export interface UpdateOutcomeRequest {
        name: string
        urgency: string
        "primary_recommendation": OutcomePrimaryRecommendation
        "outcome_advice_texts": OutcomeAdviceText[]
        "what_to_do_next": OutcomeWhatToDoNext
        "what_you_need_to_know": OutcomeWhatYouNeedToKnow
        "venom_code_doc_ids": uuid.UUID[]
        "venom_code_group_doc_ids": uuid.UUID[]
        "product_recommendation_doc_ids": uuid.UUID[]
        "wtdn_product_recommendation_doc_ids": uuid.UUID[]
        "wyntk_product_recommendation_doc_ids": uuid.UUID[]
        sections?: OutcomeSection[]
        "tms_step_status"?: string
    }

    export interface UpdateOutcomeResponse {
        id: number
    }

    export interface UpdateQuestionRequest {
        type: string
        texts: QuestionText[]
        /**
         * only populated if its a text input for example
         */
        placeholder: string

        options: UpdateOptionRequest[]
        /**
         * these are the optional labels for the slider datapoint
         */
        labels: UpdateLabelRequest[]

        /**
         * a nullable field requested by Sam D to aid the import
         */
        "legacy_id": string

        /**
         * these are the actual labels to associate with the question
         */
        "question_label_ids": number[]

        "upload_bucket": string
        "ai_backend"?: string
        "ai_backend_dependency"?: string
    }

    export interface UpdateQuestionResponse {
        Question: Question
    }

    export interface VenomCode {
        VenomID: string
        DocID: uuid.UUID
        TermName: string
        Synonym: string
        CustomerSynonym: string
    }

    export interface VenomCodeGroup {
        DocID: uuid.UUID
        Name: string
    }

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.AddAlgorithmToCategory = this.AddAlgorithmToCategory.bind(this)
            this.ArchiveAlgorithm = this.ArchiveAlgorithm.bind(this)
            this.ArchiveInformation = this.ArchiveInformation.bind(this)
            this.ArchiveQuestion = this.ArchiveQuestion.bind(this)
            this.CheckDataPointKey = this.CheckDataPointKey.bind(this)
            this.CheckFormula = this.CheckFormula.bind(this)
            this.CloneAlgorithm = this.CloneAlgorithm.bind(this)
            this.CloneInformation = this.CloneInformation.bind(this)
            this.CloneOutcome = this.CloneOutcome.bind(this)
            this.CloneQuestion = this.CloneQuestion.bind(this)
            this.CreateAlgorithm = this.CreateAlgorithm.bind(this)
            this.CreateAlgorithmCategory = this.CreateAlgorithmCategory.bind(this)
            this.CreateInformation = this.CreateInformation.bind(this)
            this.CreateNewAlgorithmDraft = this.CreateNewAlgorithmDraft.bind(this)
            this.CreateOutcome = this.CreateOutcome.bind(this)
            this.CreateQuestion = this.CreateQuestion.bind(this)
            this.CreateResourceLabel = this.CreateResourceLabel.bind(this)
            this.DeleteAlgorithmCategory = this.DeleteAlgorithmCategory.bind(this)
            this.GaitModeResponseReceiver = this.GaitModeResponseReceiver.bind(this)
            this.GetAlgorithmByDocID = this.GetAlgorithmByDocID.bind(this)
            this.GetAlgorithmByID = this.GetAlgorithmByID.bind(this)
            this.GetAlgorithmCategory = this.GetAlgorithmCategory.bind(this)
            this.GetFeaturedAlgorithm = this.GetFeaturedAlgorithm.bind(this)
            this.GetFeaturedCategories = this.GetFeaturedCategories.bind(this)
            this.GetInformation = this.GetInformation.bind(this)
            this.GetInformationByID = this.GetInformationByID.bind(this)
            this.GetOutcomeByDocID = this.GetOutcomeByDocID.bind(this)
            this.GetOutcomeByID = this.GetOutcomeByID.bind(this)
            this.GetQuestionByDocID = this.GetQuestionByDocID.bind(this)
            this.GetQuestionByID = this.GetQuestionByID.bind(this)
            this.GetSessionSymptonCheckerSummary = this.GetSessionSymptonCheckerSummary.bind(this)
            this.ListAIBackends = this.ListAIBackends.bind(this)
            this.ListAlgorithmCategories = this.ListAlgorithmCategories.bind(this)
            this.ListAlgorithmTranslationPreviews = this.ListAlgorithmTranslationPreviews.bind(this)
            this.ListAlgorithms = this.ListAlgorithms.bind(this)
            this.ListAlgorithmsInCategory = this.ListAlgorithmsInCategory.bind(this)
            this.ListAlgoritmRevisions = this.ListAlgoritmRevisions.bind(this)
            this.ListInformationAlgorithms = this.ListInformationAlgorithms.bind(this)
            this.ListInformations = this.ListInformations.bind(this)
            this.ListOutcomeAlgorithms = this.ListOutcomeAlgorithms.bind(this)
            this.ListOutcomePreviews = this.ListOutcomePreviews.bind(this)
            this.ListQuestionAlgorithms = this.ListQuestionAlgorithms.bind(this)
            this.ListQuestionRevisions = this.ListQuestionRevisions.bind(this)
            this.ListQuestions = this.ListQuestions.bind(this)
            this.ListRecommendationTypes = this.ListRecommendationTypes.bind(this)
            this.ListResourceLabels = this.ListResourceLabels.bind(this)
            this.ListRuleOperations = this.ListRuleOperations.bind(this)
            this.ListRuleProperties = this.ListRuleProperties.bind(this)
            this.ListRuleValues = this.ListRuleValues.bind(this)
            this.ListSymptomCheckerSummaries = this.ListSymptomCheckerSummaries.bind(this)
            this.ListUrgencies = this.ListUrgencies.bind(this)
            this.ListWhatToDoNextTypes = this.ListWhatToDoNextTypes.bind(this)
            this.PauseAlgorithm = this.PauseAlgorithm.bind(this)
            this.PublishAlgorithm = this.PublishAlgorithm.bind(this)
            this.ReorderOrderAlgorithmCategories = this.ReorderOrderAlgorithmCategories.bind(this)
            this.ReorderOrderAlgorithmsInCategory = this.ReorderOrderAlgorithmsInCategory.bind(this)
            this.SetAlgorithmForReview = this.SetAlgorithmForReview.bind(this)
            this.SetAlgorithmToDraft = this.SetAlgorithmToDraft.bind(this)
            this.ToggleFeatureAlgorithm = this.ToggleFeatureAlgorithm.bind(this)
            this.ToggleFeatureCategory = this.ToggleFeatureCategory.bind(this)
            this.UnArchiveQuestion = this.UnArchiveQuestion.bind(this)
            this.UnarchiveInformation = this.UnarchiveInformation.bind(this)
            this.UpdateAlgorithm = this.UpdateAlgorithm.bind(this)
            this.UpdateAlgorithmCategory = this.UpdateAlgorithmCategory.bind(this)
            this.UpdateAlgorithmMetadata = this.UpdateAlgorithmMetadata.bind(this)
            this.UpdateInformation = this.UpdateInformation.bind(this)
            this.UpdateOutcome = this.UpdateOutcome.bind(this)
            this.UpdateQuestion = this.UpdateQuestion.bind(this)
        }

        /**
         * Add algorithm to a category
         * Add the given algorithm to the given category
         */
        public async AddAlgorithmToCategory(params: AddAlgorithmToCategoryRequest): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/v1/internal/algorithm-categories/algorithm`, JSON.stringify(params))
        }

        /**
         * Archives an entire algorithm given the doc ID
         * algorithms that have been published can never be archived, only paused
         */
        public async ArchiveAlgorithm(algorithmDocID: string): Promise<void> {
            await this.baseClient.callTypedAPI("PATCH", `/v1/algorithms/${encodeURIComponent(algorithmDocID)}/archive`)
        }

        /**
         * ArchiveInformation archives an information screen
         * Can't be used if the information screen is used in a published/draft algorithm
         */
        public async ArchiveInformation(informationDocID: string): Promise<void> {
            await this.baseClient.callTypedAPI("DELETE", `/v1/information/${encodeURIComponent(informationDocID)}`)
        }

        /**
         * ArchiveQuestion archives a question
         * Can't be used if the question is used in a published or draft algorithm
         */
        public async ArchiveQuestion(questionDocID: string): Promise<ArchiveQuestionResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("DELETE", `/v1/questions/${encodeURIComponent(questionDocID)}`)
            return await resp.json() as ArchiveQuestionResponse
        }

        /**
         * Count Datapoint Keys.
         * Used by the frontend to help suggest a new datapoint key to the user.
         * the user shouldn't have to worry too much about the datapoint key as its auto
         * generated, but a bit like google service accounts, if there is a conflict we
         * should allow them to modify the key a little
         */
        public async CheckDataPointKey(keyID: string): Promise<CheckDataPointKeyResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/datapoints/keys/check/${encodeURIComponent(keyID)}`)
            return await resp.json() as CheckDataPointKeyResponse
        }

        /**
         * Check Formula
         * 
         * Check a formula for correctness
         */
        public async CheckFormula(params: CheckFormulaRequest): Promise<CheckFormulaResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/formulas/evaluate`, JSON.stringify(params))
            return await resp.json() as CheckFormulaResponse
        }

        /**
         * Returns a new copy of an existing algorithm, with a brand new doc ID
         */
        public async CloneAlgorithm(id: number, params: AlgorithmCloneRequest): Promise<AlgorithmCloneResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/algorithms/${encodeURIComponent(id)}/clone`, JSON.stringify(params))
            return await resp.json() as AlgorithmCloneResponse
        }

        /**
         * Returns a new copy of an existing information, with a brand new doc ID
         */
        public async CloneInformation(docID: string): Promise<InformationCloneResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/informations/${encodeURIComponent(docID)}/clone`)
            return await resp.json() as InformationCloneResponse
        }

        /**
         * Returns a new copy of an existing outcome, with a brand new doc ID
         */
        public async CloneOutcome(docID: string): Promise<OutcomeCloneResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/outcomes/${encodeURIComponent(docID)}/clone`)
            return await resp.json() as OutcomeCloneResponse
        }

        /**
         * Returns a new copy of an existing question, with a brand new doc ID
         */
        public async CloneQuestion(docID: string): Promise<QuestionCloneResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/questions/${encodeURIComponent(docID)}/clone`)
            return await resp.json() as QuestionCloneResponse
        }

        /**
         * Create algorithm.
         * Creates an algorithm with a single node.
         */
        public async CreateAlgorithm(params: CreateAlgorithmRequest): Promise<CreateAlgorithmResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/algorithms`, JSON.stringify(params))
            return await resp.json() as CreateAlgorithmResponse
        }

        /**
         * Create algorithm category.
         * Creates an algorithm category.
         */
        public async CreateAlgorithmCategory(params: CreateAlgorithmCategoryRequest): Promise<CreateAlgorithmCategoryResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/internal/algorithm-categories`, JSON.stringify(params))
            return await resp.json() as CreateAlgorithmCategoryResponse
        }

        /**
         * Create Information.
         * Creates a new Information.
         */
        public async CreateInformation(params: CreateInformationRequest): Promise<CreateInformationResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/information`, JSON.stringify(params))
            return await resp.json() as CreateInformationResponse
        }

        /**
         * Creates a new version of an existing algorithm. Will error if the algorithm ID is already draft or published
         */
        public async CreateNewAlgorithmDraft(algorithmDocID: string): Promise<NewAlgorithmDraftResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("PATCH", `/v1/algorithms-id/${encodeURIComponent(algorithmDocID)}/new-version`)
            return await resp.json() as NewAlgorithmDraftResponse
        }

        /**
         * Create Outcome.
         * Creates a new outcome. All input is assumed to be in english on creation.
         */
        public async CreateOutcome(params: CreateOutcomeRequest): Promise<CreateOutcomeResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/outcome`, JSON.stringify(params))
            return await resp.json() as CreateOutcomeResponse
        }

        /**
         * Create Question.
         * Creates a new Question.
         */
        public async CreateQuestion(params: CreateQuestionRequest): Promise<CreateQuestionResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/questions`, JSON.stringify(params))
            return await resp.json() as CreateQuestionResponse
        }

        /**
         * Lists all labels in the database
         * were published or drafted and by whom.
         */
        public async CreateResourceLabel(params: CreateResourceLabelRequest): Promise<CreateResourceLabelResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/question-labels`, JSON.stringify(params))
            return await resp.json() as CreateResourceLabelResponse
        }

        /**
         * Deletes an algorithm category.
         * Does not delete all the algorithms in that category. Just deletes the algo->category link
         */
        public async DeleteAlgorithmCategory(categoryDocID: string): Promise<void> {
            await this.baseClient.callTypedAPI("DELETE", `/v1/internal/algorithm-categories/${encodeURIComponent(categoryDocID)}`)
        }

        /**
         * GaitModeResponseReceiver receives the response from the gait model
         * and updates the session with the score
         */
        public async GaitModeResponseReceiver(params: GaitModelResponse): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/v1/gait-response`, JSON.stringify(params))
        }

        /**
         * Get algorithm.
         * Returns an algorithm with a tree of nodes. Does not support pagination for now
         * TODO: this was a method to get us going, hence the hardcoded version.
         * We'll want to update this eventually, but for now I'll keep it the same to reduce diff
         * in this PR
         */
        public async GetAlgorithmByDocID(docID: string): Promise<Algorithm> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/algorithms/${encodeURIComponent(docID)}`)
            return await resp.json() as Algorithm
        }

        /**
         * Get algorithm by ID
         * Returns an algorithm that matches the given ID, effectively denoting the algorithm at a particular version
         * We need the id to avoid a path clash. We'll need to revisit this bit of the API as a group
         */
        public async GetAlgorithmByID(id: number): Promise<Algorithm> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/algorithms-id/${encodeURIComponent(id)}`)
            return await resp.json() as Algorithm
        }

        /**
         * Get information about a single algorithm category
         * Get the information about a single algorithm category
         */
        public async GetAlgorithmCategory(categoryDocID: string): Promise<GetAlgorithmCategoryResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/internal/algorithm-categories/${encodeURIComponent(categoryDocID)}`)
            return await resp.json() as GetAlgorithmCategoryResponse
        }

        public async GetFeaturedAlgorithm(): Promise<GetFeaturedAlgorithmResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/feature-algorithm`)
            return await resp.json() as GetFeaturedAlgorithmResponse
        }

        public async GetFeaturedCategories(): Promise<GetFeaturedCategoriesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/feature-categories`)
            return await resp.json() as GetFeaturedCategoriesResponse
        }

        /**
         * GetInformation retrieves an information screen by doc ID
         */
        public async GetInformation(informationDocID: string): Promise<Information> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/information/${encodeURIComponent(informationDocID)}`)
            return await resp.json() as Information
        }

        /**
         * GetInformation retrieves an information screen by its ID
         */
        public async GetInformationByID(id: number): Promise<Information> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/information-id/${encodeURIComponent(id)}`)
            return await resp.json() as Information
        }

        /**
         * Get Outcome By DocID.
         * Returns the latest version of that outcome by its doc ID.
         */
        public async GetOutcomeByDocID(docID: string): Promise<GetOutcomeByIDResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/outcome/${encodeURIComponent(docID)}`)
            return await resp.json() as GetOutcomeByIDResponse
        }

        /**
         * Get Outcome By ID.
         * Returns an outcome by its ID.
         */
        public async GetOutcomeByID(id: number): Promise<GetOutcomeByIDResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/outcome-id/${encodeURIComponent(id)}`)
            return await resp.json() as GetOutcomeByIDResponse
        }

        /**
         * Get question.
         * Returns a question, as an aggregate with its datapoint(s) and options
         */
        public async GetQuestionByDocID(docID: string): Promise<Question> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/questions/${encodeURIComponent(docID)}`)
            return await resp.json() as Question
        }

        /**
         * Get question. Returns a question, as an aggregate with its datapoint(s) and
         * options We'll need to revisit this part of the API along with its companion
         * method algorithm-id
         */
        public async GetQuestionByID(id: number): Promise<Question> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/questions-id/${encodeURIComponent(id)}`)
            return await resp.json() as Question
        }

        /**
         * Get symptom checker summary
         * Returns a list of questions and their responses from this session with links to attached image/video files
         */
        public async GetSessionSymptonCheckerSummary(docID: string): Promise<SymptomCheckerSummary> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/sessions/${encodeURIComponent(docID)}/symptom-checker-summary`)
            return await resp.json() as SymptomCheckerSummary
        }

        /**
         * Lists all AI Backends that are available
         * Use the optional filters to filter the list to those that are compatible with the given data point type
         */
        public async ListAIBackends(params: FilterAIBackends): Promise<ListAIBackendResponses> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "data_point_type": params.Accepts,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/ai-backends`, undefined, {query})
            return await resp.json() as ListAIBackendResponses
        }

        /**
         * List algorithm categories.
         * Lists algorithm categories with pagination support
         */
        public async ListAlgorithmCategories(params: ListAlgorithmCategoriesRequest): Promise<ListAlgorithmCategoriesResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "items_per_page": String(params.RequestedItemsPerPage),
                "page_number":    String(params.RequestedPageNumber),
                search:           params.Filter,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/internal/algorithm-categories`, undefined, {query})
            return await resp.json() as ListAlgorithmCategoriesResponse
        }

        /**
         * List algorithms.
         * Lists algorithms with pagination support
         */
        public async ListAlgorithmTranslationPreviews(params: ListAlgorithmsRequest): Promise<ListAlgorithmTranslationPreviewResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "items_per_page":  String(params.RequestedItemsPerPage),
                "page_number":     String(params.RequestedPageNumber),
                search:            params.Name,
                "species_doc_ids": params.SpeciesDocIDs.map((v) => v),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/internal/algorithms/translations`, undefined, {query})
            return await resp.json() as ListAlgorithmTranslationPreviewResponse
        }

        /**
         * List algorithms.
         * Lists algorithms with pagination support
         */
        public async ListAlgorithms(params: ListAlgorithmsRequest): Promise<ListAlgorithmsResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "items_per_page":  String(params.RequestedItemsPerPage),
                "page_number":     String(params.RequestedPageNumber),
                search:            params.Name,
                "species_doc_ids": params.SpeciesDocIDs.map((v) => v),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/internal/algorithms`, undefined, {query})
            return await resp.json() as ListAlgorithmsResponse
        }

        /**
         * Get algorithms in a category
         * Gets the algorithms contained in a category
         */
        public async ListAlgorithmsInCategory(docID: string): Promise<ListAlgorithmsInCategoryResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/internal/algorithm-categories/${encodeURIComponent(docID)}/algorithms`)
            return await resp.json() as ListAlgorithmsInCategoryResponse
        }

        /**
         * Lists all question revisions for a given question by docID, showing when they
         * were published or drafted and by whom.
         */
        public async ListAlgoritmRevisions(docID: string): Promise<ListAlgorithmRevisionsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/algorithms/${encodeURIComponent(docID)}/revisions`)
            return await resp.json() as ListAlgorithmRevisionsResponse
        }

        /**
         * Lists all information algorithms
         * List all algorithms an information is apart of
         */
        public async ListInformationAlgorithms(docID: string, params: ListInformationAlgorithmsRequest): Promise<ListInformationAlgorithmsResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                filter:           params.Filter,
                "items_per_page": String(params.RequestedItemsPerPage),
                "page_number":    String(params.RequestedPageNumber),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/information/${encodeURIComponent(docID)}/algorithms`, undefined, {query})
            return await resp.json() as ListInformationAlgorithmsResponse
        }

        /**
         * List information pages
         * Lists information pages with pagination support
         */
        public async ListInformations(params: ListInformationsRequest): Promise<ListInformationsResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                filter:             params.Filter,
                "filter_label_ids": params.FilterLabelIDs.map((v) => String(v)),
                "items_per_page":   String(params.RequestedItemsPerPage),
                "page_number":      String(params.RequestedPageNumber),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/information`, undefined, {query})
            return await resp.json() as ListInformationsResponse
        }

        /**
         * Lists all outcome algorithms
         * List all algorithms an outcome is apart of
         */
        public async ListOutcomeAlgorithms(docID: string, params: ListOutcomeAlgorithmsRequest): Promise<ListOutcomeAlgorithmsResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                filter:           params.Filter,
                "items_per_page": String(params.RequestedItemsPerPage),
                "page_number":    String(params.RequestedPageNumber),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/outcome/${encodeURIComponent(docID)}/algorithms`, undefined, {query})
            return await resp.json() as ListOutcomeAlgorithmsResponse
        }

        /**
         * List existing outcomes
         * Lists Outcome pages with pagination support
         */
        public async ListOutcomePreviews(params: ListOutcomesRequest): Promise<ListOutcomesResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                filter:             params.Filter,
                "filter_label_ids": params.FilterLabelIDs.map((v) => String(v)),
                "items_per_page":   String(params.RequestedItemsPerPage),
                language:           params.Language,
                "page_number":      String(params.RequestedPageNumber),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/outcome-previews`, undefined, {query})
            return await resp.json() as ListOutcomesResponse
        }

        /**
         * Lists all question algorithms
         * List all algorithms a question is apart of
         */
        public async ListQuestionAlgorithms(docID: string, params: ListQuestionAlgorithmsRequest): Promise<ListQuestionAlgorithmsResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                filter:           params.Filter,
                "items_per_page": String(params.RequestedItemsPerPage),
                "page_number":    String(params.RequestedPageNumber),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/questions/${encodeURIComponent(docID)}/algorithms`, undefined, {query})
            return await resp.json() as ListQuestionAlgorithmsResponse
        }

        /**
         * Lists all question revisions for a given question by docID, showing when they
         * were published or drafted and by whom.
         */
        public async ListQuestionRevisions(docID: string): Promise<QuestionRevisionsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/questions/${encodeURIComponent(docID)}/revisions`)
            return await resp.json() as QuestionRevisionsResponse
        }

        /**
         * List questions.
         * Lists questions with pagination support
         */
        public async ListQuestions(params: ListQuestionsRequest): Promise<ListQuestionsResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                filter:             params.Filter,
                "filter_label_ids": params.FilterLabelIDs.map((v) => String(v)),
                "items_per_page":   String(params.RequestedItemsPerPage),
                "legacy_id":        params.LegacyID,
                "page_number":      String(params.RequestedPageNumber),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/questions`, undefined, {query})
            return await resp.json() as ListQuestionsResponse
        }

        /**
         * List Recommendation Types
         * Returns all available recommendation types
         */
        public async ListRecommendationTypes(): Promise<ListRecommedationTypes> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/recommendation-types`)
            return await resp.json() as ListRecommedationTypes
        }

        /**
         * Lists all question labels in the database
         */
        public async ListResourceLabels(params: ListResourceLabelsRequest): Promise<ResourceLabelsResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                filter: params.Filter,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/node-labels`, undefined, {query})
            return await resp.json() as ResourceLabelsResponse
        }

        /**
         * Returns all available operations for a given condition property
         * 
         * e.g. given Breed, returns "equals", "not equals"
         * given Age (Weeks) returns "equals", "not equals", "greater than", "less than" etc
         * this probably warrants some services later, but is not captured right now
         */
        public async ListRuleOperations(params: ListRuleOperationsRequest): Promise<ListRuleOperationsResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "condition_property": params.ConditionProperty,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/rules/operations`, undefined, {query})
            return await resp.json() as ListRuleOperationsResponse
        }

        /**
         * List available rule condition properties. e.g. "Breed", "Gender", "Species".
         * 
         * This is a flat list right now, so doesn't contain business logic.
         */
        public async ListRuleProperties(): Promise<ListRulePropertiesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/rules/properties`)
            return await resp.json() as ListRulePropertiesResponse
        }

        /**
         * list potential rule values. e.g. for Breed, return all possible breeds
         * 
         * e.g. given Breed, returns all the breeds in the system
         * given gender, returns the genders in the system
         * if given something it doesn't understand, returns an error.
         * this is a little bit like a poor mans version of the "resolvers" in the old system
         * the downside of that is that it tightly coupled the rules engine to
         * everything in the system, but it did allow for higher cohesion.
         * This is quicker to implement. If others start using the rules, we can reintroduce the resolvers
         */
        public async ListRuleValues(params: ListRuleValuesRequest): Promise<ListRuleValuesResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "condition_property": params.ConditionProperty,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/rules/property-values`, undefined, {query})
            return await resp.json() as ListRuleValuesResponse
        }

        /**
         * List symptom checker session summaries
         * Returns a list of symptom checker sessions for a particular pet
         * this is intended as an internal endpoint for our vets to use. Its created for trials
         * but should be generic
         */
        public async ListSymptomCheckerSummaries(params: ListSymptomCheckerSummariesParams): Promise<ListSymptomCheckerSummariesResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "items_per_page": String(params.RequestedItemsPerPage),
                "page_number":    String(params.RequestedPageNumber),
                "pet_doc_id":     params.PetDocID,
                "user_doc_id":    params.UserDocID,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/internal/symptom-checker-sessions`, undefined, {query})
            return await resp.json() as ListSymptomCheckerSummariesResponse
        }

        /**
         * List Urgency Types
         * Returns all available urgency types
         */
        public async ListUrgencies(): Promise<ListOutcomeUrgency> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/urgencies`)
            return await resp.json() as ListOutcomeUrgency
        }

        /**
         * List What To Do Next Types
         * Returns all available what to do next types
         */
        public async ListWhatToDoNextTypes(): Promise<ListWhatToDoNext> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/what-to-do-next-types`)
            return await resp.json() as ListWhatToDoNext
        }

        /**
         * Sets a particular algorithm ID to be paused. Will error if that algorithm ID is
         * already published or isn't draft
         */
        public async PauseAlgorithm(algorithmID: number): Promise<void> {
            await this.baseClient.callTypedAPI("PATCH", `/v1/algorithms-id/${encodeURIComponent(algorithmID)}/pause`)
        }

        /**
         * Sets a particular algorithm ID to published. Will error if that algorithm ID is
         * already published or isn't draft
         */
        public async PublishAlgorithm(algorithmID: number): Promise<void> {
            await this.baseClient.callTypedAPI("PATCH", `/v1/algorithms-id/${encodeURIComponent(algorithmID)}/publish`)
        }

        /**
         * Reorder the order of two algorithm categories
         * Reorders the order of two algorithm categories
         */
        public async ReorderOrderAlgorithmCategories(params: ReorderAlgorithmCategoriesRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PATCH", `/v1/internal/algorithm-categories/category-order`, JSON.stringify(params))
        }

        /**
         * Reorder the order of two algorithms in a category
         * Reorders the order of two algorithms in a category
         */
        public async ReorderOrderAlgorithmsInCategory(categoryDocID: string, params: ReorderAlgorithmsInCategoryRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PATCH", `/v1/internal/algorithm-categories/algorithm-order/${encodeURIComponent(categoryDocID)}`, JSON.stringify(params))
        }

        /**
         * Sets a particular algorithm ID to published. Will error if that algorithm ID is
         * already published or isn't draft
         */
        public async SetAlgorithmForReview(algorithmID: number): Promise<void> {
            await this.baseClient.callTypedAPI("PATCH", `/v1/algorithms-id/${encodeURIComponent(algorithmID)}/review`)
        }

        /**
         * Sets a particular algorithm ID to draft from in review. Will error if that
         * algorithm ID is already draft or isn't in review
         */
        public async SetAlgorithmToDraft(algorithmID: number): Promise<void> {
            await this.baseClient.callTypedAPI("PATCH", `/v1/algorithms-id/${encodeURIComponent(algorithmID)}/draft`)
        }

        public async ToggleFeatureAlgorithm(algorithm_doc_id: string): Promise<ToggleFeatureAlgorithmResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("PUT", `/v1/feature-algorithm/${encodeURIComponent(algorithm_doc_id)}`)
            return await resp.json() as ToggleFeatureAlgorithmResponse
        }

        public async ToggleFeatureCategory(category_doc_id: string): Promise<ToggleFeatureCategoryResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("PUT", `/v1/feature-categories/${encodeURIComponent(category_doc_id)}`)
            return await resp.json() as ToggleFeatureCategoryResponse
        }

        /**
         * Unarchive Question removes the archived status of a question
         */
        public async UnArchiveQuestion(questionDocID: string): Promise<UnarchiveQuestionResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("PATCH", `/v1/questions/${encodeURIComponent(questionDocID)}/unarchive`)
            return await resp.json() as UnarchiveQuestionResponse
        }

        /**
         * UnarchiveInformation removes the archived status of an information screen
         */
        public async UnarchiveInformation(informationDocID: string): Promise<void> {
            await this.baseClient.callTypedAPI("PATCH", `/v1/information/${encodeURIComponent(informationDocID)}/unarchive`)
        }

        /**
         * Save algorithm.
         * Saves the entire algorithm in the database.
         */
        public async UpdateAlgorithm(id: number, params: UpdateAlgorithmRequest): Promise<UpdateAlgorithmResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/algorithms/${encodeURIComponent(id)}`, JSON.stringify(params))
            return await resp.json() as UpdateAlgorithmResponse
        }

        /**
         * Update algorithm category.
         * Updates an algorithm category.
         */
        public async UpdateAlgorithmCategory(docID: string, params: UpdateAlgorithmCategoryRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PUT", `/v1/internal/algorithm-categories/${encodeURIComponent(docID)}`, JSON.stringify(params))
        }

        /**
         * Update Algorithm Metadata.
         * Updates the algorithms region, species and categories
         */
        public async UpdateAlgorithmMetadata(docID: string, params: UpdateAlgorithmMetaDataRequest): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/v1/algorithms/${encodeURIComponent(docID)}/metadata`, JSON.stringify(params))
        }

        /**
         * UpdateInformation updates a draft information.
         */
        public async UpdateInformation(docID: string, params: UpdateInformationRequest): Promise<UpdateInformationResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("PUT", `/v1/information/${encodeURIComponent(docID)}`, JSON.stringify(params))
            return await resp.json() as UpdateInformationResponse
        }

        /**
         * Updates draft Outcome By DocID.
         */
        public async UpdateOutcome(docID: string, params: UpdateOutcomeRequest): Promise<UpdateOutcomeResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("PUT", `/v1/outcome/${encodeURIComponent(docID)}`, JSON.stringify(params))
            return await resp.json() as UpdateOutcomeResponse
        }

        /**
         * Update Question.
         * Updates a Question. This produces a new version of that question, ready for
         * use in algorithms. It does not immediately update algorithms.
         */
        public async UpdateQuestion(docID: string, params: UpdateQuestionRequest): Promise<UpdateQuestionResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("PUT", `/v1/questions/${encodeURIComponent(docID)}`, JSON.stringify(params))
            return await resp.json() as UpdateQuestionResponse
        }
    }
}

export namespace seeding {
    export interface WebhookRequest {
        Token: string
    }

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.Webhook = this.Webhook.bind(this)
        }

        public async Webhook(params: WebhookRequest): Promise<void> {
            // Convert our params into the objects we need for the request
            const headers = makeRecord<string, string>({
                "x-access-token": params.Token,
            })

            await this.baseClient.callTypedAPI("POST", `/v1/seeding/webhook`, undefined, {headers})
        }
    }
}

export namespace sessions {
    export interface AppointmentDetails {
        /**
         * DocId
         * The **doc_id** of the appointment in **UUID** format.
         */
        "doc_id": string

        /**
         * Status
         * Current status of the appointment.
         * Valid values: **Reserved**, **PaymentRequired**, **Booked**, **Waiting**, **Abandoned**, **Cancelled**, **DidNotAttend**.
         */
        status: string

        /**
         * ConsultStatus
         * Current consultation status.
         * Valid values: **Ready**, **InProgress**, **Complete**, **Disrupted**.
         */
        "consult_status": string

        /**
         * Start
         * The scheduled start time of the appointment.
         */
        start: string

        /**
         * TreatmentPlan
         * the same detail as the treatment plan endpoint returns.
         * Present once the appointment has a consultation.
         */
        "treatment_plan"?: TreatmentPlan

        /**
         * Staff
         * The staff member for the consultation.
         */
        staff?: StaffDetails

        /**
         * End
         * The scheduled end time of the appointment.
         */
        end: string

        /**
         * PetDocID
         * The **doc_id** of the pet in **UUID** format.
         */
        "pet_doc_id": uuid.UUID

        /**
         * ActualStart
         * The actual start time of the appointment (optional).
         */
        "actual_start"?: string

        /**
         * ActualEnd
         * The actual end time of the appointment (optional).
         */
        "actual_end"?: string

        /**
         * DisruptedReason
         * The reason the consultation was disrupted. Only present when ConsultStatus is **Disrupted**.
         */
        "disrupted_reason"?: string

        /**
         * PreviousChatDocID
         * The **doc_id** of the preceding chat in **UUID** format (optional).
         */
        "previous_chat_doc_id"?: string

        /**
         * PreviousAppointmentDocID
         * The **doc_id** of the previous appointment in **UUID** format (optional).
         */
        "previous_appointment_doc_id"?: string

        /**
         * ServiceName
         * The name of the service (e.g. **Vet**).
         */
        "service_name": string

        /**
         * RoomID
         * The ID of the virtual waiting room for the consultation.
         */
        "room_id"?: string

        /**
         * SessionID
         * The session ID for the video call.
         */
        "session_id"?: string

        /**
         * CanStartWaiting
         * Indicates if the user can join the waiting room.
         */
        "can_start_waiting": boolean

        /**
         * WaitTime
         * Estimated wait time in minutes before the consultation starts.
         */
        "wait_time": number

        /**
         * CanStartWaitingBefore
         * Time in minutes until the user can enter the waiting room.
         */
        "can_start_waiting_before": number

        /**
         * WaitingRoomPollingIntervalInMilliSeconds
         * Suggested polling interval in milliseconds for waiting room status updates.
         */
        "waiting_room_polling_interval_in_milliseconds": number

        /**
         * WaitingRoomFetchAppointmentIntervalInMilliSeconds
         * Suggested interval in milliseconds for fetching appointment updates.
         */
        "waiting_room_fetch_appointment_interval_in_milliseconds": number

        /**
         * TreatmentPlanReady
         * Indicates if the treatment plan is available.
         */
        "treatment_plan_ready": boolean

        /**
         * ServiceDocID
         * The **doc_id** of the service in **UUID** format.
         */
        "service_doc_id": string
    }

    export interface ChatDetails {
        "doc_id": string
        "channel_id": string
        "current_status": string
        "created_at": string
        "updated_at": string
        /**
         * ConsultStatus
         * the vet consultation status for this chat, one of
         * Ready, InProgress, Complete or Disrupted.
         * Absent on chats that never reached a consultation
         */
        "consult_status"?: string

        /**
         * Staff
         * the vet on this chat. Present as soon as a vet has joined, so it is
         * populated for in-progress chats that have no consultation or treatment
         * plan yet. Absent while the chat is still unassigned or with the AI
         */
        staff?: StaffDetails

        /**
         * TreatmentPlan
         * the same detail as the treatment plan endpoint returns.
         * Present as soon as the chat has a consultation, so where the vet has not
         * written a plan yet treatment_plan is empty and the rest is still populated.
         * resources are time-limited signed document URLs; basket_url and cart_url
         * are freshly signed multipass checkout links. expires_at is when those
         * checkout links stop working.
         */
        "treatment_plan"?: TreatmentPlan

        /**
         * LastMessage
         * the most recent message in the chat, only populated while the consultation
         * is not yet complete and the chat has at least one message
         */
        "last_message"?: ChatMessage
    }

    export interface ChatMessage {
        /**
         * MessageID
         * The chat provider's identifier for this message.
         */
        "message_id": string

        /**
         * SentAt
         * When the message was sent.
         */
        "sent_at": string

        /**
         * Content
         * The message body. Empty for messages that are only an attachment.
         */
        content: string

        /**
         * MessageType
         * The kind of message, used by clients to pick a renderer.
         */
        "message_type": string

        /**
         * IsPinned
         * Whether the message has been pinned in the chat.
         */
        "is_pinned": boolean

        /**
         * Attachments
         * Files sent with the message.
         */
        attachments: ChatMessageAttachment[]

        /**
         * SenderID
         * Either the sender's user or staff doc ID, or DR_JOII_AI for the LLM
         * or VET_AI for the welcome bot.
         */
        "sender_id": string

        /**
         * ParticipantDocID
         * The chat participant who sent the message.
         */
        "participant_doc_id": string

        /**
         * UserDocID
         * Set when the sender was a user rather than staff or a bot.
         */
        "user_doc_id"?: uuid.UUID

        /**
         * PetDocID
         * The pet the sending participant is associated with, where there is one.
         */
        "pet_doc_id"?: uuid.UUID
    }

    export interface ChatMessageAttachment {
        /**
         * BucketURL
         * Storage path or URL for the attachment.
         */
        "bucket_url": string

        /**
         * MimeType
         * The attachment's content type.
         */
        "mime_type": string
    }

    export interface CreateSessionRequestV1 {
        /**
         * PetDocID
         * the pet that the user wants to use for this session.
         * Must belong to the user
         */
        "pet_doc_id": string

        /**
         * Type
         * can be one of:
         * * chat
         * * on-demand-video
         * * pre-booked-video
         * * home
         */
        type: string

        /**
         * ResourceDocID
         * optional. For chat this is a chat doc id; for on-demand-video and
         * pre-booked-video this is an appointment doc id. If the resource exists
         * for the user it is added to the session URL as resourceId. If it does
         * not exist the session redirects to home. Ignored when type is home.
         */
        "resource_doc_id"?: string

        /**
         * SymptomCheckerSessionDocID
         * optional. The doc id of the symptom checker session this session follows
         * on from. If supplied it is added to the session URL as
         * symptomCheckerSessionDocID. It is not otherwise validated.
         */
        "symptom_checker_session_doc_id"?: string
    }

    export interface CreateSessionResponseV1 {
        "session_doc_id": string
        "custom_token": string
        /**
         * SessionURL
         * is of the form https://<session_host>/start?customToken=<custom_token>&tenant=<auth-tenant>&redirectTo=<redirectenum>&petDocID=<pet_doc_id>[&resourceId=<resource_doc_id>][&symptomCheckerSessionDocID=<symptom_checker_session_doc_id>]
         * and should be passed to the WebView to redirect the user to their session
         */
        "session_url": string
    }

    export interface ListSessionsForPetRequest {
        PetDocID?: string
    }

    export interface ListSessionsResponse {
        sessions: SessionResponse[]
    }

    export interface PrescriptionDietItem {
        name: string
    }

    export interface PrescriptionMedicationItem {
        name: string
        strength: string
        quantity: number
        refills: number
        "directions_for_use": string
        "dispense_as_written": boolean
    }

    export interface PrescriptionPrice {
        "currency_code": string
        amount: number
    }

    export interface PrescriptionProgressEvent {
        status: string
    }

    export interface RecommendedProduct {
        "product_doc_id": string
        "product_name": string
        "product_url": string
        "product_image": string
        "product_price": number
        currency: string
        quantity: number
        sku: string
        frequency: string
        usage: string
    }

    export interface RemotePrescription {
        "prescription_type": string
        "prescription_payment_url"?: string
        "current_prescription_payment_status": string
        "prescription_progress"?: PrescriptionProgressEvent[]
        "prescription_price": PrescriptionPrice
        "fulfilment_location": string
        "medication_items_us"?: PrescriptionMedicationItem[]
        "diet_items_us"?: PrescriptionDietItem[]
    }

    export interface SessionResponse {
        /**
         * Type
         * the session type.
         * can be one of chat, appointment, or symptom checker
         * based on which one of these it is, it'll hydrate
         * the relevant details
         */
        type: string

        "chat_details"?: ChatDetails
        "appointment_details"?: AppointmentDetails
    }

    export interface StaffDetails {
        "staff_profile_doc_id"?: string
        name: string
        description: string
        "photo_url": string
    }

    export interface TreatmentPlan {
        /**
         * TreatmentPlan
         * Vet-authored treatment plan content for the consultation.
         * Empty until the vet writes one; the rest of this object is still populated.
         */
        "treatment_plan": string

        /**
         * Resources
         * Signed URLs to documents the vet uploaded during the consultation.
         */
        resources: string[]

        /**
         * RecommendedProducts
         * Product recommendations attached to this treatment plan.
         */
        "recommended_products": RecommendedProduct[]

        /**
         * Reasons
         * Clinical diagnosis reasons grouped into likely and other categories.
         */
        reasons: TreatmentPlanReason[]

        /**
         * IsTreatmentPlanRead
         * Whether the user has opened or marked the treatment plan as read.
         */
        "is_treatment_plan_read": boolean

        /**
         * BasketUrl
         * Freshly signed multipass checkout URL that opens the prepared basket.
         * Valid until ExpiresAt.
         */
        "basket_url": string

        /**
         * CartUrl
         * Optional signed cart URL used to add or review items before checkout.
         * Valid until ExpiresAt.
         */
        "cart_url"?: string

        /**
         * ExpiresAt
         * RFC3339 expiry for BasketUrl and CartUrl.
         */
        "expires_at"?: string

        /**
         * ConsultationCreatedAt
         * When the consultation was created.
         */
        "consultation_created_at": string

        /**
         * ConsultationDocID
         * UUID of the consultation this plan belongs to.
         */
        "consultation_doc_id": string

        /**
         * UserDocID
         * UUID of the user who owns the consultation.
         */
        "user_doc_id": string

        /**
         * AppointmentDocID
         * Set when the consultation came from an appointment booking.
         */
        "appointment_doc_id"?: string

        /**
         * RemotePrescriptions
         * Prescription payment information, where applicable.
         */
        "remote_prescriptions"?: RemotePrescription[]
    }

    export interface TreatmentPlanReason {
        /**
         * ReasonType
         * The reason for visit the vet recorded for this reason.
         */
        "reason_type": string

        "likely_diagnosis_codes": VenomCode[]
        "likely_diagnosis_groups": VenomGroup[]
        "other_diagnosis_codes": VenomCode[]
        "other_diagnosis_groups": VenomGroup[]
    }

    export interface VenomCode {
        "display_name": string
        "venom_code": string
    }

    export interface VenomGroup {
        "display_name": string
    }

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.CreateSession = this.CreateSession.bind(this)
            this.ListSessionsForPet = this.ListSessionsForPet.bind(this)
        }

        /**
         * CreateSession
         * CreateSession is intended to be used as part of the Joii Sessions SDK.
         * calling it will return a session url, with various parameters encoded in it.
         * this URL is not intended to be inspected. Rather, it should be passed to the
         * accompanying JoiiSessions embedded webview as is. The JoiiSessions Embed
         * will handle any actions it needs to, and redirect the user to where
         * they should be.
         * 
         * For example, a request to this endpoint with a type of chat, may return a URL
         * with the redirectTo set to 'chat' and an optional resourceId for an in-progress
         * chat. JoiiSessions then knows where to redirect the user to.
         */
        public async CreateSession(userDocID: string, params: CreateSessionRequestV1): Promise<CreateSessionResponseV1> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/integrator/user/${encodeURIComponent(userDocID)}/sessions`, JSON.stringify(params))
            return await resp.json() as CreateSessionResponseV1
        }

        /**
         * ListSessionsForUser
         * returns the existing chats and appointments that can be
         * resumed through a Joii Session.
         */
        public async ListSessionsForPet(userDocID: string, params: ListSessionsForPetRequest): Promise<ListSessionsResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "pet_doc_id": params.PetDocID,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/integrator/user/${encodeURIComponent(userDocID)}/sessions`, undefined, {query})
            return await resp.json() as ListSessionsResponse
        }
    }
}

export namespace trialmanagementexternal {
    export interface ActiveTrialResponse {
        "doc_id": uuid.UUID
        name: string
        description: string
        status: string
        "adverse_events_form_io_id": string
        "screening_enabled": boolean
        "application_screening_form_id": string
        "landing_page": string
        "clinic_management_enabled": boolean
        "trial_chat_service_doc_id": string
    }

    /**
     * AppliedTrialHomeResponse represents a trial the user has applied to
     */
    export interface AppliedTrialHomeResponse {
        "trial_doc_id": uuid.UUID
        "trial_name": string
        "trial_description": string
        "landing_page": string
        status: string
    }

    export interface AssignClinicianToStepResponse {
        success: boolean
    }

    export interface ClinicianCreateAdverseEventRequest {
        "pet_doc_id": string
        "issue_type_doc_id"?: string
        summary: string
        "form_data": JSONValue
        "form_version_id": number
    }

    export interface ClinicianCreateAdverseEventResponse {
        "doc_id": uuid.UUID
    }

    /**
     * ClinicianCreateFormSubmissionRequest represents the request for a clinician to create a form submission against a participant
     */
    export interface ClinicianCreateFormSubmissionRequest {
        "form_type"?: entities.FormSubmissionType
        "form_name": string
        "form_data": JSONValue
        "form_version_id": number
        "participant_step_doc_id"?: uuid.UUID
        "pet_doc_id"?: uuid.UUID
        source?: string
        "source_id"?: string
        "tagged_fields"?: { [key: string]: JSONValue }
    }

    export interface ClinicianCreateStepNoteRequest {
        note: string
    }

    export interface ClinicianCreateStepNoteResponse {
        "doc_id": uuid.UUID
        note: string
        "created_at": string
    }

    export interface ClinicianParticipantPet {
        "doc_id": string
        name: string
    }

    export interface ClinicianParticipantResponse {
        "doc_id": string
        "trial_doc_id": string
        "trial_name": string
        user: ClinicianParticipantUser
        pet: ClinicianParticipantPet
        "participant_status": string
        "group_name"?: string
        step: ClinicianParticipantStep
    }

    export interface ClinicianParticipantStep {
        "doc_id": uuid.UUID
        "step_type": string
        status: string
        name: string
        description?: string
        number: number
        duration: number
        "appointment_date": string
        "start_date": string
        "end_date": string
        "step_complete_date": string
        "calculated_start_date"?: string
        "calculated_target_date"?: string
        "calculated_end_date"?: string
        "target_day"?: number
        "shifted_days": number
        "derived_status"?: string
    }

    export interface ClinicianParticipantUser {
        "doc_id": string
        name: string
        email: string
    }

    /**
     * CreateAdverseEventSignatureRequest represents the request to sign an adverse event
     */
    export interface CreateAdverseEventSignatureRequest {
        "pet_doc_id": string
        meaning: string
        "ip_address"?: string
        "user_agent"?: string
    }

    /**
     * CreateAdverseEventSignatureResponse represents the response when creating a signature
     */
    export interface CreateAdverseEventSignatureResponse {
        "doc_id": uuid.UUID
    }

    /**
     * CreateFormSubmissionRequest represents the request to create a form submission
     */
    export interface CreateFormSubmissionRequest {
        "form_type"?: entities.FormSubmissionType
        "form_name": string
        "form_data": JSONValue
        "form_version_id": number
        "participant_doc_id"?: uuid.UUID
        "trial_doc_id"?: uuid.UUID
        "participant_step_doc_id"?: uuid.UUID
        "pet_doc_id"?: uuid.UUID
        source?: string
        "source_id"?: string
        "tagged_fields"?: { [key: string]: JSONValue }
    }

    /**
     * CreateFormSubmissionResponse represents the response when creating a form submission
     */
    export interface CreateFormSubmissionResponse {
        "doc_id": uuid.UUID
    }

    /**
     * CreateSignatureRequest represents the request to create a signature
     */
    export interface CreateSignatureRequest {
        meaning: string
        "ip_address"?: string
        "user_agent"?: string
    }

    /**
     * CreateSignatureResponse represents the response when creating a signature
     */
    export interface CreateSignatureResponse {
        "doc_id": uuid.UUID
        "created_at": string
    }

    export interface CreateTrialAppointmentRequest {
        "pet_doc_id": string
        "availability_id": string
    }

    export interface CreateTrialAppointmentResponse {
        "appointment_doc_id": string
        "start_time_utc": string
    }

    export interface CreateTrialChatRequest {
        "pet_doc_id": string
        "pet_name": string
        timezone: string
    }

    export interface CreateTrialChatResponse {
        "chat_doc_id": string
        "channel_id": string
    }

    export interface ExternalCreateAdverseEventRequest {
        "pet_doc_id": string
        "issue_type_doc_id"?: string
        "consultation_doc_id"?: string
        summary: string
        "form_data": JSONValue
        "form_version_id": number
        "tagged_fields"?: { [key: string]: JSONValue }
        "participant_note"?: string
    }

    export interface ExternalCreateAdverseEventResponse {
        "doc_id": uuid.UUID
    }

    export interface ExternalListStepNotesResponse {
        notes: ExternalStepNoteResponse[]
    }

    export interface ExternalListStepVideosResponse {
        videos: ExternalStepVideoResponse[]
        "clinic_profile": ExternalStepVideoClinicProfile
    }

    export interface ExternalListTrialIssueTypesResponse {
        "issue_types": ExternalTrialIssueTypeResponse[]
    }

    /**
     * ExternalParticipantAdverseEventListItem is a participant-facing adverse event row without form payload.
     */
    export interface ExternalParticipantAdverseEventListItem {
        "doc_id": uuid.UUID
        type: entities.AdverseEventType
        summary: string
        "created_at": string
        /**
         * SubmittedBy is a human-readable submitter label (e.g. "Participant", or clinician name and email).
         */
        "submitted_by": string

        "participant_note": string
    }

    export interface ExternalStepNoteResponse {
        "doc_id": uuid.UUID
        "clinician_id"?: number
        "staff_doc_id"?: string
        note: string
        "read_at"?: string
        "created_at": string
        "created_by_name"?: string
    }

    export interface ExternalStepVideoClinicProfile {
        "doc_id": string
        "full_name": string
        discipline: string
        "avatar_variant": string
    }

    export interface ExternalStepVideoResponse {
        "doc_id": uuid.UUID
        "video_call_id": string
        "video_provider": string
        status: string
        "created_at": string
    }

    export interface ExternalTrialIssueTypeResponse {
        "doc_id": uuid.UUID
        "form_io_id": string
        name: string
        "display_order": number
    }

    /**
     * FormSubmissionResponse represents a form submission in API responses
     */
    export interface FormSubmissionResponse {
        "doc_id": uuid.UUID
        "form_type"?: entities.FormSubmissionType
        "form_name": string
        "form_data": JSONValue
        "form_version_id": number
        "participant_id"?: number
        "trial_doc_id"?: uuid.UUID
        "step_doc_id"?: uuid.UUID
        "user_doc_id": uuid.UUID
        "pet_doc_id"?: uuid.UUID
        source?: string
        "source_id"?: string
        "created_at": string
        "created_by": uuid.UUID
        "updated_at": string
        "updated_by"?: uuid.UUID
    }

    export interface GetBookingWindowRequest {
        "pet_doc_id": string
        "service_doc_id": string
    }

    export interface GetBookingWindowResponse {
        /**
         * start time in UTC format
         */
        "start_time"?: string

        /**
         * end time in UTC format
         */
        "end_time"?: string
    }

    /**
     * GetClinicianParticipantPet represents full pet details for GetClinicianParticipant
     */
    export interface GetClinicianParticipantPet {
        "doc_id": string
        name: string
        species: string
        breed: string
        age: PetAge
        gender: string
        weight?: PetWeight
        neutered?: boolean
    }

    /**
     * GetClinicianParticipantResponse represents a participant with full user and pet details for clinicians
     */
    export interface GetClinicianParticipantResponse {
        "doc_id": string
        "trial_doc_id": string
        "trial_name": string
        "participant_status": string
        "group_name"?: string
        user: GetClinicianParticipantUser
        pet: GetClinicianParticipantPet
    }

    /**
     * GetClinicianParticipantUser represents full user details for GetClinicianParticipant
     */
    export interface GetClinicianParticipantUser {
        "doc_id": string
        name: string
        "phone_number": string
        email: string
    }

    /**
     * GetFormSubmissionByParticipantStepParams represents the query parameters for getting a form submission by step
     */
    export interface GetFormSubmissionByParticipantStepParams {
        ParticipantDocID: string
        TrialDocID: string
        ParticipantStepDocID: string
    }

    export interface GetMyClinicProfileResponse {
        "doc_id": uuid.UUID
        "clinic_doc_id": uuid.UUID
        "clinic_name": string
        "clinic_address_line1": string
        "clinic_address_line2": string
        "clinic_city": string
        "clinic_state": string
        "clinic_postal_code": string
        "clinic_country": string
        email: string
        "full_name": string
        "license_number": string
        "phone_number": string
        discipline: string
        "avatar_variant": string
        "invite_status": string
        "is_active": boolean
        "created_at": string
        "updated_at": string
    }

    export interface JoinStepVideoResponse {
        "video_call_id": string
        "api_key": string
        token: string
    }

    export interface ListActiveTrialsWithScreeningResponse {
        trials: ActiveTrialResponse[]
    }

    /**
     * ListAdverseEventSignaturesRequest holds query parameters for listing signatures
     */
    export interface ListAdverseEventSignaturesRequest {
        "pet_doc_id": string
    }

    export interface ListClinicianParticipantsRequest {
        /**
         * optional: filter to participants in this trial only; omit for all trials
         */
        TrialDocID?: string

        /**
         * filter by step status field
         */
        StepStatuses?: string[]

        /**
         * filter to participants with overdue steps
         */
        Overdue?: boolean

        /**
         * search by pet name or owner name
         */
        Search?: string

        /**
         * filter steps by date - include steps where date falls within start_date/end_date or matches step_complete_date (YYYY-MM-DD)
         */
        FilterDate?: string

        /**
         * sort order e.g. ASC/DESC
         */
        SortOrder?: string

        /**
         * the number of results requested for the page
         */
        RequestedItemsPerPage: number

        /**
         * the page number requested
         */
        RequestedPageNumber: number
    }

    export interface ListClinicianParticipantsResponse {
        participants: ClinicianParticipantResponse[]
        pagination: shared.Pagination
    }

    /**
     * ListFormSubmissionsParams represents the query parameters for listing form submissions
     */
    export interface ListFormSubmissionsParams {
        FormType?: string
        ItemsPerPage?: number
        PageNumber?: number
    }

    /**
     * ListFormSubmissionsResponse represents the response for listing form submissions
     */
    export interface ListFormSubmissionsResponse {
        "form_submissions": FormSubmissionResponse[]
        total: number
        "page_number": number
        "items_per_page": number
    }

    /**
     * ListParticipantStepsResponse represents the response for listing participant steps
     */
    export interface ListParticipantStepsResponse {
        steps: ParticipantStepListItem[]
        timeline?: ParticipantTimelineEntry[]
        "timeline_pagination"?: shared.Pagination
    }

    /**
     * ListSignaturesResponse represents the response for listing signatures
     */
    export interface ListSignaturesResponse {
        signatures: SignatureResponse[]
    }

    export interface MarkNoteReadResponse {
        success: boolean
    }

    /**
     * OngoingTrialHomeResponse represents an ongoing trial for the home screen
     */
    export interface OngoingTrialHomeResponse {
        "trial_doc_id": uuid.UUID
        "trial_name": string
        "trial_description": string
        "landing_page": string
        "participant_id": number
        "participant_doc_id": uuid.UUID
        "current_step": number
        "current_step_doc_id": uuid.UUID
        "current_step_name": string
        "current_step_type": string
        "current_step_description": string
        "current_step_status": string
        "card_state": string
        "step_participation": string
        "derived_status": string
    }

    /**
     * ParticipantStepListItem represents a participant step in list responses
     */
    export interface ParticipantStepListItem {
        "doc_id": uuid.UUID
        "trial_step_doc_id": uuid.UUID
        "step_name": string
        "step_description"?: string
        "step_type": string
        "step_number": number
        "step_duration": number
        "step_status"?: string
        "service_doc_id"?: uuid.UUID
        "service_name"?: string
        "algorithm_doc_id"?: uuid.UUID
        "algorithm_name"?: string
        "appointment_date"?: string
        "appointment_doc_id"?: uuid.UUID
        "start_date"?: string
        "end_date"?: string
        "step_complete_date"?: string
        "auto_progress": boolean
        "auto_progress_date"?: string
        "meta_data"?: JSONValue
        "booking_window"?: number
        notes?: ExternalStepNoteResponse[]
        "calculated_start_date"?: string
        "calculated_target_date"?: string
        "calculated_end_date"?: string
        "target_day"?: number
        "shifted_days": number
        "derived_status"?: string
    }

    /**
     * ParticipantStepParams represents query parameters for participant step endpoints
     */
    export interface ParticipantStepParams {
        PetDocID: string
        /**
         * TimelinePage is 1-based. When TimelineItemsPerPage is unset or 0, timeline fields are omitted.
         */
        TimelinePage?: number

        /**
         * TimelineItemsPerPage controls paging for the merged previous-steps + adverse-events timeline.
         */
        TimelineItemsPerPage?: number
    }

    /**
     * ParticipantStepResponse represents a trial participant step in API responses
     */
    export interface ParticipantStepResponse {
        "doc_id": uuid.UUID
        "participant_id": uuid.UUID
        "trial_step_doc_id": uuid.UUID
        "step_name": string
        "step_description"?: string
        "step_type": string
        "step_number": number
        "step_duration": number
        "step_status"?: string
        "service_doc_id"?: uuid.UUID
        "service_name"?: string
        "algorithm_doc_id"?: uuid.UUID
        "algorithm_name"?: string
        "appointment_date"?: string
        "appointment_doc_id"?: uuid.UUID
        "start_date"?: string
        "end_date"?: string
        "step_complete_date"?: string
        "auto_progress": boolean
        "auto_progress_date"?: string
        "meta_data"?: JSONValue
        "booking_window"?: number
        "eligibility_form_id"?: string
        "property_name"?: string
        "step_form_id"?: string
        "step_form_type"?: string
        "video_enabled": boolean
        "clinician_id"?: number
        video?: ExternalStepVideoResponse
        "calculated_start_date"?: string
        "calculated_target_date"?: string
        "calculated_end_date"?: string
        "target_day"?: number
        "shifted_days": number
        "derived_status"?: string
        "card_state"?: entities.CardState
        "step_participation"?: entities.StepParticipation
    }

    /**
     * ParticipantTimelineEntry is one row in the participant trial timeline (previous steps + adverse events).
     */
    export interface ParticipantTimelineEntry {
        /**
         * "step" | "adverse_event"
         */
        kind: string

        step?: ParticipantStepListItem
        "adverse_event"?: ExternalParticipantAdverseEventListItem
        "sort_date": string
    }

    /**
     * PetAge represents pet age in API responses
     */
    export interface PetAge {
        years: number
        months: number
    }

    /**
     * PetWeight represents pet weight in API responses
     */
    export interface PetWeight {
        g: number
        kg: number
        lbs: number
    }

    /**
     * PreviousTrialHomeResponse represents a completed or removed trial for the home screen
     */
    export interface PreviousTrialHomeResponse {
        "trial_doc_id": uuid.UUID
        "trial_name": string
        "trial_description": string
        "participant_id": number
        "participant_doc_id": uuid.UUID
        "participant_status": string
        "current_step": number
        "current_step_doc_id": uuid.UUID
        "current_step_name": string
        "current_step_type": string
        "current_step_description": string
        "current_step_status": string
    }

    /**
     * RegisterPushSubscriptionRequest is the body for registering a push subscription
     */
    export interface RegisterPushSubscriptionRequest {
        endpoint: string
        keys: {
            p256dh: string
            auth: string
        }
    }

    /**
     * SetTrialOnboardingConsentRequest is the body for saving marketing and terms consents during trials onboarding.
     */
    export interface SetTrialOnboardingConsentRequest {
        "marketing_consent": boolean
        "terms_consent": boolean
    }

    /**
     * SignatureResponse represents a signature in API responses
     */
    export interface SignatureResponse {
        "doc_id": uuid.UUID
        meaning: string
        "signature_hash": string
        "form_submission_id"?: number
        "adverse_event_id"?: number
        "ip_address"?: string
        "user_agent"?: string
        "created_at": string
        "created_by": uuid.UUID
        "created_by_name": string
        "created_by_email": string
    }

    export interface TrialAppointmentBookedRequest {
        "pet_doc_id": string
        "service_doc_id": string
        "service_name": string
        "appointment_start_date": string
        "trial_participant_step_doc_id"?: string
    }

    export interface TrialAppointmentCanncelledOrAbandonedRequest {
        "pet_doc_id": string
        "service_doc_id": string
        "service_name": string
        "appointment_status": string
    }

    export interface TrialParticipantRequest {
        "pet_doc_id": string
        "service_doc_id": string
    }

    export interface TrialParticipantResponse {
        HasParticipant: boolean
    }

    /**
     * TrialsHomeRequest represents the request parameters for the trials home endpoint
     */
    export interface TrialsHomeRequest {
        PetDocID?: string
    }

    /**
     * TrialsHomeResponse represents the response for the trials home endpoint
     */
    export interface TrialsHomeResponse {
        ongoing: OngoingTrialHomeResponse[]
        applied: AppliedTrialHomeResponse[]
        upcoming: UpcomingTrialHomeResponse[]
        previous: PreviousTrialHomeResponse[]
    }

    /**
     * UpcomingTrialHomeResponse represents an upcoming trial available for application
     */
    export interface UpcomingTrialHomeResponse {
        "trial_doc_id": uuid.UUID
        "trial_name": string
        "trial_description": string
        "landing_page": string
    }

    export interface UpdateClinicianStepStatusRequest {
        status: string
        reason?: string
    }

    export interface UpdateClinicianStepStatusResponse {
        success: boolean
    }

    /**
     * UpdateFormSubmissionRequest represents the request to update a form submission
     */
    export interface UpdateFormSubmissionRequest {
        "form_data": JSONValue
    }

    export interface UpdateMyClinicProfileAvatarParams {
        "avatar_variant": string
    }

    export interface VerifyAndLinkResponse {
        "doc_id": uuid.UUID
        "clinic_doc_id": uuid.UUID
        email: string
        "full_name": string
        "license_number": string
        "phone_number": string
        discipline: string
        "invite_status": string
        "is_active": boolean
        "created_at": string
        "updated_at": string
    }

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.AssignClinicianToStep = this.AssignClinicianToStep.bind(this)
            this.ClinicianCreateAdverseEvent = this.ClinicianCreateAdverseEvent.bind(this)
            this.ClinicianCreateFormSubmission = this.ClinicianCreateFormSubmission.bind(this)
            this.ClinicianCreateStepNote = this.ClinicianCreateStepNote.bind(this)
            this.ClinicianJoinStepVideo = this.ClinicianJoinStepVideo.bind(this)
            this.ClinicianListStepNotes = this.ClinicianListStepNotes.bind(this)
            this.ClinicianListTrialIssueTypes = this.ClinicianListTrialIssueTypes.bind(this)
            this.CreateAdverseEventSignature = this.CreateAdverseEventSignature.bind(this)
            this.CreateClinicianFormSubmissionSignature = this.CreateClinicianFormSubmissionSignature.bind(this)
            this.CreateFormSubmission = this.CreateFormSubmission.bind(this)
            this.CreateFormSubmissionSignature = this.CreateFormSubmissionSignature.bind(this)
            this.CreateParticipantAdverseEvent = this.CreateParticipantAdverseEvent.bind(this)
            this.CreateTrialAppointment = this.CreateTrialAppointment.bind(this)
            this.CreateTrialChat = this.CreateTrialChat.bind(this)
            this.GetActiveTrial = this.GetActiveTrial.bind(this)
            this.GetClinicianFormSubmissionByStep = this.GetClinicianFormSubmissionByStep.bind(this)
            this.GetClinicianParticipant = this.GetClinicianParticipant.bind(this)
            this.GetFormSubmissionByStep = this.GetFormSubmissionByStep.bind(this)
            this.GetMyClinicProfile = this.GetMyClinicProfile.bind(this)
            this.GetParticipantCurrentStep = this.GetParticipantCurrentStep.bind(this)
            this.GetParticipantStep = this.GetParticipantStep.bind(this)
            this.GetTrialStudyCallStepBookingWindow = this.GetTrialStudyCallStepBookingWindow.bind(this)
            this.Home = this.Home.bind(this)
            this.JoinStepVideo = this.JoinStepVideo.bind(this)
            this.ListActiveTrialsWithScreening = this.ListActiveTrialsWithScreening.bind(this)
            this.ListAdverseEventSignatures = this.ListAdverseEventSignatures.bind(this)
            this.ListClinicianParticipants = this.ListClinicianParticipants.bind(this)
            this.ListFormSubmissionSignatures = this.ListFormSubmissionSignatures.bind(this)
            this.ListFormSubmissions = this.ListFormSubmissions.bind(this)
            this.ListParticipantStepNotes = this.ListParticipantStepNotes.bind(this)
            this.ListParticipantStepVideos = this.ListParticipantStepVideos.bind(this)
            this.ListParticipantSteps = this.ListParticipantSteps.bind(this)
            this.ListTrialIssueTypes = this.ListTrialIssueTypes.bind(this)
            this.MarkParticipantStepNoteRead = this.MarkParticipantStepNoteRead.bind(this)
            this.RegisterPushSubscription = this.RegisterPushSubscription.bind(this)
            this.SetTrialOnboardingConsent = this.SetTrialOnboardingConsent.bind(this)
            this.TrialAppointmentBooked = this.TrialAppointmentBooked.bind(this)
            this.TrialAppointmentCanncelledOrAbandoned = this.TrialAppointmentCanncelledOrAbandoned.bind(this)
            this.TrialParticipantExists = this.TrialParticipantExists.bind(this)
            this.TrialsHome = this.TrialsHome.bind(this)
            this.UpdateClinicianStepStatus = this.UpdateClinicianStepStatus.bind(this)
            this.UpdateFormSubmission = this.UpdateFormSubmission.bind(this)
            this.UpdateMyClinicProfileAvatar = this.UpdateMyClinicProfileAvatar.bind(this)
            this.VerifyAndLinkClinicProfile = this.VerifyAndLinkClinicProfile.bind(this)
        }

        /**
         * AssignClinicianToStep allows a clinician to self-assign to a Clinician Step
         */
        public async AssignClinicianToStep(trial_doc_id: string, participant_doc_id: string, step_doc_id: string): Promise<AssignClinicianToStepResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("PUT", `/v1/clinician/trials/${encodeURIComponent(trial_doc_id)}/participants/${encodeURIComponent(participant_doc_id)}/steps/${encodeURIComponent(step_doc_id)}/assign`)
            return await resp.json() as AssignClinicianToStepResponse
        }

        /**
         * ClinicianCreateAdverseEvent allows a clinician to create an adverse event for a participant
         */
        public async ClinicianCreateAdverseEvent(trial_doc_id: string, participant_doc_id: string, params: ClinicianCreateAdverseEventRequest): Promise<ClinicianCreateAdverseEventResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/clinician/trials/${encodeURIComponent(trial_doc_id)}/participants/${encodeURIComponent(participant_doc_id)}/adverse-events`, JSON.stringify(params))
            return await resp.json() as ClinicianCreateAdverseEventResponse
        }

        /**
         * ClinicianCreateFormSubmission allows a clinician to create a form submission for a participant
         */
        public async ClinicianCreateFormSubmission(trial_doc_id: string, participant_doc_id: string, params: ClinicianCreateFormSubmissionRequest): Promise<CreateFormSubmissionResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/clinician/trials/${encodeURIComponent(trial_doc_id)}/participants/${encodeURIComponent(participant_doc_id)}/form-submissions`, JSON.stringify(params))
            return await resp.json() as CreateFormSubmissionResponse
        }

        /**
         * ClinicianCreateStepNote allows a clinician to create a note for a participant step
         */
        public async ClinicianCreateStepNote(trial_doc_id: string, participant_doc_id: string, step_doc_id: string, params: ClinicianCreateStepNoteRequest): Promise<ClinicianCreateStepNoteResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/clinician/trials/${encodeURIComponent(trial_doc_id)}/participants/${encodeURIComponent(participant_doc_id)}/steps/${encodeURIComponent(step_doc_id)}/notes`, JSON.stringify(params))
            return await resp.json() as ClinicianCreateStepNoteResponse
        }

        /**
         * ClinicianJoinStepVideo allows a clinician to join a video session
         */
        public async ClinicianJoinStepVideo(trial_doc_id: string, participant_doc_id: string, step_doc_id: string, video_doc_id: string): Promise<JoinStepVideoResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/clinician/trials/${encodeURIComponent(trial_doc_id)}/participants/${encodeURIComponent(participant_doc_id)}/steps/${encodeURIComponent(step_doc_id)}/videos/${encodeURIComponent(video_doc_id)}/join`)
            return await resp.json() as JoinStepVideoResponse
        }

        /**
         * ClinicianListStepNotes lists notes for a participant step (read-only, clinic-scoped).
         */
        public async ClinicianListStepNotes(trial_doc_id: string, participant_doc_id: string, step_doc_id: string): Promise<ExternalListStepNotesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/clinician/trials/${encodeURIComponent(trial_doc_id)}/participants/${encodeURIComponent(participant_doc_id)}/steps/${encodeURIComponent(step_doc_id)}/notes`)
            return await resp.json() as ExternalListStepNotesResponse
        }

        /**
         * ClinicianListTrialIssueTypes lists active issue types for a trial (clinicians only)
         */
        public async ClinicianListTrialIssueTypes(trial_doc_id: string): Promise<ExternalListTrialIssueTypesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/clinician/trials/${encodeURIComponent(trial_doc_id)}/issue-types`)
            return await resp.json() as ExternalListTrialIssueTypesResponse
        }

        /**
         * CreateAdverseEventSignature creates a signature for an adverse event (for participants)
         */
        public async CreateAdverseEventSignature(user_doc_id: string, trial_doc_id: string, adverse_event_doc_id: string, params: CreateAdverseEventSignatureRequest): Promise<CreateAdverseEventSignatureResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/users/${encodeURIComponent(user_doc_id)}/trial-participants/${encodeURIComponent(trial_doc_id)}/adverse-events/${encodeURIComponent(adverse_event_doc_id)}/signatures`, JSON.stringify(params))
            return await resp.json() as CreateAdverseEventSignatureResponse
        }

        /**
         * CreateClinicianFormSubmissionSignature creates a signature for a clinician form submission
         */
        public async CreateClinicianFormSubmissionSignature(clinician_doc_id: string, form_submission_doc_id: string, params: CreateSignatureRequest): Promise<CreateSignatureResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/clinicians/${encodeURIComponent(clinician_doc_id)}/form-submissions/${encodeURIComponent(form_submission_doc_id)}/signatures`, JSON.stringify(params))
            return await resp.json() as CreateSignatureResponse
        }

        /**
         * CreateFormSubmission creates a new form submission for a user
         */
        public async CreateFormSubmission(user_doc_id: string, params: CreateFormSubmissionRequest): Promise<CreateFormSubmissionResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/users/${encodeURIComponent(user_doc_id)}/form-submissions`, JSON.stringify(params))
            return await resp.json() as CreateFormSubmissionResponse
        }

        /**
         * CreateFormSubmissionSignature creates a signature for a form submission (pet owners and clinicians)
         */
        public async CreateFormSubmissionSignature(user_doc_id: string, form_submission_doc_id: string, params: CreateSignatureRequest): Promise<CreateSignatureResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/users/${encodeURIComponent(user_doc_id)}/form-submissions/${encodeURIComponent(form_submission_doc_id)}/signatures`, JSON.stringify(params))
            return await resp.json() as CreateSignatureResponse
        }

        /**
         * CreateParticipantAdverseEvent creates a new adverse event for a participant
         */
        public async CreateParticipantAdverseEvent(user_doc_id: string, trial_doc_id: string, params: ExternalCreateAdverseEventRequest): Promise<ExternalCreateAdverseEventResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/users/${encodeURIComponent(user_doc_id)}/trial-participants/${encodeURIComponent(trial_doc_id)}/adverse-events`, JSON.stringify(params))
            return await resp.json() as ExternalCreateAdverseEventResponse
        }

        /**
         * CreateTrialAppointment creates a new appointment for a trial participant.
         * The user must be an active or action-required participant in the trial.
         * When the current step has no step-level booking service (step_service_doc_id), the trial must
         * have trial_appointment_service_doc_id configured.
         * 
         * For "Studies Consultation" steps, the appointment stores the participant_step_doc_id so that
         * staff can create a linked trial consultation when they attend the call.
         */
        public async CreateTrialAppointment(trial_doc_id: string, participant_doc_id: string, params: CreateTrialAppointmentRequest): Promise<CreateTrialAppointmentResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/trials/${encodeURIComponent(trial_doc_id)}/participants/${encodeURIComponent(participant_doc_id)}/appointment`, JSON.stringify(params))
            return await resp.json() as CreateTrialAppointmentResponse
        }

        /**
         * CreateTrialChat creates a new chat for a trial participant.
         * The user must be an active or action-required participant in the trial.
         * The trial must have a chat service configured (trial_chat_service_doc_id).
         * Participant is resolved from the authenticated user and pet_doc_id in the request.
         */
        public async CreateTrialChat(trial_doc_id: string, params: CreateTrialChatRequest): Promise<CreateTrialChatResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/trials/${encodeURIComponent(trial_doc_id)}/chat`, JSON.stringify(params))
            return await resp.json() as CreateTrialChatResponse
        }

        /**
         * GetActiveTrial fetches an active trial by doc_id
         */
        public async GetActiveTrial(doc_id: string): Promise<ActiveTrialResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/public/trials/active-screening/${encodeURIComponent(doc_id)}`)
            return await resp.json() as ActiveTrialResponse
        }

        /**
         * GetClinicianFormSubmissionByStep returns the form submission for a participant's step (read-only, clinic-scoped).
         */
        public async GetClinicianFormSubmissionByStep(trial_doc_id: string, participant_doc_id: string, step_doc_id: string): Promise<FormSubmissionResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/clinician/trials/${encodeURIComponent(trial_doc_id)}/participants/${encodeURIComponent(participant_doc_id)}/steps/${encodeURIComponent(step_doc_id)}/form-submission`)
            return await resp.json() as FormSubmissionResponse
        }

        /**
         * GetClinicianParticipant returns participant details including user and pet for a clinician.
         * Restricted to clinicians with a clinic profile on the same clinic as the participant.
         */
        public async GetClinicianParticipant(trial_doc_id: string, participant_doc_id: string): Promise<GetClinicianParticipantResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/clinician/trials/${encodeURIComponent(trial_doc_id)}/participants/${encodeURIComponent(participant_doc_id)}`)
            return await resp.json() as GetClinicianParticipantResponse
        }

        /**
         * GetFormSubmissionByStep retrieves a form submission by participant, trial, and step
         */
        public async GetFormSubmissionByStep(user_doc_id: string, params: GetFormSubmissionByParticipantStepParams): Promise<FormSubmissionResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "participant_doc_id":      params.ParticipantDocID,
                "participant_step_doc_id": params.ParticipantStepDocID,
                "trial_doc_id":            params.TrialDocID,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/users/${encodeURIComponent(user_doc_id)}/trial-form-submission`, undefined, {query})
            return await resp.json() as FormSubmissionResponse
        }

        /**
         * GetMyClinicProfile returns the authenticated external clinician's profile.
         */
        public async GetMyClinicProfile(): Promise<GetMyClinicProfileResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/clinic-auth/me`)
            return await resp.json() as GetMyClinicProfileResponse
        }

        /**
         * GetParticipantCurrentStep returns the current step (In Progress or Upcoming) for a participant
         */
        public async GetParticipantCurrentStep(user_doc_id: string, trial_doc_id: string, params: ParticipantStepParams): Promise<ParticipantStepResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "pet_doc_id":              params.PetDocID,
                "timeline_items_per_page": params.TimelineItemsPerPage === undefined ? undefined : String(params.TimelineItemsPerPage),
                "timeline_page":           params.TimelinePage === undefined ? undefined : String(params.TimelinePage),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/users/${encodeURIComponent(user_doc_id)}/trial-participants/${encodeURIComponent(trial_doc_id)}/current-step`, undefined, {query})
            return await resp.json() as ParticipantStepResponse
        }

        /**
         * GetParticipantStep returns a specific step by ID for a participant
         */
        public async GetParticipantStep(user_doc_id: string, trial_doc_id: string, step_doc_id: string, params: ParticipantStepParams): Promise<ParticipantStepResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "pet_doc_id":              params.PetDocID,
                "timeline_items_per_page": params.TimelineItemsPerPage === undefined ? undefined : String(params.TimelineItemsPerPage),
                "timeline_page":           params.TimelinePage === undefined ? undefined : String(params.TimelinePage),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/users/${encodeURIComponent(user_doc_id)}/trial-participants/${encodeURIComponent(trial_doc_id)}/steps/${encodeURIComponent(step_doc_id)}`, undefined, {query})
            return await resp.json() as ParticipantStepResponse
        }

        /**
         * GetTrialStudyCallStepBookingWindow retrieves allowed booking window for the step
         */
        public async GetTrialStudyCallStepBookingWindow(user_doc_id: string, params: GetBookingWindowRequest): Promise<GetBookingWindowResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "pet_doc_id":     params["pet_doc_id"],
                "service_doc_id": params["service_doc_id"],
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/users/${encodeURIComponent(user_doc_id)}/trial-appointment-booking-window`, undefined, {query})
            return await resp.json() as GetBookingWindowResponse
        }

        /**
         * Home moves participant to next step Study Call
         */
        public async Home(user_doc_id: string): Promise<void> {
            await this.baseClient.callTypedAPI("GET", `/v1/users/${encodeURIComponent(user_doc_id)}/trial-home`)
        }

        /**
         * JoinStepVideo allows a participant to join a video session
         */
        public async JoinStepVideo(user_doc_id: string, trial_doc_id: string, step_doc_id: string, video_doc_id: string): Promise<JoinStepVideoResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/users/${encodeURIComponent(user_doc_id)}/trial-participants/${encodeURIComponent(trial_doc_id)}/steps/${encodeURIComponent(step_doc_id)}/videos/${encodeURIComponent(video_doc_id)}/join`)
            return await resp.json() as JoinStepVideoResponse
        }

        /**
         * ListActiveTrialsWithScreening lists all active trials with screening enabled
         */
        public async ListActiveTrialsWithScreening(): Promise<ListActiveTrialsWithScreeningResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/public/trials/active-screening`)
            return await resp.json() as ListActiveTrialsWithScreeningResponse
        }

        /**
         * ListAdverseEventSignatures lists all signatures for an adverse event (for participants)
         */
        public async ListAdverseEventSignatures(user_doc_id: string, trial_doc_id: string, adverse_event_doc_id: string, params: ListAdverseEventSignaturesRequest): Promise<ListSignaturesResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "pet_doc_id": params["pet_doc_id"],
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/users/${encodeURIComponent(user_doc_id)}/trial-participants/${encodeURIComponent(trial_doc_id)}/adverse-events/${encodeURIComponent(adverse_event_doc_id)}/signatures`, undefined, {query})
            return await resp.json() as ListSignaturesResponse
        }

        /**
         * ListClinicianParticipants lists participants for the authenticated clinician's clinic.
         * If trial_doc_id is supplied, results are limited to that trial; otherwise all trials are included.
         */
        public async ListClinicianParticipants(params: ListClinicianParticipantsRequest): Promise<ListClinicianParticipantsResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "filter_date":    params.FilterDate,
                "items_per_page": String(params.RequestedItemsPerPage),
                overdue:          params.Overdue === undefined ? undefined : String(params.Overdue),
                "page_number":    String(params.RequestedPageNumber),
                search:           params.Search,
                "sort_order":     params.SortOrder,
                "step_statuses":  params.StepStatuses?.map((v) => v),
                "trial_doc_id":   params.TrialDocID,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/clinician/participants`, undefined, {query})
            return await resp.json() as ListClinicianParticipantsResponse
        }

        /**
         * ListFormSubmissionSignatures lists all signatures for a form submission (pet owners and clinicians)
         */
        public async ListFormSubmissionSignatures(user_doc_id: string, form_submission_doc_id: string): Promise<ListSignaturesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/users/${encodeURIComponent(user_doc_id)}/form-submissions/${encodeURIComponent(form_submission_doc_id)}/signatures`)
            return await resp.json() as ListSignaturesResponse
        }

        /**
         * ListFormSubmissions lists form submissions for a user
         */
        public async ListFormSubmissions(user_doc_id: string, params: ListFormSubmissionsParams): Promise<ListFormSubmissionsResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "form_type":      params.FormType,
                "items_per_page": params.ItemsPerPage === undefined ? undefined : String(params.ItemsPerPage),
                "page_number":    params.PageNumber === undefined ? undefined : String(params.PageNumber),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/users/${encodeURIComponent(user_doc_id)}/form-submissions`, undefined, {query})
            return await resp.json() as ListFormSubmissionsResponse
        }

        /**
         * ListParticipantStepNotes lists notes for a participant's step
         */
        public async ListParticipantStepNotes(user_doc_id: string, trial_doc_id: string, step_doc_id: string, params: ParticipantStepParams): Promise<ExternalListStepNotesResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "pet_doc_id":              params.PetDocID,
                "timeline_items_per_page": params.TimelineItemsPerPage === undefined ? undefined : String(params.TimelineItemsPerPage),
                "timeline_page":           params.TimelinePage === undefined ? undefined : String(params.TimelinePage),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/users/${encodeURIComponent(user_doc_id)}/trial-participants/${encodeURIComponent(trial_doc_id)}/steps/${encodeURIComponent(step_doc_id)}/notes`, undefined, {query})
            return await resp.json() as ExternalListStepNotesResponse
        }

        /**
         * ListParticipantStepVideos lists video sessions for a participant's step
         */
        public async ListParticipantStepVideos(user_doc_id: string, trial_doc_id: string, step_doc_id: string, params: ParticipantStepParams): Promise<ExternalListStepVideosResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "pet_doc_id":              params.PetDocID,
                "timeline_items_per_page": params.TimelineItemsPerPage === undefined ? undefined : String(params.TimelineItemsPerPage),
                "timeline_page":           params.TimelinePage === undefined ? undefined : String(params.TimelinePage),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/users/${encodeURIComponent(user_doc_id)}/trial-participants/${encodeURIComponent(trial_doc_id)}/steps/${encodeURIComponent(step_doc_id)}/videos`, undefined, {query})
            return await resp.json() as ExternalListStepVideosResponse
        }

        /**
         * ListParticipantSteps returns all steps for a participant in a trial
         */
        public async ListParticipantSteps(user_doc_id: string, trial_doc_id: string, params: ParticipantStepParams): Promise<ListParticipantStepsResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "pet_doc_id":              params.PetDocID,
                "timeline_items_per_page": params.TimelineItemsPerPage === undefined ? undefined : String(params.TimelineItemsPerPage),
                "timeline_page":           params.TimelinePage === undefined ? undefined : String(params.TimelinePage),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/users/${encodeURIComponent(user_doc_id)}/trial-participants/${encodeURIComponent(trial_doc_id)}/steps`, undefined, {query})
            return await resp.json() as ListParticipantStepsResponse
        }

        /**
         * ListTrialIssueTypes lists active issue types for a trial (participants only)
         */
        public async ListTrialIssueTypes(user_doc_id: string, trial_doc_id: string): Promise<ExternalListTrialIssueTypesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/users/${encodeURIComponent(user_doc_id)}/trial-participants/${encodeURIComponent(trial_doc_id)}/issue-types`)
            return await resp.json() as ExternalListTrialIssueTypesResponse
        }

        /**
         * MarkParticipantStepNoteRead marks a note as read by the participant
         */
        public async MarkParticipantStepNoteRead(user_doc_id: string, trial_doc_id: string, step_doc_id: string, note_doc_id: string): Promise<MarkNoteReadResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("PUT", `/v1/users/${encodeURIComponent(user_doc_id)}/trial-participants/${encodeURIComponent(trial_doc_id)}/steps/${encodeURIComponent(step_doc_id)}/notes/${encodeURIComponent(note_doc_id)}/read`)
            return await resp.json() as MarkNoteReadResponse
        }

        /**
         * RegisterPushSubscription stores the participant's push subscription so the API can send notifications.
         */
        public async RegisterPushSubscription(user_doc_id: string, params: RegisterPushSubscriptionRequest): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/v1/users/${encodeURIComponent(user_doc_id)}/push-subscription`, JSON.stringify(params))
        }

        /**
         * SetTrialOnboardingConsent upserts consent flags for the authenticated user and emits trial-onboarding-consent-updated.
         */
        public async SetTrialOnboardingConsent(user_doc_id: string, params: SetTrialOnboardingConsentRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PUT", `/v1/users/${encodeURIComponent(user_doc_id)}/trial-onboarding-consent`, JSON.stringify(params))
        }

        /**
         * TrialAppointmentBooked completes the active booking step and advances the participant when an
         * appointment reaches Booked, except for Studies Consultation (that step completes with the trial consultation).
         */
        public async TrialAppointmentBooked(user_doc_id: string, params: TrialAppointmentBookedRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PATCH", `/v1/users/${encodeURIComponent(user_doc_id)}/trial-appointment-booked`, JSON.stringify(params))
        }

        /**
         * TrialAppointmentCanncelledOrAbandoned cancels or abandons appointment
         */
        public async TrialAppointmentCanncelledOrAbandoned(user_doc_id: string, params: TrialAppointmentCanncelledOrAbandonedRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PATCH", `/v1/users/${encodeURIComponent(user_doc_id)}/trial-appointment-cancelled-or-abandoned`, JSON.stringify(params))
        }

        /**
         * TrialParticipantExists updates the status of a trial step for a participant
         */
        public async TrialParticipantExists(user_doc_id: string, params: TrialParticipantRequest): Promise<TrialParticipantResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "pet_doc_id":     params["pet_doc_id"],
                "service_doc_id": params["service_doc_id"],
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/users/${encodeURIComponent(user_doc_id)}/trial-participant-exists`, undefined, {query})
            return await resp.json() as TrialParticipantResponse
        }

        /**
         * TrialsHome returns categorized trial data for the participant home screen
         */
        public async TrialsHome(user_doc_id: string, params: TrialsHomeRequest): Promise<TrialsHomeResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "pet_doc_id": params.PetDocID,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/users/${encodeURIComponent(user_doc_id)}/trials/home`, undefined, {query})
            return await resp.json() as TrialsHomeResponse
        }

        /**
         * UpdateClinicianStepStatus allows a clinician to update the status of a Clinician Step
         */
        public async UpdateClinicianStepStatus(trial_doc_id: string, participant_doc_id: string, step_doc_id: string, params: UpdateClinicianStepStatusRequest): Promise<UpdateClinicianStepStatusResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("PUT", `/v1/clinician/trials/${encodeURIComponent(trial_doc_id)}/participants/${encodeURIComponent(participant_doc_id)}/steps/${encodeURIComponent(step_doc_id)}/status`, JSON.stringify(params))
            return await resp.json() as UpdateClinicianStepStatusResponse
        }

        /**
         * UpdateFormSubmission updates a form submission
         */
        public async UpdateFormSubmission(user_doc_id: string, form_submission_doc_id: string, params: UpdateFormSubmissionRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PUT", `/v1/users/${encodeURIComponent(user_doc_id)}/form-submissions/${encodeURIComponent(form_submission_doc_id)}`, JSON.stringify(params))
        }

        /**
         * UpdateMyClinicProfileAvatar updates the authenticated user's clinic profile avatar.
         */
        public async UpdateMyClinicProfileAvatar(params: UpdateMyClinicProfileAvatarParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/v1/clinic-auth/me/avatar`, JSON.stringify(params))
        }

        /**
         * VerifyAndLinkClinicProfile looks up a clinic profile by the authenticated user's email,
         * links the Firebase UID to the profile, and returns the profile.
         * Called by the frontend during onboarding/first login.
         */
        public async VerifyAndLinkClinicProfile(): Promise<VerifyAndLinkResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/clinic-auth/verify-and-link`)
            return await resp.json() as VerifyAndLinkResponse
        }
    }
}

export namespace trialmanagementinternal {
    export interface ActiveStep {
        "doc_id": uuid.UUID
        status: string
        name: string
        number: number
        duration: number
        "appointment_date": string
        "start_date": string
        "end_date": string
    }

    export interface AddAdverseEventToParticipantStepHistoryRequest {
        AdverseEventDocID: string
    }

    export interface AdverseEventAuditResponse {
        "created_at": string
        "created_by": string
        "changes_summary": string
        "change_reason": entities.ChangeReasonType
        "change_notes": string
    }

    export interface AdverseEventsResponse {
        "doc_id": uuid.UUID
        type: entities.AdverseEventType
        summary: string
        "recorded_at"?: string
        "form_name": string
        "form_version_id": number
        "form_data": JSONValue
        "created_at": string
        "created_by": string
        "updated_at": string
        "updated_by": string
        "form_submission_doc_id"?: uuid.UUID
        "participant_note"?: string
        "completed_by": string
        "change_reason"?: string
        "change_notes"?: string
        "changes_summary"?: string
    }

    export interface AdverseEventsSummary {
        "adverse_event_doc_id": uuid.UUID
        summary: string
    }

    export interface Age {
        years: number
        months: number
    }

    export interface BulkUpdateParticipantGroupRequest {
        "participants_doc_id": string[]
        "group_doc_id": string
        /**
         * AssignRandomGroup
         * Indicates if a group should be automatically assigned to the participant by the system.
         * When this flag if false GroupDocID is assigned to the participant and can either be simple group or sub group.
         * When this flag is true GroupDocID should be either empty or a parent group id
         * When GroupDocID is empty than a random simple group or subgroup will be assigned to the participant
         * When GroupDocID is parent group id than a random subgroup of the selected parent group will be assigned to the participant
         */
        "assign_random_group": boolean
    }

    export interface BulkUpdateParticipantsStatusesRequest {
        "participants_doc_id": string[]
        status: string
        reason: string
        source: string
    }

    export interface BulkUpdateParticipantsStepStatusesRequest {
        "participants_steps": ParticipantStep[]
        status: string
        reason: string
        source: string
    }

    export interface ClinicProfileResponse {
        "doc_id": uuid.UUID
        "user_doc_id": uuid.UUID
        email: string
        "full_name": string
        "license_number": string
        "phone_number": string
        discipline: string
        "invite_status": string
        "is_active": boolean
        "created_at": string
        "updated_at": string
    }

    export interface ClinicResponse {
        "doc_id": uuid.UUID
        name: string
        "email_domain": string
        "address_line1": string
        "address_line2": string
        city: string
        state: string
        "postal_code": string
        country: string
        phone: string
        "contact_name": string
        "contact_phone_number": string
        "contact_email": string
        "is_active": boolean
        "created_at": string
        "updated_at": string
    }

    export interface ClinicTrialResponse {
        "is_active": boolean
        "enrolled_at": string
        "created_at": string
        "updated_at": string
        "deleted_at": string
        trial: TrialResponse
    }

    export interface ConsultationAdverseEventResponse {
        "doc_id": uuid.UUID
        type: entities.AdverseEventType
        summary?: string
        "form_name": string
        "form_data": JSONValue
        "form_version_id": number
        "created_at": string
        "created_by": string
        "participant_note"?: string
    }

    export interface CreateAdverseEventRequest {
        summary: string
        "recorded_at": string
        "form_data": JSONValue
        "form_version_id": number
        "form_name"?: string
        "form_submission_doc_id"?: string
        "issue_type_doc_id"?: string
        "initial_audit"?: InitialAuditRequest
        "initial_signature"?: InitialSignatureRequest
        "tagged_fields"?: { [key: string]: JSONValue }
    }

    export interface CreateAdverseEventResponse {
        "doc_id": uuid.UUID
    }

    export interface CreateClinicProfileRequest {
        "user_doc_id"?: uuid.UUID
        email: string
        "full_name": string
        "license_number"?: string
        "phone_number"?: string
        discipline?: string
    }

    export interface CreateClinicProfileResponse {
        "doc_id": uuid.UUID
    }

    export interface CreateClinicRequest {
        name: string
        "email_domain"?: string
        "address_line1"?: string
        "address_line2"?: string
        city?: string
        state?: string
        "postal_code"?: string
        country: string
        phone?: string
        "contact_name"?: string
        "contact_phone_number"?: string
        "contact_email"?: string
    }

    export interface CreateClinicResponse {
        "doc_id": uuid.UUID
    }

    /**
     * CreateFormSubmissionResponse is returned when a form submission is created.
     */
    export interface CreateFormSubmissionResponse {
        "doc_id": uuid.UUID
    }

    export interface CreateParticipantRequest {
        /**
         * UserDocID
         * The **doc_id** of the user, selected to be added as a participant.
         */
        "user_doc_id": string

        /**
         * PetDocID
         * The **doc_id** of the pet, selected to be added as a participant.
         */
        "pet_doc_id": string

        /**
         * GroupDocID
         * The **doc_id** of the group, selected to be assigned to the participant.
         * Group can either be a simple group, parent group or sub group.
         * Only simple groups or subgroups can be assigned to a participant.
         * Parent groups cannot be assigned to a participant.
         */
        "group_doc_id"?: string

        /**
         * AssignRandomGroup
         * Indicates if a group should be automatically assigned to the participant by the system.
         * When this flag if false GroupDocID is assigned to the participant and can either be simple group or sub group.
         * When this flag is true GroupDocID should be either empty or a parent group id
         * When GroupDocID is empty than a random simple group or subgroup will be assigned to the participant
         * When GroupDocID is parent group id than a random subgroup of the selected parent group will be assigned to the participant
         */
        "assign_random_group": boolean
    }

    export interface CreateParticipantResponse {
        "doc_id": uuid.UUID
    }

    /**
     * CreateSignatureRequest represents the request to create a signature
     */
    export interface CreateSignatureRequest {
        meaning: string
        "ip_address"?: string
        "user_agent"?: string
    }

    /**
     * CreateSignatureResponse represents the response when creating a signature
     */
    export interface CreateSignatureResponse {
        "doc_id": uuid.UUID
        "created_at": string
    }

    /**
     * CreateStaffFormSubmissionRequest is the body for staff-created participant form submissions (PMS / booking staff).
     */
    export interface CreateStaffFormSubmissionRequest {
        "form_type"?: entities.FormSubmissionType
        "form_name": string
        "form_data": JSONValue
        "form_version_id": number
        "participant_step_doc_id"?: uuid.UUID
        "pet_doc_id"?: uuid.UUID
        source?: string
        "source_id"?: string
        "tagged_fields"?: { [key: string]: JSONValue }
    }

    export interface CreateStepNoteRequest {
        note: string
    }

    export interface CreateStepNoteResponse {
        "doc_id": uuid.UUID
        note: string
        "created_at": string
    }

    export interface CreateStepVideoRequest {
        "created_by_id": string
        "created_by_name": string
        members: VideoCallMemberRequest[]
    }

    export interface CreateStepVideoResponse {
        "doc_id": uuid.UUID
        "video_call_id": string
        "api_key": string
        token: string
    }

    export interface CreateTrialClinicRequest {
        "clinic_doc_id": uuid.UUID
    }

    export interface CreateTrialClinicResponse {
        "clinic_doc_id": uuid.UUID
    }

    export interface CreateTrialConsultationRequest {
        "trial_participant_step_doc_id"?: string
        "chat_doc_id"?: string
        "appointment_doc_id"?: string
    }

    export interface CreateTrialGroupRequest {
        name: string
        description: string
        "parent_doc_id"?: string
    }

    export interface CreateTrialGroupResponse {
        "doc_id": uuid.UUID
    }

    export interface CreateTrialIssueTypeRequest {
        "form_io_id": string
        name: string
        "display_order": number
        visibility?: entities.IssueTypeVisibility
        "adverse_event_type"?: entities.AdverseEventType
    }

    export interface CreateTrialIssueTypeResponse {
        "doc_id": uuid.UUID
    }

    export interface CreateTrialRequest {
        name: string
        description: string
        "adverse_events_form_io_id": string
        "screening_enabled": boolean
        "application_screening_form_id": string
        "landing_page": string
        "clinic_management_enabled": boolean
        "scheduling_mode"?: string
        "trial_chat_service_doc_id"?: string
    }

    export interface CreateTrialResponse {
        "doc_id": uuid.UUID
    }

    export interface CreateTrialStepRequest {
        "step_name": string
        "step_type": string
        duration: number
        description?: string
        "service_doc_id": string
        "service_name": string
        "auto_progress": boolean
        metadata: JSONValue
        "booking_window"?: number
        "eligibility_form_id"?: string
        "property_name"?: string
        "formio_form_id"?: string
        "formio_form_type"?: string
        "video_enabled": boolean
        "visibility_day_start"?: number
        "target_day"?: number
        "visibility_day_end"?: number
        "auto_shift_on_delay": boolean
    }

    export interface CreateTrialStepResponse {
        "doc_id": uuid.UUID
    }

    export interface DeleteParticipantRequest {
        reason: string
    }

    /**
     * FormSubmissionResponse represents a form submission in API responses
     */
    export interface FormSubmissionResponse {
        "doc_id": uuid.UUID
        "form_type"?: entities.FormSubmissionType
        "form_name": string
        "form_data": JSONValue
        "form_version_id": number
        "participant_id"?: number
        "trial_doc_id"?: uuid.UUID
        "step_doc_id"?: uuid.UUID
        "user_doc_id": uuid.UUID
        "pet_doc_id"?: uuid.UUID
        source?: string
        "source_id"?: string
        "created_at": string
        "created_by": uuid.UUID
        "updated_at": string
        "updated_by"?: uuid.UUID
        "staff_profile_doc_id"?: uuid.UUID
        "participant_step_doc_id"?: uuid.UUID
    }

    export interface GetParticipantMetadataResponse {
        metadata: JSONValue
    }

    export interface GetParticipantPet {
        "doc_id": string
        name: string
        species: string
        breed: string
        "is_insured": boolean
        insurer: string
        age: Age
        gender: string
        "date_of_birth": string
        neutered?: boolean
    }

    export interface GetParticipantResponse {
        id: number
        "doc_id": string
        user: GetParticipantUser
        pet: GetParticipantPet
        "participant_status": string
        "group_name"?: string
        "parent_group_doc_id"?: uuid.UUID
        "parent_group_name"?: string
        "child_group_doc_id"?: uuid.UUID
        "child_group_name"?: string
        "are_groups_enabled": boolean
        "clinic_doc_id"?: uuid.UUID
        "clinic_name"?: string
        "entry_date"?: string
    }

    export interface GetParticipantUser {
        "doc_id": string
        name: string
        "phone_number": string
        email: string
    }

    /**
     * GetScreeningParticipantsStatusCountsResponse represents screening participant counts grouped by status
     */
    export interface GetScreeningParticipantsStatusCountsResponse {
        total: number
        pending: number
        approved: number
        rejected: number
    }

    export interface GetTrialParticipantStepResponse {
        id: number
        "doc_id": uuid.UUID
        "trial_step_doc_id": uuid.UUID
        "participant_doc_id": uuid.UUID
        "step_status": string
        "step_name": string
        "step_type": string
        "step_number": number
        "appointment_date": string
        "start_date": string
        "end_date": string
        "step_complete_date": string
        "visibility_day_start": number
        "target_day": number
        "visibility_day_end": number
        "auto_shift_on_delay": boolean
        "calculated_start_date": string
        "calculated_target_date": string
        "calculated_end_date": string
        "shifted_days": number
        "derived_status": entities.DerivedStatus
        "form_submissions": StepFormSubmissionSummary[]
        notes: StepNoteResponse[]
    }

    export interface GetTrialStepResponse {
        id: number
        "doc_id": uuid.UUID
        "trial_doc_id": uuid.UUID
        "step_name": string
        "step_type": string
        "step_number": number
        duration: number
        description?: string
        "service_doc_id": uuid.UUID
        "service_name": string
        "algorithm_doc_id": uuid.UUID
        "algorithm_name": string
        "auto_progress": boolean
        metadata: JSONValue
        "booking_window"?: number
        "eligibility_form_id"?: string
        "property_name"?: string
        "formio_form_id"?: string
        "formio_form_type"?: string
        "video_enabled": boolean
        "visibility_day_start": number
        "target_day": number
        "visibility_day_end": number
        "auto_shift_on_delay": boolean
    }

    export interface InitialAuditRequest {
        "change_reason": entities.ChangeReasonType
        "change_notes": string
    }

    export interface InitialSignatureRequest {
        meaning: string
        "ip_address"?: string
        "user_agent"?: string
    }

    export interface ListAdverseEventAuditRecordsResponse {
        audits: AdverseEventAuditResponse[]
    }

    export interface ListAdverseEventsResponse {
        "adverse_events": AdverseEventsResponse[]
        pagination: shared.Pagination
    }

    export interface ListClinicProfilesRequest {
        RequestedItemsPerPage: number
        RequestedPageNumber: number
        SortColumn?: string
        SortOrder?: string
    }

    export interface ListClinicProfilesResponse {
        profiles: ClinicProfileResponse[]
        pagination: shared.Pagination
    }

    export interface ListClinicTrialsResponse {
        trials: ClinicTrialResponse[]
    }

    export interface ListClinicsRequest {
        RequestedItemsPerPage: number
        RequestedPageNumber: number
        ExcludeClinicDocIDs?: string[]
    }

    export interface ListClinicsResponse {
        clinics: ClinicResponse[]
        pagination: shared.Pagination
    }

    export interface ListParentOrChildGroupsOnlyRequest {
        IsParentOnly: boolean
        IsChildOnly: boolean
    }

    export interface ListParentOrChildGroupsOnlyResponse {
        groups: TrialGroupWithName[]
    }

    /**
     * ListParticipantAdverseEventsRequest is the request payload for ListParticipantAdverseEvents
     */
    export interface ListParticipantAdverseEventsRequest {
        "items_per_page": number
        "page_number": number
        type?: string
    }

    export interface ListParticipantAdverseEventsSummariesResponse {
        Summaries: AdverseEventsSummary[]
    }

    /**
     * ListParticipantFormSubmissionsResponse is returned when listing form submissions for a participant.
     */
    export interface ListParticipantFormSubmissionsResponse {
        "form_submissions": FormSubmissionResponse[]
    }

    export interface ListParticipantPet {
        "doc_id": string
        name: string
    }

    export interface ListParticipantUser {
        "doc_id": string
        name: string
        email: string
    }

    export interface ListParticipantsRequest {
        /**
         * sort column name
         */
        SortColumn?: string

        /**
         * filter by step status field
         */
        StepStatuses?: string[]

        /**
         * filter by participant status field
         */
        ParticipantStatuses?: string[]

        /**
         * filter by step name field
         */
        StepNames?: string[]

        /**
         * filter by participant parent group field
         */
        ParentGroupDocIDs?: string[]

        /**
         * filter by participant child group field
         */
        ChildGroupDocIDs?: string[]

        /**
         * filter by owner name field
         */
        UserName?: string

        /**
         * filter by user email field
         */
        UserEmail?: string

        /**
         * sort order e.g. ASC/DESC
         */
        SortOrder?: string

        /**
         * the number of results requested for the page
         */
        RequestedItemsPerPage: number

        /**
         * the page number requested
         */
        RequestedPageNumber: number
    }

    export interface ListParticipantsResponse {
        participants: ParticipantResponse[]
        pagination: shared.Pagination
    }

    /**
     * ListScreeningParticipantsParams represents the query parameters for listing screening participants
     */
    export interface ListScreeningParticipantsParams {
        Status?: string
        Search?: string
        ItemsPerPage?: number
        PageNumber?: number
    }

    /**
     * ListScreeningParticipantsResponse represents the response for listing screening participants
     */
    export interface ListScreeningParticipantsResponse {
        "screening_participants": ScreeningParticipantResponse[]
        total: number
        "page_number": number
        "items_per_page": number
    }

    /**
     * ListSignaturesResponse represents the response for listing signatures
     */
    export interface ListSignaturesResponse {
        signatures: SignatureResponse[]
    }

    export interface ListStepNotesResponse {
        notes: StepNoteResponse[]
    }

    export interface ListStepVideosResponse {
        videos: StepVideoResponse[]
    }

    export interface ListTrialClinicsResponse {
        clinics: TrialClinicResponse[]
    }

    export interface ListTrialConsultationsResponse {
        consultations: TrialConsultationResponse[]
    }

    export interface ListTrialGroupsResponse {
        groups: TrialGroupResponse[]
    }

    export interface ListTrialIssueTypesResponse {
        "issue_types": TrialIssueTypeResponse[]
    }

    export interface ListTrialParticipantStepHistory {
        history: StepHistory[]
        pagination: shared.Pagination
    }

    export interface ListTrialParticipantStepHistoryRequest {
        /**
         * filter by category field
         * values: Trial Step / Consultation / Algorithm / Adverse Event
         */
        Categories?: string[]

        /**
         * filter by event field
         * values: Step status updated / Appointment status updated / Algorithm completed
         */
        Events?: string[]

        /**
         * filter by type field
         * every step / service / algorithm name attached to the trial
         */
        Type?: string

        /**
         * filter by status field
         * values: Upcoming / In Progress / Complete / Skipped / Missed / Failed / Action Required / On Hold
         */
        Statuses?: string[]

        /**
         * filter by adverse events field values = yes, no, all
         */
        HasAdverseEvents?: string

        /**
         * filter by notes field values = yes, no, all
         */
        HasNotes?: string

        /**
         * sort column e.g. date / category / event/ type / status / adverse_event / notes
         */
        SortColumn?: string

        /**
         * sort order e.g. ASC/DESC
         */
        SortOrder?: string

        RequestedItemsPerPage: number
        RequestedPageNumber: number
    }

    export interface ListTrialParticipantStepResponse {
        steps: TrialParticipantStepResponse[]
        "adverse_events": AdverseEventsResponse[]
        pagination: shared.Pagination
    }

    export interface ListTrialParticipantStepsRequest {
        RequestedItemsPerPage?: number
        RequestedPageNumber?: number
    }

    export interface ListTrialStepsRequest {
        RequestedItemsPerPage: number
        RequestedPageNumber: number
    }

    export interface ListTrialStepsResponse {
        steps: GetTrialStepResponse[]
        pagination: shared.Pagination
    }

    export interface ListTrialsRequest {
        /**
         * the number of results requested for the page
         */
        RequestedItemsPerPage: number

        /**
         * the page number requested
         */
        RequestedPageNumber: number

        /**
         * filter by owner email field
         */
        UserEmail?: string
    }

    export interface ListTrialsResponse {
        trials: TrialResponse[]
        pagination: shared.Pagination
    }

    export interface NextStepRequest {
        reason: string
    }

    export interface ParticipantResponse {
        "doc_id": string
        user: ListParticipantUser
        pet: ListParticipantPet
        "participant_status": string
        "parent_group_doc_id"?: uuid.UUID
        "parent_group_name"?: string
        "child_group_doc_id"?: uuid.UUID
        "child_group_name"?: string
        "are_groups_enabled": boolean
        step: ActiveStep
        "clinic_doc_id"?: uuid.UUID
        "clinic_name"?: string
        "has_open_reported_issues": boolean
    }

    export interface ParticipantStep {
        "participant_doc_id": string
        "participant_step_doc_id": string
    }

    export interface ParticipantStepHistoryAdverseEvent {
        "linked_at": string
        "linked_by": string
        "adverse_event_doc_id": uuid.UUID
        "adverse_event_summary": string
    }

    export interface ParticipantStepHistoryAdverseEventResponse {
        "adverse_events": ParticipantStepHistoryAdverseEvent[]
    }

    export interface PreviousStepRequest {
        reason: string
    }

    export interface ReorderTrialStepsRequest {
        "source_doc_id": string
        "target_doc_id": string
    }

    /**
     * ScreeningParticipantFormSubmissionResponse represents form submission info in screening participant response
     */
    export interface ScreeningParticipantFormSubmissionResponse {
        "doc_id": uuid.UUID
        "form_name": string
        "form_data": JSONValue
        "form_version_id": number
        "created_at": string
    }

    /**
     * ScreeningParticipantPetResponse represents pet info in screening participant response
     */
    export interface ScreeningParticipantPetResponse {
        "doc_id": string
        name: string
        species: string
        breed?: string
        "date_of_birth": string
        gender: string
        neutered?: boolean
        "photo_url"?: string
    }

    /**
     * ScreeningParticipantResponse represents a screening participant in API responses
     */
    export interface ScreeningParticipantResponse {
        "doc_id": uuid.UUID
        "trial_doc_id": uuid.UUID
        "user_doc_id": uuid.UUID
        "pet_doc_id": uuid.UUID
        status: entities.ScreeningParticipantStatus
        "status_change_reason": string
        user?: ScreeningParticipantUserResponse
        pet?: ScreeningParticipantPetResponse
        "form_submission"?: ScreeningParticipantFormSubmissionResponse
        "created_at": string
        "updated_at": string
    }

    /**
     * ScreeningParticipantUserResponse represents user info in screening participant response
     */
    export interface ScreeningParticipantUserResponse {
        "doc_id": uuid.UUID
        email: string
        "first_name": string
        "last_name": string
    }

    export interface SetParticipantEntryDateRequest {
        /**
         * EntryDate is the participant's trial entry date in YYYY-MM-DD format.
         */
        "entry_date": string
    }

    export interface SetTrialAppointmentServiceRequest {
        "appointment_service_doc_id"?: string
    }

    export interface SetTrialChatServiceRequest {
        "chat_service_doc_id"?: string
    }

    export interface ShiftTimelineRequest {
        /**
         * FromStepNumber is the step number from which to start shifting (inclusive).
         */
        "from_step_number": number

        /**
         * Days is the number of days to shift (positive = forward, negative = backward).
         */
        days: number

        reason: string
    }

    /**
     * SignatureResponse represents a signature in API responses
     */
    export interface SignatureResponse {
        "doc_id": uuid.UUID
        meaning: string
        "signature_hash": string
        "form_submission_id"?: number
        "adverse_event_id"?: number
        "ip_address"?: string
        "user_agent"?: string
        "created_at": string
        "created_by": uuid.UUID
        "created_by_name": string
        "created_by_email": string
    }

    /**
     * StepFormSubmissionMetadata is a lightweight form submission for list endpoints (without form_data).
     */
    export interface StepFormSubmissionMetadata {
        "doc_id": uuid.UUID
        "form_type": string
        "form_name": string
        "created_at": string
        "completed_by": string
    }

    /**
     * StepFormSubmissionSummary is a form submission for inclusion on a step (includes form data).
     */
    export interface StepFormSubmissionSummary {
        "doc_id": uuid.UUID
        "form_type": string
        "form_name": string
        "form_data": JSONValue
        "created_at": string
        "completed_by": string
    }

    export interface StepHisotryNotesAudit {
        notes: string
        "created_by": string
        "created_at": string
    }

    export interface StepHisotryNotesAuditResponse {
        audits: StepHisotryNotesAudit[]
    }

    export interface StepHistory {
        "doc_id": uuid.UUID
        "user_doc_id": uuid.UUID
        "pet_doc_id": uuid.UUID
        "participant_step_doc_id": uuid.UUID
        category: string
        event: string
        type: string
        status: string
        "updated_at": string
        "updated_by": string
        reason: string
        "has_notes": boolean
        notes: string
        "service_doc_id": uuid.UUID
        "algorithm_doc_id": uuid.UUID
        "appointment_date": string
        "has_adverse_events": boolean
        "is_trial_step_event": boolean
    }

    export interface StepHistoryNotesAuditRequest {
        notes: string
    }

    export interface StepNoteResponse {
        "doc_id": uuid.UUID
        "clinician_id"?: number
        "staff_doc_id"?: string
        note: string
        "read_at"?: string
        "created_at": string
    }

    export interface StepVideoResponse {
        "doc_id": uuid.UUID
        "video_call_id": string
        "video_room_id"?: string
        "video_provider": string
        status: string
        "status_reason"?: string
        "created_at": string
        "updated_at": string
    }

    export interface ToggleClinicActiveRequest {
        "is_active": boolean
    }

    export interface ToggleClinicProfileActiveRequest {
        "is_active": boolean
    }

    export interface ToggleTrialClinicActiveRequest {
        "is_active": boolean
    }

    export interface TrialClinicResponse {
        "is_active": boolean
        "enrolled_at": string
        "created_at": string
        "updated_at": string
        "deleted_at": string
        clinic: ClinicResponse
    }

    export interface TrialConsultationResponse {
        "doc_id": uuid.UUID
        "trial_doc_id": uuid.UUID
        "trial_participant_doc_id": uuid.UUID
        "trial_participant_step_doc_id"?: uuid.UUID
        "chat_doc_id"?: uuid.UUID
        "appointment_doc_id"?: uuid.UUID
        "clinical_notes"?: string
        "staff_doc_id"?: uuid.UUID
        "staff_name"?: string
        status: entities.TrialConsultationStatus
        "created_at": string
        "updated_at": string
        "completed_at"?: string
        notes: StepNoteResponse[]
        "form_submissions": FormSubmissionResponse[]
        "adverse_events": ConsultationAdverseEventResponse[]
    }

    export interface TrialGroup {
        "doc_id": uuid.UUID
        name: string
        description: string
        "created_at": string
    }

    export interface TrialGroupResponse {
        "doc_id": uuid.UUID
        name: string
        description: string
        "created_at": string
        "child_groups": TrialGroup[]
    }

    export interface TrialGroupWithName {
        "doc_id": uuid.UUID
        name: string
    }

    export interface TrialIssueTypeResponse {
        "doc_id": uuid.UUID
        "form_io_id": string
        name: string
        "display_order": number
        "is_active": boolean
        visibility: entities.IssueTypeVisibility
        "adverse_event_type": entities.AdverseEventType
        "created_at": string
        "updated_at": string
    }

    export interface TrialParticipantStepResponse {
        id: number
        "doc_id": uuid.UUID
        "trial_step_doc_id": uuid.UUID
        "participant_doc_id": uuid.UUID
        "step_status": string
        "step_name": string
        "step_type": string
        "step_number": number
        "step_service_doc_id": uuid.UUID
        "appointment_date": string
        "start_date": string
        "end_date": string
        "updated_at": string
        "step_complete_date": string
        "auto_progress_datetime": string
        "step_auto_progress_datetime_missed": boolean
        "form_submissions": StepFormSubmissionMetadata[]
        "visibility_day_start": number
        "target_day": number
        "visibility_day_end": number
        "auto_shift_on_delay": boolean
        "calculated_start_date": string
        "calculated_target_date": string
        "calculated_end_date": string
        "shifted_days": number
        "derived_status": entities.DerivedStatus
    }

    export interface TrialResponse {
        id: number
        "doc_id": uuid.UUID
        name: string
        description: string
        status: string
        "adverse_events_form_io_id": string
        "are_groups_enabled": boolean
        "screening_enabled": boolean
        "application_screening_form_id": string
        "landing_page": string
        "clinic_management_enabled": boolean
        "scheduling_mode": string
        "trial_chat_service_doc_id"?: uuid.UUID
        "trial_appointment_service_doc_id"?: uuid.UUID
    }

    export interface UpdateAdverseEventRecordedAtRequest {
        "recorded_at": string
    }

    export interface UpdateAdverseEventRequest {
        "form_data": JSONValue
        "change_reason": entities.ChangeReasonType
        "change_notes": string
    }

    export interface UpdateAdverseEventSummaryRequest {
        summary: string
    }

    export interface UpdateAutoProgressDateRequest {
        /**
         * The date when a step should go in progress
         */
        "auto_progress_datetime"?: string
    }

    export interface UpdateClinicProfileRequest {
        "user_doc_id"?: uuid.UUID
        email?: string
        "full_name"?: string
        "license_number"?: string
        "phone_number"?: string
        discipline?: string
        "invite_status"?: string
    }

    export interface UpdateClinicRequest {
        name?: string
        "email_domain"?: string
        "address_line1"?: string
        "address_line2"?: string
        city?: string
        state?: string
        "postal_code"?: string
        country?: string
        phone?: string
        "contact_name"?: string
        "contact_phone_number"?: string
        "contact_email"?: string
    }

    export interface UpdateParticipantClinicRequest {
        "clinic_doc_id"?: uuid.UUID
    }

    export interface UpdateParticipantGroupRequest {
        "group_id": string
        "assign_random_group": boolean
    }

    export interface UpdateParticipantMetadataRequest {
        metadata: JSONValue
    }

    export interface UpdateParticipantStatusRequest {
        status: entities.ParticipantStatus
        reason: string
        source: string
    }

    /**
     * UpdateScreeningParticipantStatusRequest represents the request to update a screening participant status
     */
    export interface UpdateScreeningParticipantStatusRequest {
        status: string
        "clinic_doc_id"?: string
        "status_change_reason"?: string
    }

    export interface UpdateStepVideoStatusRequest {
        status: string
        "status_reason"?: string
    }

    export interface UpdateTrialGroupRequest {
        name: string
        description: string
    }

    export interface UpdateTrialGroupsStatusRequest {
        "are_groups_enabled": boolean
    }

    export interface UpdateTrialIssueTypeRequest {
        name?: string
        "display_order"?: number
        "is_active"?: boolean
        visibility?: entities.IssueTypeVisibility
        "adverse_event_type"?: entities.AdverseEventType
    }

    export interface UpdateTrialParticipantStepRequest {
        "step_status": string
        reason: string
        source: string
    }

    export interface UpdateTrialRequest {
        name: string
        description: string
        "adverse_events_form_io_id": string
        "screening_enabled": boolean
        "application_screening_form_id": string
        "landing_page": string
        "clinic_management_enabled": boolean
        "scheduling_mode"?: string
        "trial_chat_service_doc_id"?: string
    }

    export interface UpdateTrialStatusRequest {
        status: string
    }

    export interface UpdateTrialStepRequest {
        "step_name": string
        "step_type": string
        duration: number
        description?: string
        "service_doc_id": string
        "service_name": string
        "auto_progress": boolean
        metadata: JSONValue
        "booking_window"?: number
        "eligibility_form_id"?: string
        "property_name"?: string
        "formio_form_id"?: string
        "formio_form_type"?: string
        "video_enabled": boolean
        "visibility_day_start"?: number
        "target_day"?: number
        "visibility_day_end"?: number
        "auto_shift_on_delay": boolean
    }

    export interface VideoCallMemberRequest {
        "user_id": string
        role: string
    }

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.AddAdverseEventToParticipantStepHistory = this.AddAdverseEventToParticipantStepHistory.bind(this)
            this.BulkUpdateParticipantGroup = this.BulkUpdateParticipantGroup.bind(this)
            this.BulkUpdateParticipantsStatuses = this.BulkUpdateParticipantsStatuses.bind(this)
            this.BulkUpdateParticipantsStepStatuses = this.BulkUpdateParticipantsStepStatuses.bind(this)
            this.ClinicianListTrialParticipantSteps = this.ClinicianListTrialParticipantSteps.bind(this)
            this.CompleteTrialConsultation = this.CompleteTrialConsultation.bind(this)
            this.CreateAdverseEventSignature = this.CreateAdverseEventSignature.bind(this)
            this.CreateClinic = this.CreateClinic.bind(this)
            this.CreateClinicProfile = this.CreateClinicProfile.bind(this)
            this.CreateFormSubmissionSignature = this.CreateFormSubmissionSignature.bind(this)
            this.CreateNoteForFormSubmission = this.CreateNoteForFormSubmission.bind(this)
            this.CreateParticipant = this.CreateParticipant.bind(this)
            this.CreateParticipantAdverseEvent = this.CreateParticipantAdverseEvent.bind(this)
            this.CreateStaffFormSubmission = this.CreateStaffFormSubmission.bind(this)
            this.CreateStepNote = this.CreateStepNote.bind(this)
            this.CreateStepVideo = this.CreateStepVideo.bind(this)
            this.CreateTrial = this.CreateTrial.bind(this)
            this.CreateTrialClinic = this.CreateTrialClinic.bind(this)
            this.CreateTrialConsultation = this.CreateTrialConsultation.bind(this)
            this.CreateTrialGroup = this.CreateTrialGroup.bind(this)
            this.CreateTrialIssueType = this.CreateTrialIssueType.bind(this)
            this.CreateTrialStep = this.CreateTrialStep.bind(this)
            this.DeleteParticipant = this.DeleteParticipant.bind(this)
            this.DeleteParticipantStepHisotryAdverseEvent = this.DeleteParticipantStepHisotryAdverseEvent.bind(this)
            this.DeleteTrialClinic = this.DeleteTrialClinic.bind(this)
            this.DeleteTrialGroup = this.DeleteTrialGroup.bind(this)
            this.DeleteTrialIssueType = this.DeleteTrialIssueType.bind(this)
            this.DeleteTrialStep = this.DeleteTrialStep.bind(this)
            this.GetClinic = this.GetClinic.bind(this)
            this.GetClinicProfile = this.GetClinicProfile.bind(this)
            this.GetParticipant = this.GetParticipant.bind(this)
            this.GetParticipantAdverseEvent = this.GetParticipantAdverseEvent.bind(this)
            this.GetParticipantMetadata = this.GetParticipantMetadata.bind(this)
            this.GetScreeningParticipant = this.GetScreeningParticipant.bind(this)
            this.GetScreeningParticipantsStatusCounts = this.GetScreeningParticipantsStatusCounts.bind(this)
            this.GetSignature = this.GetSignature.bind(this)
            this.GetTrial = this.GetTrial.bind(this)
            this.GetTrialConsultation = this.GetTrialConsultation.bind(this)
            this.GetTrialGroup = this.GetTrialGroup.bind(this)
            this.GetTrialIssueType = this.GetTrialIssueType.bind(this)
            this.GetTrialParticipantStep = this.GetTrialParticipantStep.bind(this)
            this.GetTrialStep = this.GetTrialStep.bind(this)
            this.ListAdverseEventSignatures = this.ListAdverseEventSignatures.bind(this)
            this.ListClinicProfiles = this.ListClinicProfiles.bind(this)
            this.ListClinicTrials = this.ListClinicTrials.bind(this)
            this.ListClinics = this.ListClinics.bind(this)
            this.ListFormSubmissionSignatures = this.ListFormSubmissionSignatures.bind(this)
            this.ListNotesForFormSubmission = this.ListNotesForFormSubmission.bind(this)
            this.ListParentOrChildGroupsOnly = this.ListParentOrChildGroupsOnly.bind(this)
            this.ListParticipantAdverseEventAuditRecords = this.ListParticipantAdverseEventAuditRecords.bind(this)
            this.ListParticipantAdverseEvents = this.ListParticipantAdverseEvents.bind(this)
            this.ListParticipantAdverseEventsByFormSubmission = this.ListParticipantAdverseEventsByFormSubmission.bind(this)
            this.ListParticipantAdverseEventsSummaries = this.ListParticipantAdverseEventsSummaries.bind(this)
            this.ListParticipantFormSubmissions = this.ListParticipantFormSubmissions.bind(this)
            this.ListParticipantStepHisotryAdverseEvents = this.ListParticipantStepHisotryAdverseEvents.bind(this)
            this.ListParticipants = this.ListParticipants.bind(this)
            this.ListScreeningParticipants = this.ListScreeningParticipants.bind(this)
            this.ListStepNotes = this.ListStepNotes.bind(this)
            this.ListStepVideos = this.ListStepVideos.bind(this)
            this.ListTrialClinics = this.ListTrialClinics.bind(this)
            this.ListTrialConsultations = this.ListTrialConsultations.bind(this)
            this.ListTrialGroups = this.ListTrialGroups.bind(this)
            this.ListTrialIssueTypes = this.ListTrialIssueTypes.bind(this)
            this.ListTrialParticipantStepHisotryNotesAuidit = this.ListTrialParticipantStepHisotryNotesAuidit.bind(this)
            this.ListTrialParticipantSteps = this.ListTrialParticipantSteps.bind(this)
            this.ListTrialParticipantStepsHistory = this.ListTrialParticipantStepsHistory.bind(this)
            this.ListTrialSteps = this.ListTrialSteps.bind(this)
            this.ListTrials = this.ListTrials.bind(this)
            this.NextStep = this.NextStep.bind(this)
            this.PreviousStep = this.PreviousStep.bind(this)
            this.ProcessAutoProgressSteps = this.ProcessAutoProgressSteps.bind(this)
            this.ProcessMissedSteps = this.ProcessMissedSteps.bind(this)
            this.RecalculateTimeline = this.RecalculateTimeline.bind(this)
            this.ReorderTrialSteps = this.ReorderTrialSteps.bind(this)
            this.RestoreTrialClinic = this.RestoreTrialClinic.bind(this)
            this.SetParticipantEntryDate = this.SetParticipantEntryDate.bind(this)
            this.SetTrialAppointmentService = this.SetTrialAppointmentService.bind(this)
            this.SetTrialChatService = this.SetTrialChatService.bind(this)
            this.ShiftTimeline = this.ShiftTimeline.bind(this)
            this.TerminateTrialConsultation = this.TerminateTrialConsultation.bind(this)
            this.ToggleClinicActive = this.ToggleClinicActive.bind(this)
            this.ToggleClinicProfileActive = this.ToggleClinicProfileActive.bind(this)
            this.ToggleTrialClinicActive = this.ToggleTrialClinicActive.bind(this)
            this.UpdateClinic = this.UpdateClinic.bind(this)
            this.UpdateClinicProfile = this.UpdateClinicProfile.bind(this)
            this.UpdateParticipantAdverseEvent = this.UpdateParticipantAdverseEvent.bind(this)
            this.UpdateParticipantAdverseEventRecordedAt = this.UpdateParticipantAdverseEventRecordedAt.bind(this)
            this.UpdateParticipantAdverseEventSummary = this.UpdateParticipantAdverseEventSummary.bind(this)
            this.UpdateParticipantClinic = this.UpdateParticipantClinic.bind(this)
            this.UpdateParticipantGroup = this.UpdateParticipantGroup.bind(this)
            this.UpdateParticipantMetadata = this.UpdateParticipantMetadata.bind(this)
            this.UpdateParticipantStatus = this.UpdateParticipantStatus.bind(this)
            this.UpdateParticipantStepHistoryNotes = this.UpdateParticipantStepHistoryNotes.bind(this)
            this.UpdateScreeningParticipantStatus = this.UpdateScreeningParticipantStatus.bind(this)
            this.UpdateStepVideoStatus = this.UpdateStepVideoStatus.bind(this)
            this.UpdateTrial = this.UpdateTrial.bind(this)
            this.UpdateTrialGroup = this.UpdateTrialGroup.bind(this)
            this.UpdateTrialGroupsStatus = this.UpdateTrialGroupsStatus.bind(this)
            this.UpdateTrialIssueType = this.UpdateTrialIssueType.bind(this)
            this.UpdateTrialParticipantStepAutoProgressDate = this.UpdateTrialParticipantStepAutoProgressDate.bind(this)
            this.UpdateTrialParticipantStepStatus = this.UpdateTrialParticipantStepStatus.bind(this)
            this.UpdateTrialStatus = this.UpdateTrialStatus.bind(this)
            this.UpdateTrialStep = this.UpdateTrialStep.bind(this)
            this.VerifyClinicProfileEmail = this.VerifyClinicProfileEmail.bind(this)
        }

        /**
         * AddAdverseEventToParticipantStepHistory links adverse event to participant step history
         */
        public async AddAdverseEventToParticipantStepHistory(trial_doc_id: string, participant_doc_id: string, step_doc_id: string, step_history_doc_id: string, params: AddAdverseEventToParticipantStepHistoryRequest): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/v1/trials/${encodeURIComponent(trial_doc_id)}/participant/${encodeURIComponent(participant_doc_id)}/steps/${encodeURIComponent(step_doc_id)}/steps-history/${encodeURIComponent(step_history_doc_id)}/adverse-events`, JSON.stringify(params))
        }

        /**
         * BulkUpdateParticipantGroup updates multiple participants' trial group at once
         */
        public async BulkUpdateParticipantGroup(trial_doc_id: string, params: BulkUpdateParticipantGroupRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PATCH", `/v1/trials/${encodeURIComponent(trial_doc_id)}/update-participants-group`, JSON.stringify(params))
        }

        /**
         * BulkUpdateParticipantsStatuses updates multiple participants' trial status at once
         */
        public async BulkUpdateParticipantsStatuses(trial_doc_id: string, params: BulkUpdateParticipantsStatusesRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PATCH", `/v1/trials/${encodeURIComponent(trial_doc_id)}/update-participants-statuses`, JSON.stringify(params))
        }

        /**
         * BulkUpdateParticipantsStepStatuses updates multiple participants' step status at once
         */
        public async BulkUpdateParticipantsStepStatuses(trial_doc_id: string, params: BulkUpdateParticipantsStepStatusesRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PATCH", `/v1/trials/${encodeURIComponent(trial_doc_id)}/update-participants-step-statuses`, JSON.stringify(params))
        }

        /**
         * ListClinicianParticipantSteps returns all steps for a participant in a trial.
         * Restricted to clinicians whose clinic matches the participant's clinic (tenant isolation).
         */
        public async ClinicianListTrialParticipantSteps(trial_doc_id: string, participant_doc_id: string, params: ListTrialParticipantStepsRequest): Promise<ListTrialParticipantStepResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "items_per_page": params.RequestedItemsPerPage === undefined ? undefined : String(params.RequestedItemsPerPage),
                "page_number":    params.RequestedPageNumber === undefined ? undefined : String(params.RequestedPageNumber),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/clinician/trials/${encodeURIComponent(trial_doc_id)}/participants/${encodeURIComponent(participant_doc_id)}/steps`, undefined, {query})
            return await resp.json() as ListTrialParticipantStepResponse
        }

        /**
         * CompleteTrialConsultation marks a consultation as completed, allowing the participant to start a new one.
         * If the consultation is linked to a Studies Consultation step, that step is also completed.
         */
        public async CompleteTrialConsultation(trial_doc_id: string, participant_doc_id: string, consultation_doc_id: string): Promise<void> {
            await this.baseClient.callTypedAPI("PATCH", `/v1/trials/${encodeURIComponent(trial_doc_id)}/participants/${encodeURIComponent(participant_doc_id)}/consultations/${encodeURIComponent(consultation_doc_id)}/complete`)
        }

        /**
         * CreateAdverseEventSignature creates a signature for an adverse event
         */
        public async CreateAdverseEventSignature(trial_doc_id: string, participant_doc_id: string, adverse_event_doc_id: string, params: CreateSignatureRequest): Promise<CreateSignatureResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/trials/${encodeURIComponent(trial_doc_id)}/participants/${encodeURIComponent(participant_doc_id)}/adverse-events/${encodeURIComponent(adverse_event_doc_id)}/signatures`, JSON.stringify(params))
            return await resp.json() as CreateSignatureResponse
        }

        /**
         * CreateClinic creates a new clinic
         */
        public async CreateClinic(params: CreateClinicRequest): Promise<CreateClinicResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/clinics`, JSON.stringify(params))
            return await resp.json() as CreateClinicResponse
        }

        /**
         * CreateClinicProfile creates a new profile for a clinic
         */
        public async CreateClinicProfile(clinic_doc_id: string, params: CreateClinicProfileRequest): Promise<CreateClinicProfileResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/clinics/${encodeURIComponent(clinic_doc_id)}/profiles`, JSON.stringify(params))
            return await resp.json() as CreateClinicProfileResponse
        }

        /**
         * CreateFormSubmissionSignature creates a signature for a form submission
         */
        public async CreateFormSubmissionSignature(trial_doc_id: string, participant_doc_id: string, form_submission_doc_id: string, params: CreateSignatureRequest): Promise<CreateSignatureResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/trials/${encodeURIComponent(trial_doc_id)}/participants/${encodeURIComponent(participant_doc_id)}/form-submissions/${encodeURIComponent(form_submission_doc_id)}/signatures`, JSON.stringify(params))
            return await resp.json() as CreateSignatureResponse
        }

        /**
         * CreateNoteForFormSubmission creates a note for a form submission (on the linked participant step when present, otherwise on the submission only).
         */
        public async CreateNoteForFormSubmission(trial_doc_id: string, participant_doc_id: string, form_submission_doc_id: string, params: CreateStepNoteRequest): Promise<CreateStepNoteResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/trials/${encodeURIComponent(trial_doc_id)}/participants/${encodeURIComponent(participant_doc_id)}/form-submissions/${encodeURIComponent(form_submission_doc_id)}/notes`, JSON.stringify(params))
            return await resp.json() as CreateStepNoteResponse
        }

        /**
         * CreateParticipant creates a trial participant
         */
        public async CreateParticipant(trial_doc_id: string, params: CreateParticipantRequest): Promise<CreateParticipantResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/trials/${encodeURIComponent(trial_doc_id)}/participants`, JSON.stringify(params))
            return await resp.json() as CreateParticipantResponse
        }

        /**
         * CreateParticipantAdverseEvent creates a new adverse event
         */
        public async CreateParticipantAdverseEvent(trial_doc_id: string, participant_doc_id: string, params: CreateAdverseEventRequest): Promise<CreateAdverseEventResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/trials/${encodeURIComponent(trial_doc_id)}/participants/${encodeURIComponent(participant_doc_id)}/adverse-events`, JSON.stringify(params))
            return await resp.json() as CreateAdverseEventResponse
        }

        /**
         * CreateStaffFormSubmission creates a form submission on behalf of a trial participant, attributed to the authenticated staff profile.
         */
        public async CreateStaffFormSubmission(trial_doc_id: string, participant_doc_id: string, params: CreateStaffFormSubmissionRequest): Promise<CreateFormSubmissionResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/trials/${encodeURIComponent(trial_doc_id)}/participants/${encodeURIComponent(participant_doc_id)}/staff-form-submissions`, JSON.stringify(params))
            return await resp.json() as CreateFormSubmissionResponse
        }

        /**
         * CreateStepNote creates a new note for a participant step
         */
        public async CreateStepNote(trial_doc_id: string, participant_doc_id: string, step_doc_id: string, params: CreateStepNoteRequest): Promise<CreateStepNoteResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/trials/${encodeURIComponent(trial_doc_id)}/participants/${encodeURIComponent(participant_doc_id)}/steps/${encodeURIComponent(step_doc_id)}/notes`, JSON.stringify(params))
            return await resp.json() as CreateStepNoteResponse
        }

        /**
         * CreateStepVideo creates a new video session for a participant step
         */
        public async CreateStepVideo(trial_doc_id: string, participant_doc_id: string, step_doc_id: string, params: CreateStepVideoRequest): Promise<CreateStepVideoResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/trials/${encodeURIComponent(trial_doc_id)}/participants/${encodeURIComponent(participant_doc_id)}/steps/${encodeURIComponent(step_doc_id)}/videos`, JSON.stringify(params))
            return await resp.json() as CreateStepVideoResponse
        }

        /**
         * CreateTrial creates new trial
         */
        public async CreateTrial(params: CreateTrialRequest): Promise<CreateTrialResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/trials`, JSON.stringify(params))
            return await resp.json() as CreateTrialResponse
        }

        /**
         * CreateTrialClinic associates a clinic with a trial
         */
        public async CreateTrialClinic(trial_doc_id: string, params: CreateTrialClinicRequest): Promise<CreateTrialClinicResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/trials/${encodeURIComponent(trial_doc_id)}/clinics`, JSON.stringify(params))
            return await resp.json() as CreateTrialClinicResponse
        }

        /**
         * CreateTrialConsultation creates a consultation record for a participant.
         * If the participant already has an open consultation of the same type (chat or appointment), returns the existing consultation instead of creating a new one.
         */
        public async CreateTrialConsultation(trial_doc_id: string, participant_doc_id: string, params: CreateTrialConsultationRequest): Promise<TrialConsultationResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/trials/${encodeURIComponent(trial_doc_id)}/participants/${encodeURIComponent(participant_doc_id)}/consultations`, JSON.stringify(params))
            return await resp.json() as TrialConsultationResponse
        }

        /**
         * CreateTrialGroup creates a new trial group
         */
        public async CreateTrialGroup(trial_doc_id: string, params: CreateTrialGroupRequest): Promise<CreateTrialGroupResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/trials/${encodeURIComponent(trial_doc_id)}/groups`, JSON.stringify(params))
            return await resp.json() as CreateTrialGroupResponse
        }

        /**
         * CreateTrialIssueType creates a new issue type for a trial
         */
        public async CreateTrialIssueType(trial_doc_id: string, params: CreateTrialIssueTypeRequest): Promise<CreateTrialIssueTypeResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/trials/${encodeURIComponent(trial_doc_id)}/issue-types`, JSON.stringify(params))
            return await resp.json() as CreateTrialIssueTypeResponse
        }

        /**
         * CreateTrialStep creates a new trial step
         */
        public async CreateTrialStep(trial_doc_id: string, params: CreateTrialStepRequest): Promise<CreateTrialStepResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/trials/${encodeURIComponent(trial_doc_id)}/steps`, JSON.stringify(params))
            return await resp.json() as CreateTrialStepResponse
        }

        /**
         * Delete Participant
         * This endpoint soft deletes a participant.
         */
        public async DeleteParticipant(trial_doc_id: string, participant_doc_id: string, params: DeleteParticipantRequest): Promise<void> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                reason: params.reason,
            })

            await this.baseClient.callTypedAPI("DELETE", `/v1/trials/${encodeURIComponent(trial_doc_id)}/participants/${encodeURIComponent(participant_doc_id)}`, undefined, {query})
        }

        /**
         * DeleteParticipantStepHisotryAdverseEvent retrieves adverse events for participant step history event
         */
        public async DeleteParticipantStepHisotryAdverseEvent(trial_doc_id: string, participant_doc_id: string, step_doc_id: string, step_history_doc_id: string, adverse_event_doc_id: string): Promise<void> {
            await this.baseClient.callTypedAPI("DELETE", `/v1/trials/${encodeURIComponent(trial_doc_id)}/participant/${encodeURIComponent(participant_doc_id)}/steps/${encodeURIComponent(step_doc_id)}/steps-history/${encodeURIComponent(step_history_doc_id)}/adverse-events/${encodeURIComponent(adverse_event_doc_id)}`)
        }

        /**
         * DeleteTrialClinic removes a clinic from a trial
         */
        public async DeleteTrialClinic(trial_doc_id: string, clinic_doc_id: string): Promise<void> {
            await this.baseClient.callTypedAPI("DELETE", `/v1/trials/${encodeURIComponent(trial_doc_id)}/clinics/${encodeURIComponent(clinic_doc_id)}`)
        }

        /**
         * DeleteTrialGroup deletes an existing trial group and its subgroups
         */
        public async DeleteTrialGroup(trial_doc_id: string, group_doc_id: string): Promise<void> {
            await this.baseClient.callTypedAPI("DELETE", `/v1/trials/${encodeURIComponent(trial_doc_id)}/groups/${encodeURIComponent(group_doc_id)}`)
        }

        /**
         * DeleteTrialIssueType deletes an issue type
         */
        public async DeleteTrialIssueType(trial_doc_id: string, issue_type_doc_id: string): Promise<void> {
            await this.baseClient.callTypedAPI("DELETE", `/v1/trials/${encodeURIComponent(trial_doc_id)}/issue-types/${encodeURIComponent(issue_type_doc_id)}`)
        }

        /**
         * DeleteTrialStep deletes a trial step if the trial is in Draft status
         */
        public async DeleteTrialStep(trial_doc_id: string, step_doc_id: string): Promise<void> {
            await this.baseClient.callTypedAPI("DELETE", `/v1/trials/${encodeURIComponent(trial_doc_id)}/steps/${encodeURIComponent(step_doc_id)}`)
        }

        /**
         * GetClinic gets a specific clinic
         */
        public async GetClinic(clinic_doc_id: string): Promise<ClinicResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/clinics/${encodeURIComponent(clinic_doc_id)}`)
            return await resp.json() as ClinicResponse
        }

        /**
         * GetClinicProfile gets a specific clinic profile
         */
        public async GetClinicProfile(clinic_doc_id: string, profile_doc_id: string): Promise<ClinicProfileResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/clinics/${encodeURIComponent(clinic_doc_id)}/profiles/${encodeURIComponent(profile_doc_id)}`)
            return await resp.json() as ClinicProfileResponse
        }

        /**
         * GetParticipant fetches a trial participant by doc_id
         */
        public async GetParticipant(trial_doc_id: string, participant_doc_id: string): Promise<GetParticipantResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/trials/${encodeURIComponent(trial_doc_id)}/participants/${encodeURIComponent(participant_doc_id)}`)
            return await resp.json() as GetParticipantResponse
        }

        /**
         * GetParticipantAdverseEvent gets a specific adverse event
         */
        public async GetParticipantAdverseEvent(trial_doc_id: string, participant_doc_id: string, adverse_event_doc_id: string): Promise<AdverseEventsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/trials/${encodeURIComponent(trial_doc_id)}/participants/${encodeURIComponent(participant_doc_id)}/adverse-events/${encodeURIComponent(adverse_event_doc_id)}`)
            return await resp.json() as AdverseEventsResponse
        }

        /**
         * GetParticipantMetadata fetches a trial participant's metadata
         */
        public async GetParticipantMetadata(trial_doc_id: string, participant_doc_id: string): Promise<GetParticipantMetadataResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/trials/${encodeURIComponent(trial_doc_id)}/participants/${encodeURIComponent(participant_doc_id)}/metadata`)
            return await resp.json() as GetParticipantMetadataResponse
        }

        /**
         * GetScreeningParticipant retrieves a screening participant by doc ID
         */
        public async GetScreeningParticipant(trial_doc_id: string, screening_participant_doc_id: string): Promise<ScreeningParticipantResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/internal/trials/${encodeURIComponent(trial_doc_id)}/screening-participants/${encodeURIComponent(screening_participant_doc_id)}`)
            return await resp.json() as ScreeningParticipantResponse
        }

        /**
         * GetScreeningParticipantsStatusCounts returns screening participant counts grouped by status
         */
        public async GetScreeningParticipantsStatusCounts(trial_doc_id: string): Promise<GetScreeningParticipantsStatusCountsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/internal/trials/${encodeURIComponent(trial_doc_id)}/screening-participant-status-counts`)
            return await resp.json() as GetScreeningParticipantsStatusCountsResponse
        }

        /**
         * GetSignature retrieves a specific signature by doc ID
         */
        public async GetSignature(signature_doc_id: string): Promise<SignatureResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/signatures/${encodeURIComponent(signature_doc_id)}`)
            return await resp.json() as SignatureResponse
        }

        /**
         * GetTrial fetches a trial by doc_id
         */
        public async GetTrial(doc_id: string): Promise<TrialResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/trials/${encodeURIComponent(doc_id)}`)
            return await resp.json() as TrialResponse
        }

        /**
         * GetTrialConsultation returns a single consultation by ID.
         */
        public async GetTrialConsultation(consultation_doc_id: string): Promise<TrialConsultationResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/trial-consultations/${encodeURIComponent(consultation_doc_id)}`)
            return await resp.json() as TrialConsultationResponse
        }

        /**
         * GetTrialGroup fetches a trial group by its DocID
         */
        public async GetTrialGroup(trial_doc_id: string, group_doc_id: string): Promise<TrialGroupResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/trials/${encodeURIComponent(trial_doc_id)}/groups/${encodeURIComponent(group_doc_id)}`)
            return await resp.json() as TrialGroupResponse
        }

        /**
         * GetTrialIssueType gets a specific issue type
         */
        public async GetTrialIssueType(trial_doc_id: string, issue_type_doc_id: string): Promise<TrialIssueTypeResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/trials/${encodeURIComponent(trial_doc_id)}/issue-types/${encodeURIComponent(issue_type_doc_id)}`)
            return await resp.json() as TrialIssueTypeResponse
        }

        /**
         * GetTrialParticipantStep retrieves a trial step for a participant
         */
        public async GetTrialParticipantStep(trial_doc_id: string, participant_doc_id: string, participant_step_doc_id: string): Promise<GetTrialParticipantStepResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/trials/${encodeURIComponent(trial_doc_id)}/participant/${encodeURIComponent(participant_doc_id)}/steps/${encodeURIComponent(participant_step_doc_id)}`)
            return await resp.json() as GetTrialParticipantStepResponse
        }

        /**
         * GetTrialStep fetches a trial step by its DocID
         */
        public async GetTrialStep(trial_doc_id: string, step_doc_id: string): Promise<GetTrialStepResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/trials/${encodeURIComponent(trial_doc_id)}/steps/${encodeURIComponent(step_doc_id)}`)
            return await resp.json() as GetTrialStepResponse
        }

        /**
         * ListAdverseEventSignatures lists all signatures for an adverse event
         */
        public async ListAdverseEventSignatures(trial_doc_id: string, participant_doc_id: string, adverse_event_doc_id: string): Promise<ListSignaturesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/trials/${encodeURIComponent(trial_doc_id)}/participants/${encodeURIComponent(participant_doc_id)}/adverse-events/${encodeURIComponent(adverse_event_doc_id)}/signatures`)
            return await resp.json() as ListSignaturesResponse
        }

        /**
         * ListClinicProfiles lists all profiles for a clinic with pagination
         */
        public async ListClinicProfiles(clinic_doc_id: string, params: ListClinicProfilesRequest): Promise<ListClinicProfilesResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "items_per_page": String(params.RequestedItemsPerPage),
                "page_number":    String(params.RequestedPageNumber),
                "sort_column":    params.SortColumn,
                "sort_order":     params.SortOrder,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/clinics/${encodeURIComponent(clinic_doc_id)}/profiles`, undefined, {query})
            return await resp.json() as ListClinicProfilesResponse
        }

        /**
         * ListClinicTrials lists all trials for a clinic
         */
        public async ListClinicTrials(clinic_doc_id: string): Promise<ListClinicTrialsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/clinics/${encodeURIComponent(clinic_doc_id)}/trials`)
            return await resp.json() as ListClinicTrialsResponse
        }

        /**
         * ListClinics lists all clinics with pagination
         */
        public async ListClinics(params: ListClinicsRequest): Promise<ListClinicsResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "exclude_clinic_doc_ids": params.ExcludeClinicDocIDs?.map((v) => v),
                "items_per_page":         String(params.RequestedItemsPerPage),
                "page_number":            String(params.RequestedPageNumber),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/clinics`, undefined, {query})
            return await resp.json() as ListClinicsResponse
        }

        /**
         * ListFormSubmissionSignatures lists all signatures for a form submission
         */
        public async ListFormSubmissionSignatures(trial_doc_id: string, participant_doc_id: string, form_submission_doc_id: string): Promise<ListSignaturesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/trials/${encodeURIComponent(trial_doc_id)}/participants/${encodeURIComponent(participant_doc_id)}/form-submissions/${encodeURIComponent(form_submission_doc_id)}/signatures`)
            return await resp.json() as ListSignaturesResponse
        }

        /**
         * ListNotesForFormSubmission lists notes for a form submission (step notes when the submission has a step, otherwise notes stored on the submission).
         */
        public async ListNotesForFormSubmission(trial_doc_id: string, participant_doc_id: string, form_submission_doc_id: string): Promise<ListStepNotesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/trials/${encodeURIComponent(trial_doc_id)}/participants/${encodeURIComponent(participant_doc_id)}/form-submissions/${encodeURIComponent(form_submission_doc_id)}/notes`)
            return await resp.json() as ListStepNotesResponse
        }

        /**
         * ListParentOrChildGroupsOnly - Lists parent or child trial groups for a given trial DocID
         */
        public async ListParentOrChildGroupsOnly(trial_doc_id: string, params: ListParentOrChildGroupsOnlyRequest): Promise<ListParentOrChildGroupsOnlyResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "is_child_only":  String(params.IsChildOnly),
                "is_parent_only": String(params.IsParentOnly),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/trials/${encodeURIComponent(trial_doc_id)}/parent-or-child-groups-only`, undefined, {query})
            return await resp.json() as ListParentOrChildGroupsOnlyResponse
        }

        /**
         * ListParticipantAdverseEventAuditRecords lists all audit records for a specific adverse event
         */
        public async ListParticipantAdverseEventAuditRecords(trial_doc_id: string, participant_doc_id: string, adverse_event_doc_id: string): Promise<ListAdverseEventAuditRecordsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/trials/${encodeURIComponent(trial_doc_id)}/participants/${encodeURIComponent(participant_doc_id)}/adverse-events/${encodeURIComponent(adverse_event_doc_id)}/audits`)
            return await resp.json() as ListAdverseEventAuditRecordsResponse
        }

        /**
         * ListParticipantAdverseEvents lists all adverse events for a participant
         */
        public async ListParticipantAdverseEvents(trial_doc_id: string, participant_doc_id: string, params: ListParticipantAdverseEventsRequest): Promise<ListAdverseEventsResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "items_per_page": String(params["items_per_page"]),
                "page_number":    String(params["page_number"]),
                type:             params.type,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/trials/${encodeURIComponent(trial_doc_id)}/participants/${encodeURIComponent(participant_doc_id)}/adverse-events`, undefined, {query})
            return await resp.json() as ListAdverseEventsResponse
        }

        /**
         * ListParticipantAdverseEventsByFormSubmission lists all adverse events linked to a specific form submission
         */
        public async ListParticipantAdverseEventsByFormSubmission(trial_doc_id: string, participant_doc_id: string, form_submission_doc_id: string): Promise<ListAdverseEventsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/trials/${encodeURIComponent(trial_doc_id)}/participants/${encodeURIComponent(participant_doc_id)}/form-submissions/${encodeURIComponent(form_submission_doc_id)}/adverse-events`)
            return await resp.json() as ListAdverseEventsResponse
        }

        /**
         * ListParticipantAdverseEventsSummaries lists all adverse events' summaries for a participant
         */
        public async ListParticipantAdverseEventsSummaries(trial_doc_id: string, participant_doc_id: string): Promise<ListParticipantAdverseEventsSummariesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/trials/${encodeURIComponent(trial_doc_id)}/participants/${encodeURIComponent(participant_doc_id)}/adverse-events-summaries`)
            return await resp.json() as ListParticipantAdverseEventsSummariesResponse
        }

        /**
         * ListParticipantFormSubmissions lists all form submissions for a trial participant.
         */
        public async ListParticipantFormSubmissions(trial_doc_id: string, participant_doc_id: string): Promise<ListParticipantFormSubmissionsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/trials/${encodeURIComponent(trial_doc_id)}/participants/${encodeURIComponent(participant_doc_id)}/form-submissions`)
            return await resp.json() as ListParticipantFormSubmissionsResponse
        }

        /**
         * ListParticipantStepHisotryAdverseEvents retrieves adverse events for participant step history event
         */
        public async ListParticipantStepHisotryAdverseEvents(trial_doc_id: string, participant_doc_id: string, step_doc_id: string, step_history_doc_id: string): Promise<ParticipantStepHistoryAdverseEventResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/trials/${encodeURIComponent(trial_doc_id)}/participant/${encodeURIComponent(participant_doc_id)}/steps/${encodeURIComponent(step_doc_id)}/steps-history/${encodeURIComponent(step_history_doc_id)}/adverse-events`)
            return await resp.json() as ParticipantStepHistoryAdverseEventResponse
        }

        /**
         * ListParticipants fetches  all trial's participants with pagination
         */
        public async ListParticipants(trial_doc_id: string, params: ListParticipantsRequest): Promise<ListParticipantsResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "child_group_doc_ids":  params.ChildGroupDocIDs?.map((v) => v),
                "filter_column":        params.SortColumn,
                "items_per_page":       String(params.RequestedItemsPerPage),
                "page_number":          String(params.RequestedPageNumber),
                "parent_group_doc_ids": params.ParentGroupDocIDs?.map((v) => v),
                "participant_statuses": params.ParticipantStatuses?.map((v) => v),
                "sort_order":           params.SortOrder,
                "step_names":           params.StepNames?.map((v) => v),
                "step_statuses":        params.StepStatuses?.map((v) => v),
                "user_email":           params.UserEmail,
                "user_name":            params.UserName,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/trials/${encodeURIComponent(trial_doc_id)}/participants`, undefined, {query})
            return await resp.json() as ListParticipantsResponse
        }

        /**
         * ListScreeningParticipants lists screening participants for a trial
         */
        public async ListScreeningParticipants(trial_doc_id: string, params: ListScreeningParticipantsParams): Promise<ListScreeningParticipantsResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "items_per_page": params.ItemsPerPage === undefined ? undefined : String(params.ItemsPerPage),
                "page_number":    params.PageNumber === undefined ? undefined : String(params.PageNumber),
                search:           params.Search,
                status:           params.Status,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/internal/trials/${encodeURIComponent(trial_doc_id)}/screening-participants`, undefined, {query})
            return await resp.json() as ListScreeningParticipantsResponse
        }

        /**
         * ListStepNotes lists all notes for a participant step
         */
        public async ListStepNotes(trial_doc_id: string, participant_doc_id: string, step_doc_id: string): Promise<ListStepNotesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/trials/${encodeURIComponent(trial_doc_id)}/participants/${encodeURIComponent(participant_doc_id)}/steps/${encodeURIComponent(step_doc_id)}/notes`)
            return await resp.json() as ListStepNotesResponse
        }

        /**
         * ListStepVideos lists all video sessions for a participant step
         */
        public async ListStepVideos(trial_doc_id: string, participant_doc_id: string, step_doc_id: string): Promise<ListStepVideosResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/trials/${encodeURIComponent(trial_doc_id)}/participants/${encodeURIComponent(participant_doc_id)}/steps/${encodeURIComponent(step_doc_id)}/videos`)
            return await resp.json() as ListStepVideosResponse
        }

        /**
         * ListTrialClinics lists all clinics for a trial
         */
        public async ListTrialClinics(trial_doc_id: string): Promise<ListTrialClinicsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/trials/${encodeURIComponent(trial_doc_id)}/clinics`)
            return await resp.json() as ListTrialClinicsResponse
        }

        /**
         * ListTrialConsultations lists all consultations for a participant.
         */
        public async ListTrialConsultations(trial_doc_id: string, participant_doc_id: string): Promise<ListTrialConsultationsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/trials/${encodeURIComponent(trial_doc_id)}/participants/${encodeURIComponent(participant_doc_id)}/consultations`)
            return await resp.json() as ListTrialConsultationsResponse
        }

        /**
         * ListTrialGroups - Lists trial groups for a given trial DocID with pagination.
         */
        public async ListTrialGroups(trial_doc_id: string): Promise<ListTrialGroupsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/trials/${encodeURIComponent(trial_doc_id)}/groups`)
            return await resp.json() as ListTrialGroupsResponse
        }

        /**
         * ListTrialIssueTypes lists all issue types for a trial
         */
        public async ListTrialIssueTypes(trial_doc_id: string): Promise<ListTrialIssueTypesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/trials/${encodeURIComponent(trial_doc_id)}/issue-types`)
            return await resp.json() as ListTrialIssueTypesResponse
        }

        /**
         * ListTrialParticipantStepHisotryNotesAuidit retrieves notes audit for a participant step history log
         */
        public async ListTrialParticipantStepHisotryNotesAuidit(trial_doc_id: string, participant_doc_id: string, step_doc_id: string, step_history_doc_id: string): Promise<StepHisotryNotesAuditResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/trials/${encodeURIComponent(trial_doc_id)}/participant/${encodeURIComponent(participant_doc_id)}/steps/${encodeURIComponent(step_doc_id)}/steps-history/${encodeURIComponent(step_history_doc_id)}/notes-audit`)
            return await resp.json() as StepHisotryNotesAuditResponse
        }

        /**
         * ListTrialParticipantStep retrieves all trial steps for a participant, including form submissions per step.
         */
        public async ListTrialParticipantSteps(trial_doc_id: string, participant_doc_id: string, params: ListTrialParticipantStepsRequest): Promise<ListTrialParticipantStepResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "items_per_page": params.RequestedItemsPerPage === undefined ? undefined : String(params.RequestedItemsPerPage),
                "page_number":    params.RequestedPageNumber === undefined ? undefined : String(params.RequestedPageNumber),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/trials/${encodeURIComponent(trial_doc_id)}/participant/${encodeURIComponent(participant_doc_id)}/steps`, undefined, {query})
            return await resp.json() as ListTrialParticipantStepResponse
        }

        /**
         * ListTrialParticipantStepsHistory retrieves history for all trial steps for a participant
         */
        public async ListTrialParticipantStepsHistory(trial_doc_id: string, participant_doc_id: string, params: ListTrialParticipantStepHistoryRequest): Promise<ListTrialParticipantStepHistory> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                categories:           params.Categories?.map((v) => v),
                events:               params.Events?.map((v) => v),
                "filter_column":      params.SortColumn,
                "has_adverse_events": params.HasAdverseEvents,
                "has_notes":          params.HasNotes,
                "items_per_page":     String(params.RequestedItemsPerPage),
                "page_number":        String(params.RequestedPageNumber),
                "sort_order":         params.SortOrder,
                statuses:             params.Statuses?.map((v) => v),
                type:                 params.Type,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/trials/${encodeURIComponent(trial_doc_id)}/participant/${encodeURIComponent(participant_doc_id)}/steps-history`, undefined, {query})
            return await resp.json() as ListTrialParticipantStepHistory
        }

        /**
         * Lists trial steps for a given trial DocID with pagination.
         */
        public async ListTrialSteps(trial_doc_id: string, params: ListTrialStepsRequest): Promise<ListTrialStepsResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "items_per_page": String(params.RequestedItemsPerPage),
                "page_number":    String(params.RequestedPageNumber),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/trials/${encodeURIComponent(trial_doc_id)}/steps`, undefined, {query})
            return await resp.json() as ListTrialStepsResponse
        }

        /**
         * ListTrials fetches all trials with pagination
         */
        public async ListTrials(params: ListTrialsRequest): Promise<ListTrialsResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "items_per_page": String(params.RequestedItemsPerPage),
                "page_number":    String(params.RequestedPageNumber),
                "user_email":     params.UserEmail,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/trials`, undefined, {query})
            return await resp.json() as ListTrialsResponse
        }

        /**
         * NextStep completes current active steps and moves the participant to the next one
         */
        public async NextStep(trial_doc_id: string, participant_doc_id: string, params: NextStepRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PUT", `/v1/trials/${encodeURIComponent(trial_doc_id)}/participant/${encodeURIComponent(participant_doc_id)}/steps/next-step`, JSON.stringify(params))
        }

        /**
         * PreviousStep moves participant back to a previous step
         */
        public async PreviousStep(trial_doc_id: string, participant_doc_id: string, step_doc_id: string, params: PreviousStepRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PUT", `/v1/trials/${encodeURIComponent(trial_doc_id)}/participant/${encodeURIComponent(participant_doc_id)}/steps/previous-step/${encodeURIComponent(step_doc_id)}`, JSON.stringify(params))
        }

        /**
         * Run CRON job from portal
         * 
         * Automatically processes all steps that have auto progress date time set. Marks Participants' steps with In Progress status.
         */
        public async ProcessAutoProgressSteps(): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/v1/cron/process-trial-auto-progress-steps`)
        }

        /**
         * Run CRON job from portal
         * 
         * Automatically processes all steps that have been Missed. Marks Participant with Action Required status.
         */
        public async ProcessMissedSteps(): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/v1/cron/process-trial-missed-steps`)
        }

        /**
         * RecalculateTimeline recalculates all participant step dates from the participant's entry_date.
         */
        public async RecalculateTimeline(trial_doc_id: string, participant_doc_id: string): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/v1/trials/${encodeURIComponent(trial_doc_id)}/participant/${encodeURIComponent(participant_doc_id)}/timeline/recalculate`)
        }

        /**
         * Reorder trials steps
         * Updates the order of trial's steps. Only allowed if the trial is in Draft status
         */
        public async ReorderTrialSteps(trial_doc_id: string, params: ReorderTrialStepsRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PATCH", `/v1/trials/${encodeURIComponent(trial_doc_id)}/steps/steps-order`, JSON.stringify(params))
        }

        /**
         * RestoreTrialClinic restores a previously removed clinic-trial association
         */
        public async RestoreTrialClinic(trial_doc_id: string, clinic_doc_id: string): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/v1/trials/${encodeURIComponent(trial_doc_id)}/clinics/${encodeURIComponent(clinic_doc_id)}/restore`)
        }

        /**
         * SetParticipantEntryDate sets the entry date for a participant.
         */
        public async SetParticipantEntryDate(trial_doc_id: string, participant_doc_id: string, params: SetParticipantEntryDateRequest): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/v1/trials/${encodeURIComponent(trial_doc_id)}/participant/${encodeURIComponent(participant_doc_id)}/timeline/entry-date`, JSON.stringify(params))
        }

        /**
         * SetTrialAppointmentService configures which appointment service is used for trial appointments
         */
        public async SetTrialAppointmentService(doc_id: string, params: SetTrialAppointmentServiceRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PUT", `/v1/trials/${encodeURIComponent(doc_id)}/appointment-service`, JSON.stringify(params))
        }

        /**
         * SetTrialChatService configures which chat service is used for trial chats
         */
        public async SetTrialChatService(doc_id: string, params: SetTrialChatServiceRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PUT", `/v1/trials/${encodeURIComponent(doc_id)}/chat-service`, JSON.stringify(params))
        }

        /**
         * ShiftTimeline shifts all participant steps from a given step number by the specified number of days.
         */
        public async ShiftTimeline(trial_doc_id: string, participant_doc_id: string, params: ShiftTimelineRequest): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/v1/trials/${encodeURIComponent(trial_doc_id)}/participant/${encodeURIComponent(participant_doc_id)}/timeline/shift`, JSON.stringify(params))
        }

        /**
         * TerminateTrialConsultation closes the trial consultation record without completing a linked Studies Consultation step,
         * so the participant can open a new consultation while the step remains in progress.
         */
        public async TerminateTrialConsultation(trial_doc_id: string, participant_doc_id: string, consultation_doc_id: string): Promise<void> {
            await this.baseClient.callTypedAPI("PATCH", `/v1/trials/${encodeURIComponent(trial_doc_id)}/participants/${encodeURIComponent(participant_doc_id)}/consultations/${encodeURIComponent(consultation_doc_id)}/terminate`)
        }

        /**
         * ToggleClinicActive toggles the active status of a clinic
         */
        public async ToggleClinicActive(clinic_doc_id: string, params: ToggleClinicActiveRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PATCH", `/v1/clinics/${encodeURIComponent(clinic_doc_id)}/active`, JSON.stringify(params))
        }

        /**
         * ToggleClinicProfileActive toggles the active status of a clinic profile
         */
        public async ToggleClinicProfileActive(clinic_doc_id: string, profile_doc_id: string, params: ToggleClinicProfileActiveRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PATCH", `/v1/clinics/${encodeURIComponent(clinic_doc_id)}/profiles/${encodeURIComponent(profile_doc_id)}/active`, JSON.stringify(params))
        }

        /**
         * ToggleTrialClinicActive toggles the active status of a trial-clinic association
         */
        public async ToggleTrialClinicActive(trial_doc_id: string, clinic_doc_id: string, params: ToggleTrialClinicActiveRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PATCH", `/v1/trials/${encodeURIComponent(trial_doc_id)}/clinics/${encodeURIComponent(clinic_doc_id)}/active`, JSON.stringify(params))
        }

        /**
         * UpdateClinic updates an existing clinic
         */
        public async UpdateClinic(clinic_doc_id: string, params: UpdateClinicRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PUT", `/v1/clinics/${encodeURIComponent(clinic_doc_id)}`, JSON.stringify(params))
        }

        /**
         * UpdateClinicProfile updates an existing clinic profile
         */
        public async UpdateClinicProfile(clinic_doc_id: string, profile_doc_id: string, params: UpdateClinicProfileRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PUT", `/v1/clinics/${encodeURIComponent(clinic_doc_id)}/profiles/${encodeURIComponent(profile_doc_id)}`, JSON.stringify(params))
        }

        /**
         * UpdateParticipantAdverseEvent updates an existing adverse event
         */
        public async UpdateParticipantAdverseEvent(trial_doc_id: string, participant_doc_id: string, adverse_event_doc_id: string, params: UpdateAdverseEventRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PATCH", `/v1/trials/${encodeURIComponent(trial_doc_id)}/participants/${encodeURIComponent(participant_doc_id)}/adverse-events/${encodeURIComponent(adverse_event_doc_id)}`, JSON.stringify(params))
        }

        /**
         * UpdateParticipantAdverseEventRecordedAt updates an existing adverse event's recorded at date
         */
        public async UpdateParticipantAdverseEventRecordedAt(trial_doc_id: string, participant_doc_id: string, adverse_event_doc_id: string, params: UpdateAdverseEventRecordedAtRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PATCH", `/v1/trials/${encodeURIComponent(trial_doc_id)}/participants/${encodeURIComponent(participant_doc_id)}/adverse-events/${encodeURIComponent(adverse_event_doc_id)}/recordedat`, JSON.stringify(params))
        }

        /**
         * UpdateParticipantAdverseEventSummary updates an existing adverse event's summary
         */
        public async UpdateParticipantAdverseEventSummary(trial_doc_id: string, participant_doc_id: string, adverse_event_doc_id: string, params: UpdateAdverseEventSummaryRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PATCH", `/v1/trials/${encodeURIComponent(trial_doc_id)}/participants/${encodeURIComponent(participant_doc_id)}/adverse-events/${encodeURIComponent(adverse_event_doc_id)}/summary`, JSON.stringify(params))
        }

        /**
         * UpdateParticipantClinic assigns or removes a clinic for a participant
         */
        public async UpdateParticipantClinic(trial_doc_id: string, participant_doc_id: string, params: UpdateParticipantClinicRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PATCH", `/v1/trials/${encodeURIComponent(trial_doc_id)}/participants/${encodeURIComponent(participant_doc_id)}/clinic`, JSON.stringify(params))
        }

        /**
         * UpdateParticipantGroup updates a participant's group
         */
        public async UpdateParticipantGroup(trial_doc_id: string, participant_doc_id: string, params: UpdateParticipantGroupRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PATCH", `/v1/trials/${encodeURIComponent(trial_doc_id)}/participants/${encodeURIComponent(participant_doc_id)}/group`, JSON.stringify(params))
        }

        /**
         * UpdateParticipantMetadata updates a participant's metadata
         */
        public async UpdateParticipantMetadata(trial_doc_id: string, participant_doc_id: string, params: UpdateParticipantMetadataRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PATCH", `/v1/trials/${encodeURIComponent(trial_doc_id)}/participants/${encodeURIComponent(participant_doc_id)}/metadata`, JSON.stringify(params))
        }

        /**
         * UpdateParticipantStatus updates a participant's trial status
         */
        public async UpdateParticipantStatus(trial_doc_id: string, participant_doc_id: string, params: UpdateParticipantStatusRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PATCH", `/v1/trials/${encodeURIComponent(trial_doc_id)}/participants/${encodeURIComponent(participant_doc_id)}/status`, JSON.stringify(params))
        }

        /**
         * UpdateParticipantStepHistoryNotes adds notes to a participant step history log
         */
        public async UpdateParticipantStepHistoryNotes(trial_doc_id: string, participant_doc_id: string, step_doc_id: string, step_history_doc_id: string, params: StepHistoryNotesAuditRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PATCH", `/v1/trials/${encodeURIComponent(trial_doc_id)}/participant/${encodeURIComponent(participant_doc_id)}/steps/${encodeURIComponent(step_doc_id)}/steps-history/${encodeURIComponent(step_history_doc_id)}/notes`, JSON.stringify(params))
        }

        /**
         * UpdateScreeningParticipantStatus updates the status of a screening participant
         */
        public async UpdateScreeningParticipantStatus(trial_doc_id: string, screening_participant_doc_id: string, params: UpdateScreeningParticipantStatusRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PUT", `/v1/internal/trials/${encodeURIComponent(trial_doc_id)}/screening-participants/${encodeURIComponent(screening_participant_doc_id)}/status`, JSON.stringify(params))
        }

        /**
         * UpdateStepVideoStatus updates the status of a video session
         */
        public async UpdateStepVideoStatus(trial_doc_id: string, participant_doc_id: string, step_doc_id: string, video_doc_id: string, params: UpdateStepVideoStatusRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PUT", `/v1/trials/${encodeURIComponent(trial_doc_id)}/participants/${encodeURIComponent(participant_doc_id)}/steps/${encodeURIComponent(step_doc_id)}/videos/${encodeURIComponent(video_doc_id)}/status`, JSON.stringify(params))
        }

        /**
         * UpdateTrial updates trial data
         */
        public async UpdateTrial(doc_id: string, params: UpdateTrialRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PUT", `/v1/trials/${encodeURIComponent(doc_id)}`, JSON.stringify(params))
        }

        /**
         * UpdateTrialGroup updates an existing trial group
         */
        public async UpdateTrialGroup(trial_doc_id: string, group_doc_id: string, params: UpdateTrialGroupRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PUT", `/v1/trials/${encodeURIComponent(trial_doc_id)}/groups/${encodeURIComponent(group_doc_id)}`, JSON.stringify(params))
        }

        /**
         * UpdateTrialGroupsStatus updates participant trial status
         */
        public async UpdateTrialGroupsStatus(doc_id: string, params: UpdateTrialGroupsStatusRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PATCH", `/v1/trials/${encodeURIComponent(doc_id)}/groups-status`, JSON.stringify(params))
        }

        /**
         * UpdateTrialIssueType updates an existing issue type
         */
        public async UpdateTrialIssueType(trial_doc_id: string, issue_type_doc_id: string, params: UpdateTrialIssueTypeRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PATCH", `/v1/trials/${encodeURIComponent(trial_doc_id)}/issue-types/${encodeURIComponent(issue_type_doc_id)}`, JSON.stringify(params))
        }

        /**
         * UpdateTrialParticipantStepAutoProgressDate updates the auto progress date for a step
         */
        public async UpdateTrialParticipantStepAutoProgressDate(trial_doc_id: string, participant_doc_id: string, participant_step_doc_id: string, params: UpdateAutoProgressDateRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PATCH", `/v1/trials/${encodeURIComponent(trial_doc_id)}/participant/${encodeURIComponent(participant_doc_id)}/steps/${encodeURIComponent(participant_step_doc_id)}/auto-progress-date`, JSON.stringify(params))
        }

        /**
         * UpdateTrialParticipantStepStatus updates the status of a trial step for a participant
         */
        public async UpdateTrialParticipantStepStatus(trial_doc_id: string, participant_doc_id: string, participant_step_doc_id: string, params: UpdateTrialParticipantStepRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PATCH", `/v1/trials/${encodeURIComponent(trial_doc_id)}/participant/${encodeURIComponent(participant_doc_id)}/steps/${encodeURIComponent(participant_step_doc_id)}`, JSON.stringify(params))
        }

        /**
         * UpdateTrialStatus updates participant trial status
         */
        public async UpdateTrialStatus(doc_id: string, params: UpdateTrialStatusRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PATCH", `/v1/trials/${encodeURIComponent(doc_id)}/status`, JSON.stringify(params))
        }

        /**
         * UpdateTrialStep updates an existing trial step
         */
        public async UpdateTrialStep(trial_doc_id: string, step_doc_id: string, params: UpdateTrialStepRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PUT", `/v1/trials/${encodeURIComponent(trial_doc_id)}/steps/${encodeURIComponent(step_doc_id)}`, JSON.stringify(params))
        }

        /**
         * VerifyClinicProfileEmail marks a clinic profile's email as verified with the auth
         * provider (Firebase), without them completing Firebase's own verification-link flow.
         * Intended for support cases where ownership of the account has already been confirmed
         * through another channel.
         */
        public async VerifyClinicProfileEmail(clinic_doc_id: string, profile_doc_id: string): Promise<void> {
            await this.baseClient.callTypedAPI("PUT", `/v1/clinics/${encodeURIComponent(clinic_doc_id)}/profiles/${encodeURIComponent(profile_doc_id)}/verify-email`)
        }
    }
}

export namespace usersubmission {
    export interface AnswerOption {
        /**
         * DisplayValue
         * String representation of the answer option.
         */
        "display_value": string

        /**
         * WasSelected
         * Indicator for selection.
         */
        "was_selected": boolean
    }

    export interface CreateUserSubmissionRequest {
        /**
         * EventID
         * A valid Typeform EventID. Unique ID for the webhook. Automatically assigned by Typeform.
         */
        "event_id": string

        /**
         * EventType
         * A valid Typeform EventType. Reason the webhook is being sent.
         */
        "event_type": string

        /**
         * FormResponse
         * A valid Typeform FormResponse data in json format. Object that contains information about the typeform and account associated with the webhook.
         */
        "form_response": JSONValue
    }

    export interface GetUserSubmissionResponse {
        /**
         * PetDocID
         * The **doc_id** of the pet for which the typeform was submitted.
         */
        "pet_doc_id": uuid.UUID

        /**
         * TrialDocID
         * The **doc_id** of the trial for which the typeform was submitted.
         */
        "trial_doc_id": uuid.UUID

        /**
         * StepDocID
         * The **doc_id** of the step of the trial for which the typeform was submitted.
         */
        "step_doc_id": uuid.UUID

        /**
         * EventID
         * A valid Typeform EventID. Unique ID for the webhook. Automatically assigned by Typeform.
         */
        "event_id": string

        /**
         * EventType
         * A valid Typeform EventType. Reason the webhook is being sent.
         */
        "event_type": string

        /**
         * FormTitle
         * Title of the typeform.
         */
        "form_title": string

        /**
         * SubmittedAt
         * Date and time the typeform responses were submitted. In ISO 8601 format, Coordinated Universal Time (UTC), to the second.
         * (e.g. **2017-09-04T04:00:00Z**)
         */
        "submitted_at": string

        /**
         * LandedAt
         * Date and time the typeform responses were submitted. In ISO 8601 format, Coordinated Universal Time (UTC), to the second.
         * (e.g. **2017-09-04T04:00:00Z**)
         */
        "landed_at": string

        /**
         * FormResponses
         * List of all questions with selected answers.
         */
        "form_responses": UserSubmissionFormData[]
    }

    export interface ListUserSubmissionsRequest {
        /**
         * EventID
         * A valid Typeform EventID. Unique ID for the webhook. Automatically assigned by Typeform.
         * If present the response will contain only one form data for the selected EventID.
         */
        EventID: string

        /**
         * PetDocID
         * An existing pet **doc_id**.
         * If present the response will contain all form data for the selected PetDocID.
         */
        PetDocID: string

        /**
         * ExcludeEventIDs
         * List of unique typeform event_ids to be excluded from the final list of pet's form submissions.
         * If present the response will contain all form data for the selected PetDocID excluding the forms with event_ids from the ExcludeEventIDs list.
         */
        ExcludeEventIDs: string[]

        /**
         * RequestedItemsPerPage
         * the number of results requested for the page
         */
        RequestedItemsPerPage: number

        /**
         * RequestedPageNumber
         * the page number requested
         */
        RequestedPageNumber: number
    }

    export interface ListUserSubmissionsResponse {
        "pet_forms": GetUserSubmissionResponse[]
        pagination: shared.Pagination
    }

    export interface UserSubmissionFormData {
        /**
         * Title
         * Typeform question text.
         */
        title: string

        /**
         * AnswerType
         * Type of the display data e.g. **text**, **img** or **video**.
         */
        "answer_type": string

        /**
         * Response
         * When the answer is a single value it would be populated here.
         */
        response: string

        /**
         * AnswerOptions
         * When the answer is a selection from multiple possible values all possible values will be populated here
         *  along with information if they were selected or not.
         */
        "answer_options": AnswerOption[]
    }

    export interface UserSubmissionResponse {
        "doc_id": uuid.UUID
    }

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.CreateUserSubmission = this.CreateUserSubmission.bind(this)
            this.ListUserSubmission = this.ListUserSubmission.bind(this)
        }

        /**
         * Create User Submission
         * This endpoint expects webhook data coming through Typeform.
         */
        public async CreateUserSubmission(params: CreateUserSubmissionRequest): Promise<UserSubmissionResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/usersubmissions`, JSON.stringify(params))
            return await resp.json() as UserSubmissionResponse
        }

        /**
         * List User Submissions
         * This endpoint returns user submission data in a format suitable for PMS visualisation.
         * The list of data is sorted desc by typeform submitted_at date.
         */
        public async ListUserSubmission(params: ListUserSubmissionsRequest): Promise<ListUserSubmissionsResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "event_id":         params.EventID,
                "exclude_event_id": params.ExcludeEventIDs.map((v) => v),
                "items_per_page":   String(params.RequestedItemsPerPage),
                "page_number":      String(params.RequestedPageNumber),
                "pet_doc_id":       params.PetDocID,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/usersubmissions`, undefined, {query})
            return await resp.json() as ListUserSubmissionsResponse
        }
    }
}

export namespace venomcodeinternal {
    export interface AllVenomCodesResponse {
        categories: CategoryResponse[]
    }

    export interface CategoryResponse {
        "doc_id": uuid.UUID
        name: string
        groups: VenomGroupWithCodesResponse[]
    }

    export interface CreateVenomCategoryRequest {
        name: string
    }

    export interface CreateVenomCategoryResponse {
        "doc_id": uuid.UUID
    }

    export interface CreateVenomCodeRequest {
        "venom_id": string
        "term_name": string
        "group_doc_id": string
        synonym: string
        "customer_synonym": string
    }

    export interface CreateVenomCodeResponse {
        "doc_id": uuid.UUID
    }

    export interface CreateVenomGroupRequest {
        name: string
        "category_doc_id": string
    }

    export interface CreateVenomGroupResponse {
        "doc_id": uuid.UUID
    }

    export interface GetVenomCategoryResponse {
        "doc_id": uuid.UUID
        name: string
    }

    export interface GetVenomCodeResponse {
        "doc_id": uuid.UUID
        "venom_id": string
        "term_name": string
        synonym: string
        "customer_synonym": string
        groups: VenomGroupResponse[]
    }

    export interface GetVenomGroupResponse {
        "doc_id": uuid.UUID
        name: string
        "category_doc_id": uuid.UUID
    }

    export interface ListVenomCategoriesRequest {
        /**
         * the number of results requested for the page
         */
        RequestedItemsPerPage: number

        /**
         * the page number requested
         */
        RequestedPageNumber: number

        /**
         * the name which is searched for
         */
        Name: string
    }

    export interface ListVenomCategoriesResponse {
        pagination: shared.Pagination
        "venom_categories": VenomCategoryResponse[]
    }

    export interface ListVenomCodesRequest {
        /**
         * the number of results requested for the page
         */
        RequestedItemsPerPage: number

        /**
         * the page number requested
         */
        RequestedPageNumber: number

        /**
         * the term name which is searched for
         */
        TermName: string
    }

    export interface ListVenomCodesResponse {
        pagination: shared.Pagination
        "venom_codes": VenomCodeResponse[]
    }

    export interface ListVenomGroupsRequest {
        /**
         * the number of results requested for the page
         */
        RequestedItemsPerPage: number

        /**
         * the page number requested
         */
        RequestedPageNumber: number

        /**
         * the name which is searched for
         */
        Name: string
    }

    export interface ListVenomGroupsResponse {
        pagination: shared.Pagination
        "venom_groups": VenomGroupResponse[]
    }

    export interface UpdateVenomCodeRequest {
        synonym: string
        "customer_synonym": string
        "group_doc_id": string[]
        deleted: boolean
    }

    export interface UpdateVenomGroupRequest {
        "category_doc_id": string
        deleted: boolean
    }

    export interface UploadVenomCodesRequest {
        /**
         * the category that this csv file belongs to
         */
        category: string

        /**
         * csv file in base64 format that contains venom codes
         */
        "venom_codes_csv": string
    }

    export interface VenomCategoryResponse {
        "doc_id": uuid.UUID
        name: string
    }

    export interface VenomCodeResponse {
        "doc_id": uuid.UUID
        "venom_id": string
        "term_name": string
        synonym: string
        "customer_synonym": string
    }

    export interface VenomGroupResponse {
        "doc_id": uuid.UUID
        name: string
    }

    export interface VenomGroupWithCodesResponse {
        "doc_id": uuid.UUID
        name: string
        "venom_codes": VenomCodeResponse[]
    }

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.CreateVenomCategory = this.CreateVenomCategory.bind(this)
            this.CreateVenomCode = this.CreateVenomCode.bind(this)
            this.CreateVenomGroup = this.CreateVenomGroup.bind(this)
            this.DeleteVenomCode = this.DeleteVenomCode.bind(this)
            this.DeleteVenomGroup = this.DeleteVenomGroup.bind(this)
            this.GetVenomCategory = this.GetVenomCategory.bind(this)
            this.GetVenomCode = this.GetVenomCode.bind(this)
            this.GetVenomGroup = this.GetVenomGroup.bind(this)
            this.ListVenomCategories = this.ListVenomCategories.bind(this)
            this.ListVenomCategoriesWithCodes = this.ListVenomCategoriesWithCodes.bind(this)
            this.ListVenomCodes = this.ListVenomCodes.bind(this)
            this.ListVenomGroups = this.ListVenomGroups.bind(this)
            this.UpdateVenomCode = this.UpdateVenomCode.bind(this)
            this.UpdateVenomGroup = this.UpdateVenomGroup.bind(this)
            this.UploadVenomCodes = this.UploadVenomCodes.bind(this)
        }

        /**
         * Create Venom Category
         */
        public async CreateVenomCategory(params: CreateVenomCategoryRequest): Promise<CreateVenomCategoryResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/venom-categories`, JSON.stringify(params))
            return await resp.json() as CreateVenomCategoryResponse
        }

        /**
         * Create Venom Code
         */
        public async CreateVenomCode(params: CreateVenomCodeRequest): Promise<CreateVenomCodeResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/venom-codes`, JSON.stringify(params))
            return await resp.json() as CreateVenomCodeResponse
        }

        /**
         * Create Venom Group
         */
        public async CreateVenomGroup(params: CreateVenomGroupRequest): Promise<CreateVenomGroupResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/venom-groups`, JSON.stringify(params))
            return await resp.json() as CreateVenomGroupResponse
        }

        /**
         * Delete Venom Code
         */
        public async DeleteVenomCode(docID: string): Promise<void> {
            await this.baseClient.callTypedAPI("DELETE", `/v1/venom-codes/${encodeURIComponent(docID)}`)
        }

        /**
         * Delete Venom Group
         */
        public async DeleteVenomGroup(docID: string): Promise<void> {
            await this.baseClient.callTypedAPI("DELETE", `/v1/venom-groups/${encodeURIComponent(docID)}`)
        }

        /**
         * Get Venom Category
         */
        public async GetVenomCategory(docID: string): Promise<GetVenomCategoryResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/venom-categories/${encodeURIComponent(docID)}`)
            return await resp.json() as GetVenomCategoryResponse
        }

        /**
         * Get Venom Code
         */
        public async GetVenomCode(docID: string): Promise<GetVenomCodeResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/venom-codes/codes/${encodeURIComponent(docID)}`)
            return await resp.json() as GetVenomCodeResponse
        }

        /**
         * Get Venom Group
         * Get a Venom Group by its doc ID
         */
        public async GetVenomGroup(docID: string): Promise<GetVenomGroupResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/venom-groups/${encodeURIComponent(docID)}`)
            return await resp.json() as GetVenomGroupResponse
        }

        /**
         * List Venom Codes
         */
        public async ListVenomCategories(params: ListVenomCategoriesRequest): Promise<ListVenomCategoriesResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "items_per_page": String(params.RequestedItemsPerPage),
                "page_number":    String(params.RequestedPageNumber),
                search:           params.Name,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/venom-categories`, undefined, {query})
            return await resp.json() as ListVenomCategoriesResponse
        }

        /**
         * List All Venom Codes
         */
        public async ListVenomCategoriesWithCodes(): Promise<AllVenomCodesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/venom-codes/all`)
            return await resp.json() as AllVenomCodesResponse
        }

        /**
         * List Venom Codes
         */
        public async ListVenomCodes(params: ListVenomCodesRequest): Promise<ListVenomCodesResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "items_per_page": String(params.RequestedItemsPerPage),
                "page_number":    String(params.RequestedPageNumber),
                search:           params.TermName,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/venom-codes`, undefined, {query})
            return await resp.json() as ListVenomCodesResponse
        }

        /**
         * List Venom Codes
         */
        public async ListVenomGroups(params: ListVenomGroupsRequest): Promise<ListVenomGroupsResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "items_per_page": String(params.RequestedItemsPerPage),
                "page_number":    String(params.RequestedPageNumber),
                search:           params.Name,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/venom-groups`, undefined, {query})
            return await resp.json() as ListVenomGroupsResponse
        }

        /**
         * Update Venom Code
         */
        public async UpdateVenomCode(docID: string, params: UpdateVenomCodeRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PUT", `/v1/venom-codes/${encodeURIComponent(docID)}`, JSON.stringify(params))
        }

        /**
         * Update Venom Group
         */
        public async UpdateVenomGroup(docID: string, params: UpdateVenomGroupRequest): Promise<void> {
            await this.baseClient.callTypedAPI("PUT", `/v1/venom-groups/${encodeURIComponent(docID)}`, JSON.stringify(params))
        }

        /**
         * Upload Venom Codes
         * Upload venom codes through csv file
         */
        public async UploadVenomCodes(params: UploadVenomCodesRequest): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/v1/venom-codes/csv-upload`, JSON.stringify(params))
        }
    }
}

/**
 * vetaichatexternal is effectively a proxy for the LLM vet chat
 */
export namespace vetaichatexternal {
    export interface ChatCallToActionRequest {
        /**
         * the doc id of the chat
         */
        "chat_doc_id": string

        /**
         * the id of the message that the cta was attached to
         */
        "message_id": string

        /**
         * "genericButton"
         */
        type: string

        /**
         * "llmCallToAction", "vetPracticeReferralIgnore"
         */
        id: string

        /**
         * e.g. {"advice_text": "Please contact your vet for further advice."}
         */
        "cta_callback_data": JSONValue
    }

    export interface ChatCallToActionResponse {
    }

    export interface CheckStartLLMChatRequest {
        /**
         * Species can be "Dog" or "Cat"
         */
        Species: string

        /**
         * VenomCodeDocIDs is a mixed list of venom code and venom group DocIDs
         */
        VenomCodeDocIDs?: string[]
    }

    export interface CheckStartLLMChatResponse {
        eligible: boolean
    }

    export interface DiscoveryLLMPrompt {
        prompt: string
        "tracking_id": string
    }

    export interface ListDiscoveryLLMPromptsRequest {
        PetDocID: string
    }

    export interface ListDiscoveryLLMPromptsResponse {
        prompts: DiscoveryLLMPrompt[]
    }

    export interface SetChatRatingReasonRequest {
        /**
         * The list of possible reasons is in the frontend.
         * The backend saves the supplied strings
         */
        reason?: string[]

        /**
         * The user can always supply a free text comment, but they don't have to
         */
        comment?: string
    }

    export interface SetChatRatingReasonResponse {
    }

    export interface SetChatRatingRequest {
        /**
         * The score given by the user
         */
        score: number

        /**
         * The maximum possible score
         */
        "max_score": number

        /**
         * Which part of the chat flow this rating applies to: llm, consultation, ai-review, ai-review-accepted, or ai-review-ignored.
         * Optional for backwards compatibility; omitted or empty defaults to llm.
         */
        "rating_target"?: entities.UserChatRatingTarget
    }

    export interface SetChatRatingResponse {
    }

    export interface SkipChatResponse {
    }

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.ChatCallToActionCallback = this.ChatCallToActionCallback.bind(this)
            this.CheckStartLLMChat = this.CheckStartLLMChat.bind(this)
            this.ListDiscoveryLLMPrompts = this.ListDiscoveryLLMPrompts.bind(this)
            this.SetChatRating = this.SetChatRating.bind(this)
            this.SetChatRatingReason = this.SetChatRatingReason.bind(this)
            this.SkipChat = this.SkipChat.bind(this)
        }

        /**
         * ChatCallToActionCallback is a generic handler that the frontends can call when the user
         * interacts with a CTA in a chat.
         */
        public async ChatCallToActionCallback(params: ChatCallToActionRequest): Promise<ChatCallToActionResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/chat-cta-callback`, JSON.stringify(params))
            return await resp.json() as ChatCallToActionResponse
        }

        /**
         * Skips the Given LLM Chat.
         * If it's an llm-triage-chat, it will set the status to pending
         * If it's an llm-appointment-chat, it will set the status to completed
         * in both instances it'll summarise the notes for a vet.
         */
        public async CheckStartLLMChat(params: CheckStartLLMChatRequest): Promise<CheckStartLLMChatResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                species:              params.Species,
                "venom_code_doc_ids": params.VenomCodeDocIDs?.map((v) => v),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/llm-chat/eligible`, undefined, {query})
            return await resp.json() as CheckStartLLMChatResponse
        }

        /**
         * ListDiscoveryLLMPrompts lists the discovery LLM prompts appropriate for the given pet doc id
         */
        public async ListDiscoveryLLMPrompts(params: ListDiscoveryLLMPromptsRequest): Promise<ListDiscoveryLLMPromptsResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "pet_doc_id": params.PetDocID,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/discovery-llm-prompts`, undefined, {query})
            return await resp.json() as ListDiscoveryLLMPromptsResponse
        }

        /**
         * SetChatRating
         * Allows the user to submit a numerical rating for a chat score (effectively stars out of X)
         */
        public async SetChatRating(userDocID: string, chatDocID: string, params: SetChatRatingRequest): Promise<SetChatRatingResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/users/${encodeURIComponent(userDocID)}/chat/${encodeURIComponent(chatDocID)}/rating`, JSON.stringify(params))
            return await resp.json() as SetChatRatingResponse
        }

        /**
         * SetChatRating
         * Allows the user to submit text for the reason for their chat rating
         */
        public async SetChatRatingReason(userDocID: string, chatDocID: string, params: SetChatRatingReasonRequest): Promise<SetChatRatingReasonResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/users/${encodeURIComponent(userDocID)}/chat/${encodeURIComponent(chatDocID)}/rating-reason`, JSON.stringify(params))
            return await resp.json() as SetChatRatingReasonResponse
        }

        /**
         * Skips the Given LLM Chat.
         * If it's an llm-triage-chat, it will set the status to pending
         * If it's an llm-appointment-chat, it will set the status to completed
         * in both instances it'll summarise the notes for a vet.
         */
        public async SkipChat(userDocID: string, chatDocID: string): Promise<SkipChatResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("PATCH", `/v1/users/${encodeURIComponent(userDocID)}/chat/${encodeURIComponent(chatDocID)}/skip`)
            return await resp.json() as SkipChatResponse
        }
    }
}

export namespace vetaichatinternal {
    export interface AIOutcome {
        "agent_name": string
        preview: string
        introduction: string
        "staff_profile": AIOutcomeStaffProfile
        sections: AIOutcomeSection[]
        id: string
        "published_at": string
        products: AIOutcomeProduct[]
    }

    /**
     * this is in the product world actually a product variant. I want to maintain
     * the abstraction here thought to avoid leaking that concept through the system
     * as far as we're concerned these are just products.
     */
    export interface AIOutcomeProduct {
        /**
         * title of the head product e.g. Tick Remover
         */
        "product_title": string

        /**
         * variant title e.g. Small Size
         */
        title: string

        price: string
        "currency_code": string
        "image_url": string
        sku: string
        url: string
    }

    export interface AIOutcomeSection {
        title: string
        body: string
        "icon_url": string
        warning: AIOutcomeWarning
    }

    export interface AIOutcomeStaffProfile {
        name: string
        role: string
        "photo_url": string
    }

    export interface AIOutcomeWarning {
        body: string
    }

    /**
     * BackfillContentDTO maps to entities.InteractionContent.
     */
    export interface BackfillContentDTO {
        "chat_transcript": string
        "video_transcript": string
        "customer_input_notes": string
        "treatment_plan": string
        "clinical_notes": string
        "vet_triage_codes": string[]
        "vet_venom_codes": string[]
    }

    /**
     * BackfillMemoriesRequest is a small batch of historical consultations to write
     * memories for. The AI-side driver computes the source content from BigQuery and
     * POSTs it here; the Go side runs the same WriteMemory path as the live writer
     * (interaction write -> ADK summarise -> memory write).
     * 
     * Secret is a shared secret passed in the X-Backfill-Secret header rather than
     * the body, checked against the memoryBackfillSecret Encore secret. The endpoint
     * is public so the header is the only authorisation.
     */
    export interface BackfillMemoriesRequest {
        Secret: string
        records: BackfillMemoryRecord[]
    }

    /**
     * BackfillMemoriesResponse reports a per-record outcome so the driver can retry
     * only the failures. A whole-batch error is reserved for auth failures; once
     * authorised, individual record failures are isolated and reported here.
     */
    export interface BackfillMemoriesResponse {
        results: BackfillMemoryResult[]
    }

    /**
     * BackfillMemoryRecord is one historical interaction's fully resolved source
     * content. It mirrors entities.MemoryWriteInput in JSON-serialisable form.
     */
    export interface BackfillMemoryRecord {
        "interaction_doc_id": string
        "pet_doc_id": string
        source: string
        /**
         * RFC3339
         */
        "interaction_ts": string

        pet: BackfillPetDTO
        content: BackfillContentDTO
    }

    export interface BackfillMemoryResult {
        "interaction_doc_id": string
        success: boolean
        error: string
    }

    /**
     * BackfillPetDTO maps to entities.MemoryPet.
     */
    export interface BackfillPetDTO {
        "owner_name": string
        "pet_name": string
        "pet_species": string
        "pet_breed": string
        "pet_gender": string
        "pet_age_in_months": number
        "pet_neutered": boolean
    }

    /**
     * BackfillRagConsultRecord is one consultation's rendered document joined to the
     * identifiers retrieval filters on. It mirrors entities.RagConsultWriteInput in
     * JSON-serialisable form; the row invariants are the writer service's.
     */
    export interface BackfillRagConsultRecord {
        "consult_doc_id": string
        "pet_doc_id": string
        source: string
        /**
         * RFC3339
         */
        "consult_ts": string

        species: string
        "embedding_content": string
        "retrieval_content": string
        embedding: number[]
        extraction: JSONValue
    }

    export interface BackfillRagConsultResult {
        "consult_doc_id": string
        success: boolean
        error: string
    }

    /**
     * BackfillRagConsultsRequest is a batch of historical consultations' Layer B RAG
     * documents. Unlike the memory backfill, no generation happens here: the driver
     * has already rendered each document through the ADK /ragdocument route, so this
     * endpoint is a pure write and the batch can be much larger.
     * 
     * Secret is the same shared secret as the memory backfill, passed in the
     * X-Backfill-Secret header rather than the body and checked against the
     * memoryBackfillSecret Encore secret. The endpoint is public so the header is
     * the only authorisation.
     */
    export interface BackfillRagConsultsRequest {
        Secret: string
        records: BackfillRagConsultRecord[]
    }

    /**
     * BackfillRagConsultsResponse reports a per-record outcome so the driver can
     * retry only the failures. A whole-batch error is reserved for auth failures;
     * once authorised, individual record failures are isolated and reported here.
     */
    export interface BackfillRagConsultsResponse {
        results: BackfillRagConsultResult[]
    }

    export interface GeneralTriageCompleteToolRequest {
        /**
         * emergency
         */
        "is_emergency": boolean

        /**
         * referral
         */
        "is_referral": boolean

        /**
         * venom codes
         */
        "venom_codes": string[]

        "venom_codes_reasoning": string
        /**
         * triage codes
         */
        "triage_codes": string[]

        "triage_codes_reasoning": string
        /**
         * treatment plan
         */
        "proposed_treatment_plan": string

        /**
         * request id. This will be generated by the client to track the request
         */
        "request_id": string

        /**
         * speak to a vet right now
         */
        "speak_to_a_vet": boolean

        /**
         * vet-only audit trail of how any toxin calculations were made
         */
        "toxin_calculations"?: string
    }

    export interface GeneralTriageCompleteToolResponse {
        /**
         * here for openai generation compatibility
         */
        placeholder: string
    }

    export interface GetAIOutcomeRequest {
        PetDocID: string
        OwnerDocID: string
    }

    export interface GetAIOutcomeResponse {
        "ai_outcome": AIOutcome
    }

    export interface GetChatSummaryResponse {
        "chat_doc_id": string
        "channel_id": string
        "channel_type": string
        summary: string
    }

    export interface MissingMemoriesRequest {
        Secret: string
        "interaction_doc_ids": string[]
    }

    export interface MissingMemoriesResponse {
        "missing_interaction_doc_ids": string[]
    }

    export interface MissingRagConsultsRequest {
        Secret: string
        "consult_doc_ids": string[]
    }

    export interface MissingRagConsultsResponse {
        "missing_consult_doc_ids": string[]
    }

    export interface RateChatSummaryRequest {
        rating: string
    }

    export interface RateChatSummaryResponse {
    }

    export interface UpdateChatAIStateRequest {
        /**
         * Status is the AI status to display to the user.
         * Status values: "AI_STATE_THINKING", "AI_STATE_CHECKING", "AI_STATE_WRITING", "AI_STATE_DONE"
         * "AI_STATE_DONE" will clear the AI indicator.
         */
        status: string
    }

    export interface UpdateChatAIStateResponse {
        success: boolean
    }

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.BackfillMemories = this.BackfillMemories.bind(this)
            this.BackfillRagConsults = this.BackfillRagConsults.bind(this)
            this.GaitModeResponseReceiver = this.GaitModeResponseReceiver.bind(this)
            this.GeneralTriageCompleteTool = this.GeneralTriageCompleteTool.bind(this)
            this.GetAIOutcome = this.GetAIOutcome.bind(this)
            this.GetChatSummary = this.GetChatSummary.bind(this)
            this.MissingMemories = this.MissingMemories.bind(this)
            this.MissingRagConsults = this.MissingRagConsults.bind(this)
            this.PingLLMChat = this.PingLLMChat.bind(this)
            this.RateChatSummary = this.RateChatSummary.bind(this)
            this.UpdateChatAIState = this.UpdateChatAIState.bind(this)
        }

        /**
         * BackfillMemories writes memories for a batch of historical consultations.
         */
        public async BackfillMemories(params: BackfillMemoriesRequest): Promise<BackfillMemoriesResponse> {
            // Convert our params into the objects we need for the request
            const headers = makeRecord<string, string>({
                "x-backfill-secret": params.Secret,
            })

            // Construct the body with only the fields which we want encoded within the body (excluding query string or header fields)
            const body: Record<string, any> = {
                records: params.records,
            }

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/memory/backfill`, JSON.stringify(body), {headers})
            return await resp.json() as BackfillMemoriesResponse
        }

        /**
         * BackfillRagConsults writes the Layer B RAG rows for a batch of historical
         * consultations.
         */
        public async BackfillRagConsults(params: BackfillRagConsultsRequest): Promise<BackfillRagConsultsResponse> {
            // Convert our params into the objects we need for the request
            const headers = makeRecord<string, string>({
                "x-backfill-secret": params.Secret,
            })

            // Construct the body with only the fields which we want encoded within the body (excluding query string or header fields)
            const body: Record<string, any> = {
                records: params.records,
            }

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/rag/backfill`, JSON.stringify(body), {headers})
            return await resp.json() as BackfillRagConsultsResponse
        }

        /**
         * GaitModeResponseReceiver receives the response from the gait model
         * and updates the session with the score
         */
        public async GaitModeResponseReceiver(params: entities.GaitModelResponse): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/v1/ai-gait-response`, JSON.stringify(params))
        }

        /**
         * Called by the general triage tool to complete the triage process
         */
        public async GeneralTriageCompleteTool(chatDocID: string, params: GeneralTriageCompleteToolRequest): Promise<GeneralTriageCompleteToolResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/chats/${encodeURIComponent(chatDocID)}/triagecomplete`, JSON.stringify(params))
            return await resp.json() as GeneralTriageCompleteToolResponse
        }

        /**
         * RenderAIOutcome gets the latest active agent version for a specific agent.
         * then it substitutes in all the staff, owner details etc to provide a rendered outcome.
         * It does NOT store any of this information, it is just rendered on the fly.
         */
        public async GetAIOutcome(agentName: string, params: GetAIOutcomeRequest): Promise<GetAIOutcomeResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                "owner_doc_id": params.OwnerDocID,
                "pet_doc_id":   params.PetDocID,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/ai_outcomes/${encodeURIComponent(agentName)}`, undefined, {query})
            return await resp.json() as GetAIOutcomeResponse
        }

        /**
         * Get Chat Summary by Chat Doc ID.
         * Returns the summary for a given chat.
         */
        public async GetChatSummary(chatDocID: string): Promise<GetChatSummaryResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/v1/chats/${encodeURIComponent(chatDocID)}/summary`)
            return await resp.json() as GetChatSummaryResponse
        }

        /**
         * MissingMemories returns the subset of the requested interactions that are not
         * yet present in the memories table.
         */
        public async MissingMemories(params: MissingMemoriesRequest): Promise<MissingMemoriesResponse> {
            // Convert our params into the objects we need for the request
            const headers = makeRecord<string, string>({
                "x-backfill-secret": params.Secret,
            })

            // Construct the body with only the fields which we want encoded within the body (excluding query string or header fields)
            const body: Record<string, any> = {
                "interaction_doc_ids": params["interaction_doc_ids"],
            }

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/memory/backfill/missing`, JSON.stringify(body), {headers})
            return await resp.json() as MissingMemoriesResponse
        }

        /**
         * MissingRagConsults returns the subset of the requested consultations that are
         * not yet present in the rag_consults table. The driver cannot read prod, so
         * this is what lets it resume a run without re-paying for document generation.
         */
        public async MissingRagConsults(params: MissingRagConsultsRequest): Promise<MissingRagConsultsResponse> {
            // Convert our params into the objects we need for the request
            const headers = makeRecord<string, string>({
                "x-backfill-secret": params.Secret,
            })

            // Construct the body with only the fields which we want encoded within the body (excluding query string or header fields)
            const body: Record<string, any> = {
                "consult_doc_ids": params["consult_doc_ids"],
            }

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/v1/rag/backfill/missing`, JSON.stringify(body), {headers})
            return await resp.json() as MissingRagConsultsResponse
        }

        /**
         * PingLLMChat is a dummy method to try authentication with LLM
         */
        public async PingLLMChat(): Promise<void> {
            await this.baseClient.callTypedAPI("GET", `/v1/ping-llm-chat`)
        }

        /**
         * Rate a chat summary
         * Intended for use by clinicians to provide feedback on an AI chat summary
         * and rate the quality of the summary.
         * send a rating of 'good', or 'bad' to rate the summary.
         */
        public async RateChatSummary(chatDocID: string, params: RateChatSummaryRequest): Promise<RateChatSummaryResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("PATCH", `/v1/chats/${encodeURIComponent(chatDocID)}/summary/rating`, JSON.stringify(params))
            return await resp.json() as RateChatSummaryResponse
        }

        /**
         * UpdateChatAIState sets the AI status indicator on a chat channel.
         */
        public async UpdateChatAIState(chatDocID: string, params: UpdateChatAIStateRequest): Promise<UpdateChatAIStateResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("PUT", `/v1/chats/${encodeURIComponent(chatDocID)}/ai-state`, JSON.stringify(params))
            return await resp.json() as UpdateChatAIStateResponse
        }
    }
}

export namespace entities {
    /**
     * ActivePackageResponse is one active package (grant) the entity is on.
     */
    export interface ActivePackageResponse {
        "grant_doc_id": string
        "package_template_code": string
        "package_template_name": string
        "source_type": string
        "effective_date": string
        "expiry_date"?: string
        /**
         * "user" or "pet"
         */
        "grant_entity_type": string
    }

    export type AdverseEventType = string

    export interface Age {
        years: number
        months: number
    }

    /**
     * An AndCondition is composed of a list of OR conditions where at least one condition must evaluate to true for the
     * AND condition to be true
     */
    export interface AndCondition {
        /**
         * The ID of the rule group
         */
        id: number

        /**
         * The OR conditions to refine this and condition
         */
        "or_conditions": OrCondition[]
    }

    export interface AppointmentEvent {
        user: UserSummary
        "appointment_status": utilities.AppointmentStatus
        "consult_status": utilities.ConsultStatus
        "platform_os": string
        "platform_os_version": string
        "client_version": string
        trace: string
        timestamp: string
    }

    export interface Business {
        "business_doc_id": uuid.UUID
        name: string
    }

    export interface BusinessResponse {
        /**
         * this is horrid, but `DocID` was already keyed to `id` so without breaking changes there's nothing for it
         */
        "internal_id": number

        id: string
        name: string
        "external_id"?: string
        "partner_integration": string
    }

    export interface BusinessServiceMappingResponse {
        /**
         * the id of the business
         */
        id: string

        name: string
    }

    export interface Call {
        id: number
        "doc_id": uuid.UUID
        "consultation_doc_id": uuid.UUID
        "user_doc_id"?: uuid.UUID
        "pet_doc_id"?: uuid.UUID
        "vonage_call_uuid": string
        "vonage_conversation_id": string
        "call_status": CallStatus
        "consult_status": utilities.ConsultStatus
        "consult_disrupted_reason": string
        "consult_staff_profile_doc_id": uuid.UUID
        "consult_staff_profile_name"?: string
        "consult_staff_profile_description"?: string
        "consult_staff_profile_photo_url"?: string
        "consult_staff_profile_rcvs_number"?: string
        direction: string
        "started_at": string
        "answered_at": string
        "ended_at": string
        "duration_seconds": number
        "disconnect_reason": string
        "from_number": string
        "to_number": string
        "created_at": string
        "updated_at": string
    }

    export type CallStatus = string

    /**
     * CardState represents the visual card state for an ongoing trial step
     */
    export type CardState = string

    export interface Catalogue {
        id: number
        "doc_id": uuid.UUID
        name: string
        description: string
    }

    export interface CatalogueBusinessMappingRequest {
        RequestedItemsPerPage: number
        RequestedPageNumber: number
        CatalogueId: string
    }

    export interface CatalogueProduct {
        id: number
        "doc_id": uuid.UUID
        sku: string
        "catalogue_name": string
        url: string
        "catalogue_id": number
        currency: string
        price: number
        description: string
        "photo_url": string
        "created_at": string
        "updated_at": string
        deleted: boolean
        "deleted_at": string
        "classification_doc_id": uuid.UUID
        "legal_category": string
        "classification_description": string
        "external_product_variant_id"?: string
        "external_inventory_item_id"?: string
        "out_of_stock": boolean
        "external_inventory_policy": string
        "stock_source"?: StockSource
    }

    export interface CatalogueProductWithCatalogueDocID {
        id: number
        "doc_id": uuid.UUID
        sku: string
        "catalogue_name": string
        url: string
        "catalogue_id": number
        currency: string
        price: number
        description: string
        "photo_url": string
        "created_at": string
        "updated_at": string
        "catalogue_doc_id": uuid.UUID
        "catalogue_title": string
        "classification_doc_id": uuid.UUID
        "legal_category": string
        "classification_description": string
    }

    /**
     * CatalogueProducts TODO: Remove this and replace with singular CatalogueProduct, this is a duplicate
     */
    export interface CatalogueProducts {
        id: number
        "doc_id": uuid.UUID
        sku: string
        name: string
        url: string
        "catalogue_id": number
        currency: string
        price: number
        description: string
        "photo_url": string
        "created_at": string
        "updated_at": string
        "classification_id": number
        "classification_doc_id": uuid.UUID
        "legal_category": string
        "classification_description": string
        "out_of_stock": boolean
        "shopify_variant_id"?: string
    }

    export interface CategoriesWithSubcategoriesResponse {
        categories: CategoryWithSubcategoriesResponse[]
    }

    /**
     * Category
     */
    export interface Category {
        ID: number
        DocID: uuid.UUID
        Name: string
    }

    export interface CategoryWithSubcategoriesResponse {
        "category_id": uuid.UUID
        name: string
        subcategories: SubcategoryNameResponse[]
    }

    export type ChangeReasonType = string

    export interface ChatResponse {
        /**
         * this is the unique identifier for a chat room
         */
        "doc_id": string

        /**
         * channel ID is the identifier for the chat room the users are in
         */
        "channel_id": string

        /**
         * status is the current status of this chat
         */
        status: string

        /**
         * status history of the chat in order from first to current over its lifetime
         */
        "status_history": string[]

        /**
         * Channel Type is the type of chat room the users are in (messaging, video)
         */
        "channel_type": string

        /**
         * the last time the chat room was updated
         */
        "updated_at": utilities.Dates

        /**
         * the time the chat room was created
         */
        "created_at": utilities.Dates

        /**
         * the participants in the chat
         */
        participants: GetParticipantResponse[]

        /**
         * the pet that is associated with this chat
         */
        pet: accountinternal.PetResponse

        /**
         * the user that is associated with this chat
         */
        user: accountinternal.UserResponse

        /**
         * the business that is associated with this chat
         */
        business: BusinessResponse

        /**
         * the consult status of the chat
         */
        "consult_status": utilities.ConsultStatus

        /**
         * the reason the chat was disrupted
         */
        "disrupted_reason": string

        /**
         * the actual start time of the chat
         */
        "actual_start_time": utilities.Dates

        /**
         * the actual end time of the chat
         */
        "actual_end_time": utilities.Dates

        /**
         * the time the LLM handed over the chat to a human responder
         */
        "llm_triage_handover_time": utilities.Dates

        /**
         * the name of the chat service
         */
        "service_name": string

        /**
         * the unique identifier for the chat service
         */
        "service_doc_id": string

        /**
         * the timezone of the chat
         */
        "time_zone": string

        /**
         * the video room associated with the chat
         */
        "chat_video_room": ChatVideoRoom

        /**
         * previous sympsom checker session id, if one exists
         */
        "symptom_checker_session_doc_id"?: string

        /**
         * the reason for the visit
         */
        "reason_for_visit"?: ReasonForVisit

        /**
         * marked by the LLM as an emergency. Not ptr like on appointments as every chat will have this true or false
         */
        "is_emergency": boolean

        /**
         * set when the chat was started as a follow-up to a previous consultation
         */
        "is_followup": boolean

        /**
         * whether the chat is overdue, time waiting exceeds set time, helps indicate if it can be terminated, used for pending chats
         */
        "is_overdue": boolean

        /**
         * whether the chat is a whatsapp chat
         */
        "is_whatsapp": boolean

        /**
         * phone number associated with the chat at creation
         */
        "phone_number"?: string

        /**
         * trial context when chat was created from a trial
         */
        "trial_doc_id": uuid.UUID

        /**
         * trial participant context when chat was created from a trial
         */
        "trial_participant_doc_id": uuid.UUID

        /**
         * client data such as operating system and build number, used for analytics and debugging
         */
        "client_data": ClientData

        /**
         * EVCPRElibility
         * based on the users reported current state, the vets registered state, and state specific configuration records whether the consult is eligible for evcpr
         * if the user has not sent a US State shortcode when they created the chat, its nil
         * if the user sent a US State shortcode and there is no evcpr eligibility, its set to false, and returns the users state
         * if the user sent a US State shortcode and there is evcpr eligibility, its true and returns the users state
         */
        "evcpr_elibility"?: EVCPRChatEligibilityDTO
    }

    export interface ChatVideoRoom {
        id: number
        "doc_id": string
        "session_room_id": string
        "current_call_details"?: CurrentCallDetails
    }

    export interface ClientData {
        ClientOS: string
        ClientOSVersion: string
        ClientBuildNumber: string
    }

    /**
     * ConsultationSourceType represents the source/origin of a consultation
     */
    export type ConsultationSourceType = string

    export interface CreateBusinessRequest {
        name: string
        "external_id": string
        "partner_integration": string
    }

    export interface CreateBusinessResponse {
        id: uuid.UUID
    }

    export interface CreateCallConsultationRequest {
        "call_doc_id": string
        "staff_doc_id": string
    }

    export interface CreateCatalogueBusinessRequest {
        "business_doc_id": uuid.UUID
    }

    export interface CreateCatalogueBusinessResponse {
        "business_doc_id": uuid.UUID
    }

    export interface CreateCatalogueProductMappingResponse {
        "product_id": number
        "catalogue_product_id": number
    }

    export interface CreateCatalogueProductResponse {
        "doc_id": uuid.UUID
    }

    export interface CreateCatalogueRequest {
        "catalogue_name": string
        "catalogue_description": string
    }

    export interface CreateCatalogueResponse {
        "doc_id": uuid.UUID
    }

    export interface CreateCategoryRequest {
        Name: string
    }

    export interface CreateCategoryResponse {
        "doc_id": uuid.UUID
    }

    export interface CreateChatConsultationRequest {
        "chat_doc_id": string
        "pet_doc_id": string
        "owner_doc_id": string
    }

    export interface CreatePetResponse {
        /**
         * DocID
         * The **doc_id** of the new pet in **UUID** format.
         */
        "doc_id": string

        /**
         * CreatedfAt
         * The timestamp when the pet was created.
         */
        "created_at": string
    }

    export interface CreateProductVenomCategoryRequest {
        "venom_category_id": uuid.UUID
    }

    export interface CreateProductVenomCategoryResponse {
        "venom_category_id": uuid.UUID
    }

    export interface CreateProductVenomCodeRequest {
        "venom_code_doc_id": uuid.UUID
    }

    export interface CreateProductVenomCodeResponse {
        "venom_code_doc_id": uuid.UUID
        "product_id": uuid.UUID
    }

    export interface CreateStaffRequest {
    }

    export interface CreateSubcategoryRequest {
        name: string
        "category_id": uuid.UUID
    }

    export interface CreateSubcategoryResponse {
        "subcategory_doc_id": uuid.UUID
    }

    export interface CreateWeightResponse {
        /**
         * DocID
         * The **doc_id** of the weight in **UUID** format.
         */
        "doc_id": string
    }

    export interface CurrentCallDetails {
        "doc_id": string
        "message_id": string
        "staff_name": string
        "staff_picture": string
        status: getstream.ChatVideoRoomStatuses
        "created_at": string
        duration: number
    }

    export interface DeleteBusinessRequest {
        DocID: string
    }

    export type DerivedStatus = string

    /**
     * EVCPREligibilityDTO is a struct representing the EVCPR eligibility
     * it should be in bookinginternal, but because the main chat DTO is here in the entities
     * this must be as well. I've separated it from the business logic struct, so if we do
     * ever move the chat entity to the bookinginternal package, this should be easier as well
     */
    export interface EVCPRChatEligibilityDTO {
        "is_evcpr_eligible": boolean
        "user_current_state": string
    }

    /**
     * EffectiveEntitlementResponse is the merged effective entitlement (no originating package; drives paywalls).
     */
    export interface EffectiveEntitlementResponse {
        code: string
        name: string
        unit: string
        value?: number
        period?: string
        used: number
        remaining?: number
        "has_credit": boolean
        "period_start"?: string
        "period_end"?: string
    }

    /**
     * EntitlementCalculatorResponse is the response shape for entitlement calculator endpoints.
     */
    export interface EntitlementCalculatorResponse {
        "entity_type": string
        "entity_doc_id": string
        "active_packages"?: ActivePackageResponse[]
        "user_entitlements"?: ResolvedEntitlementResponse[]
        "pet_entitlements"?: ResolvedEntitlementResponse[]
        "effective_entitlements"?: EffectiveEntitlementResponse[]
        "grants_count": number
    }

    /**
     * FormSubmissionType represents the type of form submission
     */
    export type FormSubmissionType = string

    export interface GaitModelResponse {
        status: string
        "session_doc_id": string
        "video_section_results": GaitModelVideoSectionResults[]
        "full_url": string
    }

    export interface GaitModelVideoSectionResults {
        result: number
        contextresult: number
        start: number
        end: number
        usefresult: number
    }

    export interface GetBreedsResponse {
        breeds: GetBreedsResponseItem[]
    }

    export interface GetBreedsResponseItem {
        /**
         * DocId
         * The **doc_id** of the breed in **UUID** format.
         */
        "doc_id": string

        /**
         * Name
         * The name of the breed.
         */
        name: string
    }

    export interface GetBusinessRequest {
        /**
         * the id of the business
         */
        DocID: string
    }

    export interface GetCatalogueRequest {
        DocID: string
    }

    export interface GetCatalogueResponse {
        id: number
        "doc_id": uuid.UUID
        name: string
        description: string
    }

    export interface GetParticipantResponse {
        "session_user_id": string
        "user_doc_id": string
        "pet_doc_id": string
        "staff_profile_doc_id": string
        "business_doc_id": string
        "staff_profile_name": string
        "staff_profile_description": string
        "staff_profile_photo_url": string
    }

    export interface GetPendingChatsRequest {
        RequestedItemsPerPage: number
        RequestedPageNumber: number
    }

    export interface GetPendingChatsResponse {
        pagination: shared.Pagination
        chats: ChatResponse[]
    }

    export interface GetProductCatalogueResponse {
        products: CatalogueProduct[]
    }

    export interface GetProductCataloguesByDocIDsRequest {
        DocIDs: string[]
    }

    export interface HandoverReason {
        id: number
        reason: string
    }

    export interface HydratedMissedCall {
        "appointment_id": number
        user: UserSummary
        staff: UserSummary
        "client_operating_system": string
        "client_os_version": string
        "build_number": string
        "appointment_status": string
        "consult_status": string
    }

    export type InformationType = string

    /**
     * IssueTypeVisibility controls which roles can see an issue type.
     */
    export type IssueTypeVisibility = string

    export type LanguageISO639 = string

    /**
     * published, draft or archived. Shared across entities for now
     */
    export type LifecycleStatus = string

    export interface ListBusinessServiceMappingResponse {
        businesses: BusinessServiceMappingResponse[]
    }

    /**
     * once encore supports embedded query params, we could just embed the PaginatedRequest struct
     */
    export interface ListBusinessesRequest {
        /**
         * the number of results requested for the page
         */
        RequestedItemsPerPage: number

        /**
         * the page number requested
         */
        RequestedPageNumber: number

        /**
         * partial name of the business
         */
        Name: string
    }

    export interface ListBusinessesResponse {
        pagination: shared.Pagination
        businesses: BusinessResponse[]
    }

    export interface ListBusinessesWithNoPaginationResponse {
        businesses: BusinessResponse[]
    }

    export interface ListCatalogueBusinessMappingResponse {
        pagination: shared.Pagination
        Businesses: Business[]
    }

    export interface ListCatalogueProductsMappedToProductResponse {
        products: CatalogueProductWithCatalogueDocID[]
    }

    export interface ListCataloguesRequest {
        RequestedItemsPerPage: number
        RequestedPageNumber: number
        Name: string
    }

    export interface ListCataloguesResponse {
        pagination: shared.Pagination
        catalogues: Catalogue[]
    }

    export interface ListCategoriesRequest {
        "items_per_page": number
        "page_number": number
        name: string
    }

    export interface ListCategoriesResponse {
        pagination: shared.Pagination
        categories: Category[]
    }

    export interface ListClinicalHistoryCategoryResponse {
        "doc_id": uuid.UUID
        name: string
        "form_name": string
    }

    export interface ListClinicalHistoryGroupWithCategories {
        "group_doc_id": uuid.UUID
        "group_name": string
        "clinical_history_category": ListClinicalHistoryCategoryResponse[]
    }

    export interface ListMappedSubCategoriesForCategoryResponse {
        subcategories: SubcategoryResponse[]
    }

    export interface ListPetsResponse {
        pets: PetResponse[]
    }

    export interface ListProductCatalogueRequest {
        Name: string
        RequestedItemsPerPage: number
        RequestedPageNumber: number
        CatalogueID: string
    }

    export interface ListProductCatalogueResponse {
        pagination: shared.Pagination
        products: CatalogueProducts[]
    }

    export interface ListProductCataloguesRequest {
        RequestedItemsPerPage: number
        RequestedPageNumber: number
        ProductID: string
    }

    export interface ListProductCataloguesResponse {
        pagination: shared.Pagination
        catalogues: Catalogue[]
    }

    export interface ListProductVenomCategoriesResponse {
        categories: ListedVenom[]
    }

    export interface ListProductVenomCodesResponse {
        codes: ListedVenom[]
    }

    export interface ListProductVenomGroupsResponse {
        groups: ListedVenom[]
    }

    export interface ListProductsBySubcategory {
        pagination: shared.Pagination
        products: Product[]
    }

    export interface ListProductsForCatalogue {
        products: CatalogueProduct[]
    }

    export interface ListProductsRequest {
        RequestedItemsPerPage: number
        RequestedPageNumber: number
        Name: string
    }

    export interface ListProductsResponse {
        pagination: shared.Pagination
        products: Product[]
    }

    export interface ListReasonGroupWithTypes {
        "group_doc_id": uuid.UUID
        "group_name": string
        "reason_types": ListReasonTypeResponse[]
    }

    export interface ListReasonTypeResponse {
        "doc_id": uuid.UUID
        name: string
    }

    export interface ListReasonTypesResponse {
        "doc_id": string
        name: string
        "group_doc_id": uuid.UUID
    }

    export interface ListServicePricesBusinessMappingResponse {
        businesses: ServicePricesBusinessMappingResponse[]
    }

    export interface ListStaffProfilesRequest {
        /**
         * the number of results requested for the page
         */
        RequestedItemsPerPage: number

        /**
         * the page number requested
         */
        RequestedPageNumber: number

        /**
         * partial name of the business
         */
        Name: string
    }

    export interface ListSubcategoriesRequest {
        "items_per_page": number
        "page_number": number
        name: string
    }

    export interface ListSubcategoriesResponse {
        pagination: shared.Pagination
        subcategories: SubcategoryResponse[]
    }

    export interface ListWebhookEventsResponse {
        events: WebhookEventResponse[]
    }

    export interface ListWebhookResponse {
        webhooks: WebhookResponse[]
    }

    export interface ListWeightsResponse {
        weights: WeightResponse[]
    }

    export interface ListedVenom {
        id: uuid.UUID
        name: string
    }

    export interface MissedCallDashboard {
        appointments: PlatformStatusBin[]
        consultations: PlatformStatusBin[]
        "missed_calls": HydratedMissedCall[]
    }

    /**
     * An OrCondition represents a single truthy logical condition that must return true or false
     * OrCondition can only exist in an AndCondition
     */
    export interface OrCondition {
        /**
         * The ID of the rule condition
         */
        id: number

        /**
         * The id of the parent rule group
         */
        "rule_group_id": number

        /**
         * The Property to test the value for
         * required: true
         */
        property: RuleConditionProperty

        /**
         * The optional PropertyReference allows property values to be sourced from a keyed data source like a map
         */
        "property_ref": string

        /**
         * The logical Operation to apply to test the Property value
         * required: true
         */
        operation: RuleConditionOperation

        /**
         * The Value that will make this condition true.
         * 
         * example: Breed Is 'Labrador'
         * required: true
         */
        value: string
    }

    export type ParticipantStatus = string

    export interface PartnerPractice {
        name: string
        address: string
        "google_location_id": string
        "doc_id": uuid.UUID
        id: number
        long: string
        lat: string
    }

    export interface PatchPet {
        name?: string | null
        gender?: string | null
        neutered?: string | null
        "date_of_birth"?: string | null
        "breed_doc_id"?: string | null
        "species_doc_id"?: string | null
        "species_name_or_id"?: string | null
        weight?: number | null
    }

    export type PatientRecordSource = string

    export interface PetResponse {
        /**
         * DocID
         * The **doc_id** of the pet in **UUID** format.
         */
        "doc_id": string

        /**
         * Name
         * The name of the pet.
         */
        name: string

        /**
         * Gender
         * The gender of the pet.
         * 
         * Accepted values are:  **Male**, **Female**, **Unknown**.
         */
        gender: string

        /**
         * Weight
         * The weight of the pet.
         */
        weight?: WeightUnitsResponse

        /**
         * Neutered
         * Indicates if the pet has been neutered.
         */
        neutered?: boolean

        /**
         * DateOfBirth
         * The pet date of birth.
         * 
         * Accepted date format: **YYYY-MM-DD**.
         */
        "date_of_birth": string

        /**
         * Breed
         */
        breed?: GetBreedsResponseItem

        /**
         * CreatedAt
         * **created_at** in UTC time format (e.g. **2017-09-04T04:00:00Z**)
         */
        "created_at": string

        /**
         * Species
         * The species associated with the pet.
         */
        species: string

        /**
         * SpeciesDocID
         * The species **doc_id** associated with the pet in **UUID** format.
         */
        "species_id": uuid.UUID

        /**
         * PhotoUrl
         * Valid url for retrieving pet photo. The url is only valid for one hour.
         */
        "photo_url"?: string

        /**
         * PolicyCustomerNo
         * The policy number of the pet's owner.
         */
        "policy_customer_no"?: string

        /**
         * PolicyNo
         * The policy number of the pet.
         */
        "policy_no"?: string

        /**
         * PolicyActive
         * Indicates if the policy of the pet is active.
         */
        "policy_active": boolean

        /**
         * PolicyRegisteredDate
         * The time when the pet's policy was registered in UTC time format (e.g. **2017-09-04T04:00:00.000000Z**)
         */
        "policy_registered_date"?: string

        /**
         * PolicyDisabledDate
         * The time when the pet's policy was disabled in UTC time format (e.g. **2017-09-04T04:00:00.000000Z**)
         * It has values only when **policy_active** is false.
         */
        "policy_disabled_date"?: string

        /**
         * RequiresVerification
         * Indicates if pet's policy data has been verified by the owner
         * after it has been retrieved from an insurer.
         */
        "requires_verification": boolean

        /**
         * PolicyStartDate
         * The time when the pet's policy was started in UTC time format (e.g. **2017-09-04T04:00:00.000000Z**)
         */
        "policy_start_date"?: string

        /**
         * Triage
         * Indicates if the pet is a Triage customer.
         */
        triage?: boolean
    }

    export interface PlatformStatusBin {
        bin: string
        platform: string
        statuses: { [key: string]: number }
    }

    export interface PrescriptionCartItem {
        SKU: string
        Quantity: number
    }

    export interface PrescriptionCartRequest {
        items: PrescriptionCartItem[]
    }

    /**
     * Saved against a prescription, and mirrors the form name thats saved against the form submission table
     */
    export type PrescriptionType = string

    export interface Product {
        ID: number
        DocID: uuid.UUID
        GTIN: string
        Name: string
        ProductDesc: string
        CreatedAt: string
        UpdatedAt: string
    }

    export interface ProductSubCategoriesRequest {
        RequestedItemsPerPage: number
        RequestedPageNumber: number
        SubcatDocIDs: string[]
    }

    export interface ProductSubcategoryRequest {
        "product_id": uuid.UUID
        "sub_category_id": uuid.UUID
    }

    export type PromptType = string

    export interface ReasonForVisit {
        summary: string
        source: ReasonForVisitSource
    }

    export type ReasonForVisitSource = string

    /**
     * ResolvedEntitlementResponse is used for user_entitlements and pet_entitlements (with originating package).
     * Usage (used, remaining, has_credit) is only on effective_entitlements.
     */
    export interface ResolvedEntitlementResponse {
        code: string
        name: string
        description?: string
        unit: string
        value?: number
        period?: string
        "grant_doc_id": string
        "grant_entity_type": string
        "package_template_code": string
        "package_template_name": string
        "source_type": string
        "effective_date": string
        "expiry_date"?: string
    }

    /**
     * A Rule is composed of a list of AND conditions that must all evaluate to true in order for the rule to pass
     */
    export interface Rule {
        /**
         * The ID of the rule
         */
        id: number

        /**
         * The name of the rule
         * required: true
         */
        name: string

        /**
         * The AND rule groups for this rule
         */
        "and_conditions": AndCondition[]
    }

    export type RuleConditionOperation = string

    export type RuleConditionProperty = string

    /**
     * ScreeningParticipantStatus represents the status of a screening participant
     */
    export type ScreeningParticipantStatus = string

    export interface SendCallKitNotificationRequest {
        "notification_token": string
        "appointment_id": string
        "user_doc_id": string
        "auth_key": string
    }

    export interface ServicePricesBusinessMappingResponse {
        /**
         * the id of the business
         */
        id: string

        name: string
    }

    /**
     * StepParticipation represents whether a participant can interact with a step
     */
    export type StepParticipation = string

    export type StockSource = string

    export interface SubcategoriesResponseWithCat {
        subcategories: SubcategoryResponseWithCategory[]
    }

    export interface SubcategoryNameResponse {
        "subcategory_id": uuid.UUID
        name: string
    }

    export interface SubcategoryResponse {
        id: number
        "doc_id": uuid.UUID
        "category_id": uuid.UUID
        name: string
    }

    export interface SubcategoryResponseWithCategory {
        id: number
        "doc_id": uuid.UUID
        category: Category
        name: string
    }

    export interface TreatmentPlanReady {
        "consultation_doc_id": uuid.UUID
        /**
         * AppointmentID
         * This is a UUID referencing the appointment that proceeded the consultation.
         * It is optional and may not be present, for example if the user has come in through a chat.
         */
        "appointment_id"?: string

        /**
         * ChatID
         * This is a UUID referencing the chat that proceeded the consultation. It is optional and may not be present.
         */
        "chat_id"?: string

        /**
         * CallID
         * Deprecated: related to the call centre integration. Do not use.
         */
        "call_id"?: string

        /**
         * CreatedAt
         * this is the point at which the consultation was created.
         */
        "created_at": string

        "staff_profile_doc_id": string
        "staff_profile_photo_url": string
        "staff_profile_name": string
        /**
         * StaffProfileDescription
         * The role of the staff member shown to the user. For example, "Veterinary Surgeon" or "Vet Nurse".
         */
        "staff_profile_description": string

        /**
         * StartAt
         * The time that the consultation started, which is either when the appointment was scheduled to start or when the chat was initiated.
         */
        "start_at": utilities.Dates

        /**
         * ServiceName
         * A consultation at Vet-AI is associated with a service internally.
         * There is no definitive list of services, however some examples include
         * * Vet
         * * Specialist: Behaviourist
         * * Vet Follow Up
         * * Vet Chat
         */
        "service_name": string

        /**
         * TreatmentPlanRead
         * This boolean indicates whether the treatment plan has been read by the user.
         * This in turn is set through a request to mark treatment plan read.
         */
        "treatment_plan_read": boolean

        /**
         * SourceType
         * one of
         * * appointment
         * * chat
         * * call
         * * ai-review
         */
        "source_type": ConsultationSourceType
    }

    export interface TreatmentPlanReadyList {
        "treatment_plans": TreatmentPlanReady[]
        pagination: shared.Pagination
    }

    export type TrialConsultationStatus = string

    export interface UpdateBusinessRequest {
        id: string
        name: string
        "external_id": string
        "partner_integration": string
    }

    export interface UpdateCatalogueRequest {
        "doc_id": string
        name: string
        description: string
    }

    export interface UpdateCatalogueResponse {
        id: number
        "doc_id": uuid.UUID
        name: string
        description: string
    }

    export interface UpdateCategoryRequest {
        Name: string
    }

    export interface UpdateCategoryResponse {
        name: string
    }

    export interface UpdatePetResponse {
    }

    export interface UpdateProductRequest {
        id: number
        "doc_id": uuid.UUID
        gtin: string
        name: string
        "product_description": string
    }

    export interface UpdateProductResponse {
        id: number
        "doc_id": uuid.UUID
        gtin: string
        name: string
        "product_desc": string
    }

    export interface UpdateSubcategoryRequest {
        name: string
        "category_id": uuid.UUID
    }

    export interface UpdateSubcategoryResponse {
        name: string
        "category_id": uuid.UUID
    }

    export interface UploadProductsRequest {
        "catalogue_doc_id": string
        "products_csv_file": string
    }

    export type UserChatRatingTarget = string

    export interface UserSummary {
        "doc_id": uuid.UUID
        name: string
    }

    export interface WebhookEventMappingRequest {
        /**
         * the name of the webhook event
         */
        "webhook_event_id": string
    }

    export interface WebhookEventMappingResponse {
        /**
         * the webhook id
         */
        WebhookID: uuid.UUID

        /**
         * the webhook event id
         */
        EventID: uuid.UUID
    }

    export interface WebhookEventRequest {
        /**
         * the name of the webhook event
         */
        name: string
    }

    export interface WebhookEventResponse {
        /**
         * the id of the user
         */
        id: string

        name: string
    }

    export interface WebhookRequest {
        /**
         * the business url of the webhook
         */
        url: string
    }

    export interface WebhookResponse {
        /**
         * the id of the webhook
         */
        id: string

        /**
         * the business url of the webhook
         */
        url: string
    }

    export interface WeightResponse {
        /**
         * DocID
         * The **doc_id** of the weight in **UUID** format.
         */
        "doc_id": string

        /**
         * PetDocID
         * The **doc_id** of the pet in **UUID** format.
         */
        "pet_doc_id": string

        /**
         * Weight
         * The weight object
         */
        weight: WeightUnitsResponse

        /**
         * MeasuredAt
         * **measured_at** in UTC time format (e.g. **2017-09-04T04:00:00.000000Z**)
         */
        "measured_at"?: string
    }

    export interface WeightType {
        /**
         * WeightValue
         * The value of the weight.
         */
        "weight_value": number

        /**
         * Unit
         */
        unit: WeightUnit
    }

    export type WeightUnit = string

    export interface WeightUnitsResponse {
        /**
         * Grams
         * The weight value calculated in grams
         */
        g: number

        /**
         * Kg
         * The weight value calculated in kilograms
         */
        kg: number

        /**
         * Lbs
         * The weight value calculated in pounds
         */
        lbs: number
    }
}

export namespace getstream {
    export type ChatVideoRoomStatuses = string
}

export namespace integrations {
    export interface Client {
        Name: string
        Email: string
        Phone: string
        CustomerNumber: string
        /**
         * currently manypets is the only insurer to send this back.
         */
        Postcode: string
    }

    export interface InsurancePolicies {
        Client: Client
        Policies: Policy[]
    }

    export interface Pet {
        Name: string
        Species: string
        Breed: string
        Gender: string
        DateOfBirth: string
        Deceased: boolean
        /**
         * Only manypets sets this for now. true/false, and unknown is nil
         */
        Neutered: boolean
    }

    export interface Policy {
        PolicyNumber: string
        Active: boolean
        TriageEnabled: boolean
        Deceased: boolean
        Pet: Pet
        StartDate: string
    }
}

export namespace services {
    /**
     * ApplyMembershipResult is one membership that was applied.
     */
    export interface ApplyMembershipResult {
        "membership_identifier": string
        "package_code": string
    }
}

export namespace shared {
    export interface Pagination {
        total: number
        "current_page": number
        pages: number
    }
}

export namespace usstates {
    /**
     * https://www.iso.org/obp/ui/#iso:code:3166:US
     * These are the ISO 3166-2 us state short codes
     */
    export type ISO31662ShortCode = string
}

export namespace utilities {
    export type AppointmentStatus = string

    export type ConsultStatus = string

    export interface Dates {
        /**
         * UTC
         * Time in UTC (e.g. **2017-09-04T04:00:00Z**)
         */
        utc: string

        /**
         * Local
         * Time in local (e.g. **2017-09-04T04:00:00**)
         */
        local: string

        /**
         * DateFriendly
         * Date (e.g. **04/09/2017**)
         */
        "date_friendly": string

        /**
         * TimeFriendly
         * Time (e.g. **04:00 BST**)
         */
        "time_friendly": string

        /**
         * Timezone
         * **timezone** in IANA format
         * (e.g **Europe/London**, **UTC**, **Europe/Berlin**)
         */
        timezone: string
    }
}

export namespace uuid {
    /**
     * A UUID is a 128 bit (16 byte) Universal Unique IDentifier as defined in RFC
     * 4122.
     */
    export type UUID = string
}

// JSONValue represents an arbitrary JSON value.
export type JSONValue = string | number | boolean | null | JSONValue[] | {[key: string]: JSONValue}


function encodeQuery(parts: Record<string, string | string[]>): string {
    const pairs: string[] = []
    for (const key in parts) {
        const val = (Array.isArray(parts[key]) ?  parts[key] : [parts[key]]) as string[]
        for (const v of val) {
            pairs.push(`${key}=${encodeURIComponent(v)}`)
        }
    }
    return pairs.join("&")
}

// makeRecord takes a record and strips any undefined values from it,
// and returns the same record with a narrower type.
// @ts-ignore - TS ignore because makeRecord is not always used
function makeRecord<K extends string | number | symbol, V>(record: Record<K, V | undefined>): Record<K, V> {
    for (const key in record) {
        if (record[key] === undefined) {
            delete record[key]
        }
    }
    return record as Record<K, V>
}

function encodeWebSocketHeaders(headers: Record<string, string>) {
    // url safe, no pad
    const base64encoded = btoa(JSON.stringify(headers))
      .replaceAll("=", "")
      .replaceAll("+", "-")
      .replaceAll("/", "_");
    return "encore.dev.headers." + base64encoded;
}

class WebSocketConnection {
    public ws: WebSocket;

    private hasUpdateHandlers: (() => void)[] = [];

    constructor(url: string, headers?: Record<string, string>) {
        let protocols = ["encore-ws"];
        if (headers) {
            protocols.push(encodeWebSocketHeaders(headers))
        }

        this.ws = new WebSocket(url, protocols)

        this.on("error", () => {
            this.resolveHasUpdateHandlers();
        });

        this.on("close", () => {
            this.resolveHasUpdateHandlers();
        });
    }

    resolveHasUpdateHandlers() {
        const handlers = this.hasUpdateHandlers;
        this.hasUpdateHandlers = [];

        for (const handler of handlers) {
            handler()
        }
    }

    async hasUpdate() {
        // await until a new message have been received, or the socket is closed
        await new Promise((resolve) => {
            this.hasUpdateHandlers.push(() => resolve(null))
        });
    }

    on(type: "error" | "close" | "message" | "open", handler: (event: any) => void) {
        this.ws.addEventListener(type, handler);
    }

    off(type: "error" | "close" | "message" | "open", handler: (event: any) => void) {
        this.ws.removeEventListener(type, handler);
    }

    close() {
        this.ws.close();
    }
}

export class StreamInOut<Request, Response> {
    public socket: WebSocketConnection;
    private buffer: Response[] = [];

    constructor(url: string, headers?: Record<string, string>) {
        this.socket = new WebSocketConnection(url, headers);
        this.socket.on("message", (event: any) => {
            this.buffer.push(JSON.parse(event.data));
            this.socket.resolveHasUpdateHandlers();
        });
    }

    close() {
        this.socket.close();
    }

    async send(msg: Request) {
        if (this.socket.ws.readyState === WebSocket.CONNECTING) {
            // await that the socket is opened
            await new Promise((resolve) => {
                this.socket.ws.addEventListener("open", resolve, { once: true });
            });
        }

        return this.socket.ws.send(JSON.stringify(msg));
    }

    async next(): Promise<Response | undefined> {
        for await (const next of this) return next;
        return undefined;
    }

    async *[Symbol.asyncIterator](): AsyncGenerator<Response, undefined, void> {
        while (true) {
            if (this.buffer.length > 0) {
                yield this.buffer.shift() as Response;
            } else {
                if (this.socket.ws.readyState === WebSocket.CLOSED) return;
                await this.socket.hasUpdate();
            }
        }
    }
}

export class StreamIn<Response> {
    public socket: WebSocketConnection;
    private buffer: Response[] = [];

    constructor(url: string, headers?: Record<string, string>) {
        this.socket = new WebSocketConnection(url, headers);
        this.socket.on("message", (event: any) => {
            this.buffer.push(JSON.parse(event.data));
            this.socket.resolveHasUpdateHandlers();
        });
    }

    close() {
        this.socket.close();
    }

    async next(): Promise<Response | undefined> {
        for await (const next of this) return next;
        return undefined;
    }

    async *[Symbol.asyncIterator](): AsyncGenerator<Response, undefined, void> {
        while (true) {
            if (this.buffer.length > 0) {
                yield this.buffer.shift() as Response;
            } else {
                if (this.socket.ws.readyState === WebSocket.CLOSED) return;
                await this.socket.hasUpdate();
            }
        }
    }
}

export class StreamOut<Request, Response> {
    public socket: WebSocketConnection;
    private responseValue: Promise<Response>;

    constructor(url: string, headers?: Record<string, string>) {
        let responseResolver: (_: any) => void;
        this.responseValue = new Promise((resolve) => responseResolver = resolve);

        this.socket = new WebSocketConnection(url, headers);
        this.socket.on("message", (event: any) => {
            responseResolver(JSON.parse(event.data))
        });
    }

    async response(): Promise<Response> {
        return this.responseValue;
    }

    close() {
        this.socket.close();
    }

    async send(msg: Request) {
        if (this.socket.ws.readyState === WebSocket.CONNECTING) {
            // await that the socket is opened
            await new Promise((resolve) => {
                this.socket.ws.addEventListener("open", resolve, { once: true });
            });
        }

        return this.socket.ws.send(JSON.stringify(msg));
    }
}
// CallParameters is the type of the parameters to a method call, but require headers to be a Record type
type CallParameters = Omit<RequestInit, "method" | "body" | "headers"> & {
    /** Headers to be sent with the request */
    headers?: Record<string, string>

    /** Query parameters to be sent with the request */
    query?: Record<string, string | string[]>
}

// AuthDataGenerator is a function that returns a new instance of the authentication data required by this API
export type AuthDataGenerator = () =>
  | accountinternal.MyAuthParams
  | Promise<accountinternal.MyAuthParams | undefined>
  | undefined;

// A fetcher is the prototype for the inbuilt Fetch function
export type Fetcher = typeof fetch;

const boundFetch = fetch.bind(this);

class BaseClient {
    readonly baseURL: string
    readonly fetcher: Fetcher
    readonly headers: Record<string, string>
    readonly requestInit: Omit<RequestInit, "headers"> & { headers?: Record<string, string> }
    readonly authGenerator?: AuthDataGenerator

    constructor(baseURL: string, options: ClientOptions) {
        this.baseURL = baseURL
        this.headers = {}

        // Add User-Agent header if the script is running in the server
        // because browsers do not allow setting User-Agent headers to requests
        if (!BROWSER) {
            this.headers["User-Agent"] = "core-6p22-Generated-TS-Client (Encore/v1.58.8)";
        }

        this.requestInit = options.requestInit ?? {};

        // Setup what fetch function we'll be using in the base client
        if (options.fetcher !== undefined) {
            this.fetcher = options.fetcher
        } else {
            this.fetcher = boundFetch
        }

        // Setup an authentication data generator using the auth data token option
        if (options.auth !== undefined) {
            const auth = options.auth
            if (typeof auth === "function") {
                this.authGenerator = auth
            } else {
                this.authGenerator = () => auth
            }
        }
    }

    async getAuthData(): Promise<CallParameters | undefined> {
        let authData: accountinternal.MyAuthParams | undefined;

        // If authorization data generator is present, call it and add the returned data to the request
        if (this.authGenerator) {
            const mayBePromise = this.authGenerator();
            if (mayBePromise instanceof Promise) {
                authData = await mayBePromise;
            } else {
                authData = mayBePromise;
            }
        }

        if (authData) {
            const data: CallParameters = {};

            data.headers = makeRecord<string, string>({
                "accept-language":    authData.Language,
                authorization:        authData.Token,
                "x-client-version":   authData.ClientBuildNumber,
                "x-platform":         authData.ClientOperatingSystem,
                "x-platform-version": authData.ClientOSVersion,
            });

            return data;
        }

        return undefined;
    }

    // createStreamInOut sets up a stream to a streaming API endpoint.
    async createStreamInOut<Request, Response>(path: string, params?: CallParameters): Promise<StreamInOut<Request, Response>> {
        let { query, headers } = params ?? {};

        // Fetch auth data if there is any
        const authData = await this.getAuthData();

        // If we now have authentication data, add it to the request
        if (authData) {
            if (authData.query) {
                query = {...query, ...authData.query};
            }
            if (authData.headers) {
                headers = {...headers, ...authData.headers};
            }
        }

        const queryString = query ? '?' + encodeQuery(query) : ''
        return new StreamInOut(this.baseURL + path + queryString, headers);
    }

    // createStreamIn sets up a stream to a streaming API endpoint.
    async createStreamIn<Response>(path: string, params?: CallParameters): Promise<StreamIn<Response>> {
        let { query, headers } = params ?? {};

        // Fetch auth data if there is any
        const authData = await this.getAuthData();

        // If we now have authentication data, add it to the request
        if (authData) {
            if (authData.query) {
                query = {...query, ...authData.query};
            }
            if (authData.headers) {
                headers = {...headers, ...authData.headers};
            }
        }

        const queryString = query ? '?' + encodeQuery(query) : ''
        return new StreamIn(this.baseURL + path + queryString, headers);
    }

    // createStreamOut sets up a stream to a streaming API endpoint.
    async createStreamOut<Request, Response>(path: string, params?: CallParameters): Promise<StreamOut<Request, Response>> {
        let { query, headers } = params ?? {};

        // Fetch auth data if there is any
        const authData = await this.getAuthData();

        // If we now have authentication data, add it to the request
        if (authData) {
            if (authData.query) {
                query = {...query, ...authData.query};
            }
            if (authData.headers) {
                headers = {...headers, ...authData.headers};
            }
        }

        const queryString = query ? '?' + encodeQuery(query) : ''
        return new StreamOut(this.baseURL + path + queryString, headers);
    }

    // callTypedAPI makes an API call, defaulting content type to "application/json"
    public async callTypedAPI(method: string, path: string, body?: RequestInit["body"], params?: CallParameters): Promise<Response> {
        return this.callAPI(method, path, body, {
            ...params,
            headers: { "Content-Type": "application/json", ...params?.headers }
        });
    }

    // callAPI is used by each generated API method to actually make the request
    public async callAPI(method: string, path: string, body?: RequestInit["body"], params?: CallParameters): Promise<Response> {
        let { query, headers, ...rest } = params ?? {}
        const init = {
            ...this.requestInit,
            ...rest,
            method,
            body: body ?? null,
        }

        // Merge our headers with any predefined headers
        init.headers = {...this.headers, ...init.headers, ...headers}

        // Fetch auth data if there is any
        const authData = await this.getAuthData();

        // If we now have authentication data, add it to the request
        if (authData) {
            if (authData.query) {
                query = {...query, ...authData.query};
            }
            if (authData.headers) {
                init.headers = {...init.headers, ...authData.headers};
            }
        }

        // Make the actual request
        const queryString = query ? '?' + encodeQuery(query) : ''
        const response = await this.fetcher(this.baseURL+path+queryString, init)

        // handle any error responses
        if (!response.ok) {
            // try and get the error message from the response body
            let body: APIErrorResponse = { code: ErrCode.Unknown, message: `request failed: status ${response.status}` }

            // if we can get the structured error we should, otherwise give a best effort
            try {
                const text = await response.text()

                try {
                    const jsonBody = JSON.parse(text)
                    if (isAPIErrorResponse(jsonBody)) {
                        body = jsonBody
                    } else {
                        body.message += ": " + JSON.stringify(jsonBody)
                    }
                } catch {
                    body.message += ": " + text
                }
            } catch (e) {
                // otherwise we just append the text to the error message
                body.message += ": " + String(e)
            }

            throw new APIError(response.status, body)
        }

        return response
    }
}

/**
 * APIErrorDetails represents the response from an Encore API in the case of an error
 */
interface APIErrorResponse {
    code: ErrCode
    message: string
    details?: any
}

function isAPIErrorResponse(err: any): err is APIErrorResponse {
    return (
        err !== undefined && err !== null &&
        isErrCode(err.code) &&
        typeof(err.message) === "string" &&
        (err.details === undefined || err.details === null || typeof(err.details) === "object")
    )
}

function isErrCode(code: any): code is ErrCode {
    return code !== undefined && Object.values(ErrCode).includes(code)
}

/**
 * APIError represents a structured error as returned from an Encore application.
 */
export class APIError extends Error {
    /**
     * The HTTP status code associated with the error.
     */
    public readonly status: number

    /**
     * The Encore error code
     */
    public readonly code: ErrCode

    /**
     * The error details
     */
    public readonly details?: any

    constructor(status: number, response: APIErrorResponse) {
        // extending errors causes issues after you construct them, unless you apply the following fixes
        super(response.message);

        // set error name as constructor name, make it not enumerable to keep native Error behavior
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/new.target#new.target_in_constructors
        Object.defineProperty(this, 'name', {
            value:        'APIError',
            enumerable:   false,
            configurable: true,
        })

        // fix the prototype chain
        if ((Object as any).setPrototypeOf == undefined) {
            (this as any).__proto__ = APIError.prototype
        } else {
            Object.setPrototypeOf(this, APIError.prototype);
        }

        // capture a stack trace
        if ((Error as any).captureStackTrace !== undefined) {
            (Error as any).captureStackTrace(this, this.constructor);
        }

        this.status = status
        this.code = response.code
        this.details = response.details
    }
}

/**
 * Typeguard allowing use of an APIError's fields'
 */
export function isAPIError(err: any): err is APIError {
    return err instanceof APIError;
}

export enum ErrCode {
    /**
     * OK indicates the operation was successful.
     */
    OK = "ok",

    /**
     * Canceled indicates the operation was canceled (typically by the caller).
     *
     * Encore will generate this error code when cancellation is requested.
     */
    Canceled = "canceled",

    /**
     * Unknown error. An example of where this error may be returned is
     * if a Status value received from another address space belongs to
     * an error-space that is not known in this address space. Also
     * errors raised by APIs that do not return enough error information
     * may be converted to this error.
     *
     * Encore will generate this error code in the above two mentioned cases.
     */
    Unknown = "unknown",

    /**
     * InvalidArgument indicates client specified an invalid argument.
     * Note that this differs from FailedPrecondition. It indicates arguments
     * that are problematic regardless of the state of the system
     * (e.g., a malformed file name).
     *
     * This error code will not be generated by the gRPC framework.
     */
    InvalidArgument = "invalid_argument",

    /**
     * DeadlineExceeded means operation expired before completion.
     * For operations that change the state of the system, this error may be
     * returned even if the operation has completed successfully. For
     * example, a successful response from a server could have been delayed
     * long enough for the deadline to expire.
     *
     * The gRPC framework will generate this error code when the deadline is
     * exceeded.
     */
    DeadlineExceeded = "deadline_exceeded",

    /**
     * NotFound means some requested entity (e.g., file or directory) was
     * not found.
     *
     * This error code will not be generated by the gRPC framework.
     */
    NotFound = "not_found",

    /**
     * AlreadyExists means an attempt to create an entity failed because one
     * already exists.
     *
     * This error code will not be generated by the gRPC framework.
     */
    AlreadyExists = "already_exists",

    /**
     * PermissionDenied indicates the caller does not have permission to
     * execute the specified operation. It must not be used for rejections
     * caused by exhausting some resource (use ResourceExhausted
     * instead for those errors). It must not be
     * used if the caller cannot be identified (use Unauthenticated
     * instead for those errors).
     *
     * This error code will not be generated by the gRPC core framework,
     * but expect authentication middleware to use it.
     */
    PermissionDenied = "permission_denied",

    /**
     * ResourceExhausted indicates some resource has been exhausted, perhaps
     * a per-user quota, or perhaps the entire file system is out of space.
     *
     * This error code will be generated by the gRPC framework in
     * out-of-memory and server overload situations, or when a message is
     * larger than the configured maximum size.
     */
    ResourceExhausted = "resource_exhausted",

    /**
     * FailedPrecondition indicates operation was rejected because the
     * system is not in a state required for the operation's execution.
     * For example, directory to be deleted may be non-empty, an rmdir
     * operation is applied to a non-directory, etc.
     *
     * A litmus test that may help a service implementor in deciding
     * between FailedPrecondition, Aborted, and Unavailable:
     *  (a) Use Unavailable if the client can retry just the failing call.
     *  (b) Use Aborted if the client should retry at a higher-level
     *      (e.g., restarting a read-modify-write sequence).
     *  (c) Use FailedPrecondition if the client should not retry until
     *      the system state has been explicitly fixed. E.g., if an "rmdir"
     *      fails because the directory is non-empty, FailedPrecondition
     *      should be returned since the client should not retry unless
     *      they have first fixed up the directory by deleting files from it.
     *  (d) Use FailedPrecondition if the client performs conditional
     *      REST Get/Update/Delete on a resource and the resource on the
     *      server does not match the condition. E.g., conflicting
     *      read-modify-write on the same resource.
     *
     * This error code will not be generated by the gRPC framework.
     */
    FailedPrecondition = "failed_precondition",

    /**
     * Aborted indicates the operation was aborted, typically due to a
     * concurrency issue like sequencer check failures, transaction aborts,
     * etc.
     *
     * See litmus test above for deciding between FailedPrecondition,
     * Aborted, and Unavailable.
     */
    Aborted = "aborted",

    /**
     * OutOfRange means operation was attempted past the valid range.
     * E.g., seeking or reading past end of file.
     *
     * Unlike InvalidArgument, this error indicates a problem that may
     * be fixed if the system state changes. For example, a 32-bit file
     * system will generate InvalidArgument if asked to read at an
     * offset that is not in the range [0,2^32-1], but it will generate
     * OutOfRange if asked to read from an offset past the current
     * file size.
     *
     * There is a fair bit of overlap between FailedPrecondition and
     * OutOfRange. We recommend using OutOfRange (the more specific
     * error) when it applies so that callers who are iterating through
     * a space can easily look for an OutOfRange error to detect when
     * they are done.
     *
     * This error code will not be generated by the gRPC framework.
     */
    OutOfRange = "out_of_range",

    /**
     * Unimplemented indicates operation is not implemented or not
     * supported/enabled in this service.
     *
     * This error code will be generated by the gRPC framework. Most
     * commonly, you will see this error code when a method implementation
     * is missing on the server. It can also be generated for unknown
     * compression algorithms or a disagreement as to whether an RPC should
     * be streaming.
     */
    Unimplemented = "unimplemented",

    /**
     * Internal errors. Means some invariants expected by underlying
     * system has been broken. If you see one of these errors,
     * something is very broken.
     *
     * This error code will be generated by the gRPC framework in several
     * internal error conditions.
     */
    Internal = "internal",

    /**
     * Unavailable indicates the service is currently unavailable.
     * This is a most likely a transient condition and may be corrected
     * by retrying with a backoff. Note that it is not always safe to retry
     * non-idempotent operations.
     *
     * See litmus test above for deciding between FailedPrecondition,
     * Aborted, and Unavailable.
     *
     * This error code will be generated by the gRPC framework during
     * abrupt shutdown of a server process or network connection.
     */
    Unavailable = "unavailable",

    /**
     * DataLoss indicates unrecoverable data loss or corruption.
     *
     * This error code will not be generated by the gRPC framework.
     */
    DataLoss = "data_loss",

    /**
     * Unauthenticated indicates the request does not have valid
     * authentication credentials for the operation.
     *
     * The gRPC framework will generate this error code when the
     * authentication metadata is invalid or a Credentials callback fails,
     * but also expect authentication middleware to generate it.
     */
    Unauthenticated = "unauthenticated",
}
